/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/hammertime/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 251);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(8);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(19);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMProperty = __webpack_require__(17);
var ReactDOMComponentFlags = __webpack_require__(69);

var invariant = __webpack_require__(0);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(146)();
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(224);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(225);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(226);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(227);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(55);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(229);
/* unused harmony reexport withRouter */



















/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(4);

var CallbackQueue = __webpack_require__(67);
var PooledClass = __webpack_require__(15);
var ReactFeatureFlags = __webpack_require__(72);
var ReactReconciler = __webpack_require__(18);
var Transaction = __webpack_require__(31);

var invariant = __webpack_require__(0);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var PooledClass = __webpack_require__(15);

var emptyFunction = __webpack_require__(8);
var warning = __webpack_require__(1);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(38);
var setInnerHTML = __webpack_require__(33);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(46);
var setTextContent = __webpack_require__(85);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(184);
var ReactInstrumentation = __webpack_require__(10);

var warning = __webpack_require__(1);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var ReactBaseClasses = __webpack_require__(94);
var ReactChildren = __webpack_require__(237);
var ReactDOMFactories = __webpack_require__(238);
var ReactElement = __webpack_require__(20);
var ReactPropTypes = __webpack_require__(239);
var ReactVersion = __webpack_require__(240);

var createReactClass = __webpack_require__(241);
var onlyChild = __webpack_require__(245);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var ReactCurrentOwner = __webpack_require__(13);

var warning = __webpack_require__(1);
var canDefineProperty = __webpack_require__(98);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(96);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var EventPluginRegistry = __webpack_require__(39);
var EventPluginUtils = __webpack_require__(40);
var ReactErrorUtils = __webpack_require__(44);

var accumulateInto = __webpack_require__(78);
var forEachAccumulated = __webpack_require__(79);
var invariant = __webpack_require__(0);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(23);
var EventPluginUtils = __webpack_require__(40);

var accumulateInto = __webpack_require__(78);
var forEachAccumulated = __webpack_require__(79);
var warning = __webpack_require__(1);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(12);

var getEventTarget = __webpack_require__(49);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var EventPluginRegistry = __webpack_require__(39);
var ReactEventEmitterMixin = __webpack_require__(176);
var ViewportMetrics = __webpack_require__(77);

var getVendorPrefixedEventName = __webpack_require__(208);
var isEventSupported = __webpack_require__(50);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(26);
var ViewportMetrics = __webpack_require__(77);

var getEventModifierState = __webpack_require__(48);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(7);
var DOMNamespaces = __webpack_require__(38);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(46);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(247);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(248);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(16);
var Danger = __webpack_require__(153);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInstrumentation = __webpack_require__(10);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(46);
var setInnerHTML = __webpack_require__(33);
var setTextContent = __webpack_require__(85);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactErrorUtils = __webpack_require__(44);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactPropTypesSecret = __webpack_require__(182);
var propTypesFactory = __webpack_require__(63);

var React = __webpack_require__(19);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(13);
var ReactInstanceMap = __webpack_require__(25);
var ReactInstrumentation = __webpack_require__(10);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(7);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var emptyFunction = __webpack_require__(8);
var warning = __webpack_require__(1);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(212);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(214);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(215);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(216);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(217);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(219);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(220);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(222);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(223);
/* unused harmony reexport withRouter */



























/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict;

  var _compilePath = compilePath(path, { end: exact, strict: strict }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(8);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(147);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(161);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(15);

var invariant = __webpack_require__(0);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(17);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInstrumentation = __webpack_require__(10);

var quoteAttributeValueForBrowser = __webpack_require__(209);
var warning = __webpack_require__(1);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var LinkedValueUtils = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(169);

var containsNode = __webpack_require__(128);
var focusNode = __webpack_require__(59);
var getActiveElement = __webpack_require__(60);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(16);
var DOMProperty = __webpack_require__(17);
var React = __webpack_require__(19);
var ReactBrowserEventEmitter = __webpack_require__(29);
var ReactCurrentOwner = __webpack_require__(13);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMContainerInfo = __webpack_require__(163);
var ReactDOMFeatureFlags = __webpack_require__(165);
var ReactFeatureFlags = __webpack_require__(72);
var ReactInstanceMap = __webpack_require__(25);
var ReactInstrumentation = __webpack_require__(10);
var ReactMarkupChecksum = __webpack_require__(179);
var ReactReconciler = __webpack_require__(18);
var ReactUpdateQueue = __webpack_require__(45);
var ReactUpdates = __webpack_require__(11);

var emptyObject = __webpack_require__(28);
var instantiateReactComponent = __webpack_require__(83);
var invariant = __webpack_require__(0);
var setInnerHTML = __webpack_require__(33);
var shouldUpdateReactComponent = __webpack_require__(51);
var warning = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var React = __webpack_require__(19);

var invariant = __webpack_require__(0);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(76);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(7);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(5);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(4);

var ReactCompositeComponent = __webpack_require__(160);
var ReactEmptyComponent = __webpack_require__(71);
var ReactHostComponent = __webpack_require__(73);

var getNextDebugID = __webpack_require__(243);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(7);
var escapeTextContentForBrowser = __webpack_require__(32);
var setInnerHTML = __webpack_require__(33);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(13);
var REACT_ELEMENT_TYPE = __webpack_require__(175);

var getIteratorFn = __webpack_require__(206);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(41);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _screenReaderStyles = __webpack_require__(211);

var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A React component for the font-awesome icon library.
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false]Inverse the icon's color
 * @param {String} name Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another
 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
 * @module FontAwesome
 * @type {ReactClass}
 */
var FontAwesome = function (_React$Component) {
  _inherits(FontAwesome, _React$Component);

  function FontAwesome() {
    _classCallCheck(this, FontAwesome);

    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));

    _this.displayName = 'FontAwesome';
    return _this;
  }

  _createClass(FontAwesome, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          cssModule = _props.cssModule,
          className = _props.className,
          fixedWidth = _props.fixedWidth,
          flip = _props.flip,
          inverse = _props.inverse,
          name = _props.name,
          pulse = _props.pulse,
          rotate = _props.rotate,
          size = _props.size,
          spin = _props.spin,
          stack = _props.stack,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'span' : _props$tag,
          ariaLabel = _props.ariaLabel,
          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);

      var classNames = [];

      if (cssModule) {
        classNames.push(cssModule['fa']);
        classNames.push(cssModule['fa-' + name]);
        size && classNames.push(cssModule['fa-' + size]);
        spin && classNames.push(cssModule['fa-spin']);
        pulse && classNames.push(cssModule['fa-pulse']);
        border && classNames.push(cssModule['fa-border']);
        fixedWidth && classNames.push(cssModule['fa-fw']);
        inverse && classNames.push(cssModule['fa-inverse']);
        flip && classNames.push(cssModule['fa-flip-' + flip]);
        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
        stack && classNames.push(cssModule['fa-stack-' + stack]);
      } else {
        classNames.push('fa');
        classNames.push('fa-' + name);
        size && classNames.push('fa-' + size);
        spin && classNames.push('fa-spin');
        pulse && classNames.push('fa-pulse');
        border && classNames.push('fa-border');
        fixedWidth && classNames.push('fa-fw');
        inverse && classNames.push('fa-inverse');
        flip && classNames.push('fa-flip-' + flip);
        rotate && classNames.push('fa-rotate-' + rotate);
        stack && classNames.push('fa-stack-' + stack);
      }

      // Add any custom class names at the end.
      className && classNames.push(className);
      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
    }
  }]);

  return FontAwesome;
}(_react2.default.Component);

FontAwesome.propTypes = {
  ariaLabel: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  cssModule: _propTypes2.default.object,
  fixedWidth: _propTypes2.default.bool,
  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  inverse: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.oneOf([90, 180, 270]),
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  spin: _propTypes2.default.bool,
  stack: _propTypes2.default.oneOf(['1x', '2x']),
  tag: _propTypes2.default.string
};

exports.default = FontAwesome;
module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact;
    var route = _ref2.route;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    var pathname = (location || route.location).pathname;

    return path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        component = _props.component,
        render = _props.render,
        children = _props.children;


    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props2 = this.props,
        children = _props2.children,
        component = _props2.component,
        render = _props2.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(101);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(116);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(232);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(91);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(4);

var ReactNoopUpdateQueue = __webpack_require__(97);

var canDefineProperty = __webpack_require__(98);
var emptyObject = __webpack_require__(28);
var invariant = __webpack_require__(0);
var lowPriorityWarning = __webpack_require__(244);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var ReactCurrentOwner = __webpack_require__(13);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(115);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null)),document.getElementById('root'));__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(231).enable();
  window.Promise = __webpack_require__(230);
}

// fetch() polyfill for making API calls.
__webpack_require__(250);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(4);


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(249)))

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Container__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import PropTypes from 'prop-types';
var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Container__["a" /* default */],null,this.props.children));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({"sections":[{"subElement":"E1","subElementDescription":"COMMISSION�S RULES [6 Exam Questions - 6 Groups]","stats":["6 Exam Questions "," 6 Groups"],"numQuestions":"6","numGroups":"6"},{"subElement":"E2","subElementDescription":"OPERATING PROCEDURES [5 Exam Questions - 5 Groups]","stats":["5 Exam Questions "," 5 Groups"],"numQuestions":"5","numGroups":"5"},{"subElement":"E3","subElementDescription":"RADIO WAVE PROPAGATION [3 Exam Questions - 3 Groups]","stats":["3 Exam Questions "," 3 Groups"],"numQuestions":"3","numGroups":"3"},{"subElement":"E4","subElementDescription":"AMATEUR PRACTICES [5 Exam Questions - 5 Groups]","stats":["5 Exam Questions "," 5 Groups"],"numQuestions":"5","numGroups":"5"},{"subElement":"E5","subElementDescription":"ELECTRICAL PRINCIPLES [4 Exam Questions - 4 Groups]","stats":["4 Exam Questions "," 4 Groups"],"numQuestions":"4","numGroups":"4"},{"subElement":"E6","subElementDescription":"CIRCUIT COMPONENTS [6 Exam Questions - 6 Groups]","stats":["6 Exam Questions "," 6 Groups"],"numQuestions":"6","numGroups":"6"},{"subElement":"E7","subElementDescription":"PRACTICAL CIRCUITS [8 Exam Questions - 8 Groups]","stats":["8 Exam Questions "," 8 Groups"],"numQuestions":"8","numGroups":"8"},{"subElement":"E8","subElementDescription":"SIGNALS AND EMISSIONS [4 Exam Questions - 4 Groups]","stats":["4 Exam Questions "," 4 Groups"],"numQuestions":"4","numGroups":"4"},{"subElement":"E9","subElementDescription":"ANTENNAS AND TRANSMISSION LINES [8 Exam Questions - 8 Groups]","stats":["8 Exam Questions "," 8 Groups"],"numQuestions":"8","numGroups":"8"},{"subElement":"E0","subElementDescription":"SAFETY - [1 exam question -� 1 group]","stats":["1 exam question ","� 1 group"],"numQuestions":"1","numGroups":"�"}],"categories":[{"category":"E1A","categoryDescription":"erating Standards: frequency privileges; emission standards; automatic message f"+"orwarding; frequency sharing; stations aboard ships or aircraft"},{"category":"E1B","categoryDescription":"ation restrictions and special operations: restrictions on station location; gen"+"eral operating restrictions, spurious emissions, control operator reimbursement;"+" antenna structure restrictions; RACES operations; national quiet zone"},{"category":"E1C","categoryDescription":"finitions and restrictions pertaining to local, automatic and remote control ope"+"ration; control operator responsibilities for remote and automatically controlle"+"d stations; IARP and CEPT licenses; third party communications over automaticall"+"y controlled stations"},{"category":"E1D","categoryDescription":"ateur satellites: definitions and purpose; license requirements for space statio"+"ns; available frequencies and bands; telecommand and telemetry operations; restr"+"ictions, and special provisions; notification requirements"},{"category":"E1E","categoryDescription":"lunteer examiner program: definitions; qualifications; preparation and administr"+"ation of exams; accreditation; question pools; documentation requirements"},{"category":"E1F","categoryDescription":"scellaneous rules: external RF power amplifiers; business communications; compen"+"sated communications; spread spectrum; auxiliary stations; reciprocal operating "+"privileges; special temporary authority"},{"category":"E2A","categoryDescription":"ateur radio in space: amateur satellites; orbital mechanics; frequencies and mod"+"es; satellite hardware; satellite operations; experimental telemetry application"+"s"},{"category":"E2B","categoryDescription":"levision practices: fast scan television standards and techniques; slow scan tel"+"evision standards and techniques"},{"category":"E2C","categoryDescription":"erating methods: contest and DX operating; remote operation techniques; Cabrillo"+" format; QSLing; RF network connected systems"},{"category":"E2D","categoryDescription":"erating methods: VHF and UHF digital modes and procedures; APRS; EME procedures,"+" meteor scatter procedures"},{"category":"E2E","categoryDescription":"erating methods: operating HF digital modes"},{"category":"E3A","categoryDescription":"ectromagnetic waves; Earth-Moon-Earth communications; meteor scatter; microwave "+"tropospheric and scatter propagation; aurora propagation"},{"category":"E3B","categoryDescription":"ansequatorial propagation; long path; gray-line; multi-path; ordinary and extrao"+"rdinary waves; chordal hop, sporadic E mechanisms"},{"category":"E3C","categoryDescription":"dio-path horizon; less common propagation modes; propagation prediction techniqu"+"es and modeling; space weather parameters and amateur radio"},{"category":"E4A","categoryDescription":"st equipment: analog and digital instruments; spectrum and network analyzers, an"+"tenna analyzers; oscilloscopes; RF measurements; computer aided measurements"},{"category":"E4B","categoryDescription":"asurement technique and limitations: instrument accuracy and performance limitat"+"ions; probes; techniques to minimize errors; measurement of \"Q\"; instrument ca"+"libration; S parameters; vector network analyzers"},{"category":"E4C","categoryDescription":"ceiver performance characteristics, phase noise, noise floor, image rejection, M"+"DS, signal-to-noise-ratio; selectivity; effects of SDR receiver non-linearity"},{"category":"E4D","categoryDescription":"ceiver performance characteristics: blocking dynamic range; intermodulation and "+"cross-modulation interference; 3rd order intercept; desensitization; preselector"},{"category":"E4E","categoryDescription":"ise suppression: system noise; electrical appliance noise; line noise; locating "+"noise sources; DSP noise reduction; noise blankers; grounding for signals"},{"category":"E5A","categoryDescription":"sonance and Q: characteristics of resonant circuits: series and parallel resonan"+"ce; definitions and effects of Q; half-power bandwidth; phase relationships in r"+"eactive circuits"},{"category":"E5B","categoryDescription":"me constants and phase relationships: RLC time constants; definition; time const"+"ants in RL and RC circuits; phase angle between voltage and current; phase angle"+"s of series RLC; phase angle of inductance vs susceptance; admittance and suscep"+"tance"},{"category":"E5C","categoryDescription":"ordinate systems and phasors in electronics: Rectangular Coordinates; Polar Coor"+"dinates; Phasors"},{"category":"E5D","categoryDescription":" and RF energy in real circuits: skin effect; electrostatic and electromagnetic "+"fields; reactive power; power factor; electrical length of conductors at UHF and"+" microwave frequencies"},{"category":"E6A","categoryDescription":"miconductor materials and devices: semiconductor materials; germanium, silicon, "+"P-type, N-type; transistor types: NPN, PNP, junction, field-effect transistors: "+"enhancement mode; depletion mode; MOS; CMOS; N-channel; P-channel"},{"category":"E6B","categoryDescription":"odes"},{"category":"E6C","categoryDescription":"gital ICs: Families of digital ICs; gates; Programmable Logic Devices (PLDs)"},{"category":"E6D","categoryDescription":"roidal and Solenoidal Inductors: permeability, core material, selecting, winding"+"; transformers; Piezoelectric devices"},{"category":"E6E","categoryDescription":"alog ICs: MMICs, CCDs, Device packages"},{"category":"E6F","categoryDescription":"tical components: photoconductive principles and effects, photovoltaic systems, "+"optical couplers, optical sensors, and optoisolators; LCDs"},{"category":"E7A","categoryDescription":"gital circuits: digital circuit principles and logic circuits: classes of logic "+"elements; positive and negative logic; frequency dividers; truth tables"},{"category":"E7B","categoryDescription":"plifiers: Class of operation; vacuum tube and solid-state circuits; distortion a"+"nd intermodulation; spurious and parasitic suppression; microwave amplifiers; sw"+"itching-type amplifiers"},{"category":"E7C","categoryDescription":"lters and matching networks: types of networks; types of filters; filter applica"+"tions; filter characteristics; impedance matching; DSP filtering"},{"category":"E7D","categoryDescription":"wer supplies and voltage regulators; Solar array charge controllers"},{"category":"E7E","categoryDescription":"dulation and demodulation: reactance, phase and balanced modulators; detectors; "+"mixer stages"},{"category":"E7F","categoryDescription":"P filtering and other operations; Software Defined Radio Fundamentals; DSP modul"+"ation and demodulation"},{"category":"E7G","categoryDescription":"tive filters and op-amp circuits: active audio filters; characteristics; basic c"+"ircuit design; operational amplifiers"},{"category":"E7H","categoryDescription":"cillators and signal sources: types of oscillators; synthesizers and phase-locke"+"d loops; direct digital synthesizers; stabilizing thermal drift; microphonics; h"+"igh accuracy oscillators"},{"category":"E8A","categoryDescription":" waveforms: sine, square, sawtooth and irregular waveforms; AC measurements; ave"+"rage and PEP of RF signals; Fourier analysis; Analog to digital conversion: Digi"+"tal to Analog conversion"},{"category":"E8B","categoryDescription":"dulation and demodulation: modulation methods; modulation index and deviation ra"+"tio; frequency and time division multiplexing; Orthogonal Frequency Division Mul"+"tiplexing"},{"category":"E8C","categoryDescription":"gital signals: digital communication modes; information rate vs bandwidth; error"+" correction"},{"category":"E8D","categoryDescription":"ying defects and overmodulation of digital signals; digital codes; spread spectr"+"um"},{"category":"E9A","categoryDescription":"sic Antenna parameters: radiation resistance, gain, beamwidth, efficiency, beamw"+"idth; effective radiated power, polarization"},{"category":"E9B","categoryDescription":"tenna patterns: E and H plane patterns; gain as a function of pattern; antenna d"+"esign"},{"category":"E9C","categoryDescription":"re and phased array antennas: rhombic antennas; effects of ground reflections; e"+"-off angles; Practical wire antennas: Zepps, OCFD, loops"},{"category":"E9D","categoryDescription":"rectional antennas: gain; Yagi Antennas; losses; SWR bandwidth; antenna efficien"+"cy; shortened and mobile antennas; RF Grounding"},{"category":"E9E","categoryDescription":"tching: matching antennas to feed lines; phasing lines; power dividers"},{"category":"E9F","categoryDescription":"ansmission lines: characteristics of open and shorted feed lines; 1/8 wavelength"+"; 1/4 wavelength; 1/2 wavelength; feed lines: coax versus open-wire; velocity fa"+"ctor; electrical length; coaxial cable dielectrics; velocity factor"},{"category":"E9G","categoryDescription":"e Smith chart"},{"category":"E9H","categoryDescription":"ceiving Antennas: radio direction finding antennas; Beverage Antennas; specializ"+"ed receiving antennas; longwire receiving antennas"},{"category":"E0A","categoryDescription":"fety: amateur radio safety practices; RF radiation hazards; hazardous materials;"+" grounding "}],"questions":[{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A01","question":"When using a transceiver that displays the carrier frequency of phone signals, w"+"hich of the following displayed frequencies represents the highest frequency at "+"which a properly adjusted USB emission will be totally within the band?","answer":"D","choices":{"a":"The exact upper band edge","b":"300 Hz below the upper band edge","c":"1 kHz below the upper band edge","d":"3 kHz below the upper band edge"},"metadata":"97.301, 97.305"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A02","question":"When using a transceiver that displays the carrier frequency of phone signals, w"+"hich of the following displayed frequencies represents the lowest frequency at w"+"hich a properly adjusted LSB emission will be totally within the band?","answer":"D","choices":{"a":"The exact lower band edge","b":"300 Hz above the lower band edge","c":"1 kHz above the lower band edge","d":"3 kHz above the lower band edge"},"metadata":"97.301, 97.305"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A03","question":"With your transceiver displaying the carrier frequency of phone signals, you hea"+"r a station calling CQ on 14.349 MHz USB. Is it legal to return the call using u"+"pper sideband on the same frequency?","answer":"C","choices":{"a":"Yes, because you were not the station calling CQ","b":"Yes, because the displayed frequency is within the 20 meter band","c":"No, the sideband will extend beyond the band edge","d":"No, U.S. stations are not permitted to use phone emissions above 14.340 MHz"},"metadata":"97.301, 97.305"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A04","question":"With your transceiver displaying the carrier frequency of phone signals, you hea"+"r a DX station calling CQ on 3.601 MHz LSB. Is it legal to return the call using"+" lower sideband on the same frequency?","answer":"C","choices":{"a":"Yes, because the DX station initiated the contact","b":"Yes, because the displayed frequency is within the 75 meter phone band segment","c":"No, the sideband will extend beyond the edge of the phone band segment","d":"No, U.S. stations are not permitted to use phone emissions below 3.610 MHz"},"metadata":"97.301, 97.305]"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A05","question":"What is the maximum power output permitted on the 60 meter band?","answer":"C","choices":{"a":"50 watts PEP effective radiated power relative to an isotropic radiator","b":"50 watts PEP effective radiated power relative to a dipole","c":"100 watts PEP effective radiated power relative to the gain of a half-wave dipol"+"e","d":"100 watts PEP effective radiated power relative to an isotropic radiator"},"metadata":"97.313"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A06","question":"Where must the carrier frequency of a CW signal be set to comply with FCC rules "+"for 60 meter operation?","answer":"B","choices":{"a":"At the lowest frequency of the channel","b":"At the center frequency of the channel","c":"At the highest frequency of the channel","d":"On any frequency where the signal�s sidebands are within the channel"},"metadata":"97.15"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A07","question":"Which amateur band requires transmission on specific channels rather than on a r"+"ange of frequencies?","answer":"D","choices":{"a":"12 meter band","b":"17 meter band","c":"30 meter band","d":"60 meter band"},"metadata":"97.303"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A08","question":"If a station in a message forwarding system inadvertently forwards a message tha"+"t is in violation of FCC rules, who is primarily accountable for the rules viola"+"tion?","answer":"B","choices":{"a":"The control operator of the packet bulletin board station","b":"The control operator of the originating station","c":"The control operators of all the stations in the system","d":"The control operators of all the stations in the system not authenticating the s"+"ource from which they accept communications"},"metadata":"97.219"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A09","question":"What is the first action you should take if your digital message forwarding stat"+"ion inadvertently forwards a communication that violates FCC rules?","answer":"A","choices":{"a":"Discontinue forwarding the communication as soon as you become aware of it","b":"Notify the originating station that the communication does not comply with FCC r"+"ules","c":"Notify the nearest FCC Field Engineer�s office","d":"Discontinue forwarding all messages"},"metadata":"97.219"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A10","question":"If an amateur station is installed aboard a ship or aircraft, what condition mus"+"t be met before the station is operated?","answer":"A","choices":{"a":"Its operation must be approved by the master of the ship or the pilot in command"+" of the aircraft","b":"The amateur station operator must agree not to transmit when the main radio of t"+"he ship or aircraft is in use","c":"The amateur station must have a power supply that is completely independent of t"+"he main ship or aircraft power supply","d":"The amateur operator must have an FCC Marine or Aircraft endorsement on his or h"+"er amateur license"},"metadata":"97.11"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A11","question":"Which of the following describes authorization or licensing required when operat"+"ing an amateur station aboard a U.S.-registered vessel in international waters?","answer":"B","choices":{"a":"Any amateur license with an FCC Marine or Aircraft endorsement","b":"Any FCC-issued amateur license","c":"Only General class or higher amateur licenses","d":"An unrestricted Radiotelephone Operator Permit"},"metadata":"97.5"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A12","question":"With your transceiver displaying the carrier frequency of CW signals, you hear a"+" DX station's CQ on 3.500 MHz. Is it legal to return the call using CW on the sa"+"me frequency?","answer":"C","choices":{"a":"Yes, the DX station initiated the contact","b":"Yes, the displayed frequency is within the 80 meter CW band segment","c":"No, one of the sidebands of the CW signal will be out of the band","d":"No, U.S. stations are not permitted to use CW emissions below 3.525 MHz"},"metadata":"97.301, 97.305"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A13","question":"Who must be in physical control of the station apparatus of an amateur station a"+"board any vessel or craft that is documented or registered in the United States?","answer":"B","choices":{"a":"Only a person with an FCC Marine Radio","b":"Any person holding an FCC issued amateur license or who is authorized for alien "+"reciprocal operation","c":"Only a person named in an amateur station license grant","d":"Any person named in an amateur station license grant or a person holding an unre"+"stricted Radiotelephone Operator Permit"},"metadata":"97.5"},{"exam":"E","section":"E1","subSection":"E1A","questionID":"E1A14","question":"What is the maximum bandwidth for a data emission on 60 meters?","answer":"D","choices":{"a":"60 Hz","b":"170 Hz","c":"1.5 kHz","d":"2.8 kHz"},"metadata":"97.303"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B01","question":"Which of the following constitutes a spurious emission?","answer":"D","choices":{"a":"An amateur station transmission made at random without the proper call sign iden"+"tification","b":"A signal transmitted to prevent its detection by any station other than the inte"+"nded recipient","c":"Any transmitted signal that unintentionally interferes with another licensed rad"+"io station","d":"An emission outside its necessary bandwidth that can be reduced or eliminated wi"+"thout affecting the information transmitted"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B02","question":"Which of the following factors might cause the physical location of an amateur s"+"tation apparatus or antenna structure to be restricted?","answer":"D","choices":{"a":"The location is near an area of political conflict","b":"The location is of geographical or horticultural importance","c":"The location is in an ITU Zone designated for coordination with one or more fore"+"ign governments","d":"The location is of environmental importance or significant in American history, "+"architecture, or culture"},"metadata":"97.13"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B03","question":"Within what distance must an amateur station protect an FCC monitoring facility "+"from harmful interference?","answer":"A","choices":{"a":"1 mile","b":"3 miles","c":"10 miles","d":"30 miles"},"metadata":"97.13"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B04","question":"What must be done before placing an amateur station within an officially designa"+"ted wilderness area or wildlife preserve, or an area listed in the National Regi"+"ster of Historical Places?","answer":"C","choices":{"a":"A proposal must be submitted to the National Park Service","b":"A letter of intent must be filed with the National Audubon Society","c":"An Environmental Assessment must be submitted to the FCC","d":"A form FSD-15 must be submitted to the Department of the Interior"},"metadata":"97.13, 1.1305-1.1319"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B05","question":"What is the National Radio Quiet Zone?","answer":"C","choices":{"a":"An area in Puerto Rico surrounding the Arecibo Radio Telescope","b":"An area in New Mexico surrounding the White Sands Test Area","c":"An area surrounding the National Radio Astronomy Observatory","d":"An area in Florida surrounding Cape Canaveral"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B06","question":"Which of the following additional rules apply if you are installing an amateur s"+"tation antenna at a site at or near a public use airport?","answer":"A","choices":{"a":"You may have to notify the Federal Aviation Administration and register it with "+"the FCC as required by Part 17 of FCC rules","b":"No special rules apply if your antenna structure will be less than 300 feet in h"+"eight","c":"You must file an Environmental Impact Statement with the EPA before construction"+" begins","d":"You must obtain a construction permit from the airport zoning authority"},"metadata":"97.15"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B07","question":"What is the highest modulation index permitted at the highest modulation frequen"+"cy for angle modulation below 29.0 MHz?","answer":"B","choices":{"a":"0.5","b":"1.0","c":"2.0","d":"3.0"},"metadata":"97.307"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B08","question":"What limitations may the FCC place on an amateur station if its signal causes in"+"terference to domestic broadcast reception, assuming that the receivers involved"+" are of good engineering design?","answer":"D","choices":{"a":"The amateur station must cease operation","b":"The amateur station must cease operation on all frequencies below 30 MHz","c":"The amateur station must cease operation on all frequencies above 30 MHz","d":"The amateur station must avoid transmitting during certain hours on frequencies "+"that cause the interference"},"metadata":"97.121"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B09","question":"Which amateur stations may be operated under RACES rules?","answer":"C","choices":{"a":"Only those club stations licensed to Amateur Extra class operators","b":"Any FCC-licensed amateur station except a Technician class","c":"Any FCC-licensed amateur station certified by the responsible civil defense orga"+"nization for the area served","d":"Any FCC-licensed amateur station participating in the Military Auxiliary Radio S"+"ystem (MARS)"},"metadata":"97.407"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B10","question":"What frequencies are authorized to an amateur station operating under RACES rule"+"s?","answer":"A","choices":{"a":"All amateur service frequencies authorized to the control operator","b":"Specific segments in the amateur service MF, HF, VHF and UHF bands","c":"Specific local government channels","d":"Military Auxiliary Radio System (MARS) channels"},"metadata":"97.407"},{"exam":"E","section":"E1","subSection":"E1B","questionID":"E1B11","question":"What is the permitted mean power of any spurious emission relative to the mean p"+"ower of the fundamental emission from a station transmitter or external RF ampli"+"fier installed after January 1, 2003 and transmitting on a frequency below 30 MH"+"Z?","answer":"A","choices":{"a":"At least 43 dB below","b":"At least 53 dB below","c":"At least 63 dB below","d":"At least 73 dB below"},"metadata":"97.307"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C01","question":"What is a remotely controlled station?","answer":"D","choices":{"a":"A station operated away from its regular home location","b":"A station controlled by someone other than the licensee","c":"A station operating under automatic control","d":"A station controlled indirectly through a control link"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C02","question":"What is meant by automatic control of a station?","answer":"A","choices":{"a":"The use of devices and procedures for control so that the control operator does "+"not have to be present at a control point","b":"A station operating with its output power controlled automatically","c":"Remotely controlling a station�s antenna pattern through a directional control l"+"ink","d":"The use of a control link between a control point and a locally controlled stati"+"on"},"metadata":"97.3, 97.109"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C03","question":"How do the control operator responsibilities of a station under automatic contro"+"l differ from one under local control?","answer":"B","choices":{"a":"Under local control there is no control operator","b":"Under automatic control the control operator is not required to be present at th"+"e control point","c":"Under automatic control there is no control operator","d":"Under local control a control operator is not required to be present at a contro"+"l point"},"metadata":"97.3, 97.109"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C04","question":"What is meant by IARP?","answer":"A","choices":{"a":"An international amateur radio permit that allows U.S. amateurs to operate in ce"+"rtain countries of the Americas","b":"The internal amateur radio practices policy of the FCC","c":"An indication of increased antenna reflected power","d":"A forecast of intermittent aurora radio propagation"},"metadata":""},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C05","question":"When may an automatically controlled station originate third party communication"+"s?","answer":"A","choices":{"a":"Never","b":"Only when transmitting RTTY or data emissions","c":"When agreed upon by the sending or receiving station","d":"When approved by the National Telecommunication and Information Administration"},"metadata":"97.221(c)(1),[97.115(c)"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C06","question":"Which of the following statements concerning remotely controlled amateur station"+"s is true?","answer":"C","choices":{"a":"Only Extra Class operators may be the control operator of a remote station","b":"A control operator need not be present at the control point","c":"A control operator must be present at the control point","d":"Repeater and auxiliary stations may not be remotely controlled"},"metadata":"97.109"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C07","question":"What is meant by local control?","answer":"C","choices":{"a":"Controlling a station through a local auxiliary link","b":"Automatically manipulating local station controls","c":"Direct manipulation of the transmitter by a control operator","d":"Controlling a repeater using a portable handheld transceiver"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C08","question":"What is the maximum permissible duration of a remotely controlled station�s tran"+"smissions if its control link malfunctions?","answer":"B","choices":{"a":"30 seconds","b":"3 minutes","c":"5 minutes","d":"10 minutes"},"metadata":"97.213"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C09","question":"Which of these ranges of frequencies is available for an automatically controlle"+"d repeater operating below 30 MHz?","answer":"D","choices":{"a":"18.110 MHz - 18.168 MHz","b":"24.940 MHz - 24.990 MHz","c":"10.100 MHz - 10.150 MHz","d":"29.500 MHz - 29.700 MHz"},"metadata":"97.205"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C10","question":"What types of amateur stations may automatically retransmit the radio signals of"+" other amateur stations?","answer":"B","choices":{"a":"Only beacon, repeater or space stations","b":"Only auxiliary, repeater or space stations","c":"Only earth stations, repeater stations or model craft","d":"Only auxiliary, beacon or space stations"},"metadata":"97.113"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C11","question":"Which of the following operating arrangements allows an FCC-licensed U.S. citize"+"n to operate in many European countries, and alien amateurs from many European c"+"ountries to operate in the U.S.?","answer":"A","choices":{"a":"CEPT agreement","b":"IARP agreement","c":"ITU reciprocal license","d":"All of these choices are correct"},"metadata":"97.5"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C12","question":"What types of communications may be transmitted to amateur stations in foreign c"+"ountries?","answer":"C","choices":{"a":"Business-related messages for non-profit organizations","b":"Messages intended for connection to users of the maritime satellite service","c":"Communications incidental to the purpose of the amateur service and remarks of a"+" personal nature","d":"All of these choices are correct"},"metadata":"97.117"},{"exam":"E","section":"E1","subSection":"E1C","questionID":"E1C13","question":"Which of the following is required in order to operate in accordance with CEPT r"+"ules in foreign countries where permitted?","answer":"C","choices":{"a":"You must identify in the official language of the country in which you are opera"+"ting","b":"The U.S. embassy must approve of your operation","c":"You must bring a copy of FCC Public Notice DA 11-221","d":"You must append \"/CEPT\" to your call sign"},"metadata":""},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D01","question":"What is the definition of the term telemetry?","answer":"A","choices":{"a":"One-way transmission of measurements at a distance from the measuring instrument","b":"Two-way radiotelephone transmissions in excess of 1000 feet","c":"Two-way single channel transmissions of data","d":"One-way transmission that initiates, modifies, or terminates the functions of a "+"device at a distance"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D02","question":"What is the amateur satellite service?","answer":"C","choices":{"a":"A radio navigation service using satellites for the purpose of self training, in"+"tercommunication and technical studies carried out by amateurs","b":"A spacecraft launching service for amateur-built satellites","c":"A radio communications service using amateur radio stations on satellites","d":"A radio communications service using stations on Earth satellites for public ser"+"vice broadcast"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D03","question":"What is a telecommand station in the amateur satellite service?","answer":"B","choices":{"a":"An amateur station located on the Earth�s surface for communication with other E"+"arth stations by means of Earth satellites","b":"An amateur station that transmits communications to initiate, modify or terminat"+"e functions of a space station","c":"An amateur station located more than 50 km above the Earth�s surface","d":"An amateur station that transmits telemetry consisting of measurements of upper "+"atmosphere"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D04","question":"What is an Earth station in the amateur satellite service?","answer":"A","choices":{"a":"An amateur station within 50 km of the Earth's surface intended for communicatio"+"ns with amateur stations by means of objects in space","b":"An amateur station that is not able to communicate using amateur satellites","c":"An amateur station that transmits telemetry consisting of measurement of upper a"+"tmosphere","d":"Any amateur station on the surface of the Earth"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D05","question":"What class of licensee is authorized to be the control operator of a space stati"+"on?","answer":"C","choices":{"a":"All except Technician Class","b":"Only General, Advanced or Amateur Extra Class","c":"Any class with appropriate operator privileges","d":"Only Amateur Extra Class"},"metadata":"97.207"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D06","question":"Which of the following is a requirement of a space station?","answer":"A","choices":{"a":"The space station must be capable of terminating transmissions by telecommand wh"+"en directed by the FCC","b":"The space station must cease all transmissions after 5 years","c":"The space station must be capable of changing its orbit whenever such a change i"+"s ordered by NASA","d":"All of these choices are correct"},"metadata":"97.207"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D07","question":"Which amateur service HF bands have frequencies authorized for space stations?","answer":"A","choices":{"a":"Only the 40 m, 20 m, 17 m, 15 m, 12 m and 10 m bands","b":"Only the 40 m, 20 m, 17 m, 15 m and 10 m bands","c":"Only the 40 m, 30 m, 20 m, 15 m, 12 m and 10 m bands","d":"All HF bands"},"metadata":"97.207"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D08","question":"Which VHF amateur service bands have frequencies available for space stations?","answer":"D","choices":{"a":"6 meters and 2 meters","b":"6 meters, 2 meters, and 1.25 meters","c":"2 meters and 1.25 meters","d":"2 meters"},"metadata":"97.207"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D09","question":"Which UHF amateur service bands have frequencies available for a space station?","answer":"B","choices":{"a":"70 cm only","b":"70 cm and 13 cm","c":"70 cm and 33 cm","d":"33 cm and 13 cm"},"metadata":"97.207"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D10","question":"Which amateur stations are eligible to be telecommand stations?","answer":"B","choices":{"a":"Any amateur station designated by NASA","b":"Any amateur station so designated by the space station licensee, subject to the "+"privileges of the class of operator license held by the control operator","c":"Any amateur station so designated by the ITU","d":"All of these choices are correct"},"metadata":"97.211"},{"exam":"E","section":"E1","subSection":"E1D","questionID":"E1D11","question":"Which amateur stations are eligible to operate as Earth stations?","answer":"D","choices":{"a":"Any amateur station whose licensee has filed a pre-space notification with the F"+"CC's International Bureau","b":"Only those of General, Advanced or Amateur Extra Class operators","c":"Only those of Amateur Extra Class operators","d":"Any amateur station, subject to the privileges of the class of operator license "+"held by the control operator"},"metadata":"97.209"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E01","question":"What is the minimum number of qualified VEs required to administer an Element 4 "+"amateur operator license examination?","answer":"D","choices":{"a":"5","b":"2","c":"4","d":"3"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E02","question":"Where are the questions for all written U.S. amateur license examinations listed"+"?","answer":"C","choices":{"a":"In FCC Part 97","b":"In a question pool maintained by the FCC","c":"In a question pool maintained by all the VECs","d":"In the appropriate FCC Report and Order"},"metadata":"97.523"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E03","question":"What is a Volunteer Examiner Coordinator?","answer":"C","choices":{"a":"A person who has volunteered to administer amateur operator license examinations","b":"A person who has volunteered to prepare amateur operator license examinations","c":"An organization that has entered into an agreement with the FCC to coordinate am"+"ateur operator license examinations","d":"The person who has entered into an agreement with the FCC to be the VE session m"+"anager"},"metadata":"97.521"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E04","question":"Which of the following best describes the Volunteer Examiner accreditation proce"+"ss?","answer":"D","choices":{"a":"Each General, Advanced and Amateur Extra Class operator is automatically accredi"+"ted as a VE when the license is granted","b":"The amateur operator applying must pass a VE examination administered by the FCC"+" Enforcement Bureau","c":"The prospective VE obtains accreditation from the FCC","d":"The procedure by which a VEC confirms that the VE applicant meets FCC requiremen"+"ts to serve as an examiner"},"metadata":"97.509, 97.525"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E05","question":"What is the minimum passing score on amateur operator license examinations?","answer":"B","choices":{"a":"Minimum passing score of 70%","b":"Minimum passing score of 74%","c":"Minimum passing score of 80%","d":"Minimum passing score of 77%"},"metadata":"97.503"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E06","question":"Who is responsible for the proper conduct and necessary supervision during an am"+"ateur operator license examination session?","answer":"C","choices":{"a":"The VEC coordinating the session","b":"The FCC","c":"Each administering VE","d":"The VE session manager"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E07","question":"What should a VE do if a candidate fails to comply with the examiner�s instructi"+"ons during an amateur operator license examination?","answer":"B","choices":{"a":"Warn the candidate that continued failure to comply will result in termination o"+"f the examination","b":"Immediately terminate the candidate�s examination","c":"Allow the candidate to complete the examination, but invalidate the results","d":"Immediately terminate everyone�s examination and close the session"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E08","question":"To which of the following examinees may a VE not administer an examination?","answer":"C","choices":{"a":"Employees of the VE","b":"Friends of the VE","c":"Relatives of the VE as listed in the FCC rules","d":"All of these choices are correct"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E09","question":"What may be the penalty for a VE who fraudulently administers or certifies an ex"+"amination?","answer":"A","choices":{"a":"Revocation of the VE's amateur station license grant and the suspension of the V"+"E's amateur operator license grant","b":"A fine of up to $1000 per occurrence","c":"A sentence of up to one year in prison","d":"All of these choices are correct"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E10","question":"What must the administering VEs do after the administration of a successful exam"+"ination for an amateur operator license?","answer":"C","choices":{"a":"They must collect and send the documents to the NCVEC for grading","b":"They must collect and submit the documents to the coordinating VEC for grading","c":"They must submit the application document to the coordinating VEC according to t"+"he coordinating VEC instructions","d":"They must collect and send the documents to the FCC according to instructions"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E11","question":"What must the VE team do if an examinee scores a passing grade on all examinatio"+"n elements needed for an upgrade or new license?","answer":"B","choices":{"a":"Photocopy all examination documents and forward them to the FCC for processing","b":"Three VEs must certify that the examinee is qualified for the license grant and "+"that they have complied with the administering VE requirements","c":"Issue the examinee the new or upgrade license","d":"All these choices are correct"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E12","question":"What must the VE team do with the application form if the examinee does not pass"+" the exam?","answer":"A","choices":{"a":"Return the application document to the examinee","b":"Maintain the application form with the VEC's records","c":"Send the application form to the FCC and inform the FCC of the grade","d":"Destroy the application form"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E13","question":"Which of these choices is an acceptable method for monitoring the applicants if "+"a VEC opts to conduct an exam session remotely?","answer":"B","choices":{"a":"Record the exam session on video tape for later review by the","b":"team","c":"Use a real-time video link and the Internet to connect the exam session to the o"+"bserving VEs","d":"The exam proctor observes the applicants and reports any violations"},"metadata":"97.509"},{"exam":"E","section":"E1","subSection":"E1E","questionID":"E1E14","question":"For which types of out-of-pocket expenses do the Part 97 rules state that VEs an"+"d VECs may be reimbursed?","answer":"A","choices":{"a":"Preparing, processing, administering and coordinating an examination for an amat"+"eur radio license","b":"Teaching an amateur operator license examination preparation course","c":"No expenses are authorized for reimbursement","d":"Providing amateur operator license examination preparation training materials"},"metadata":"97.527"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F01","question":"On what frequencies are spread spectrum transmissions permitted?","answer":"B","choices":{"a":"Only on amateur frequencies above 50 MHz","b":"Only on amateur frequencies above 222 MHz","c":"Only on amateur frequencies above 420 MHz","d":"Only on amateur frequencies above 144 MHz"},"metadata":"97.305"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F02","question":"What privileges are authorized in the U.S. to persons holding an amateur service"+" license granted by the Government of Canada?","answer":"C","choices":{"a":"None, they must obtain a U.S. license","b":"All privileges of the Extra Class license","c":"The operating terms and conditions of the Canadian amateur service license, not "+"to exceed U.S. Extra Class privileges","d":"Full privileges, up to and including those of the Extra Class License, on the 80"+", 40, 20, 15, and 10 meter bands"},"metadata":"97.107"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F03","question":"Under what circumstances may a dealer sell an external RF power amplifier capabl"+"e of operation below 144 MHz if it has not been granted FCC certification?","answer":"A","choices":{"a":"It was purchased in used condition from an amateur operator and is sold to anoth"+"er amateur operator for use at that operator's station","b":"The equipment dealer assembled it from a kit","c":"It was imported from a manufacturer in a country that does not require certifica"+"tion of RF power amplifiers","d":"It was imported from a manufacturer in another country and was certificated by t"+"hat country�s government"},"metadata":"97.315"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F04","question":"Which of the following geographic descriptions approximately describes \"Line A"+"\"?","answer":"A","choices":{"a":"A line roughly parallel to and south of the U.S.-Canadian border","b":"A line roughly parallel to and west of the U.S. Atlantic coastline","c":"A line roughly parallel to and north of the U.S.-Mexican border and Gulf coastli"+"ne","d":"A line roughly parallel to and east of the U.S. Pacific coastline"},"metadata":"97.3"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F05","question":"Amateur stations may not transmit in which of the following frequency segments i"+"f they are located in the contiguous 48 states and north of Line A?","answer":"D","choices":{"a":"440 MHz - 450 MHz","b":"53 MHz - 54 MHz","c":"222 MHz - 223 MHz","d":"420 MHz - 430 MHz"},"metadata":"97.303"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F06","question":"Under what circumstances might the FCC issue a Special Temporary Authority (STA)"+" to an amateur station?","answer":"A","choices":{"a":"To provide for experimental amateur communications","b":"To allow regular operation on Land Mobile channels","c":"To provide additional spectrum for personal use","d":"To provide temporary operation while awaiting normal licensing"},"metadata":"1.931"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F07","question":"When may an amateur station send a message to a business?","answer":"D","choices":{"a":"When the total money involved does not exceed $25","b":"When the control operator is employed by the FCC or another government agency","c":"When transmitting international third-party communications","d":"When neither the amateur nor his or her employer has a pecuniary interest in the"+" communications"},"metadata":"97.113"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F08","question":"Which of the following types of amateur station communications are prohibited?","answer":"A","choices":{"a":"Communications transmitted for hire or material compensation, except as otherwis"+"e provided in the rules","b":"Communications that have a political content, except as allowed by the Fairness "+"Doctrine","c":"Communications that have a religious content","d":"Communications in a language other than English"},"metadata":"97.113"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F09","question":"Which of the following conditions apply when transmitting spread spectrum emissi"+"on?","answer":"D","choices":{"a":"A station transmitting SS emission must not cause harmful interference to other "+"stations employing other authorized emissions","b":"The transmitting station must be in an area regulated by the FCC or in a country"+" that permits SS emissions","c":"The transmission must not be used to obscure the meaning of any communication","d":"All of these choices are correct"},"metadata":"97.311"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F10","question":"What is the maximum permitted transmitter peak envelope power for an amateur sta"+"tion transmitting spread spectrum communications?","answer":"C","choices":{"a":"1 W","b":"1.5 W","c":"10 W","d":"1.5 kW"},"metadata":"97.313"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F11","question":"Which of the following best describes one of the standards that must be met by a"+"n external RF power amplifier if it is to qualify for a grant of FCC certificati"+"on?","answer":"D","choices":{"a":"It must produce full legal output when driven by not more than 5 watts of mean R"+"F input power","b":"It must be capable of external RF switching between its input and output network"+"s","c":"It must exhibit a gain of 0 dB or less over its full output range","d":"It must satisfy the FCC's spurious emission standards when operated at the lesse"+"r of 1500 watts or its full output power"},"metadata":"97.317"},{"exam":"E","section":"E1","subSection":"E1F","questionID":"E1F12","question":"Who may be the control operator of an auxiliary station?","answer":"B","choices":{"a":"Any licensed amateur operator","b":"Only Technician, General, Advanced or Amateur Extra Class operators","c":"Only General, Advanced or Amateur Extra Class operators","d":"Only Amateur Extra Class operators"},"metadata":"97.201"},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A01","question":"What is the direction of an ascending pass for an amateur satellite?","answer":"C","choices":{"a":"From west to east","b":"From east to west","c":"From south to north","d":"From north to south"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A02","question":"What is the direction of a descending pass for an amateur satellite?","answer":"A","choices":{"a":"From north to south","b":"From west to east","c":"From east to west","d":"From south to north"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A03","question":"What is the orbital period of an Earth satellite?","answer":"C","choices":{"a":"The point of maximum height of a satellite's orbit","b":"The point of minimum height of a satellite's orbit","c":"The time it takes for a satellite to complete one revolution around the Earth","d":"The time it takes for a satellite to travel from perigee to apogee"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A04","question":"What is meant by the term mode as applied to an amateur radio satellite?","answer":"B","choices":{"a":"The type of signals that can be relayed through the satellite","b":"The satellite's uplink and downlink frequency bands","c":"The satellite's orientation with respect to the Earth","d":"Whether the satellite is in a polar or equatorial orbit"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A05","question":"What do the letters in a satellite's mode designator specify?","answer":"D","choices":{"a":"Power limits for uplink and downlink transmissions","b":"The location of the ground control station","c":"The polarization of uplink and downlink signals","d":"The uplink and downlink frequency ranges"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A06","question":"On what band would a satellite receive signals if it were operating in mode U/V?","answer":"A","choices":{"a":"435 MHz - 438 MHz","b":"144 MHz - 146 MHz","c":"50.0 MHz - 50.2 MHz","d":"29.5 MHz - 29.7 MHz"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A07","question":"Which of the following types of signals can be relayed through a linear transpon"+"der?","answer":"D","choices":{"a":"FM and CW","b":"SSB and SSTV","c":"PSK and Packet","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A08","question":"Why should effective radiated power to a satellite which uses a linear transpond"+"er be limited?","answer":"B","choices":{"a":"To prevent creating errors in the satellite telemetry","b":"To avoid reducing the downlink power to all other users","c":"To prevent the satellite from emitting out-of-band signals","d":"To avoid interfering with terrestrial QSOs"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A09","question":"What do the terms L band and S band specify with regard to satellite communicati"+"ons?","answer":"A","choices":{"a":"The 23 centimeter and 13 centimeter bands","b":"The 2 meter and 70 centimeter bands","c":"FM and Digital Store-and-Forward systems","d":"Which sideband to use"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A10","question":"Why may the received signal from an amateur satellite exhibit a rapidly repeatin"+"g fading effect?","answer":"A","choices":{"a":"Because the satellite is spinning","b":"Because of ionospheric absorption","c":"Because of the satellite's low orbital altitude","d":"Because of the Doppler Effect"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A11","question":"What type of antenna can be used to minimize the effects of spin modulation and "+"Faraday rotation?","answer":"B","choices":{"a":"A linearly polarized antenna","b":"A circularly polarized antenna","c":"An isotropic antenna","d":"A log-periodic dipole array"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A12","question":"What is one way to predict the location of a satellite at a given time?","answer":"D","choices":{"a":"By means of the Doppler data for the specified satellite","b":"By subtracting the mean anomaly from the orbital inclination","c":"By adding the mean anomaly to the orbital inclination","d":"By calculations using the Keplerian elements for the specified satellite"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A13","question":"What type of satellite appears to stay in one position in the sky?","answer":"B","choices":{"a":"HEO","b":"Geostationary","c":"Geomagnetic","d":"LEO"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2A","questionID":"E2A14","question":"What technology is used to track, in real time, balloons carrying amateur radio "+"transmitters?","answer":"C","choices":{"a":"Radar","b":"Bandwidth compressed LORAN","c":"APRS","d":"Doppler shift of beacon signals"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B01","question":"How many times per second is a new frame transmitted in a fast-scan (NTSC) telev"+"ision system?","answer":"A","choices":{"a":"30","b":"60","c":"90","d":"120"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B02","question":"How many horizontal lines make up a fast-scan (NTSC) television frame?","answer":"C","choices":{"a":"30","b":"60","c":"525","d":"1080"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B03","question":"How is an interlaced scanning pattern generated in a fast-scan (NTSC) television"+" system?","answer":")","choices":{"a":"By scanning two fields simultaneously","b":"By scanning each field from bottom to top","c":"By scanning lines from left to right in one field and right to left in the next","d":"By scanning odd numbered lines in one field and even numbered lines in the next"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B04","question":"What is blanking in a video signal?","answer":"B","choices":{"a":"Synchronization of the horizontal and vertical sync pulses","b":"Turning off the scanning beam while it is traveling from right to left or from b"+"ottom to top","c":"Turning off the scanning beam at the conclusion of a transmission","d":"Transmitting a black and white test pattern"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B05","question":"Which of the following is an advantage of using vestigial sideband for standard "+"fast- scan TV transmissions?","answer":"C","choices":{"a":"The vestigial sideband carries the audio information","b":"The vestigial sideband contains chroma information","c":"Vestigial sideband reduces bandwidth while allowing for simple video detector ci"+"rcuitry","d":"Vestigial sideband provides high frequency emphasis to sharpen the picture"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B06","question":"What is vestigial sideband modulation?","answer":"A","choices":{"a":"Amplitude modulation in which one complete sideband and a portion of the other a"+"re transmitted","b":"A type of modulation in which one sideband is inverted","c":"Narrow-band FM modulation achieved by filtering one sideband from the audio befo"+"re frequency modulating the carrier","d":"Spread spectrum modulation achieved by applying FM modulation following single s"+"ideband amplitude modulation"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B07","question":"What is the name of the signal component that carries color information in NTSC "+"video?","answer":"B","choices":{"a":"Luminance","b":"Chroma","c":"Hue","d":"Spectral Intensity"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B08","question":"Which of the following is a common method of transmitting accompanying audio wit"+"h amateur fast-scan television?","answer":"D","choices":{"a":"Frequency-modulated sub-carrier","b":"A separate VHF or UHF audio link","c":"Frequency modulation of the video carrier","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B09","question":"What hardware, other than a receiver with SSB capability and a suitable computer"+", is needed to decode SSTV using Digital Radio Mondiale (DRM)?","answer":"D","choices":{"a":"A special IF converter","b":"A special front end limiter","c":"A special notch filter to remove synchronization pulses","d":"No other hardware is needed"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B10","question":"Which of the following is an acceptable bandwidth for Digital Radio Mondiale (DR"+"M) based voice or SSTV digital transmissions made on the HF amateur bands?","answer":"A","choices":{"a":"3 KHz","b":"10 KHz","c":"15 KHz","d":"20 KHz"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B11","question":"What is the function of the Vertical Interval Signaling (VIS) code sent as part "+"of an SSTV transmission?","answer":"B","choices":{"a":"To lock the color burst oscillator in color SSTV images","b":"To identify the SSTV mode being used","c":"To provide vertical synchronization","d":"To identify the call sign of the station transmitting"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B12","question":"How are analog SSTV images typically transmitted on the HF bands?","answer":"D","choices":{"a":"Video is converted to equivalent Baudot representation","b":"Video is converted to equivalent ASCII representation","c":"Varying tone frequencies representing the video are transmitted using PSK","d":"Varying tone frequencies representing the video are transmitted using single sid"+"eband"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B13","question":"How many lines are commonly used in each frame of an amateur slow-scan color tel"+"evision picture?","answer":"C","choices":{"a":"30 or 60","b":"60 or 100","c":"128 or 256","d":"180 or 360"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B14","question":"What aspect of an amateur slow-scan television signal encodes the brightness of "+"the picture?","answer":"A","choices":{"a":"Tone frequency","b":"Tone amplitude","c":"Sync amplitude","d":"Sync frequency"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B15","question":"What signals SSTV receiving equipment to begin a new picture line?","answer":"A","choices":{"a":"Specific tone frequencies","b":"Elapsed time","c":"Specific tone amplitudes","d":"A two-tone signal"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B16","question":"Which is a video standard used by North American Fast Scan ATV stations?","answer":"D","choices":{"a":"PAL","b":"DRM","c":"Scottie","d":"NTSC"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B17","question":"What is the approximate bandwidth of a slow-scan TV signal?","answer":"B","choices":{"a":"600 Hz","b":"3 kHz","c":"2 MHz","d":"6 MHz"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B18","question":"On which of the following frequencies is one likely to find FM ATV transmissions"+"?","answer":"D","choices":{"a":"14.230 MHz","b":"29.6 MHz","c":"52.525 MHz","d":"1255 MHz"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2B","questionID":"E2B19","question":"What special operating frequency restrictions are imposed on slow scan TV transm"+"issions?","answer":"C","choices":{"a":"None; they are allowed on all amateur frequencies","b":"They are restricted to 7.245 MHz, 14.245 MHz, 21.345 MHz, and 28.945 MHz","c":"They are restricted to phone band segments and their bandwidth can be no greater"+" than that of a voice signal of the same modulation type","d":"They are not permitted above 54 MHz"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C01","question":"Which of the following is true about contest operating?","answer":"A","choices":{"a":"Operators are permitted to make contacts even if they do not submit a log","b":"Interference to other amateurs is unavoidable and therefore acceptable","c":"It is mandatory to transmit the call sign of the station being worked as part of"+" every transmission to that station","d":"Every contest requires a signal report in the exchange"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C02","question":"Which of the following best describes the term self-spotting in regards to HF co"+"ntest operating?","answer":"A","choices":{"a":"The generally prohibited practice of posting one�s own call sign and frequency o"+"n a spotting network","b":"The acceptable practice of manually posting the call signs of stations on a spot"+"ting network","c":"A manual technique for rapidly zero beating or tuning to a station�s frequency b"+"efore calling that station","d":"An automatic method for rapidly zero beating or tuning to a station�s frequency "+"before calling that station"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C03","question":"From which of the following bands is amateur radio contesting generally excluded"+"?","answer":"A","choices":{"a":"30 m","b":"6 m","c":"2 m","d":"33 cm"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C04","question":"What type of transmission is most often used for a ham radio mesh network?","answer":"A","choices":{"a":"Spread spectrum in the 2.4 GHz band","b":"Multiple Frequency Shift Keying in the 10 GHz band","c":"Store and forward on the 440 MHz band","d":"Frequency division multiplex in the 24 GHz band"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C05","question":"What is the function of a DX QSL Manager?","answer":"B","choices":{"a":"To allocate frequencies for DXpeditions","b":"To handle the receiving and sending of confirmation cards for a DX station","c":"To run a net to allow many stations to contact a rare DX station","d":"To relay calls to and from a DX station"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C06","question":"During a VHF/UHF contest, in which band segment would you expect to find the hig"+"hest level of activity?","answer":"C","choices":{"a":"At the top of each band, usually in a segment reserved for contests","b":"In the middle of each band, usually on the national calling frequency","c":"In the weak signal segment of the band, with most of the activity near the calli"+"ng frequency","d":"In the middle of the band, usually 25 kHz above the national calling frequency"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C07","question":"What is the Cabrillo format?","answer":"A","choices":{"a":"A standard for submission of electronic contest logs","b":"A method of exchanging information during a contest QSO","c":"The most common set of contest rules","d":"The rules of order for meetings between contest sponsors"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C08","question":"Which of the following contacts may be confirmed through the U.S. QSL bureau sys"+"tem?","answer":"B","choices":{"a":"Special event contacts between stations in the U.S.","b":"Contacts between a U.S. station and a non-U.S. station","c":"Repeater contacts between U.S. club members","d":"Contacts using tactical call signs"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C09","question":"What type of equipment is commonly used to implement a ham radio mesh network?","answer":"C","choices":{"a":"A 2 meter VHF transceiver with a 1200 baud modem","b":"An optical cable connection between the USB ports of 2 separate computers","c":"A standard wireless router running custom software","d":"A 440 MHz transceiver with a 9600 baud modem"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C10","question":"Why might a DX station state that they are listening on another frequency?","answer":"D","choices":{"a":"Because the DX station may be transmitting on a frequency that is prohibited to "+"some responding stations","b":"To separate the calling stations from the DX station","c":"To improve operating efficiency by reducing interference","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C11","question":"How should you generally identify your station when attempting to contact a DX s"+"tation during a contest or in a pileup?","answer":"A","choices":{"a":"Send your full call sign once or twice","b":"Send only the last two letters of your call sign until you make contact","c":"Send your full call sign and grid square","d":"Send the call sign of the DX station three times, the words \"this is\", then yo"+"ur call sign three times"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C12","question":"What might help to restore contact when DX signals become too weak to copy acros"+"s an entire HF band a few hours after sunset?","answer":"B","choices":{"a":"Switch to a higher frequency HF band","b":"Switch to a lower frequency HF band","c":"Wait 90 minutes or so for the signal degradation to pass","d":"Wait 24 hours before attempting another communication on the band"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2C","questionID":"E2C13","question":"What indicator is required to be used by U.S.-licensed operators when operating "+"a station via remote control where the transmitter is located in the U.S.?","answer":"D","choices":{"a":"/ followed by the USPS two letter abbreviation for the state in which the remote"+" station is located","b":"/R# where # is the district of the remote station","c":"The ARRL section of the remote station","d":"No additional indicator is required"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D01","question":"Which of the following digital modes is especially designed for use for meteor s"+"catter signals?","answer":"B","choices":{"a":"WSPR","b":"FSK441","c":"Hellschreiber","d":"APRS"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D02","question":"Which of the following is a good technique for making meteor scatter contacts?","answer":"D","choices":{"a":"15 second timed transmission sequences with stations alternating based on locati"+"on","b":"Use of high speed CW or digital modes","c":"Short transmission with rapidly repeated call signs and signal reports","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D03","question":"Which of the following digital modes is especially useful for EME communications"+"?","answer":"D","choices":{"a":"FSK441","b":"PACTOR III","c":"Olivia","d":"JT65"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D04","question":"What is the purpose of digital store-and-forward functions on an Amateur Radio s"+"atellite?","answer":"C","choices":{"a":"To upload operational software for the transponder","b":"To delay download of telemetry between satellites","c":"To store digital messages in the satellite for later download by other stations","d":"To relay messages between satellites"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D05","question":"Which of the following techniques is normally used by low Earth orbiting digital"+" satellites to relay messages around the world?","answer":"B","choices":{"a":"Digipeating","b":"Store-and-forward","c":"Multi-satellite relaying","d":"Node hopping"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D06","question":"Which of the following describes a method of establishing EME contacts?","answer":"A","choices":{"a":"Time synchronous transmissions alternately from each station","b":"Storing and forwarding digital messages","c":"Judging optimum transmission times by monitoring beacons reflected from the Moon","d":"High speed CW identification to avoid fading"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D07","question":"What digital protocol is used by APRS?","answer":"C","choices":{"a":"PACTOR","b":"802.11","c":"AX.25","d":"AMTOR"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D08","question":"What type of packet frame is used to transmit APRS beacon data?","answer":"A","choices":{"a":"Unnumbered Information","b":"Disconnect","c":"Acknowledgement","d":"Connect"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D09","question":"Which of these digital modes has the fastest data throughput under clear communi"+"cation conditions? ","answer":"D","choices":{"a":"AMTOR","b":"170 Hz shift, 45 baud RTTY","c":"PSK31","d":"300 baud packet"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D10","question":"How can an APRS station be used to help support a public service communications "+"activity?","answer":"C","choices":{"a":"An APRS station with an emergency medical technician can automatically transmit "+"medical data to the nearest hospital","b":"APRS stations with General Personnel Scanners can automatically relay the partic"+"ipant numbers and time as they pass the check points","c":"An APRS station with a GPS unit can automatically transmit information to show a"+" mobile station's position during the event","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D11","question":"Which of the following data are used by the APRS network to communicate your loc"+"ation?","answer":"D","choices":{"a":"Polar coordinates","b":"Time and frequency","c":"Radio direction finding spectrum analysis","d":"Latitude and longitude"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D12","question":"How does JT65 improve EME communications?","answer":"A","choices":{"a":"It can decode signals many dB below the noise floor using FEC","b":"It controls the receiver to track Doppler shift","c":"It supplies signals to guide the antenna to track the Moon","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D13","question":"What type of modulation is used for JT65 contacts?","answer":"A","choices":{"a":"Multi-tone AFSK","b":"PSK","c":"RTTY","d":"IEEE 802.11"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2D","questionID":"E2D14","question":"What is one advantage of using JT65 coding?","answer":"B","choices":{"a":"Uses only a 65 Hz bandwidth","b":"The ability to decode signals which have a very low signal to noise ratio","c":"Easily copied by ear if necessary","d":"Permits fast-scan TV transmissions over narrow bandwidth"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E01","question":"Which type of modulation is common for data emissions below 30 MHz?","answer":"B","choices":{"a":"DTMF tones modulating an FM signal","b":"FSK","c":"Pulse modulation","d":"Spread spectrum"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E02","question":"What do the letters FEC mean as they relate to digital operation?","answer":"A","choices":{"a":"Forward Error Correction","b":"First Error Correction","c":"Fatal Error Correction","d":"Final Error Correction"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E03","question":"How is the timing of JT65 contacts organized?","answer":"C","choices":{"a":"By exchanging ACK/NAK packets","b":"Stations take turns on alternate days","c":"Alternating transmissions at 1 minute intervals","d":"It depends on the lunar phase"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E04","question":"What is indicated when one of the ellipses in an FSK crossed-ellipse display sud"+"denly disappears?","answer":"A","choices":{"a":"Selective fading has occurred","b":"One of the signal filters is saturated","c":"The receiver has drifted 5 kHz from the desired receive frequency","d":"The mark and space signal have been inverted"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E05","question":"Which type of digital mode does not support keyboard-to-keyboard operation?","answer":"A","choices":{"a":"Winlink","b":"RTTY","c":"PSK31","d":"MFSK"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E06","question":"What is the most common data rate used for HF packet?","answer":"C","choices":{"a":"48 baud","b":"110 baud","c":"300 baud","d":"1200 baud"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E07","question":"What is the typical bandwidth of a properly modulated MFSK16 signal?","answer":"B","choices":{"a":"31 Hz","b":"316 Hz","c":"550 Hz","d":"2.16 kHz"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E08","question":"Which of the following HF digital modes can be used to transfer binary files?","answer":"B","choices":{"a":"Hellschreiber","b":"PACTOR","c":"RTTY","d":"AMTOR"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E09","question":"Which of the following HF digital modes uses variable-length coding for bandwidt"+"h efficiency?","answer":"D","choices":{"a":"RTTY","b":"PACTOR","c":"MT63","d":"PSK31"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E10","question":"Which of these digital modes has the narrowest bandwidth?","answer":"C","choices":{"a":"MFSK16","b":"170 Hz shift, 45 baud RTTY","c":"PSK31","d":"300-baud packet"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E11","question":"What is the difference between direct FSK and audio FSK?","answer":"A","choices":{"a":"Direct FSK applies the data signal to the transmitter VFO","b":"Audio FSK has a superior frequency response","c":"Direct FSK uses a DC-coupled data connection","d":"Audio FSK can be performed anywhere in the transmit chain"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E12","question":"Which type of control is used by stations using the Automatic Link Enable (ALE) "+"protocol?","answer":"C","choices":{"a":"Local","b":"Remote","c":"Automatic","d":"ALE can use any type of control"},"metadata":""},{"exam":"E","section":"E2","subSection":"E2E","questionID":"E2E13","question":"Which of the following is a possible reason that attempts to initiate contact wi"+"th a digital station on a clear frequency are unsuccessful?","answer":"D","choices":{"a":"Your transmit frequency is incorrect","b":"The protocol version you are using is not the supported by the digital station","c":"Another station you are unable to hear is using the frequency","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A01","question":"What is the approximate maximum separation measured along the surface of the Ear"+"th between two stations communicating by Moon bounce?","answer":"D","choices":{"a":"500 miles, if the Moon is at perigee","b":"2000 miles, if the Moon is at apogee","c":"5000 miles, if the Moon is at perigee","d":"12,000 miles, if the Moon is visible by both stations"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A02","question":"What characterizes libration fading of an EME signal?","answer":"B","choices":{"a":"A slow change in the pitch of the CW signal","b":"A fluttery irregular fading","c":"A gradual loss of signal as the Sun rises","d":"The returning echo is several Hertz lower in frequency than the transmitted sign"+"al"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A03","question":"When scheduling EME contacts, which of these conditions will generally result in"+" the least path loss?","answer":"A","choices":{"a":"When the Moon is at perigee","b":"When the Moon is full","c":"When the Moon is at apogee","d":"When the MUF is above 30 MHz"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A04","question":"What do Hepburn maps predict?","answer":"D","choices":{"a":"Sporadic E propagation","b":"Locations of auroral reflecting zones","c":"Likelihood of rain-scatter along cold or warm fronts","d":"Probability of tropospheric propagation"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A05","question":"Tropospheric propagation of microwave signals often occurs along what weather re"+"lated structure?","answer":"C","choices":{"a":"Gray-line","b":"Lightning discharges","c":"Warm and cold fronts","d":"Sprites and jets"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A06","question":"Which of the following is required for microwave propagation via rain scatter?","answer":"C","choices":{"a":"Rain droplets must be electrically charged","b":"Rain droplets must be within the E layer","c":"The rain must be within radio range of both stations","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A07","question":"Atmospheric ducts capable of propagating microwave signals often form over what "+"geographic feature?","answer":"C","choices":{"a":"Mountain ranges","b":"Forests","c":"Bodies of water","d":"Urban areas"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A08","question":"When a meteor strikes the Earth's atmosphere, a cylindrical region of free elect"+"rons is formed at what layer of the ionosphere?","answer":"A","choices":{"a":"The E layer","b":"The F1 layer","c":"The F2 layer","d":"The D layer"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A09","question":"Which of the following frequency range is most suited for meteor scatter communi"+"cations?","answer":"C","choices":{"a":"1.8 MHz - 1.9 MHz","b":"10 MHz - 14 MHz","c":"28 MHz - 148 MHz","d":"220 MHz - 450 MHz"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A10","question":"Which type of atmospheric structure can create a path for microwave propagation?","answer":"B","choices":{"a":"The jet stream","b":"Temperature inversion","c":"Wind shear","d":"Dust devil"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A11","question":"What is a typical range for tropospheric propagation of microwave signals?","answer":"B","choices":{"a":"10 miles to 50 miles","b":"100 miles to 300 miles","c":"1200 miles","d":"2500 miles"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A12","question":"What is the cause of auroral activity?","answer":"C","choices":{"a":"The interaction in the F2 layer between the solar wind and the Van Allen belt","b":"A low sunspot level combined with tropospheric ducting","c":"The interaction in the E layer of charged particles from the Sun with the Earth�"+"s magnetic field","d":"Meteor showers concentrated in the extreme northern and southern latitudes"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A13","question":"Which emission mode is best for aurora propagation?","answer":"A","choices":{"a":"CW","b":"SSB","c":"FM","d":"RTTY"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A14","question":"From the contiguous 48 states, in which approximate direction should an antenna "+"be pointed to take maximum advantage of aurora propagation?","answer":"B","choices":{"a":"South","b":"North","c":"East","d":"West"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A15","question":"What is an electromagnetic wave?","answer":"C","choices":{"a":"A wave of alternating current, in the core of an electromagnet","b":"A wave consisting of two electric fields at parallel right angles to each other","c":"A wave consisting of an electric field and a magnetic field oscillating at right"+" angles to each other","d":"A wave consisting of two magnetic fields at right angles to each other"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A16","question":"Which of the following best describes electromagnetic waves traveling in free sp"+"ace?","answer":"D","choices":{"a":"Electric and magnetic fields become aligned as they travel","b":"The energy propagates through a medium with a high refractive index","c":"The waves are reflected by the ionosphere and return to their source","d":"Changing electric and magnetic fields propagate the energy"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3A","questionID":"E3A17","question":"What is meant by circularly polarized electromagnetic waves?","answer":"B","choices":{"a":"Waves with an electric field bent into a circular shape","b":"Waves with a rotating electric field","c":"Waves that circle the Earth","d":"Waves produced by a loop antenna"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B01","question":"What is transequatorial propagation?","answer":"A","choices":{"a":"Propagation between two mid-latitude points at approximately the same distance n"+"orth and south of the magnetic equator","b":"Propagation between any two points located on the magnetic equator","c":"Propagation between two continents by way of ducts along the magnetic equator","d":"Propagation between two stations at the same latitude"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B02","question":"What is the approximate maximum range for signals using transequatorial propagat"+"ion?","answer":"C","choices":{"a":"1000 miles","b":"2500 miles","c":"5000 miles","d":"7500 miles"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B03","question":"What is the best time of day for transequatorial propagation?","answer":"C","choices":{"a":"Morning","b":"Noon","c":"Afternoon or early evening","d":"Late at night"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B04","question":"What is meant by the terms extraordinary and ordinary waves?","answer":"B","choices":{"a":"Extraordinary waves describe rare long skip propagation compared to ordinary wav"+"es which travel shorter distances","b":"Independent waves created in the ionosphere that are elliptically polarized","c":"Long path and short path waves","d":"Refracted rays and reflected waves"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B05","question":"Which amateur bands typically support long-path propagation?","answer":"C","choices":{"a":"160 meters to 40 meters","b":"30 meters to 10 meters","c":"160 meters to 10 meters","d":"6 meters to 2 meters"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B06","question":"Which of the following amateur bands most frequently provides long-path propagat"+"ion?","answer":"B","choices":{"a":"80 meters","b":"20 meters","c":"10 meters","d":"6 meters"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B07","question":"Which of the following could account for hearing an echo on the received signal "+"of a distant station?","answer":"D","choices":{"a":"High D layer absorption","b":"Meteor scatter","c":"Transmit frequency is higher than the MUF","d":"Receipt of a signal by more than one path"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B08","question":"What type of HF propagation is probably occurring if radio signals travel along "+"the terminator between daylight and darkness?","answer":"D","choices":{"a":"Transequatorial","b":"Sporadic-E","c":"Long-path","d":"Gray-line"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B09","question":"At what time of year is Sporadic E propagation most likely to occur?","answer":"A","choices":{"a":"Around the solstices, especially the summer solstice","b":"Around the solstices, especially the winter solstice","c":"Around the equinoxes, especially the spring equinox","d":"Around the equinoxes, especially the fall equinox"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B10","question":"What is the cause of gray-line propagation?","answer":"B","choices":{"a":"At midday, the Sun super heats the ionosphere causing increased refraction of ra"+"dio waves","b":"At twilight and sunrise, D-layer absorption is low while E-layer and F-layer pro"+"pagation remains high","c":"In darkness, solar absorption drops greatly while atmospheric ionization remains"+" steady","d":"At mid-afternoon, the Sun heats the ionosphere decreasing radio wave refraction "+"and the MUF"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B11","question":"At what time of day is Sporadic-E propagation most likely to occur?","answer":"D","choices":{"a":"Around sunset","b":"Around sunrise","c":"Early evening","d":"Any time"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B12","question":"What is the primary characteristic of chordal hop propagation?","answer":"B","choices":{"a":"Propagation away from the great circle bearing between stations","b":"Successive ionospheric reflections without an intermediate reflection from the g"+"round","c":"Propagation across the geomagnetic equator","d":"Signals reflected back toward the transmitting station"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B13","question":"Why is chordal hop propagation desirable?","answer":"A","choices":{"a":"The signal experiences less loss along the path compared to normal skip propagat"+"ion","b":"The MUF for chordal hop propagation is much lower than for normal skip propagati"+"on","c":"Atmospheric noise is lower in the direction of chordal hop propagation","d":"Signals travel faster along ionospheric chords"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3B","questionID":"E3B14","question":"What happens to linearly polarized radio waves that split into ordinary and extr"+"aordinary waves in the ionosphere?","answer":"C","choices":{"a":"They are bent toward the magnetic poles","b":"Their polarization is randomly modified","c":"They become elliptically polarized","d":"They become phase-locked"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C01","question":"What does the term ray tracing describe in regard to radio communications?","answer":"B","choices":{"a":"The process in which an electronic display presents a pattern","b":"Modeling a radio wave's path through the ionosphere","c":"Determining the radiation pattern from an array of antennas","d":"Evaluating high voltage sources for X-Rays"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C02","question":"What is indicated by a rising A or K index?","answer":"A","choices":{"a":"Increasing disruption of the geomagnetic field","b":"Decreasing disruption of the geomagnetic field","c":"Higher levels of solar UV radiation","d":"An increase in the critical frequency"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C03","question":"Which of the following signal paths is most likely to experience high levels of "+"absorption when the A index or K index is elevated?","answer":"B","choices":{"a":"Transequatorial propagation","b":"Polar paths","c":"Sporadic-E","d":"NVIS"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C04","question":"What does the value of Bz (B sub Z) represent?","answer":"C","choices":{"a":"Geomagnetic field stability","b":"Critical frequency for vertical transmissions","c":"Direction and strength of the interplanetary magnetic field","d":"Duration of long-delayed echoes"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C05","question":"What orientation of Bz (B sub z) increases the likelihood that incoming particle"+"s from the Sun will cause disturbed conditions?","answer":"A","choices":{"a":"Southward","b":"Northward","c":"Eastward","d":"Westward"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C06","question":"By how much does the VHF/UHF radio horizon distance exceed the geometric horizon"+"?","answer":"A","choices":{"a":"By approximately 15 percent of the distance","b":"By approximately twice the distance","c":"By approximately 50 percent of the distance","d":"By approximately four times the distance"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C07","question":"Which of the following descriptors indicates the greatest solar flare intensity?","answer":"D","choices":{"a":"Class A","b":"Class B","c":"Class M","d":"Class X"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C08","question":"What does the space weather term G5 mean?","answer":"A","choices":{"a":"An extreme geomagnetic storm","b":"Very low solar activity","c":"Moderate solar wind","d":"Waning sunspot numbers"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C09","question":"How does the intensity of an X3 flare compare to that of an X2 flare?","answer":"C","choices":{"a":"10 percent greater","b":"50 percent greater","c":"Twice as great","d":"Four times as great"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C10","question":"What does the 304A solar parameter measure?","answer":"B","choices":{"a":"The ratio of X-Ray flux to radio flux, correlated to sunspot number","b":"UV emissions at 304 angstroms, correlated to solar flux index","c":"The solar wind velocity at 304 degrees from the solar equator, correlated to sol"+"ar activity","d":"The solar emission at 304 GHz, correlated to X-Ray flare levels"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C11","question":"What does VOACAP software model?","answer":"C","choices":{"a":"AC voltage and impedance","b":"VHF radio propagation","c":"HF propagation","d":"AC current and impedance"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C12","question":"How does the maximum distance of ground-wave propagation change when the signal "+"frequency is increased?","answer":"C","choices":{"a":"It stays the same","b":"It increases","c":"It decreases","d":"It peaks at roughly 14 MHz"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C13","question":"What type of polarization is best for ground-wave propagation?","answer":"A","choices":{"a":"Vertical","b":"Horizontal","c":"Circular","d":"Elliptical"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C14","question":"Why does the radio-path horizon distance exceed the geometric horizon?","answer":"D","choices":{"a":"E-region skip","b":"D-region skip","c":"Downward bending due to aurora refraction","d":"Downward bending due to density variations in the atmosphere"},"metadata":""},{"exam":"E","section":"E3","subSection":"E3C","questionID":"E3C15","question":"What might a sudden rise in radio background noise indicate?","answer":"B","choices":{"a":"A meteor ping","b":"A solar flare has occurred","c":"Increased transequatorial propagation likely","d":"Long-path propagation is occurring"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A01","question":"Which of the following parameter determines the bandwidth of a digital or comput"+"er-based oscilloscope?","answer":"C","choices":{"a":"Input capacitance","b":"Input impedance","c":"Sampling rate","d":"Sample resolution"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A02","question":"Which of the following parameters would a spectrum analyzer display on the verti"+"cal and horizontal axes?","answer":"B","choices":{"a":"RF amplitude and time","b":"RF amplitude and frequency","c":"SWR and frequency","d":"SWR and time"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A03","question":"Which of the following test instrument is used to display spurious signals and/o"+"r intermodulation distortion products in an SSB transmitter?","answer":"B","choices":{"a":"A wattmeter","b":"A spectrum analyzer","c":"A logic analyzer","d":"A time-domain reflectometer"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A04","question":"What determines the upper frequency limit for a computer soundcard-based oscillo"+"scope program?","answer":"A","choices":{"a":"Analog-to-digital conversion speed of the soundcard","b":"Amount of memory on the soundcard","c":"Q of the interface of the interface circuit","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A05","question":"What might be an advantage of a digital vs an analog oscilloscope?","answer":"D","choices":{"a":"Automatic amplitude and frequency numerical readout","b":"Storage of traces for future reference","c":"Manipulation of time base after trace capture","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A06","question":"What is the effect of aliasing in a digital or computer-based oscilloscope?","answer":"A","choices":{"a":"False signals are displayed","b":"All signals will have a DC offset","c":"Calibration of the vertical scale is no longer valid","d":"False triggering occurs"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A07","question":"Which of the following is an advantage of using an antenna analyzer compared to "+"an SWR bridge to measure antenna SWR?","answer":"B","choices":{"a":"Antenna analyzers automatically tune your antenna for resonance","b":"Antenna analyzers do not need an external RF source","c":"Antenna analyzers display a time-varying representation of the modulation envelo"+"pe","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A08","question":"Which of the following instrument would be best for measuring the SWR of a beam "+"antenna?","answer":"D","choices":{"a":"A spectrum analyzer","b":"A Q meter","c":"An ohmmeter","d":"An antenna analyzer"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A09","question":"When using a computer�s soundcard input to digitize signals, what is the highest"+" frequency signal that can be digitized without aliasing?","answer":"B","choices":{"a":"The same as the sample rate","b":"One-half the sample rate","c":"One-tenth the sample rate","d":"It depends on how the data is stored internally"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A10","question":"Which of the following displays multiple digital signal states simultaneously?","answer":"D","choices":{"a":"Network analyzer","b":"Bit error rate tester","c":"Modulation monitor","d":"Logic analyzer"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A11","question":"Which of the following is good practice when using an oscilloscope probe?","answer":"A","choices":{"a":"Keep the signal ground connection of the probe as short as possible","b":"Never use a high impedance probe to measure a low impedance circuit","c":"Never use a DC-coupled probe to measure an AC circuit","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A12","question":"Which of the following procedures is an important precaution to follow when conn"+"ecting a spectrum analyzer to a transmitter output?","answer":"B","choices":{"a":"Use high quality double shielded coaxial cables to reduce signal losses","b":"Attenuate the transmitter output going to the spectrum analyzer","c":"Match the antenna to the load","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A13","question":"How is the compensation of an oscilloscope probe typically adjusted?","answer":"A","choices":{"a":"A square wave is displayed and the probe is adjusted until the horizontal portio"+"ns of the displayed wave are as nearly flat as possible","b":"A high frequency sine wave is displayed and the probe is adjusted for maximum am"+"plitude","c":"A frequency standard is displayed and the probe is adjusted until the deflection"+" time is accurate","d":"A DC voltage standard is displayed and the probe is adjusted until the displayed"+" voltage is accurate"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A14","question":"What is the purpose of the prescaler function on a frequency counter?","answer":"D","choices":{"a":"It amplifies low level signals for more accurate counting","b":"It multiplies a higher frequency signal so a low-frequency counter can display t"+"he operating frequency","c":"It prevents oscillation in a low-frequency counter circuit","d":"It divides a higher frequency signal so a low-frequency counter can display the "+"input frequency"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4A","questionID":"E4A15","question":"What is an advantage of a period-measuring frequency counter over a direct-count"+" type?","answer":"C","choices":{"a":"It can run on battery power for remote measurements","b":"It does not require an expensive high-precision time base","c":"It provides improved resolution of low-frequency signals within a comparable tim"+"e period","d":"It can directly measure the modulation index of an FM transmitter"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B01","question":"Which of the following factors most affects the accuracy of a frequency counter?","answer":"B","choices":{"a":"Input attenuator accuracy","b":"Time base accuracy","c":"Decade divider accuracy","d":"Temperature coefficient of the logic"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B02","question":"What is an advantage of using a bridge circuit to measure impedance?","answer":"C","choices":{"a":"It provides an excellent match under all conditions","b":"It is relatively immune to drift in the signal generator source","c":"It is very precise in obtaining a signal null","d":"It can display results directly in Smith chart format"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B03","question":"If a frequency counter with a specified accuracy of +/- 1.0 ppm reads 146,520,00"+"0 Hz, what is the most the actual frequency being measured could differ from the"+" reading?","answer":"C","choices":{"a":"165.2 Hz","b":"14.652 kHz","c":"146.52 Hz","d":"1.4652 MHz"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B04","question":"If a frequency counter with a specified accuracy of +/- 0.1 ppm reads 146,520,00"+"0 Hz, what is the most the actual frequency being measured could differ from the"+" reading?","answer":"A","choices":{"a":"14.652 Hz","b":"0.1 MHz","c":"1.4652 Hz","d":"1.4652 kHz"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B05","question":"If a frequency counter with a specified accuracy of +/- 10 ppm reads 146,520,000"+" Hz, what is the most the actual frequency being measured could differ from the "+"reading?","answer":"D","choices":{"a":"146.52 Hz","b":"10 Hz","c":"146.52 kHz","d":"1465.20 Hz"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B06","question":"How much power is being absorbed by the load when a directional power meter conn"+"ected between a transmitter and a terminating load reads 100 watts forward power"+" and 25 watts reflected power?","answer":"D","choices":{"a":"100 watts","b":"125 watts","c":"25 watts","d":"75 watts"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B07","question":"What do the subscripts of S parameters represent?","answer":"A","choices":{"a":"The port or ports at which measurements are made","b":"The relative time between measurements","c":"Relative quality of the data","d":"Frequency order of the measurements"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B08","question":"Which of the following is a characteristic of a good DC voltmeter?","answer":"C","choices":{"a":"High reluctance input","b":"Low reluctance input","c":"High impedance input","d":"Low impedance input"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B09","question":"What is indicated if the current reading on an RF ammeter placed in series with "+"the antenna feed line of a transmitter increases as the transmitter is tuned to "+"resonance?","answer":"D","choices":{"a":"There is possibly a short to ground in the feed line","b":"The transmitter is not properly neutralized","c":"There is an impedance mismatch between the antenna and feed line","d":"There is more power going into the antenna"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B10","question":"Which of the following describes a method to measure intermodulation distortion "+"in an SSB transmitter?","answer":"B","choices":{"a":"Modulate the transmitter with two non-harmonically related radio frequencies and"+" observe the RF output with a spectrum analyzer","b":"Modulate the transmitter with two non-harmonically related audio frequencies and"+" observe the RF output with a spectrum analyzer","c":"Modulate the transmitter with two harmonically related audio frequencies and obs"+"erve the RF output with a peak reading wattmeter","d":"Modulate the transmitter with two harmonically related audio frequencies and obs"+"erve the RF output with a logic analyzer"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B11","question":"How should an antenna analyzer be connected when measuring antenna resonance and"+" feed point impedance?","answer":"D","choices":{"a":"Loosely couple the analyzer near the antenna base","b":"Connect the analyzer via a high-impedance transformer to the antenna","c":"Loosely couple the antenna and a dummy load to the analyzer","d":"Connect the antenna feed line directly to the analyzer's connector"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B12","question":"What is the significance of voltmeter sensitivity expressed in ohms per volt?","answer":"A","choices":{"a":"The full scale reading of the voltmeter multiplied by its ohms per volt rating w"+"ill indicate the input impedance of the voltmeter","b":"When used as a galvanometer, the reading in volts multiplied by the ohms per vol"+"t rating will determine the power drawn by the device under test","c":"When used as an ohmmeter, the reading in ohms divided by the ohms per volt ratin"+"g will determine the voltage applied to the circuit","d":"When used as an ammeter, the full scale reading in amps divided by ohms per volt"+" rating will determine the size of shunt needed"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B13","question":"Which S parameter is equivalent to forward gain?","answer":"C","choices":{"a":"S11","b":"S12","c":"S21","d":"S22"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B14","question":"What happens if a dip meter is too tightly coupled to a tuned circuit being chec"+"ked?","answer":"B","choices":{"a":"Harmonics are generated","b":"A less accurate reading results","c":"Cross modulation occurs","d":"Intermodulation distortion occurs"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B15","question":"Which of the following can be used as a relative measurement of the Q for a seri"+"es-tuned circuit?","answer":"C","choices":{"a":"The inductance to capacitance ratio","b":"The frequency shift","c":"The bandwidth of the circuit's frequency response","d":"The resonant frequency of the circuit"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B16","question":"Which S parameter represents return loss or SWR?","answer":"A","choices":{"a":"S11","b":"S12","c":"S21","d":"S22"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4B","questionID":"E4B17","question":"What three test loads are used to calibrate a standard RF vector network analyze"+"r?","answer":"B","choices":{"a":"50 ohms, 75 ohms, and 90 ohms","b":"Short circuit, open circuit, and 50 ohms","c":"Short circuit, open circuit, and resonant circuit","d":"50 ohms through 1/8 wavelength, 1/4 wavelength, and 1/2 wavelength of coaxial ca"+"ble"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C01","question":"What is an effect of excessive phase noise in the local oscillator section of a "+"receiver?","answer":"D","choices":{"a":"It limits the receiver�s ability to receive strong signals","b":"It reduces receiver sensitivity","c":"It decreases receiver third-order intermodulation distortion dynamic range","d":"It can cause strong signals on nearby frequencies to interfere with reception of"+" weak signals"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C02","question":"Which of the following portions of a receiver can be effective in eliminating im"+"age signal interference?","answer":"A","choices":{"a":"A front-end filter or pre-selector","b":"A narrow IF filter","c":"A notch filter","d":"A properly adjusted product detector"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C03","question":"What is the term for the blocking of one FM phone signal by another, stronger FM"+" phone signal?","answer":"C","choices":{"a":"Desensitization","b":"Cross-modulation interference","c":"Capture effect","d":"Frequency discrimination"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C04","question":"How is the noise figure of a receiver defined?","answer":"D","choices":{"a":"The ratio of atmospheric noise to phase noise","b":"The ratio of the noise bandwidth in Hertz to the theoretical bandwidth of a resi"+"stive network","c":"The ratio of thermal noise to atmospheric noise","d":"The ratio in dB of the noise generated by the receiver to the theoretical minimu"+"m noise"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C05","question":"What does a value of -174 dBm/Hz represent with regard to the noise floor of a r"+"eceiver?","answer":"B","choices":{"a":"The minimum detectable signal as a function of receive frequency","b":"The theoretical noise at the input of a perfect receiver at room temperature","c":"The noise figure of a 1 Hz bandwidth receiver","d":"The galactic noise contribution to minimum detectable signal"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C06","question":"A CW receiver with the AGC off has an equivalent input noise power density of -1"+"74 dBm/Hz. What would be the level of an unmodulated carrier input to this recei"+"ver that would yield an audio output SNR of 0 dB in a 400 Hz noise bandwidth?","answer":"D","choices":{"a":"-174 dBm","b":"-164 dBm","c":"-155 dBm","d":"-148 dBm"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C07","question":"What does the MDS of a receiver represent?","answer":"B","choices":{"a":"The meter display sensitivity","b":"The minimum discernible signal","c":"The multiplex distortion stability","d":"The maximum detectable spectrum"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C08","question":"An SDR receiver is overloaded when input signals exceed what level?","answer":"C","choices":{"a":"One-half the maximum sample rate","b":"One-half the maximum sampling buffer size","c":"The maximum count value of the analog-to-digital converter","d":"The reference voltage of the analog-to-digital converter"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C09","question":"Which of the following choices is a good reason for selecting a high frequency f"+"or the design of the IF in a conventional HF or VHF communications receiver?","answer":"C","choices":{"a":"Fewer components in the receiver","b":"Reduced drift","c":"Easier for front-end circuitry to eliminate image responses","d":"Improved receiver noise figure"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C10","question":"Which of the following is a desirable amount of selectivity for an amateur RTTY "+"HF receiver?","answer":"B","choices":{"a":"100 Hz","b":"300 Hz","c":"6000 Hz","d":"2400 Hz"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C11","question":"Which of the following is a desirable amount of selectivity for an amateur SSB p"+"hone receiver?","answer":"B","choices":{"a":"1 kHz","b":"2.4 kHz","c":"4.2 kHz","d":"4.8 kHz"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C12","question":"What is an undesirable effect of using too wide a filter bandwidth in the IF sec"+"tion of a receiver?","answer":"D","choices":{"a":"Output-offset overshoot","b":"Filter ringing","c":"Thermal-noise distortion","d":"Undesired signals may be heard"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C13","question":"How does a narrow-band roofing filter affect receiver performance?","answer":"C","choices":{"a":"It improves sensitivity by reducing front end noise","b":"It improves intelligibility by using low Q circuitry to reduce ringing","c":"It improves dynamic range by attenuating strong signals near the receive frequen"+"cy","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C14","question":"What transmit frequency might generate an image response signal in a receiver tu"+"ned to 14.300 MHz and which uses a 455 kHz IF frequency?","answer":"D","choices":{"a":"13.845 MHz","b":"14.755 MHz","c":"14.445 MHz","d":"15.210 MHz"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C15","question":"What is usually the primary source of noise that is heard from an HF receiver wi"+"th an antenna connected?","answer":"D","choices":{"a":"Detector noise","b":"Induction motor noise","c":"Receiver front-end noise","d":"Atmospheric noise"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C16","question":"Which of the following is caused by missing codes in an SDR receiver�s analog-to"+"-digital converter?","answer":"A","choices":{"a":"Distortion","b":"Overload","c":"Loss of sensitivity","d":"Excess output level"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4C","questionID":"E4C17","question":"Which of the following has the largest effect on an SDR receiver�s linearity?","answer":"D","choices":{"a":"CPU register width in bits","b":"Anti-aliasing input filter bandwidth","c":"RAM speed used for data storage","d":"Analog-to-digital converter sample width in bits"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D01","question":"What is meant by the blocking dynamic range of a receiver?","answer":"A","choices":{"a":"The difference in dB between the noise floor and the level of an incoming signal"+" which will cause 1 dB of gain compression","b":"The minimum difference in dB between the levels of two FM signals which will cau"+"se one signal to block the other","c":"The difference in dB between the noise floor and the third order intercept point","d":"The minimum difference in dB between two signals which produce third order inter"+"modulation products greater than the noise floor"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D02","question":"Which of the following describes two problems caused by poor dynamic range in a "+"communications receiver?","answer":"A","choices":{"a":"Cross-modulation of the desired signal and desensitization from strong adjacent "+"signals","b":"Oscillator instability requiring frequent retuning and loss of ability to recove"+"r the opposite sideband","c":"Cross-modulation of the desired signal and insufficient audio power to operate t"+"he speaker","d":"Oscillator instability and severe audio distortion of all but the strongest rece"+"ived signals"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D03","question":"How can intermodulation interference between two repeaters occur?","answer":"B","choices":{"a":"When the repeaters are in close proximity and the signals cause feedback in the "+"final amplifier of one or both transmitters","b":"When the repeaters are in close proximity and the signals mix in the final ampli"+"fier of one or both transmitters","c":"When the signals from the transmitters are reflected out of phase from airplanes"+" passing overhead","d":"When the signals from the transmitters are reflected in phase from airplanes pas"+"sing overhead"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D04","question":"Which of the following may reduce or eliminate intermodulation interference in a"+" repeater caused by another transmitter operating in close proximity?","answer":"B","choices":{"a":"A band-pass filter in the feed line between the transmitter and receiver","b":"A properly terminated circulator at the output of the transmitter","c":"A Class C final amplifier","d":"A Class D final amplifier"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D05","question":"What transmitter frequencies would cause an intermodulation-product signal in a "+"receiver tuned to 146.70 MHz when a nearby station transmits on 146.52 MHz?","answer":"A","choices":{"a":"146.34 MHz and 146.61 MHz","b":"146.88 MHz and 146.34 MHz","c":"146.10 MHz and 147.30 MHz","d":"173.35 MHz and 139.40 MHz"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D06","question":"What is the term for unwanted signals generated by the mixing of two or more sig"+"nals?","answer":"D","choices":{"a":"Amplifier desensitization","b":"Neutralization","c":"Adjacent channel interference","d":"Intermodulation interference"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D07","question":"Which describes the most significant effect of an off-frequency signal when it i"+"s causing cross-modulation interference to a desired signal?","answer":"D","choices":{"a":"A large increase in background noise","b":"A reduction in apparent signal strength","c":"The desired signal can no longer be heard","d":"The off-frequency unwanted signal is heard in addition to the desired signal"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D08","question":"What causes intermodulation in an electronic circuit?","answer":"C","choices":{"a":"Too little gain","b":"Lack of neutralization","c":"Nonlinear circuits or devices","d":"Positive feedback"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D09","question":"What is the purpose of the preselector in a communications receiver?","answer":"C","choices":{"a":"To store often-used frequencies","b":"To provide a range of AGC time constants","c":"To increase rejection of unwanted signals","d":"To allow selection of the optimum RF amplifier device"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D10","question":"What does a third-order intercept level of 40 dBm mean with respect to receiver "+"performance?","answer":"C","choices":{"a":"Signals less than 40 dBm will not generate audible third-order intermodulation p"+"roducts","b":"The receiver can tolerate signals up to 40 dB above the noise floor without prod"+"ucing third-order intermodulation products","c":"A pair of 40 dBm signals will theoretically generate a third-order intermodulati"+"on product with the same level as the input signals","d":"A pair of 1 mW input signals will produce a third-order intermodulation product "+"which is 40 dB stronger than the input signal"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D11","question":"Why are third-order intermodulation products created within a receiver of partic"+"ular interest compared to other products?","answer":"A","choices":{"a":"The third-order product of two signals which are in the band of interest is also"+" likely to be within the band","b":"The third-order intercept is much higher than other orders","c":"Third-order products are an indication of poor image rejection","d":"Third-order intermodulation produces three products for every input signal withi"+"n the band of interest"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D12","question":"What is the term for the reduction in receiver sensitivity caused by a strong si"+"gnal near the received frequency?","answer":"A","choices":{"a":"Desensitization","b":"Quieting","c":"Cross-modulation interference","d":"Squelch gain rollback"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D13","question":"Which of the following can cause receiver desensitization?","answer":"B","choices":{"a":"Audio gain adjusted too low","b":"Strong adjacent channel signals","c":"Audio bias adjusted too high","d":"Squelch gain misadjusted"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4D","questionID":"E4D14","question":"Which of the following is a way to reduce the likelihood of receiver desensitiza"+"tion?","answer":"A","choices":{"a":"Decrease the RF bandwidth of the receiver","b":"Raise the receiver IF frequency","c":"Increase the receiver front end gain","d":"Switch from fast AGC to slow AGC"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E01","question":"Which of the following types of receiver noise can often be reduced by use of a "+"receiver noise blanker?","answer":"A","choices":{"a":"Ignition noise","b":"Broadband white noise","c":"Heterodyne interference","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E02","question":"Which of the following types of receiver noise can often be reduced with a DSP n"+"oise filter?","answer":"D","choices":{"a":"Broadband white noise","b":"Ignition noise","c":"Power line noise","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E03","question":"Which of the following signals might a receiver noise blanker be able to remove "+"from desired signals?","answer":"B","choices":{"a":"Signals which are constant at all IF levels","b":"Signals which appear across a wide bandwidth","c":"Signals which appear at one IF but not another","d":"Signals which have a sharply peaked frequency distribution"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E04","question":"How can conducted and radiated noise caused by an automobile alternator be suppr"+"essed?","answer":"D","choices":{"a":"By installing filter capacitors in series with the DC power lead and a blocking "+"capacitor in the field lead","b":"By installing a noise suppression resistor and a blocking capacitor in both lead"+"s","c":"By installing a high-pass filter in series with the radio's power lead and a low"+"-pass filter in parallel with the field lead","d":"By connecting the radio's power leads directly to the battery and by installing "+"coaxial capacitors in line with the alternator leads"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E05","question":"How can noise from an electric motor be suppressed?","answer":"B","choices":{"a":"By installing a high pass filter in series with the motor�s power leads","b":"By installing a brute-force AC-line filter in series with the motor leads","c":"By installing a bypass capacitor in series with the motor leads","d":"By using a ground-fault current interrupter in the circuit used to power the mot"+"or"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E06","question":"What is a major cause of atmospheric static?","answer":"B","choices":{"a":"Solar radio frequency emissions","b":"Thunderstorms","c":"Geomagnetic storms","d":"Meteor showers"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E07","question":"How can you determine if line noise interference is being generated within your "+"home?","answer":"C","choices":{"a":"By checking the power line voltage with a time domain reflectometer","b":"By observing the AC power line waveform with an oscilloscope","c":"By turning off the AC power line main circuit breaker and listening on a battery"+" operated radio","d":"By observing the AC power line voltage with a spectrum analyzer"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E08","question":"What type of signal is picked up by electrical wiring near a radio antenna?","answer":"A","choices":{"a":"A common-mode signal at the frequency of the radio transmitter","b":"An electrical-sparking signal","c":"A differential-mode signal at the AC power line frequency","d":"Harmonics of the AC power line frequency"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E09","question":"What undesirable effect can occur when using an IF noise blanker?","answer":"C","choices":{"a":"Received audio in the speech range might have an echo effect","b":"The audio frequency bandwidth of the received signal might be compressed","c":"Nearby signals may appear to be excessively wide even if they meet emission stan"+"dards","d":"FM signals can no longer be demodulated"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E10","question":"What is a common characteristic of interference caused by a touch controlled ele"+"ctrical device?","answer":"D","choices":{"a":"The interfering signal sounds like AC hum on an AM receiver or a carrier modulat"+"ed by 60 Hz hum on a SSB or CW receiver","b":"The interfering signal may drift slowly across the HF spectrum","c":"The interfering signal can be several kHz in width and usually repeats at regula"+"r intervals across a HF band","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E11","question":"Which is the most likely cause if you are hearing combinations of local AM broad"+"cast signals within one or more of the MF or HF ham bands?","answer":"B","choices":{"a":"The broadcast station is transmitting an over-modulated signal","b":"Nearby corroded metal joints are mixing and re-radiating the broadcast signals","c":"You are receiving sky wave signals from a distant station","d":"Your station receiver IF amplifier stage is defective"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E12","question":"What is one disadvantage of using some types of automatic DSP notch-filters when"+" attempting to copy CW signals?","answer":"A","choices":{"a":"A DSP filter can remove the desired signal at the same time as it removes interf"+"ering signals","b":"Any nearby signal passing through the DSP system will overwhelm the desired sign"+"al","c":"Received CW signals will appear to be modulated at the DSP clock frequency","d":"Ringing in the DSP filter will completely remove the spaces between the CW chara"+"cters"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E13","question":"What might be the cause of a loud roaring or buzzing AC line interference that c"+"omes and goes at intervals?","answer":"D","choices":{"a":"Arcing contacts in a thermostatically controlled device","b":"A defective doorbell or doorbell transformer inside a nearby residence","c":"A malfunctioning illuminated advertising display","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E14","question":"What is one type of electrical interference that might be caused by the operatio"+"n of a nearby personal computer?","answer":"C","choices":{"a":"A loud AC hum in the audio output of your station receiver","b":"A clicking noise at intervals of a few seconds","c":"The appearance of unstable modulated or unmodulated signals at specific frequenc"+"ies","d":"A whining type noise that continually pulses off and on"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E15","question":"Which of the following can cause shielded cables to radiate or receive interfere"+"nce?","answer":"B","choices":{"a":"Low inductance ground connections at both ends of the shield","b":"Common mode currents on the shield and conductors","c":"Use of braided shielding material","d":"Tying all ground connections to a common point resulting in differential mode cu"+"rrents in the shield"},"metadata":""},{"exam":"E","section":"E4","subSection":"E4E","questionID":"E4E16","question":"What current flows equally on all conductors of an unshielded multi-conductor ca"+"ble?","answer":"B","choices":{"a":"Differential-mode current","b":"Common-mode current","c":"Reactive current only","d":"Return current"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A01","question":"What can cause the voltage across reactances in series to be larger than the vol"+"tage applied to them?","answer":"A","choices":{"a":"Resonance","b":"Capacitance","c":"Conductance","d":"Resistance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A02","question":"What is resonance in an electrical circuit?","answer":"C","choices":{"a":"The highest frequency that will pass current","b":"The lowest frequency that will pass current","c":"The frequency at which the capacitive reactance equals the inductive reactance","d":"The frequency at which the reactive impedance equals the resistive impedance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A03","question":"What is the magnitude of the impedance of a series RLC circuit at resonance?","answer":"D","choices":{"a":"High, as compared to the circuit resistance","b":"Approximately equal to capacitive reactance","c":"Approximately equal to inductive reactance","d":"Approximately equal to circuit resistance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A04","question":"What is the magnitude of the impedance of a circuit with a resistor, an inductor"+" and a capacitor all in parallel, at resonance?","answer":"A","choices":{"a":"Approximately equal to circuit resistance","b":"Approximately equal to inductive reactance","c":"Low, as compared to the circuit resistance","d":"Approximately equal to capacitive reactance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A05","question":"What is the magnitude of the current at the input of a series RLC circuit as the"+" frequency goes through resonance?","answer":"B","choices":{"a":"Minimum","b":"Maximum","c":"R/L","d":"L/R"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A06","question":"What is the magnitude of the circulating current within the components of a para"+"llel LC circuit at resonance?","answer":"B","choices":{"a":"It is at a minimum","b":"It is at a maximum","c":"It equals 1 divided by the quantity 2 times Pi, multiplied by the square root of"+" inductance L multiplied by capacitance C","d":"It equals 2 multiplied by Pi, multiplied by frequency, multiplied by inductance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A07","question":"What is the magnitude of the current at the input of a parallel RLC circuit at r"+"esonance?","answer":"A","choices":{"a":"Minimum","b":"Maximum","c":"R/L","d":"L/R"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A08","question":"What is the phase relationship between the current through and the voltage acros"+"s a series resonant circuit at resonance?","answer":"C","choices":{"a":"The voltage leads the current by 90 degrees","b":"The current leads the voltage by 90 degrees","c":"The voltage and current are in phase","d":"The voltage and current are 180 degrees out of phase"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A09","question":"How is the Q of an RLC parallel resonant circuit calculated?","answer":"C","choices":{"a":"Reactance of either the inductance or capacitance divided by the resistance","b":"Reactance of either the inductance or capacitance multiplied by the resistance","c":"Resistance divided by the reactance of either the inductance or capacitance","d":"Reactance of the inductance multiplied by the reactance of the capacitance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A10","question":"How is the Q of an RLC series resonant circuit calculated?","answer":"A","choices":{"a":"Reactance of either the inductance or capacitance divided by the resistance","b":"Reactance of either the inductance or capacitance times the resistance","c":"Resistance divided by the reactance of either the inductance or capacitance","d":"Reactance of the inductance times the reactance of the capacitance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A11","question":"What is the half-power bandwidth of a parallel resonant circuit that has a reson"+"ant frequency of 7.1 MHz and a Q of 150?","answer":"C","choices":{"a":"157.8 Hz","b":"315.6 Hz","c":"47.3 kHz","d":"23.67 kHz"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A12","question":"What is the half-power bandwidth of a parallel resonant circuit that has a reson"+"ant frequency of 3.7 MHz and a Q of 118?","answer":"C","choices":{"a":"436.6 kHz","b":"218.3 kHz","c":"31.4 kHz","d":"15.7 kHz"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A13","question":"What is an effect of increasing Q in a resonant circuit?","answer":"C","choices":{"a":"Fewer components are needed for the same performance","b":"Parasitic effects are minimized","c":"Internal voltages and circulating currents increase","d":"Phase shift can become uncontrolled"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A14","question":"What is the resonant frequency of a series RLC circuit if R is 22 ohms, L is 50 "+"microhenrys and C is 40 picofarads?","answer":"C","choices":{"a":"44.72 MHz","b":"22.36 MHz","c":"3.56 MHz","d":"1.78 MHz"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A15","question":"Which of the following can increase Q for inductors and capacitors?","answer":"A","choices":{"a":"Lower losses","b":"Lower reactance","c":"Lower self-resonant frequency","d":"Higher self-resonant frequency"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A16","question":"What is the resonant frequency of a parallel RLC circuit if R is 33 ohms, L is 5"+"0 microhenrys and C is 10 picofarads?","answer":"D","choices":{"a":"23.5 MHz","b":"23.5 kHz","c":"7.12 kHz","d":"7.12 MHz"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5A","questionID":"E5A17","question":"What is the result of increasing the Q of an impedance-matching circuit?","answer":"A","choices":{"a":"Matching bandwidth is decreased","b":"Matching bandwidth is increased","c":"Matching range is increased","d":"It has no effect on impedance matching"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B01","question":"What is the term for the time required for the capacitor in an RC circuit to be "+"charged to 63.2% of the applied voltage?","answer":"B","choices":{"a":"An exponential rate of one","b":"One time constant","c":"One exponential period","d":"A time factor of one"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B02","question":"What is the term for the time it takes for a charged capacitor in an RC circuit "+"to discharge to 36.8% of its initial voltage?","answer":"D","choices":{"a":"One discharge period","b":"An exponential discharge rate of one","c":"A discharge factor of one","d":"One time constant"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B03","question":"What happens to the phase angle of a reactance when it is converted to a suscept"+"ance?","answer":"B","choices":{"a":"It is unchanged","b":"The sign is reversed","c":"It is shifted by 90 degrees","d":"The susceptance phase angle is the inverse of the reactance phase angle"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B04","question":"What is the time constant of a circuit having two 220 microfarad capacitors and "+"two 1 megohm resistors, all in parallel?","answer":"D","choices":{"a":"55 seconds","b":"110 seconds","c":"440 seconds","d":"220 seconds"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B05","question":"What happens to the magnitude of a reactance when it is converted to a susceptan"+"ce?","answer":"D","choices":{"a":"It is unchanged","b":"The sign is reversed","c":"It is shifted by 90 degrees","d":"The magnitude of the susceptance is the reciprocal of the magnitude of the react"+"ance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B06","question":"What is susceptance?","answer":"C","choices":{"a":"The magnetic impedance of a circuit","b":"The ratio of magnetic field to electric field","c":"The inverse of reactance","d":"A measure of the efficiency of a transformer"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B07","question":"What is the phase angle between the voltage across and the current through a ser"+"ies RLC circuit if XC is 500 ohms, R is 1 kilohm, and XL is 250 ohms?","answer":"C","choices":{"a":"68.2 degrees with the voltage leading the current","b":"14.0 degrees with the voltage leading the current","c":"14.0 degrees with the voltage lagging the current","d":"68.2 degrees with the voltage lagging the current"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B08","question":"What is the phase angle between the voltage across and the current through a ser"+"ies RLC circuit if XC is 100 ohms, R is 100 ohms, and XL is 75 ohms?","answer":"A","choices":{"a":"14 degrees with the voltage lagging the current","b":"14 degrees with the voltage leading the current","c":"76 degrees with the voltage leading the current","d":"76 degrees with the voltage lagging the current"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B09","question":"What is the relationship between the current through a capacitor and the voltage"+" across a capacitor?","answer":"D","choices":{"a":"Voltage and current are in phase","b":"Voltage and current are 180 degrees out of phase","c":"Voltage leads current by 90 degrees","d":"Current leads voltage by 90 degrees"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B10","question":"What is the relationship between the current through an inductor and the voltage"+" across an inductor?","answer":"A","choices":{"a":"Voltage leads current by 90 degrees","b":"Current leads voltage by 90 degrees","c":"Voltage and current are 180 degrees out of phase","d":"Voltage and current are in phase"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B11","question":"What is the phase angle between the voltage across and the current through a ser"+"ies RLC circuit if XC is 25 ohms, R is 100 ohms, and XL is 50 ohms?","answer":"B","choices":{"a":"14 degrees with the voltage lagging the current","b":"14 degrees with the voltage leading the current","c":"76 degrees with the voltage lagging the current","d":"76 degrees with the voltage leading the current"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B12","question":"What is admittance?","answer":"A","choices":{"a":"The inverse of impedance","b":"The term for the gain of a field effect transistor","c":"The turns ratio of a transformer","d":"The unit used for Q factor"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5B","questionID":"E5B13","question":"What letter is commonly used to represent susceptance?","answer":"D","choices":{"a":"G","b":"X","c":"Y","d":"B"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C01","question":"Which of the following represents a capacitive reactance in rectangular notation"+"?","answer":"A","choices":{"a":"�jX","b":"+jX","c":"X","d":"Omega"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C02","question":"How are impedances described in polar coordinates?","answer":"C","choices":{"a":"By X and R values","b":"By real and imaginary parts","c":"By phase angle and amplitude","d":"By Y and G values"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C03","question":"Which of the following represents an inductive reactance in polar coordinates?","answer":"C","choices":{"a":"A positive real part","b":"A negative real part","c":"A positive phase angle","d":"A negative phase angle"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C04","question":"Which of the following represents a capacitive reactance in polar coordinates?","answer":"D","choices":{"a":"A positive real part","b":"A negative real part","c":"A positive phase angle","d":"A negative phase angle"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C05","question":"What is the name of the diagram used to show the phase relationship between impe"+"dances at a given frequency?","answer":"C","choices":{"a":"Venn diagram","b":"Near field diagram","c":"Phasor diagram","d":"Far field diagram"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C06","question":"What does the impedance 50�j25 represent?","answer":"B","choices":{"a":"50 ohms resistance in series with 25 ohms inductive reactance","b":"50 ohms resistance in series with 25 ohms capacitive reactance","c":"25 ohms resistance in series with 50 ohms inductive reactance","d":"25 ohms resistance in series with 50 ohms capacitive reactance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C07","question":"What is a vector?","answer":"B","choices":{"a":"The value of a quantity that changes over time","b":"A quantity with both magnitude and an angular component","c":"The inverse of the tangent function","d":"The inverse of the sine function"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C08","question":"What coordinate system is often used to display the phase angle of a circuit con"+"taining resistance, inductive and/or capacitive reactance?","answer":"D","choices":{"a":"Maidenhead grid","b":"Faraday grid","c":"Elliptical coordinates","d":"Polar coordinates"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C09","question":"When using rectangular coordinates to graph the impedance of a circuit, what doe"+"s the horizontal axis represent?","answer":"A","choices":{"a":"Resistive component","b":"Reactive component","c":"The sum of the reactive and resistive components","d":"The difference between the resistive and reactive components"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C10","question":"When using rectangular coordinates to graph the impedance of a circuit, what doe"+"s the vertical axis represent?","answer":"B","choices":{"a":"Resistive component","b":"Reactive component","c":"The sum of the reactive and resistive components","d":"The difference between the resistive and reactive components"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C11","question":"What do the two numbers that are used to define a point on a graph using rectang"+"ular coordinates represent?","answer":"C","choices":{"a":"The magnitude and phase of the point","b":"The sine and cosine values","c":"The coordinate values along the horizontal and vertical axes","d":"The tangent and cotangent values"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C12","question":"If you plot the impedance of a circuit using the rectangular coordinate system a"+"nd find the impedance point falls on the right side of the graph on the horizont"+"al axis, what do you know about the circuit?","answer":"D","choices":{"a":"It has to be a direct current circuit","b":"It contains resistance and capacitive reactance","c":"It contains resistance and inductive reactance","d":"It is equivalent to a pure resistance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C13","question":"What coordinate system is often used to display the resistive, inductive, and/or"+" capacitive reactance components of impedance?","answer":"D","choices":{"a":"Maidenhead grid","b":"Faraday grid","c":"Elliptical coordinates","d":"Rectangular coordinates"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C14","question":"Which point on Figure E5-2 best represents the impedance of a series circuit con"+"sisting of a 400 ohm resistor and a 38 picofarad capacitor at 14 MHz?","answer":"B","choices":{"a":"Point 2","b":"Point 4","c":"Point 5","d":"Point 6"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C15","question":"Which point in Figure E5-2 best represents the impedance of a series circuit con"+"sisting of a 300 ohm resistor and an 18 microhenry inductor at 3.505 MHz?","answer":"B","choices":{"a":"Point 1","b":"Point 3","c":"Point 7","d":"Point 8"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C16","question":"Which point on Figure E5-2 best represents the impedance of a series circuit con"+"sisting of a 300 ohm resistor and a 19 picofarad capacitor at 21.200 MHz?","answer":"A","choices":{"a":"Point 1","b":"Point 3","c":"Point 7","d":"Point 8"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5C","questionID":"E5C17","question":"Which point on Figure E5-2 best represents the impedance of a series circuit con"+"sisting of a 300 ohm resistor, a 0.64-microhenry inductor and an 85-picofarad ca"+"pacitor at 24.900 MHz?","answer":"D","choices":{"a":"Point 1","b":"Point 3","c":"Point 5","d":"Point 8"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D01","question":"What is the result of skin effect?","answer":"A","choices":{"a":"As frequency increases, RF current flows in a thinner layer of the conductor, cl"+"oser to the surface","b":"As frequency decreases, RF current flows in a thinner layer of the conductor, cl"+"oser to the surface","c":"Thermal effects on the surface of the conductor increase the impedance","d":"Thermal effects on the surface of the conductor decrease the impedance"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D02","question":"Why is it important to keep lead lengths short for components used in circuits f"+"or VHF and above?","answer":"B","choices":{"a":"To increase the thermal time constant","b":"To avoid unwanted inductive reactance","c":"To maintain component lifetime","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D03","question":"What is microstrip?","answer":"D","choices":{"a":"Lightweight transmission line made of common zip cord","b":"Miniature coax used for low power applications","c":"Short lengths of coax mounted on printed circuit boards to minimize time delay b"+"etween microwave circuits","d":"Precision printed circuit conductors above a ground plane that provide constant "+"impedance interconnects at microwave frequencies"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D04","question":"Why are short connections necessary at microwave frequencies?","answer":"B","choices":{"a":"To increase neutralizing resistance","b":"To reduce phase shift along the connection","c":"Because of ground reflections","d":"To reduce noise figure"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D05","question":"Which parasitic characteristic increases with conductor length?","answer":"A","choices":{"a":"Inductance","b":"Permeability","c":"Permittivity","d":"Malleability"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D06","question":"In what direction is the magnetic field oriented about a conductor in relation t"+"o the direction of electron flow?","answer":"D","choices":{"a":"In the same direction as the current","b":"In a direction opposite to the current","c":"In all directions; omni-directional","d":"In a direction determined by the left-hand rule"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D07","question":"What determines the strength of the magnetic field around a conductor?","answer":"D","choices":{"a":"The resistance divided by the current","b":"The ratio of the current to the resistance","c":"The diameter of the conductor","d":"The amount of current flowing through the conductor"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D08","question":"What type of energy is stored in an electromagnetic or electrostatic field?","answer":"B","choices":{"a":"Electromechanical energy","b":"Potential energy","c":"Thermodynamic energy","d":"Kinetic energy"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D09","question":"What happens to reactive power in an AC circuit that has both ideal inductors an"+"d ideal capacitors?","answer":"B","choices":{"a":"It is dissipated as heat in the circuit","b":"It is repeatedly exchanged between the associated magnetic and electric fields, "+"but is not dissipated","c":"It is dissipated as kinetic energy in the circuit","d":"It is dissipated in the formation of inductive and capacitive fields"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D10","question":"How can the true power be determined in an AC circuit where the voltage and curr"+"ent are out of phase?","answer":"A","choices":{"a":"By multiplying the apparent power times the power factor","b":"By dividing the reactive power by the power factor","c":"By dividing the apparent power by the power factor","d":"By multiplying the reactive power times the power factor"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D11","question":"What is the power factor of an R-L circuit having a 60 degree phase angle betwee"+"n the voltage and the current?","answer":"C","choices":{"a":"1.414","b":"0.866","c":"0.5","d":"1.73"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D12","question":"How many watts are consumed in a circuit having a power factor of 0.2 if the inp"+"ut is 100-VAC at 4 amperes?","answer":"B","choices":{"a":"400 watts","b":"80 watts","c":"2000 watts","d":"50 watts"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D13","question":"How much power is consumed in a circuit consisting of a 100 ohm resistor in seri"+"es with a 100 ohm inductive reactance drawing 1 ampere?","answer":"B","choices":{"a":"70.7 Watts","b":"100 Watts","c":"141.4 Watts","d":"200 Watts"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D14","question":"What is reactive power?","answer":"A","choices":{"a":"Wattless, nonproductive power","b":"Power consumed in wire resistance in an inductor","c":"Power lost because of capacitor leakage","d":"Power consumed in circuit Q"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D15","question":"What is the power factor of an R-L circuit having a 45 degree phase angle betwee"+"n the voltage and the current?","answer":"D","choices":{"a":"0.866","b":"1.0","c":"0.5","d":"0.707"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D16","question":"What is the power factor of an R-L circuit having a 30 degree phase angle betwee"+"n the voltage and the current?","answer":"C","choices":{"a":"1.73","b":"0.5","c":"0.866","d":"0.577"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D17","question":"How many watts are consumed in a circuit having a power factor of 0.6 if the inp"+"ut is 200VAC at 5 amperes?","answer":"D","choices":{"a":"200 watts","b":"1000 watts","c":"1600 watts","d":"600 watts"},"metadata":""},{"exam":"E","section":"E5","subSection":"E5D","questionID":"E5D18","question":"How many watts are consumed in a circuit having a power factor of 0.71 if the ap"+"parent power is 500VA?","answer":"B","choices":{"a":"704 W","b":"355 W","c":"252 W","d":"1.42 mW"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A01","question":"In what application is gallium arsenide used as a semiconductor material in pref"+"erence to germanium or silicon?","answer":"C","choices":{"a":"In high-current rectifier circuits","b":"In high-power audio circuits","c":"In microwave circuits","d":"In very low frequency RF circuits"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A02","question":"Which of the following semiconductor materials contains excess free electrons?","answer":"A","choices":{"a":"N-type","b":"P-type","c":"Bipolar","d":"Insulated gate"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A03","question":"Why does a PN-junction diode not conduct current when reverse biased?","answer":"C","choices":{"a":"Only P-type semiconductor material can conduct current","b":"Only N-type semiconductor material can conduct current","c":"Holes in P-type material and electrons in the N-type material are separated by t"+"he applied voltage, widening the depletion region","d":"Excess holes in P-type material combine with the electrons in N-type material, c"+"onverting the entire diode into an insulator"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A04","question":"What is the name given to an impurity atom that adds holes to a semiconductor cr"+"ystal structure?","answer":"C","choices":{"a":"Insulator impurity","b":"N-type impurity","c":"Acceptor impurity","d":"Donor impurity"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A05","question":"What is the alpha of a bipolar junction transistor?","answer":"C","choices":{"a":"The change of collector current with respect to base current","b":"The change of base current with respect to collector current","c":"The change of collector current with respect to emitter current","d":"The change of collector current with respect to gate current"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A06","question":"What is the beta of a bipolar junction transistor?","answer":"B","choices":{"a":"The frequency at which the current gain is reduced to 1","b":"The change in collector current with respect to base current","c":"The breakdown voltage of the base to collector junction","d":"The switching speed of the transistor"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A07","question":"Which of the following indicates that a silicon NPN junction transistor is biase"+"d on?","answer":"D","choices":{"a":"Base-to-emitter resistance of approximately 6 to 7 ohms","b":"Base-to-emitter resistance of approximately 0.6 to 0.7 ohms","c":"Base-to-emitter voltage of approximately 6 to 7 volts","d":"Base-to-emitter voltage of approximately 0.6 to 0.7 volts"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A08","question":"What term indicates the frequency at which the grounded-base current gain of a t"+"ransistor has decreased to 0.7 of the gain obtainable at 1 kHz?","answer":"D","choices":{"a":"Corner frequency","b":"Alpha rejection frequency","c":"Beta cutoff frequency","d":"Alpha cutoff frequency"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A09","question":"What is a depletion-mode FET?","answer":"A","choices":{"a":"An FET that exhibits a current flow between source and drain when no gate voltag"+"e is applied","b":"An FET that has no current flow between source and drain when no gate voltage is"+" applied","c":"Any FET without a channel","d":"Any FET for which holes are the majority carriers"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A10","question":"In Figure E6-2, what is the schematic symbol for an N-channel dual-gate MOSFET?","answer":"B","choices":{"a":"2","b":"4","c":"5","d":"6"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A11","question":"In Figure E6-2, what is the schematic symbol for a P-channel junction FET?","answer":"A","choices":{"a":"1","b":"2","c":"3","d":"6"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A12","question":"Why do many MOSFET devices have internally connected Zener diodes on the gates?","answer":"D","choices":{"a":"To provide a voltage reference for the correct amount of reverse-bias gate volta"+"ge","b":"To protect the substrate from excessive voltages","c":"To keep the gate voltage within specifications and prevent the device from overh"+"eating","d":"To reduce the chance of the gate insulation being punctured by static discharges"+" or excessive voltages"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A13","question":"What do the initials CMOS stand for?","answer":"C","choices":{"a":"Common Mode Oscillating System","b":"Complementary Mica-Oxide Silicon","c":"Complementary Metal-Oxide Semiconductor","d":"Common Mode Organic Silicon"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A14","question":"How does DC input impedance at the gate of a field-effect transistor compare wit"+"h the DC input impedance of a bipolar transistor?","answer":"C","choices":{"a":"They are both low impedance","b":"An FET has low input impedance; a bipolar transistor has high input impedance","c":"An FET has high input impedance; a bipolar transistor has low input impedance","d":"They are both high impedance"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A15","question":"Which semiconductor material contains excess holes in the outer shell of electro"+"ns?","answer":"B","choices":{"a":"N-type","b":"P-type","c":"Superconductor-type","d":"Bipolar-type"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A16","question":"What are the majority charge carriers in N-type semiconductor material?","answer":"B","choices":{"a":"Holes","b":"Free electrons","c":"Free protons","d":"Free neutrons"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6A","questionID":"E6A17","question":"What are the names of the three terminals of a field-effect transistor?","answer":"D","choices":{"a":"Gate 1, gate 2, drain","b":"Emitter, base, collector","c":"Emitter, base 1, base 2","d":"Gate, drain, source"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B01","question":"What is the most useful characteristic of a Zener diode?","answer":"B","choices":{"a":"A constant current drop under conditions of varying voltage","b":"A constant voltage drop under conditions of varying current","c":"A negative resistance region","d":"An internal capacitance that varies with the applied voltage"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B02","question":"What is an important characteristic of a Schottky diode as compared to an ordina"+"ry silicon diode when used as a power supply rectifier?","answer":"D","choices":{"a":"Much higher reverse voltage breakdown","b":"Controlled reverse avalanche voltage","c":"Enhanced carrier retention time","d":"Less forward voltage drop"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B03","question":"What special type of diode is capable of both amplification and oscillation?","answer":"C","choices":{"a":"Point contact","b":"Zener","c":"Tunnel","d":"Junction"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B04","question":"What type of semiconductor device is designed for use as a voltage-controlled ca"+"pacitor?","answer":"A","choices":{"a":"Varactor diode","b":"Tunnel diode","c":"Silicon-controlled rectifier","d":"Zener diode"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B05","question":"What characteristic of a PIN diode makes it useful as an RF switch or attenuator"+"?","answer":"D","choices":{"a":"Extremely high reverse breakdown voltage","b":"Ability to dissipate large amounts of power","c":"Reverse bias controls its forward voltage drop","d":"A large region of intrinsic material"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B06","question":"Which of the following is a common use of a hot-carrier diode?","answer":"D","choices":{"a":"As balanced mixers in FM generation","b":"As a variable capacitance in an automatic frequency control circuit","c":"As a constant voltage reference in a power supply","d":"As a VHF/UHF mixer or detector"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B07","question":"What is the failure mechanism when a junction diode fails due to excessive curre"+"nt?","answer":"B","choices":{"a":"Excessive inverse voltage","b":"Excessive junction temperature","c":"Insufficient forward voltage","d":"Charge carrier depletion"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B08","question":"Which of the following describes a type of semiconductor diode?","answer":"A","choices":{"a":"Metal-semiconductor junction","b":"Electrolytic rectifier","c":"CMOS-field effect","d":"Thermionic emission diode"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B09","question":"What is a common use for point contact diodes?","answer":"C","choices":{"a":"As a constant current source","b":"As a constant voltage source","c":"As an RF detector","d":"As a high voltage rectifier"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B10","question":"In Figure E6-3, what is the schematic symbol for a light-emitting diode?","answer":"B","choices":{"a":"1","b":"5","c":"6","d":"7"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B11","question":"What is used to control the attenuation of RF signals by a PIN diode?","answer":"A","choices":{"a":"Forward DC bias current","b":"A sub-harmonic pump signal","c":"Reverse voltage larger than the RF signal","d":"Capacitance of an RF coupling capacitor"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B12","question":"What is one common use for PIN diodes?","answer":"C","choices":{"a":"As a constant current source","b":"As a constant voltage source","c":"As an RF switch","d":"As a high voltage rectifier"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6B","questionID":"E6B13","question":"What type of bias is required for an LED to emit light?","answer":"B","choices":{"a":"Reverse bias","b":"Forward bias","c":"Zero bias","d":"Inductive bias"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C01","question":"What is the function of hysteresis in a comparator?","answer":"A","choices":{"a":"To prevent input noise from causing unstable output signals","b":"To allow the comparator to be used with AC input signal","c":"To cause the output to change states continually","d":"To increase the sensitivity"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C02","question":"What happens when the level of a comparator�s input signal crosses the threshold"+"?","answer":"B","choices":{"a":"The IC input can be damaged","b":"The comparator changes its output state","c":"The comparator enters latch-up","d":"The feedback loop becomes unstable"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C03","question":"What is tri-state logic?","answer":"A","choices":{"a":"Logic devices with 0, 1, and high impedance output states","b":"Logic devices that utilize ternary math","c":"Low power logic devices designed to operate at 3 volts","d":"Proprietary logic devices manufactured by Tri-State Devices"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C04","question":"What is the primary advantage of tri-state logic?","answer":"B","choices":{"a":"Low power consumption","b":"Ability to connect many device outputs to a common bus","c":"High speed operation","d":"More efficient arithmetic operations"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C05","question":"What is an advantage of CMOS logic devices over TTL devices?","answer":"D","choices":{"a":"Differential output capability","b":"Lower distortion","c":"Immune to damage from static discharge","d":"Lower power consumption"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C06","question":"Why do CMOS digital integrated circuits have high immunity to noise on the input"+" signal or power supply?","answer":"C","choices":{"a":"Larger bypass capacitors are used in CMOS circuit design","b":"The input switching threshold is about two times the power supply voltage","c":"The input switching threshold is about one-half the power supply voltage","d":"Input signals are stronger"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C07","question":"What best describes a pull-up or pull-down resistor?","answer":"B","choices":{"a":"A resistor in a keying circuit used to reduce key clicks","b":"A resistor connected to the positive or negative supply line used to establish a"+" voltage when an input or output is an open circuit","c":"A resistor that insures that an oscillator frequency does not drive lower over t"+"ime","d":"A resistor connected to an op-amp output that only functions when the logic outp"+"ut is false"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C08","question":"In Figure E6-5, what is the schematic symbol for a NAND gate?","answer":"B","choices":{"a":"1","b":"2","c":"3","d":"4"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C09","question":"What is a Programmable Logic Device (PLD)?","answer":"B","choices":{"a":"A device to control industrial equipment","b":"A programmable collection of logic gates and circuits in a single integrated cir"+"cuit","c":"Programmable equipment used for testing digital logic integrated circuits","d":"An algorithm for simulating logic functions during circuit design"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C10","question":"In Figure E6-5, what is the schematic symbol for a NOR gate?","answer":"D","choices":{"a":"1","b":"2","c":"3","d":"4"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C11","question":"In Figure E6-5, what is the schematic symbol for the NOT operation (inverter)?","answer":"C","choices":{"a":"2","b":"4","c":"5","d":"6"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C12","question":"What is BiCMOS logic?","answer":"D","choices":{"a":"A logic device with two CMOS circuits per package","b":"A FET logic family based on bimetallic semiconductors","c":"A logic family based on bismuth CMOS devices","d":"An integrated circuit logic family using both bipolar and CMOS transistors"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C13","question":"Which of the following is an advantage of BiCMOS logic?","answer":"C","choices":{"a":"Its simplicity results in much less expensive devices than standard CMOS","b":"It is totally immune to electrostatic damage","c":"It has the high input impedance of CMOS and the low output impedance of bipolar "+"transistors","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6C","questionID":"E6C14","question":"What is the primary advantage of using a Programmable Gate Array (PGA) in a logi"+"c circuit?","answer":"B","choices":{"a":"Many similar gates are less expensive than a mixture of gate types","b":"Complex logic functions can be created in a single integrated circuit","c":"A PGA contains its own internal power supply","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D01","question":"How many turns will be required to produce a 5-microhenry inductor using a powde"+"red-iron toroidal core that has an inductance index (A L) value of 40 microhenry"+"s/100 turns?","answer":"A","choices":{"a":"35 turns","b":"13 turns","c":"79 turns","d":"141 turns"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D02","question":"What is the equivalent circuit of a quartz crystal?","answer":"A","choices":{"a":"Motional capacitance, motional inductance, and loss resistance in series, all in"+" parallel with a shunt capacitor representing electrode and stray capacitance","b":"Motional capacitance, motional inductance, loss resistance, and a capacitor repr"+"esenting electrode and stray capacitance all in parallel","c":"Motional capacitance, motional inductance, loss resistance, and a capacitor repr"+"esenting electrode and stray capacitance all in series","d":"Motional inductance and loss resistance in series, paralleled with motional capa"+"citance and a capacitor representing electrode and stray capacitance"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D03","question":"Which of the following is an aspect of the piezoelectric effect?","answer":"A","choices":{"a":"Mechanical deformation of material by the application of a voltage","b":"Mechanical deformation of material by the application of a magnetic field","c":"Generation of electrical energy in the presence of light","d":"Increased conductivity in the presence of light"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D04","question":"Which materials are commonly used as a slug core in a variable inductor?","answer":"B","choices":{"a":"Polystyrene and polyethylene","b":"Ferrite and brass","c":"Teflon and Delrin","d":"Cobalt and aluminum"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D05","question":"What is one reason for using ferrite cores rather than powdered-iron in an induc"+"tor?","answer":"C","choices":{"a":"Ferrite toroids generally have lower initial permeability","b":"Ferrite toroids generally have better temperature stability","c":"Ferrite toroids generally require fewer turns to produce a given inductance valu"+"e","d":"Ferrite toroids are easier to use with surface mount technology"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D06","question":"What core material property determines the inductance of a toroidal inductor?","answer":"D","choices":{"a":"Thermal impedance","b":"Resistance","c":"Reactivity","d":"Permeability"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D07","question":"What is the usable frequency range of inductors that use toroidal cores, assumin"+"g a correct selection of core material for the frequency being used?","answer":"B","choices":{"a":"From a few kHz to no more than 30 MHz","b":"From less than 20 Hz to approximately 300 MHz","c":"From approximately 10 Hz to no more than 3000 kHz","d":"From about 100 kHz to at least 1000 GHz"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D08","question":"What is one reason for using powdered-iron cores rather than ferrite cores in an"+" inductor?","answer":"B","choices":{"a":"Powdered-iron cores generally have greater initial permeability","b":"Powdered-iron cores generally maintain their characteristics at higher currents","c":"Powdered-iron cores generally require fewer turns to produce a given inductance","d":"Powdered-iron cores use smaller diameter wire for the same inductance"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D09","question":"What devices are commonly used as VHF and UHF parasitic suppressors at the input"+" and output terminals of a transistor HF amplifier?","answer":"C","choices":{"a":"Electrolytic capacitors","b":"Butterworth filters","c":"Ferrite beads","d":"Steel-core toroids"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D10","question":"What is a primary advantage of using a toroidal core instead of a solenoidal cor"+"e in an inductor?","answer":"A","choices":{"a":"Toroidal cores confine most of the magnetic field within the core material","b":"Toroidal cores make it easier to couple the magnetic energy into other component"+"s","c":"Toroidal cores exhibit greater hysteresis","d":"Toroidal cores have lower Q characteristics"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D11","question":"How many turns will be required to produce a 1-mH inductor using a core that has"+" an inductance index (A L) value of 523 millihenrys/1000 turns?","answer":"C","choices":{"a":"2 turns","b":"4 turns","c":"43 turns","d":"229 turns"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D12","question":"What is the definition of saturation in a ferrite core inductor?","answer":"C","choices":{"a":"The inductor windings are over coupled","b":"The inductor�s voltage rating is exceeded causing a flashover","c":"The ability of the inductor�s core to store magnetic energy has been exceeded","d":"Adjacent inductors become over-coupled"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D13","question":"What is the primary cause of inductor self-resonance?","answer":"A","choices":{"a":"Inter-turn capacitance","b":"The skin effect","c":"Inductive kickback","d":"Non-linear core hysteresis"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D14","question":"Which type of slug material decreases inductance when inserted into a coil?","answer":"B","choices":{"a":"Ceramic","b":"Brass","c":"Ferrite","d":"Powdered-iron"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D15","question":"What is current in the primary winding of a transformer called if no load is att"+"ached to the secondary?","answer":"A","choices":{"a":"Magnetizing current","b":"Direct current","c":"Excitation current","d":"Stabilizing current"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D16","question":"What is the common name for a capacitor connected across a transformer secondary"+" that is used to absorb transient voltage spikes?","answer":"D","choices":{"a":"Clipper capacitor","b":"Trimmer capacitor","c":"Feedback capacitor","d":"Snubber capacitor"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6D","questionID":"E6D17","question":"Why should core saturation of a conventional impedance matching transformer be a"+"voided?","answer":"A","choices":{"a":"Harmonics and distortion could result","b":"Magnetic flux would increase with frequency","c":"RF susceptance would increase","d":"Temporary changes of the core permeability could result"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E01","question":"Which of the following is true of a charge-coupled device (CCD)?","answer":"C","choices":{"a":"Its phase shift changes rapidly with frequency","b":"It is a CMOS analog-to-digital converter","c":"It samples an analog signal and passes it in stages from the input to the output","d":"It is used in a battery charger circuit"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E02","question":"Which of the following device packages is a through-hole type?","answer":"A","choices":{"a":"DIP","b":"PLCC","c":"Ball grid array","d":"SOT"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E03","question":"Which of the following materials is likely to provide the highest frequency of o"+"peration when used in MMICs?","answer":"D","choices":{"a":"Silicon","b":"Silicon nitride","c":"Silicon dioxide","d":"Gallium nitride"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E04","question":"Which is the most common input and output impedance of circuits that use MMICs?","answer":"A","choices":{"a":"50 ohms","b":"300 ohms","c":"450 ohms","d":"10 ohms"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E05","question":"Which of the following noise figure values is typical of a low-noise UHF preampl"+"ifier?","answer":"A","choices":{"a":"2 dB","b":"-10 dB","c":"44 dBm","d":"-20 dBm"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E06","question":"What characteristics of the MMIC make it a popular choice for VHF through microw"+"ave circuits?","answer":"D","choices":{"a":"The ability to retrieve information from a single signal even in the presence of"+" other strong signals","b":"Plate current that is controlled by a control grid","c":"Nearly infinite gain, very high input impedance, and very low output impedance","d":"Controlled gain, low noise figure, and constant input and output impedance over "+"the specified frequency range"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E07","question":"Which of the following is typically used to construct a MMIC-based microwave amp"+"lifier?","answer":"B","choices":{"a":"Ground-plane construction","b":"Microstrip construction","c":"Point-to-point construction","d":"Wave-soldering construction"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E08","question":"How is voltage from a power supply normally furnished to the most common type of"+" monolithic microwave integrated circuit (MMIC)?","answer":"A","choices":{"a":"Through a resistor and/or RF choke connected to the amplifier output lead","b":"MMICs require no operating bias","c":"Through a capacitor and RF choke connected to the amplifier input lead","d":"Directly to the bias voltage (VCC IN) lead"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E09","question":"Which of the following component package types would be most suitable for use at"+" frequencies above the HF range?","answer":"D","choices":{"a":"TO-220","b":"Axial lead","c":"Radial lead","d":"Surface mount"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E10","question":"What is the packaging technique in which leadless components are soldered direct"+"ly to circuit boards?","answer":"D","choices":{"a":"Direct soldering","b":"Virtual lead mounting","c":"Stripped lead","d":"Surface mount"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E11","question":"What is a characteristic of DIP packaging used for integrated circuits?","answer":"D","choices":{"a":"Package mounts in a direct inverted position","b":"Low leakage doubly insulated package","c":"Two chips in each package (Dual In Package)","d":"A total of two rows of connecting pins placed on opposite sides of the package ("+"Dual In-line Package)"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6E","questionID":"E6E12","question":"Why are high-power RF amplifier ICs and transistors sometimes mounted in ceramic"+" packages?","answer":"B","choices":{"a":"High-voltage insulating ability","b":"Better dissipation of heat","c":"Enhanced sensitivity to light","d":"To provide a low-pass frequency response"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F01","question":"What is photoconductivity?","answer":"B","choices":{"a":"The conversion of photon energy to electromotive energy","b":"The increased conductivity of an illuminated semiconductor","c":"The conversion of electromotive energy to photon energy","d":"The decreased conductivity of an illuminated semiconductor"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F02","question":"What happens to the conductivity of a photoconductive material when light shines"+" on it?","answer":"A","choices":{"a":"It increases","b":"It decreases","c":"It stays the same","d":"It becomes unstable"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F03","question":"What is the most common configuration of an optoisolator or optocoupler?","answer":"D","choices":{"a":"A lens and a photomultiplier","b":"A frequency modulated helium-neon laser","c":"An amplitude modulated helium-neon laser","d":"An LED and a phototransistor"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F04","question":"What is the photovoltaic effect?","answer":"B","choices":{"a":"The conversion of voltage to current when exposed to light","b":"The conversion of light to electrical energy","c":"The conversion of electrical energy to mechanical energy","d":"The tendency of a battery to discharge when used outside"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F05","question":"Which describes an optical shaft encoder?","answer":"A","choices":{"a":"A device which detects rotation of a control by interrupting a light source with"+" a patterned wheel","b":"A device which measures the strength of a beam of light using analog to digital "+"conversion","c":"A digital encryption device often used to encrypt spacecraft control signals","d":"A device for generating RTTY signals by means of a rotating light source"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F06","question":"Which of these materials is affected the most by photoconductivity?","answer":"A","choices":{"a":"A crystalline semiconductor","b":"An ordinary metal","c":"A heavy metal","d":"A liquid semiconductor"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F07","question":"What is a solid state relay?","answer":"B","choices":{"a":"A relay using transistors to drive the relay coil","b":"A device that uses semiconductors to implement the functions of an electromechan"+"ical relay","c":"A mechanical relay that latches in the on or off state each time it is pulsed","d":"A passive delay line"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F08","question":"Why are optoisolators often used in conjunction with solid state circuits when s"+"witching 120VAC?","answer":"C","choices":{"a":"Optoisolators provide a low impedance link between a control circuit and a power"+" circuit","b":"Optoisolators provide impedance matching between the control circuit and power c"+"ircuit","c":"Optoisolators provide a very high degree of electrical isolation between a contr"+"ol circuit and the circuit being switched","d":"Optoisolators eliminate the effects of reflected light in the control circuit"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F09","question":"What is the efficiency of a photovoltaic cell?","answer":"D","choices":{"a":"The output RF power divided by the input DC power","b":"The effective payback period","c":"The open-circuit voltage divided by the short-circuit current under full illumin"+"ation","d":"The relative fraction of light that is converted to current"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F10","question":"What is the most common type of photovoltaic cell used for electrical power gene"+"ration?","answer":"B","choices":{"a":"Selenium","b":"Silicon","c":"Cadmium Sulfide","d":"Copper oxide"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F11","question":"What is the approximate open-circuit voltage produced by a fully-illuminated sil"+"icon photovoltaic cell?","answer":"B","choices":{"a":"0.1 V","b":"0.5 V","c":"1.5 V","d":"12 V"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F12","question":"What absorbs the energy from light falling on a photovoltaic cell?","answer":"C","choices":{"a":"Protons","b":"Photons","c":"Electrons","d":"Holes"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F13","question":"What is a liquid crystal display (LCD)?","answer":"B","choices":{"a":"A modern replacement for a quartz crystal oscillator which displays its fundamen"+"tal frequency","b":"A display utilizing a crystalline liquid and polarizing filters which becomes op"+"aque when voltage is applied","c":"A frequency-determining unit for a transmitter or receiver","d":"A display that uses a glowing liquid to remain brightly lit in dim light"},"metadata":""},{"exam":"E","section":"E6","subSection":"E6F","questionID":"E6F14","question":"Which of the following is true of LCD displays?","answer":"B","choices":{"a":"They are hard to view in high ambient light conditions","b":"They may be hard view through polarized lenses","c":"They only display alphanumeric symbols","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A01","question":"Which is a bi-stable circuit?","answer":"C","choices":{"a":"An \"AND\" gate","b":"An \"OR\" gate","c":"A flip-flop","d":"A clock"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A02","question":"What is the function of a decade counter digital IC?","answer":"A","choices":{"a":"It produces one output pulse for every ten input pulses","b":"It decodes a decimal number for display on a seven segment LED display","c":"It produces ten output pulses for every input pulse","d":"It adds two decimal numbers together"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A03","question":"Which of the following can divide the frequency of a pulse train by 2?","answer":"B","choices":{"a":"An XOR gate","b":"A flip-flop","c":"An OR gate","d":"A multiplexer"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A04","question":"How many flip-flops are required to divide a signal frequency by 4?","answer":"B","choices":{"a":"1","b":"2","c":"4","d":"8"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A05","question":"Which of the following is a circuit that continuously alternates between two sta"+"tes without an external clock?","answer":"D","choices":{"a":"Monostable multivibrator","b":"J-K flip-flop","c":"T flip-flop","d":"Astable multivibrator"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A06","question":"What is a characteristic of a monostable multivibrator?","answer":"A","choices":{"a":"It switches momentarily to the opposite binary state and then returns to its ori"+"ginal state after a set time","b":"It produces a continuous square wave oscillating between 1 and 0","c":"It stores one bit of data in either a 0 or 1 state","d":"It maintains a constant output voltage, regardless of variations in the input vo"+"ltage"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A07","question":"What logical operation does a NAND gate perform?","answer":"D","choices":{"a":"It produces logic \"0\" at its output only when all inputs are logic \"0\"","b":"It produces logic \"1\" at its output only when all inputs are logic \"1\"","c":"It produces logic \"0\" at its output if some but not all inputs are logic \"1\"","d":"It produces logic \"0\" at its output only when all inputs are logic \"1\""},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A08","question":"What logical operation does an OR gate perform?","answer":"A","choices":{"a":"It produces logic \"1\" at its output if any or all inputs are logic \"1\"","b":"It produces logic \"0\" at its output if all inputs are logic \"1\"","c":"It only produces logic \"0\" at its output when all inputs are logic \"1\"","d":"It produces logic \"1\" at its output if all inputs are logic \"0\""},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A09","question":"What logical operation is performed by an exclusive NOR gate?","answer":"C","choices":{"a":"It produces logic \"0\" at its output only if all inputs are logic \"0\"","b":"It produces logic \"1\" at its output only if all inputs are logic \"1\"","c":"It produces logic \"0\" at its output if any single input is logic \"1\"","d":"It produces logic \"1\" at its output if any single input is logic \"1\""},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A10","question":"What is a truth table?","answer":"C","choices":{"a":"A table of logic symbols that indicate the high logic states of an op-amp","b":"A diagram showing logic states when the digital device output is true","c":"A list of inputs and corresponding outputs for a digital device","d":"A table of logic symbols that indicate the logic states of an op-amp"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A11","question":"What type of logic defines \"1\" as a high voltage?","answer":"D","choices":{"a":"Reverse Logic","b":"Assertive Logic","c":"Negative logic","d":"Positive Logic"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7A","questionID":"E7A12","question":"What type of logic defines \"0\" as a high voltage?","answer":"C","choices":{"a":"Reverse Logic","b":"Assertive Logic","c":"Negative logic","d":"Positive Logic"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B01","question":"For what portion of a signal cycle does a Class AB amplifier operate?","answer":"A","choices":{"a":"More than 180 degrees but less than 360 degrees","b":"Exactly 180 degrees","c":"The entire cycle","d":"Less than 180 degrees"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B02","question":"What is a Class D amplifier?","answer":"A","choices":{"a":"A type of amplifier that uses switching technology to achieve high efficiency","b":"A low power amplifier that uses a differential amplifier for improved linearity","c":"An amplifier that uses drift-mode FETs for high efficiency","d":"A frequency doubling amplifier"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B03","question":"Which of the following components form the output of a class D amplifier circuit"+"?","answer":"A","choices":{"a":"A low-pass filter to remove switching signal components","b":"A high-pass filter to compensate for low gain at low frequencies","c":"A matched load resistor to prevent damage by switching transients","d":"A temperature compensating load resistor to improve linearity"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B04","question":"Where on the load line of a Class A common emitter amplifier would bias normally"+" be set?","answer":"A","choices":{"a":"Approximately half-way between saturation and cutoff","b":"Where the load line intersects the voltage axis","c":"At a point where the bias resistor equals the load resistor","d":"At a point where the load line intersects the zero bias current curve"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B05","question":"What can be done to prevent unwanted oscillations in an RF power amplifier?","answer":"C","choices":{"a":"Tune the stage for maximum SWR","b":"Tune both the input and output for maximum power","c":"Install parasitic suppressors and/or neutralize the stage","d":"Use a phase inverter in the output filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B06","question":"Which of the following amplifier types reduces or eliminates even order harmonic"+"s?","answer":"B","choices":{"a":"Push-push","b":"Push-pull","c":"Class C","d":"Class AB"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B07","question":"Which of the following is a likely result when a Class C amplifier is used to am"+"plify a single-sideband phone signal?","answer":"D","choices":{"a":"Reduced intermodulation products","b":"Increased overall intelligibility","c":"Signal inversion","d":"Signal distortion and excessive bandwidth"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B08","question":"How can an RF power amplifier be neutralized?","answer":"C","choices":{"a":"By increasing the driving power","b":"By reducing the driving power","c":"By feeding a 180-degree out-of-phase portion of the output back to the input","d":"By feeding an in-phase component of the output back to the input"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B09","question":"Which of the following describes how the loading and tuning capacitors are to be"+" adjusted when tuning a vacuum tube RF power amplifier that employs a Pi-network"+" output circuit?","answer":"D","choices":{"a":"The loading capacitor is set to maximum capacitance and the tuning capacitor is "+"adjusted for minimum allowable plate current","b":"The tuning capacitor is set to maximum capacitance and the loading capacitor is "+"adjusted for minimum plate permissible current","c":"The loading capacitor is adjusted to minimum plate current while alternately adj"+"usting the tuning capacitor for maximum allowable plate current","d":"The tuning capacitor is adjusted for minimum plate current, and the loading capa"+"citor is adjusted for maximum permissible plate current"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B10","question":"In Figure E7-1, what is the purpose of R1 and R2?","answer":"B","choices":{"a":"Load resistors","b":"Fixed bias","c":"Self bias","d":"Feedback"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B11","question":"In Figure E7-1, what is the purpose of R3?","answer":"D","choices":{"a":"Fixed bias","b":"Emitter bypass","c":"Output load resistor","d":"Self bias"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B12","question":"What type of amplifier circuit is shown in Figure E7-1?","answer":"C","choices":{"a":"Common base","b":"Common collector","c":"Common emitter","d":"Emitter follower"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B13","question":"In Figure E7-2, what is the purpose of R?","answer":"A","choices":{"a":"Emitter load","b":"Fixed bias","c":"Collector load","d":"Voltage regulation"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B14","question":"Why are switching amplifiers more efficient than linear amplifiers?","answer":"B","choices":{"a":"Switching amplifiers operate at higher voltages","b":"The power transistor is at saturation or cut off most of the time, resulting in "+"low power dissipation","c":"Linear amplifiers have high gain resulting in higher harmonic content","d":"Switching amplifiers use push-pull circuits"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B15","question":"What is one way to prevent thermal runaway in a bipolar transistor amplifier?","answer":"C","choices":{"a":"Neutralization","b":"Select transistors with high beta","c":"Use a resistor in series with the emitter","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B16","question":"What is the effect of intermodulation products in a linear power amplifier?","answer":"A","choices":{"a":"Transmission of spurious signals","b":"Creation of parasitic oscillations","c":"Low efficiency","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B17","question":"Why are odd-order rather than even-order intermodulation distortion products of "+"concern in linear power amplifiers?","answer":"A","choices":{"a":"Because they are relatively close in frequency to the desired signal","b":"Because they are relatively far in frequency from the desired signal","c":"Because they invert the sidebands causing distortion","d":"Because they maintain the sidebands, thus causing multiple duplicate signals"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7B","questionID":"E7B18","question":"What is a characteristic of a grounded-grid amplifier?","answer":"C","choices":{"a":"High power gain","b":"High filament voltage","c":"Low input impedance","d":"Low bandwidth"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C01","question":"How are the capacitors and inductors of a low-pass filter Pi-network arranged be"+"tween the network's input and output?","answer":"D","choices":{"a":"Two inductors are in series between the input and output, and a capacitor is con"+"nected between the two inductors and ground","b":"Two capacitors are in series between the input and output, and an inductor is co"+"nnected between the two capacitors and ground","c":"An inductor is connected between the input and ground, another inductor is conne"+"cted between the output and ground, and a capacitor is connected between the inp"+"ut and output","d":"A capacitor is connected between the input and ground, another capacitor is conn"+"ected between the output and ground, and an inductor is connected between input "+"and output"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C02","question":"Which of the following is a property of a T-network with series capacitors and a"+" parallel shunt inductor?","answer":"C","choices":{"a":"It is a low-pass filter","b":"It is a band-pass filter","c":"It is a high-pass filter","d":"It is a notch filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C03","question":"What advantage does a Pi-L-network have over a regular Pi-network for impedance "+"matching between the final amplifier of a vacuum-tube transmitter and an antenna"+"?","answer":"A","choices":{"a":"Greater harmonic suppression","b":"Higher efficiency","c":"Lower losses","d":"Greater transformation range"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C04","question":"How does an impedance-matching circuit transform a complex impedance to a resist"+"ive impedance?","answer":"C","choices":{"a":"It introduces negative resistance to cancel the resistive part of impedance","b":"It introduces transconductance to cancel the reactive part of impedance","c":"It cancels the reactive part of the impedance and changes the resistive part to "+"a desired value","d":"Network resistances are substituted for load resistances and reactances are matc"+"hed to the resistances"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C05","question":"Which filter type is described as having ripple in the passband and a sharp cuto"+"ff?","answer":"D","choices":{"a":"A Butterworth filter","b":"An active LC filter","c":"A passive op-amp filter","d":"A Chebyshev filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C06","question":"What are the distinguishing features of an elliptical filter?","answer":"C","choices":{"a":"Gradual passband rolloff with minimal stop band ripple","b":"Extremely flat response over its pass band with gradually rounded stop band corn"+"ers","c":"Extremely sharp cutoff with one or more notches in the stop band","d":"Gradual passband rolloff with extreme stop band ripple"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C07","question":"What kind of filter would you use to attenuate an interfering carrier signal whi"+"le receiving an SSB transmission?","answer":"B","choices":{"a":"A band-pass filter","b":"A notch filter","c":"A Pi-network filter","d":"An all-pass filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C08","question":"Which of the following factors has the greatest effect in helping determine the "+"bandwidth and response shape of a crystal ladder filter?","answer":"A","choices":{"a":"The relative frequencies of the individual crystals","b":"The DC voltage applied to the quartz crystal","c":"The gain of the RF stage preceding the filter","d":"The amplitude of the signals passing through the filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C09","question":"What is a Jones filter as used as part of an HF receiver IF stage?","answer":"B","choices":{"a":"An automatic notch filter","b":"A variable bandwidth crystal lattice filter","c":"A special filter that emphasizes image responses","d":"A filter that removes impulse noise"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C10","question":"Which of the following filters would be the best choice for use in a 2 meter rep"+"eater duplexer?","answer":"B","choices":{"a":"A crystal filter","b":"A cavity filter","c":"A DSP filter","d":"An L-C filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C11","question":"Which of the following is the common name for a filter network which is equivale"+"nt to two L-networks connected back-to-back with the two inductors in series and"+" the capacitors in shunt at the input and output?","answer":"D","choices":{"a":"Pi-L","b":"Cascode","c":"Omega","d":"Pi"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C12","question":"Which describes a Pi-L-network used for matching a vacuum tube final amplifier t"+"o a 50 ohm unbalanced output?","answer":"B","choices":{"a":"A Phase Inverter Load network","b":"A Pi-network with an additional series inductor on the output","c":"A network with only three discrete parts","d":"A matching network in which all components are isolated from ground"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C13","question":"What is one advantage of a Pi-matching network over an L-matching network consis"+"ting of a single inductor and a single capacitor?","answer":"A","choices":{"a":"The Q of Pi-networks can be varied depending on the component values chosen","b":"L-networks cannot perform impedance transformation","c":"Pi-networks have fewer components","d":"Pi-networks are designed for balanced input and output"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C14","question":"Which mode is most affected by non-linear phase response in a receiver IF filter"+"?","answer":"C","choices":{"a":"Meteor scatter","b":"Single-Sideband voice","c":"Digital","d":"Video"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7C","questionID":"E7C15","question":"What is a crystal lattice filter?","answer":"D","choices":{"a":"A power supply filter made with interlaced quartz crystals","b":"An audio filter made with four quartz crystals that resonate at 1kHz intervals","c":"A filter with wide bandwidth and shallow skirts made using quartz crystals","d":"A filter with narrow bandwidth and steep skirts made using quartz crystals"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D01","question":"What is one characteristic of a linear electronic voltage regulator?","answer":"D","choices":{"a":"It has a ramp voltage as its output","b":"It eliminates the need for a pass transistor","c":"The control element duty cycle is proportional to the line or load conditions","d":"The conduction of a control element is varied to maintain a constant output volt"+"age"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D02","question":"What is one characteristic of a switching electronic voltage regulator?","answer":"C","choices":{"a":"The resistance of a control element is varied in direct proportion to the line v"+"oltage or load current","b":"It is generally less efficient than a linear regulator","c":"The controlled device�s duty cycle is changed to produce a constant average outp"+"ut voltage","d":"It gives a ramp voltage at its output"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D03","question":"What device is typically used as a stable reference voltage in a linear voltage "+"regulator?","answer":"A","choices":{"a":"A Zener diode","b":"A tunnel diode","c":"An SCR","d":"A varactor diode"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D04","question":"Which of the following types of linear voltage regulator usually make the most e"+"fficient use of the primary power source?","answer":"B","choices":{"a":"A series current source","b":"A series regulator","c":"A shunt regulator","d":"A shunt current source"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D05","question":"Which of the following types of linear voltage regulator places a constant load "+"on the unregulated voltage source?","answer":"D","choices":{"a":"A constant current source","b":"A series regulator","c":"A shunt current source","d":"A shunt regulator"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D06","question":"What is the purpose of Q1 in the circuit shown in Figure E7-3?","answer":"C","choices":{"a":"It provides negative feedback to improve regulation","b":"It provides a constant load for the voltage source","c":"It increases the current-handling capability of the regulator","d":"It provides D1 with current"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D07","question":"What is the purpose of C2 in the circuit shown in Figure E7-3?","answer":"A","choices":{"a":"It bypasses hum around D1","b":"It is a brute force filter for the output","c":"To self-resonate at the hum frequency","d":"To provide fixed DC bias for Q1"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D08","question":"What type of circuit is shown in Figure E7-3?","answer":"C","choices":{"a":"Switching voltage regulator","b":"Grounded emitter amplifier","c":"Linear voltage regulator","d":"Emitter follower"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D09","question":"What is the main reason to use a charge controller with a solar power system?","answer":"C","choices":{"a":"Prevention of battery undercharge","b":"Control of electrolyte levels during battery discharge","c":"Prevention of battery damage due to overcharge","d":"Matching of day and night charge rates"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D10","question":"What is the primary reason that a high-frequency switching type high voltage pow"+"er supply can be both less expensive and lighter in weight than a conventional p"+"ower supply?","answer":"C","choices":{"a":"The inverter design does not require any output filtering","b":"It uses a diode bridge rectifier for increased output","c":"The high frequency inverter design uses much smaller transformers and filter com"+"ponents for an equivalent power output","d":"It uses a large power factor compensation capacitor to create free power from th"+"e unused portion of the AC cycle"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D11","question":"What circuit element is controlled by a series analog voltage regulator to maint"+"ain a constant output voltage?","answer":"D","choices":{"a":"Reference voltage","b":"Switching inductance","c":"Error amplifier","d":"Pass transistor"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D12","question":"What is the drop-out voltage of an analog voltage regulator?","answer":"C","choices":{"a":"Minimum input voltage for rated power dissipation","b":"Maximum amount that the output voltage drops when the input voltage is varied ov"+"er its specified range","c":"Minimum input-to-output voltage required to maintain regulation","d":"Maximum amount that the output voltage may decrease at rated load"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D13","question":"What is the equation for calculating power dissipation by a series connected lin"+"ear voltage regulator?","answer":"C","choices":{"a":"Input voltage multiplied by input current","b":"Input voltage divided by output current","c":"Voltage difference from input to output multiplied by output current","d":"Output voltage multiplied by output current"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D14","question":"What is one purpose of a \"bleeder\" resistor in a conventional unregulated powe"+"r supply?","answer":"C","choices":{"a":"To cut down on waste heat generated by the power supply","b":"To balance the low-voltage filament windings","c":"To improve output voltage regulation","d":"To boost the amount of output current"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D15","question":"What is the purpose of a \"step-start\" circuit in a high voltage power supply?","answer":"D","choices":{"a":"To provide a dual-voltage output for reduced power applications","b":"To compensate for variations of the incoming line voltage","c":"To allow for remote control of the power supply","d":"To allow the filter capacitors to charge gradually"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7D","questionID":"E7D16","question":"When several electrolytic filter capacitors are connected in series to increase "+"the operating voltage of a power supply filter circuit, why should resistors be "+"connected across each capacitor?","answer":"D","choices":{"a":"To equalize, as much as possible, the voltage drop across each capacitor","b":"To provide a safety bleeder to discharge the capacitors when the supply is off","c":"To provide a minimum load current to reduce voltage excursions at light loads","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E01","question":"Which of the following can be used to generate FM phone emissions?","answer":"B","choices":{"a":"A balanced modulator on the audio amplifier","b":"A reactance modulator on the oscillator","c":"A reactance modulator on the final amplifier","d":"A balanced modulator on the oscillator"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E02","question":"What is the function of a reactance modulator?","answer":"D","choices":{"a":"To produce PM signals by using an electrically variable resistance","b":"To produce AM signals by using an electrically variable inductance or capacitanc"+"e","c":"To produce AM signals by using an electrically variable resistance","d":"To produce PM signals by using an electrically variable inductance or capacitanc"+"e"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E03","question":"How does an analog phase modulator function?","answer":"C","choices":{"a":"By varying the tuning of a microphone preamplifier to produce PM signals","b":"By varying the tuning of an amplifier tank circuit to produce AM signals","c":"By varying the tuning of an amplifier tank circuit to produce PM signals","d":"By varying the tuning of a microphone preamplifier to produce AM signals"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E04","question":"What is one way a single-sideband phone signal can be generated?","answer":"A","choices":{"a":"By using a balanced modulator followed by a filter","b":"By using a reactance modulator followed by a mixer","c":"By using a loop modulator followed by a mixer","d":"By driving a product detector with a DSB signal"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E05","question":"What circuit is added to an FM transmitter to boost the higher audio frequencies"+"?","answer":"D","choices":{"a":"A de-emphasis network","b":"A heterodyne suppressor","c":"An audio prescaler","d":"A pre-emphasis network"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E06","question":"Why is de-emphasis commonly used in FM communications receivers?","answer":"A","choices":{"a":"For compatibility with transmitters using phase modulation","b":"To reduce impulse noise reception","c":"For higher efficiency","d":"To remove third-order distortion products"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E07","question":"What is meant by the term baseband in radio communications?","answer":"B","choices":{"a":"The lowest frequency band that the transmitter or receiver covers","b":"The frequency components present in the modulating signal","c":"The unmodulated bandwidth of the transmitted signal","d":"The basic oscillator frequency in an FM transmitter that is multiplied to increa"+"se the deviation and carrier frequency"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E08","question":"What are the principal frequencies that appear at the output of a mixer circuit?","answer":"C","choices":{"a":"Two and four times the original frequency","b":"The sum, difference and square root of the input frequencies","c":"The two input frequencies along with their sum and difference frequencies","d":"1.414 and 0.707 times the input frequency"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E09","question":"What occurs when an excessive amount of signal energy reaches a mixer circuit?","answer":"A","choices":{"a":"Spurious mixer products are generated","b":"Mixer blanking occurs","c":"Automatic limiting occurs","d":"A beat frequency is generated"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E10","question":"How does a diode detector function?","answer":"A","choices":{"a":"By rectification and filtering of RF signals","b":"By breakdown of the Zener voltage","c":"By mixing signals with noise in the transition region of the diode","d":"By sensing the change of reactance in the diode with respect to frequency"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E11","question":"Which type of detector is used for demodulating SSB signals?","answer":"C","choices":{"a":"Discriminator","b":"Phase detector","c":"Product detector","d":"Phase comparator"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7E","questionID":"E7E12","question":"What is a frequency discriminator stage in a FM receiver?","answer":"D","choices":{"a":"An FM generator circuit","b":"A circuit for filtering two closely adjacent signals","c":"An automatic band-switching circuit","d":"A circuit for detecting FM signals"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F01","question":"What is meant by direct digital conversion as applied to software defined radios"+"?","answer":"C","choices":{"a":"Software is converted from source code to object code during operation of the re"+"ceiver","b":"Incoming RF is converted to a control voltage for a voltage controlled oscillato"+"r","c":"Incoming RF is digitized by an analog-to-digital converter without being mixed w"+"ith a local oscillator signal","d":"A switching mixer is used to generate I and Q signals directly from the RF input"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F02","question":"What kind of digital signal processing audio filter is used to remove unwanted n"+"oise from a received SSB signal?","answer":"A","choices":{"a":"An adaptive filter","b":"A crystal-lattice filter","c":"A Hilbert-transform filter","d":"A phase-inverting filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F03","question":"What type of digital signal processing filter is used to generate an SSB signal?","answer":"C","choices":{"a":"An adaptive filter","b":"A notch filter","c":"A Hilbert-transform filter","d":"An elliptical filter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F04","question":"What is a common method of generating an SSB signal using digital signal process"+"ing?","answer":"D","choices":{"a":"Mixing products are converted to voltages and subtracted by adder circuits","b":"A frequency synthesizer removes the unwanted sidebands","c":"Emulation of quartz crystal filter characteristics","d":"Combine signals with a quadrature phase relationship"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F05","question":"How frequently must an analog signal be sampled by an analog-to-digital converte"+"r so that the signal can be accurately reproduced?","answer":"B","choices":{"a":"At half the rate of the highest frequency component of the signal","b":"At twice the rate of the highest frequency component of the signal","c":"At the same rate as the highest frequency component of the signal","d":"At four times the rate of the highest frequency component of the signal"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F06","question":"What is the minimum number of bits required for an analog-to-digital converter t"+"o sample a signal with a range of 1 volt at a resolution of 1 millivolt?","answer":"D","choices":{"a":"4 bits","b":"6 bits","c":"8 bits","d":"10 bits"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F07","question":"What function can a Fast Fourier Transform perform?","answer":"C","choices":{"a":"Converting analog signals to digital form","b":"Converting digital signals to analog form","c":"Converting digital signals from the time domain to the frequency domain","d":"Converting 8-bit data to 16 bit data"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F08","question":"What is the function of decimation with regard to digital filters?","answer":"B","choices":{"a":"Converting data to binary code decimal form","b":"Reducing the effective sample rate by removing samples","c":"Attenuating the signal","d":"Removing unnecessary significant digits"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F09","question":"Why is an anti-aliasing digital filter required in a digital decimator?","answer":"A","choices":{"a":"It removes high-frequency signal components which would otherwise be reproduced "+"as lower frequency components","b":"It peaks the response of the decimator, improving bandwidth","c":"It removes low frequency signal components to eliminate the need for DC restorat"+"ion","d":"It notches out the sampling frequency to avoid sampling errors"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F10","question":"What aspect of receiver analog-to-digital conversion determines the maximum rece"+"ive bandwidth of a Direct Digital Conversion SDR?","answer":"A","choices":{"a":"Sample rate","b":"Sample width in bits","c":"Sample clock phase noise","d":"Processor latency"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F11","question":"What sets the minimum detectable signal level for an SDR in the absence of atmos"+"pheric or thermal noise?","answer":"B","choices":{"a":"Sample clock phase noise","b":"Reference voltage level and sample width in bits","c":"Data storage transfer rate","d":"Missing codes and jitter"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F12","question":"What digital process is applied to I and Q signals in order to recover the baseb"+"and modulation information?","answer":"A","choices":{"a":"Fast Fourier Transform","b":"Decimation","c":"Signal conditioning","d":"Quadrature mixing"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F13","question":"What is the function of taps in a digital signal processing filter?","answer":"D","choices":{"a":"To reduce excess signal pressure levels","b":"Provide access for debugging software","c":"Select the point at which baseband signals are generated","d":"Provide incremental signal delays for filter algorithms"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F14","question":"Which of the following would allow a digital signal processing filter to create "+"a sharper filter response?","answer":"B","choices":{"a":"Higher data rate","b":"More taps","c":"Complex phasor representations","d":"Double-precision math routines"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F15","question":"Which of the following is an advantage of a Finite Impulse Response (FIR) filter"+" vs an Infinite Impulse Response (IIR) digital filter?","answer":"A","choices":{"a":"FIR filters delay all frequency components of the signal by the same amount","b":"FIR filters are easier to implement for a given set of passband rolloff requirem"+"ents","c":"FIR filters can respond faster to impulses","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F16","question":"How might the sampling rate of an existing digital signal be adjusted by a facto"+"r of 3/4?","answer":"D","choices":{"a":"Change the gain by a factor of 3/4","b":"Multiply each sample value by a factor of 3/4","c":"Add 3 to each input value and subtract 4 from each output value","d":"Interpolate by a factor of three, then decimate by a factor of four"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7F","questionID":"E7F17","question":"What do the letters I and Q in I/Q Modulation represent?","answer":"D","choices":{"a":"Inactive and Quiescent","b":"Instantaneous and Quasi-stable","c":"Instantaneous and Quenched","d":"In-phase and Quadrature"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G01","question":"What is the typical output impedance of an integrated circuit op-amp?","answer":"A","choices":{"a":"Very low","b":"Very high","c":"100 ohms","d":"1000 ohms"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G02","question":"What is the effect of ringing in a filter?","answer":"D","choices":{"a":"An echo caused by a long time delay","b":"A reduction in high frequency response","c":"Partial cancellation of the signal over a range of frequencies","d":"Undesired oscillations added to the desired signal"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G03","question":"What is the typical input impedance of an integrated circuit op-amp?","answer":"D","choices":{"a":"100 ohms","b":"1000 ohms","c":"Very low","d":"Very high"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G04","question":"What is meant by the term op-amp input offset voltage?","answer":"C","choices":{"a":"The output voltage of the op-amp minus its input voltage","b":"The difference between the output voltage of the op-amp and the input voltage re"+"quired in the immediately following stage","c":"The differential input voltage needed to bring the open loop output voltage to z"+"ero","d":"The potential between the amplifier input terminals of the op-amp in an open loo"+"p condition"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G05","question":"How can unwanted ringing and audio instability be prevented in a multi-section o"+"p-amp RC audio filter circuit?","answer":"A","choices":{"a":"Restrict both gain and Q","b":"Restrict gain but increase Q","c":"Restrict Q but increase gain","d":"Increase both gain and Q"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G06","question":"Which of the following is the most appropriate use of an op-amp active filter?","answer":"D","choices":{"a":"As a high-pass filter used to block RFI at the input to receivers","b":"As a low-pass filter used between a transmitter and a transmission line","c":"For smoothing power supply output","d":"As an audio filter in a receiver"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G07","question":"What magnitude of voltage gain can be expected from the circuit in Figure E7-4 w"+"hen R1 is 10 ohms and RF is 470 ohms?","answer":"C","choices":{"a":"0.21","b":"94","c":"47","d":"24"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G08","question":"How does the gain of an ideal operational amplifier vary with frequency?","answer":"D","choices":{"a":"It increases linearly with increasing frequency","b":"It decreases linearly with increasing frequency","c":"It decreases logarithmically with increasing frequency","d":"It does not vary with frequency"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G09","question":"What will be the output voltage of the circuit shown in Figure E7-4 if R1 is 100"+"0 ohms, RF is 10,000 ohms, and 0.23 volts DC is applied to the input?","answer":"D","choices":{"a":"0.23 volts","b":"2.3 volts","c":"-0.23 volts","d":"-2.3 volts"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G10","question":"What absolute voltage gain can be expected from the circuit in Figure E7-4 when "+"R1 is 1800 ohms and RF is 68 kilohms?","answer":"C","choices":{"a":"1","b":"0.03","c":"38","d":"76"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G11","question":"What absolute voltage gain can be expected from the circuit in Figure E7-4 when "+"R1 is 3300 ohms and RF is 47 kilohms?","answer":"B","choices":{"a":"28","b":"14","c":"7","d":"0.07"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7G","questionID":"E7G12","question":"What is an integrated circuit operational amplifier?","answer":"A","choices":{"a":"A high-gain, direct-coupled differential amplifier with very high input impedanc"+"e and very low output impedance","b":"A digital audio amplifier whose characteristics are determined by components ext"+"ernal to the amplifier","c":"An amplifier used to increase the average output of frequency modulated amateur "+"signals to the legal limit","d":"A RF amplifier used in the UHF and microwave regions"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H01","question":"What are three oscillator circuits used in Amateur Radio equipment?","answer":"D","choices":{"a":"Taft, Pierce and negative feedback","b":"Pierce, Fenner and Beane","c":"Taft, Hartley and Pierce","d":"Colpitts, Hartley and Pierce"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H02","question":"Which describes a microphonic?","answer":"C","choices":{"a":"An IC used for amplifying microphone signals","b":"Distortion caused by RF pickup on the microphone cable","c":"Changes in oscillator frequency due to mechanical vibration","d":"Excess loading of the microphone by an oscillator"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H03","question":"How is positive feedback supplied in a Hartley oscillator?","answer":"A","choices":{"a":"Through a tapped coil","b":"Through a capacitive divider","c":"Through link coupling","d":"Through a neutralizing capacitor"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H04","question":"How is positive feedback supplied in a Colpitts oscillator?","answer":"C","choices":{"a":"Through a tapped coil","b":"Through link coupling","c":"Through a capacitive divider","d":"Through a neutralizing capacitor"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H05","question":"How is positive feedback supplied in a Pierce oscillator?","answer":"D","choices":{"a":"Through a tapped coil","b":"Through link coupling","c":"Through a neutralizing capacitor","d":"Through a quartz crystal"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H06","question":"Which of the following oscillator circuits are commonly used in VFOs?","answer":"B","choices":{"a":"Pierce and Zener","b":"Colpitts and Hartley","c":"Armstrong and deForest","d":"Negative feedback and balanced feedback"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H07","question":"How can an oscillator�s microphonic responses be reduced?","answer":"D","choices":{"a":"Use of NP0 capacitors","b":"Eliminating noise on the oscillator�s power supply","c":"Using the oscillator only for CW and digital signals","d":"Mechanically isolating the oscillator circuitry from its enclosure"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H08","question":"Which of the following components can be used to reduce thermal drift in crystal"+" oscillators?","answer":"A","choices":{"a":"NP0 capacitors","b":"Toroidal inductors","c":"Wirewound resistors","d":"Non-inductive resistors"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H09","question":"What type of frequency synthesizer circuit uses a phase accumulator, lookup tabl"+"e, digital to analog converter, and a low-pass anti-alias filter?","answer":"A","choices":{"a":"A direct digital synthesizer","b":"A hybrid synthesizer","c":"A phase locked loop synthesizer","d":"A diode-switching matrix synthesizer"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H10","question":"What information is contained in the lookup table of a direct digital frequency "+"synthesizer?","answer":"B","choices":{"a":"The phase relationship between a reference oscillator and the output waveform","b":"The amplitude values that represent a sine-wave output","c":"The phase relationship between a voltage-controlled oscillator and the output wa"+"veform","d":"The synthesizer frequency limits and frequency values stored in the radio memori"+"es"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H11","question":"What are the major spectral impurity components of direct digital synthesizers?","answer":"C","choices":{"a":"Broadband noise","b":"Digital conversion noise","c":"Spurious signals at discrete frequencies","d":"Nyquist limit noise"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H12","question":"Which of the following must be done to insure that a crystal oscillator provides"+" the frequency specified by the crystal manufacturer?","answer":"B","choices":{"a":"Provide the crystal with a specified parallel inductance","b":"Provide the crystal with a specified parallel capacitance","c":"Bias the crystal at a specified voltage","d":"Bias the crystal at a specified current"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H13","question":"Which of the following is a technique for providing highly accurate and stable o"+"scillators needed for microwave transmission and reception?","answer":"D","choices":{"a":"Use a GPS signal reference","b":"Use a rubidium stabilized reference oscillator","c":"Use a temperature-controlled high Q dielectric resonator","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H14","question":"What is a phase-locked loop circuit?","answer":"C","choices":{"a":"An electronic servo loop consisting of a ratio detector, reactance modulator, an"+"d voltage-controlled oscillator","b":"An electronic circuit also known as a monostable multivibrator","c":"An electronic servo loop consisting of a phase detector, a low-pass filter, a vo"+"ltage-controlled oscillator, and a stable reference oscillator","d":"An electronic circuit consisting of a precision push-pull amplifier with a diffe"+"rential input"},"metadata":""},{"exam":"E","section":"E7","subSection":"E7H","questionID":"E7H15","question":"Which of these functions can be performed by a phase-locked loop?","answer":"D","choices":{"a":"Wide-band AF and RF power amplification","b":"Comparison of two digital input signals, digital pulse counter","c":"Photovoltaic conversion, optical coupling","d":"Frequency synthesis, FM demodulation"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A01","question":"What is the name of the process that shows that a square wave is made up of a si"+"ne wave plus all of its odd harmonics?","answer":"A","choices":{"a":"Fourier analysis","b":"Vector analysis","c":"Numerical analysis","d":"Differential analysis"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A02","question":"What type of wave has a rise time significantly faster than its fall time (or vi"+"ce versa)?","answer":"C","choices":{"a":"A cosine wave","b":"A square wave","c":"A sawtooth wave","d":"A sine wave"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A03","question":"What type of wave does a Fourier analysis show to be made up of sine waves of a "+"given fundamental frequency plus all of its harmonics?","answer":"A","choices":{"a":"A sawtooth wave","b":"A square wave","c":"A sine wave","d":"A cosine wave"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A04","question":"What is \"dither\" with respect to analog to digital converters?","answer":"B","choices":{"a":"An abnormal condition where the converter cannot settle on a value to represent "+"the signal","b":"A small amount of noise added to the input signal to allow more precise represen"+"tation of a signal over time","c":"An error caused by irregular quantization step size","d":"A method of decimation by randomly skipping samples"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A05","question":"What would be the most accurate way of measuring the RMS voltage of a complex wa"+"veform?","answer":"D","choices":{"a":"By using a grid dip meter","b":"By measuring the voltage with a D'Arsonval meter","c":"By using an absorption wave meter","d":"By measuring the heating effect in a known resistor"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A06","question":"What is the approximate ratio of PEP-to-average power in a typical single-sideba"+"nd phone signal?","answer":"A","choices":{"a":"2.5 to 1","b":"25 to 1","c":"1 to 1","d":"100 to 1"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A07","question":"What determines the PEP-to-average power ratio of a single-sideband phone signal"+"?","answer":"B","choices":{"a":"The frequency of the modulating signal","b":"The characteristics of the modulating signal","c":"The degree of carrier suppression","d":"The amplifier gain"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A08","question":"Why would a direct or flash conversion analog-to-digital converter be useful for"+" a software defined radio?","answer":"C","choices":{"a":"Very low power consumption decreases frequency drift","b":"Immunity to out of sequence coding reduces spurious responses","c":"Very high speed allows digitizing high frequencies","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A09","question":"How many levels can an analog-to-digital converter with 8 bit resolution encode?","answer":"D","choices":{"a":"8","b":"8 multiplied by the gain of the input amplifier","c":"256 divided by the gain of the input amplifier","d":"256"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A10","question":"What is the purpose of a low pass filter used in conjunction with a digital-to-a"+"nalog converter?","answer":"C","choices":{"a":"Lower the input bandwidth to increase the effective resolution","b":"Improve accuracy by removing out of sequence codes from the input","c":"Remove harmonics from the output caused by the discrete analog levels generated","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A11","question":"What type of information can be conveyed using digital waveforms?","answer":"D","choices":{"a":"Human speech","b":"Video signals","c":"Data","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A12","question":"What is an advantage of using digital signals instead of analog signals to conve"+"y the same information?","answer":"C","choices":{"a":"Less complex circuitry is required for digital signal generation and detection","b":"Digital signals always occupy a narrower bandwidth","c":"Digital signals can be regenerated multiple times without error","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8A","questionID":"E8A13","question":"Which of these methods is commonly used to convert analog signals to digital sig"+"nals?","answer":"A","choices":{"a":"Sequential sampling","b":"Harmonic regeneration","c":"Level shifting","d":"Phase reversal"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B01","question":"What is the term for the ratio between the frequency deviation of an RF carrier "+"wave and the modulating frequency of its corresponding FM-phone signal?","answer":"D","choices":{"a":"FM compressibility","b":"Quieting index","c":"Percentage of modulation","d":"Modulation index"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B02","question":"How does the modulation index of a phase-modulated emission vary with RF carrier"+" frequency (the modulated frequency)?","answer":"D","choices":{"a":"It increases as the RF carrier frequency increases","b":"It decreases as the RF carrier frequency increases","c":"It varies with the square root of the RF carrier frequency","d":"It does not depend on the RF carrier frequency"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B03","question":"What is the modulation index of an FM-phone signal having a maximum frequency de"+"viation of 3000 Hz either side of the carrier frequency when the modulating freq"+"uency is 1000 Hz?","answer":"A","choices":{"a":"3","b":"0.3","c":"3000","d":"1000"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B04","question":"What is the modulation index of an FM-phone signal having a maximum carrier devi"+"ation of plus or minus 6 kHz when modulated with a 2 kHz modulating frequency?","answer":"B","choices":{"a":"6000","b":"3","c":"2000","d":"1/3"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B05","question":"What is the deviation ratio of an FM-phone signal having a maximum frequency swi"+"ng of plus-or-minus 5 kHz when the maximum modulation frequency is 3 kHz?","answer":"D","choices":{"a":"60","b":"0.167","c":"0.6","d":"1.67"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B06","question":"What is the deviation ratio of an FM-phone signal having a maximum frequency swi"+"ng of plus or minus 7.5 kHz when the maximum modulation frequency is 3.5 kHz?","answer":"A","choices":{"a":"2.14","b":"0.214","c":"0.47","d":"47"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B07","question":"Orthogonal Frequency Division Multiplexing is a technique used for which type of"+" amateur communication?","answer":"A","choices":{"a":"High speed digital modes","b":"Extremely low-power contacts","c":"EME","d":"OFDM signals are not allowed on amateur bands"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B08","question":"What describes Orthogonal Frequency Division Multiplexing?","answer":"D","choices":{"a":"A frequency modulation technique which uses non-harmonically related frequencies","b":"A bandwidth compression technique using Fourier transforms","c":"A digital mode for narrow band, slow speed transmissions","d":"A digital modulation technique using subcarriers at frequencies chosen to avoid "+"intersymbol interference"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B09","question":"What is meant by deviation ratio?","answer":"B","choices":{"a":"The ratio of the audio modulating frequency to the center carrier frequency","b":"The ratio of the maximum carrier frequency deviation to the highest audio modula"+"ting frequency","c":"The ratio of the carrier center frequency to the audio modulating frequency","d":"The ratio of the highest audio modulating frequency to the average audio modulat"+"ing frequency"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B10","question":"What describes frequency division multiplexing?","answer":"B","choices":{"a":"The transmitted signal jumps from band to band at a predetermined rate","b":"Two or more information streams are merged into a baseband, which then modulates"+" the transmitter","c":"The transmitted signal is divided into packets of information","d":"Two or more information streams are merged into a digital combiner, which then p"+"ulse position modulates the transmitter"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8B","questionID":"E8B11","question":"What is digital time division multiplexing?","answer":"B","choices":{"a":"Two or more data streams are assigned to discrete sub-carriers on an FM transmit"+"ter","b":"Two or more signals are arranged to share discrete time slots of a data transmis"+"sion","c":"Two or more data streams share the same channel by transmitting time of transmis"+"sion as the sub-carrier","d":"Two or more signals are quadrature modulated to increase bandwidth efficiency"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C01","question":"How is Forward Error Correction implemented?","answer":"C","choices":{"a":"By the receiving station repeating each block of three data characters","b":"By transmitting a special algorithm to the receiving station along with the data"+" characters","c":"By transmitting extra data that may be used to detect and correct transmission e"+"rrors","d":"By varying the frequency shift of the transmitted signal according to a predefin"+"ed algorithm"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C02","question":"What is the definition of symbol rate in a digital transmission?","answer":"C","choices":{"a":"The number of control characters in a message packet","b":"The duration of each bit in a message sent over the air","c":"The rate at which the waveform of a transmitted signal changes to convey informa"+"tion","d":"The number of characters carried per second by the station-to-station link"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C03","question":"When performing phase shift keying, why is it advantageous to shift phase precis"+"ely at the zero crossing of the RF carrier?","answer":"A","choices":{"a":"This results in the least possible transmitted bandwidth for the particular mode","b":"It is easier to demodulate with a conventional, non-synchronous detector","c":"It improves carrier suppression","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C04","question":"What technique is used to minimize the bandwidth requirements of a PSK31 signal?","answer":"C","choices":{"a":"Zero-sum character encoding","b":"Reed-Solomon character encoding","c":"Use of sinusoidal data pulses","d":"Use of trapezoidal data pulses"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C05","question":"What is the necessary bandwidth of a 13-WPM international Morse code transmissio"+"n?","answer":"C","choices":{"a":"Approximately 13 Hz","b":"Approximately 26 Hz","c":"Approximately 52 Hz","d":"Approximately 104 Hz"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C06","question":"What is the necessary bandwidth of a 170-hertz shift, 300-baud ASCII transmissio"+"n?","answer":"C","choices":{"a":"0.1 Hz","b":"0.3 kHz","c":"0.5 kHz","d":"1.0 kHz"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C07","question":"What is the necessary bandwidth of a 4800-Hz frequency shift, 9600-baud ASCII FM"+" transmission?","answer":"A","choices":{"a":"15.36 kHz","b":"9.6 kHz","c":"4.8 kHz","d":"5.76 kHz"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C08","question":"How does ARQ accomplish error correction?","answer":"D","choices":{"a":"Special binary codes provide automatic correction","b":"Special polynomial codes provide automatic correction","c":"If errors are detected, redundant data is substituted","d":"If errors are detected, a retransmission is requested"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C09","question":"Which is the name of a digital code where each preceding or following character "+"changes by only one bit?","answer":"D","choices":{"a":"Binary Coded Decimal Code","b":"Extended Binary Coded Decimal Interchange Code","c":"Excess 3 code","d":"Gray code"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C10","question":"What is an advantage of Gray code in digital communications where symbols are tr"+"ansmitted as multiple bits","answer":"D","choices":{"a":"It increases security","b":"It has more possible states than simple binary","c":"It has more resolution than simple binary","d":"It facilitates error detection"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8C","questionID":"E8C11","question":"What is the relationship between symbol rate and baud?","answer":"A","choices":{"a":"They are the same","b":"Baud is twice the symbol rate","c":"Symbol rate is only used for packet-based modes","d":"Baud is only used for RTTY"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D01","question":"Why are received spread spectrum signals resistant to interference?","answer":"A","choices":{"a":"Signals not using the spread spectrum algorithm are suppressed in the receiver","b":"The high power used by a spread spectrum transmitter keeps its signal from being"+" easily overpowered","c":"The receiver is always equipped with a digital blanker","d":"If interference is detected by the receiver it will signal the transmitter to ch"+"ange frequencies"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D02","question":"What spread spectrum communications technique uses a high speed binary bit strea"+"m to shift the phase of an RF carrier?","answer":"B","choices":{"a":"Frequency hopping","b":"Direct sequence","c":"Binary phase-shift keying","d":"Phase compandored spread spectrum"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D03","question":"How does the spread spectrum technique of frequency hopping work?","answer":"D","choices":{"a":"If interference is detected by the receiver it will signal the transmitter to ch"+"ange frequencies","b":"If interference is detected by the receiver it will signal the transmitter to wa"+"it until the frequency is clear","c":"A pseudo-random binary bit stream is used to shift the phase of an RF carrier ve"+"ry rapidly in a particular sequence","d":"The frequency of the transmitted signal is changed very rapidly according to a p"+"articular sequence also used by the receiving station"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D04","question":"What is the primary effect of extremely short rise or fall time on a CW signal?","answer":"C","choices":{"a":"More difficult to copy","b":"The generation of RF harmonics","c":"The generation of key clicks","d":"Limits data speed"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D05","question":"What is the most common method of reducing key clicks?","answer":"A","choices":{"a":"Increase keying waveform rise and fall times","b":"Low-pass filters at the transmitter output","c":"Reduce keying waveform rise and fall times","d":"High-pass filters at the transmitter output"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D06","question":"Which of the following indicates likely overmodulation of an AFSK signal such as"+" PSK or MFSK?","answer":"B","choices":{"a":"High reflected power","b":"Strong ALC action","c":"Harmonics on higher bands","d":"Rapid signal fading"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D07","question":"What is a common cause of overmodulation of AFSK signals?","answer":"D","choices":{"a":"Excessive numbers of retries","b":"Ground loops","c":"Bit errors in the modem","d":"Excessive transmit audio levels"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D08","question":"What parameter might indicate that excessively high input levels are causing dis"+"tortion in an AFSK signal?","answer":"D","choices":{"a":"Signal to noise ratio","b":"Baud rate","c":"Repeat Request Rate (RRR)","d":"Intermodulation Distortion (IMD)"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D09","question":"What is considered a good minimum IMD level for an idling PSK signal?","answer":"D","choices":{"a":"+10 dB","b":"+15 dB","c":"-20 dB","d":"-30 dB"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D10","question":"What are some of the differences between the Baudot digital code and ASCII?","answer":"B","choices":{"a":"Baudot uses 4 data bits per character, ASCII uses 7 or 8; Baudot uses 1 characte"+"r as a letters/figures shift code, ASCII has no letters/figures code","b":"Baudot uses 5 data bits per character, ASCII uses 7 or 8; Baudot uses 2 characte"+"rs as letters/figures shift codes, ASCII has no letters/figures shift code","c":"Baudot uses 6 data bits per character, ASCII uses 7 or 8; Baudot has no letters/"+"figures shift code, ASCII uses 2 letters/figures shift codes","d":"Baudot uses 7 data bits per character, ASCII uses 8; Baudot has no letters/figur"+"es shift code, ASCII uses 2 letters/figures shift codes"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D11","question":"What is one advantage of using ASCII code for data communications?","answer":"C","choices":{"a":"It includes built in error correction features","b":"It contains fewer information bits per character than any other code","c":"It is possible to transmit both upper and lower case text","d":"It uses one character as a shift code to send numeric and special characters"},"metadata":""},{"exam":"E","section":"E8","subSection":"E8D","questionID":"E8D12","question":"What is the advantage of including a parity bit with an ASCII character stream?","answer":"D","choices":{"a":"Faster transmission rate","b":"The signal can overpower interfering signals","c":"Foreign language characters can be sent","d":"Some types of errors can be detected"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A01","question":"What describes an isotropic antenna?","answer":"C","choices":{"a":"A grounded antenna used to measure earth conductivity","b":"A horizontally polarized antenna used to compare Yagi antennas","c":"A theoretical antenna used as a reference for antenna gain","d":"A spacecraft antenna used to direct signals toward the earth"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A02","question":"What antenna has no gain in any direction?","answer":"D","choices":{"a":"Quarter-wave vertical","b":"Yagi","c":"Half-wave dipole","d":"Isotropic antenna"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A03","question":"Why would one need to know the feed point impedance of an antenna?","answer":"A","choices":{"a":"To match impedances in order to minimize standing wave ratio on the transmission"+" line","b":"To measure the near-field radiation density from a transmitting antenna","c":"To calculate the front-to-side ratio of the antenna","d":"To calculate the front-to-back ratio of the antenna"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A04","question":"Which of the following factors may affect the feed point impedance of an antenna"+"?","answer":"B","choices":{"a":"Transmission-line length","b":"Antenna height, conductor length/diameter ratio and location of nearby conductiv"+"e objects","c":"The settings of an antenna tuner at the transmitter","d":"Sunspot activity and time of day"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A05","question":"What is included in the total resistance of an antenna system?","answer":"D","choices":{"a":"Radiation resistance plus space impedance","b":"Radiation resistance plus transmission resistance","c":"Transmission-line resistance plus radiation resistance","d":"Radiation resistance plus ohmic resistance"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A06","question":"How does the beamwidth of an antenna vary as the gain is increased?","answer":"D","choices":{"a":"It increases geometrically","b":"It increases arithmetically","c":"It is essentially unaffected","d":"It decreases"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A07","question":"What is meant by antenna gain?","answer":"A","choices":{"a":"The ratio of the radiated signal strength of an antenna in the direction of maxi"+"mum radiation to that of a reference antenna","b":"The ratio of the signal in the forward direction to that in the opposite directi"+"on","c":"The ratio of the amount of power radiated by an antenna compared to the transmit"+"ter output power","d":"The final amplifier gain minus the transmission line losses"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A08","question":"What is meant by antenna bandwidth?","answer":"B","choices":{"a":"Antenna length divided by the number of elements","b":"The frequency range over which an antenna satisfies a performance requirement","c":"The angle between the half-power radiation points","d":"The angle formed between two imaginary lines drawn through the element ends"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A09","question":"How is antenna efficiency calculated?","answer":"B","choices":{"a":"(radiation resistance / transmission resistance) x 100 per cent","b":"(radiation resistance / total resistance) x 100 per cent","c":"(total resistance / radiation resistance) x 100 per cent","d":"(effective radiated power / transmitter output) x 100 percent"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A10","question":"Which of the following choices is a way to improve the efficiency of a ground-mo"+"unted quarter-wave vertical antenna?","answer":"A","choices":{"a":"Install a good radial system","b":"Isolate the coax shield from ground","c":"Shorten the radiating element","d":"Reduce the diameter of the radiating element"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A11","question":"Which of the following factors determines ground losses for a ground-mounted ver"+"tical antenna operating in the 3 MHz to 30 MHz range?","answer":"C","choices":{"a":"The standing wave ratio","b":"Distance from the transmitter","c":"Soil conductivity","d":"Take-off angle"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A12","question":"How much gain does an antenna have compared to a 1/2-wavelength dipole when it h"+"as 6 dB gain over an isotropic antenna?","answer":"A","choices":{"a":"3.85 dB","b":"6.0 dB","c":"8.15 dB","d":"2.79 dB"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A13","question":"How much gain does an antenna have compared to a 1/2-wavelength dipole when it h"+"as 12 dB gain over an isotropic antenna?","answer":"B","choices":{"a":"6.17 dB","b":"9.85 dB","c":"12.5 dB","d":"14.15 dB"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A14","question":"What is meant by the radiation resistance of an antenna?","answer":"C","choices":{"a":"The combined losses of the antenna elements and feed line","b":"The specific impedance of the antenna","c":"The value of a resistance that would dissipate the same amount of power as that "+"radiated from an antenna","d":"The resistance in the atmosphere that an antenna must overcome to be able to rad"+"iate a signal"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A15","question":"What is the effective radiated power relative to a dipole of a repeater station "+"with 150 watts transmitter power output, 2 dB feed line loss, 2.2 dB duplexer lo"+"ss, and 7 dBd antenna gain?","answer":"D","choices":{"a":"1977 watts","b":"78.7 watts","c":"420 watts","d":"286 watts"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A16","question":"What is the effective radiated power relative to a dipole of a repeater station "+"with 200 watts transmitter power output, 4 dB feed line loss, 3.2 dB duplexer lo"+"ss, 0.8 dB circulator loss, and 10 dBd antenna gain?","answer":"A","choices":{"a":"317 watts","b":"2000 watts","c":"126 watts","d":"300 watts"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A17","question":"What is the effective radiated power of a repeater station with 200 watts transm"+"itter power output, 2 dB feed line loss, 2.8 dB duplexer loss, 1.2 dB circulator"+" loss, and 7 dBi antenna gain?","answer":"B","choices":{"a":"159 watts","b":"252 watts","c":"632 watts","d":"63.2 watts"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9A","questionID":"E9A18","question":"What term describes station output, taking into account all gains and losses?","answer":"C","choices":{"a":"Power factor","b":"Half-power bandwidth","c":"Effective radiated power","d":"Apparent power"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B01","question":"In the antenna radiation pattern shown in Figure E9-1, what is the 3 dB beam-wid"+"th?","answer":"B","choices":{"a":"75 degrees","b":"50 degrees","c":"25 degrees","d":"30 degrees"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B02","question":"In the antenna radiation pattern shown in Figure E9-1, what is the front-to-back"+" ratio?","answer":"B","choices":{"a":"36 dB","b":"18 dB","c":"24 dB","d":"14 dB"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B03","question":"In the antenna radiation pattern shown in Figure E9-1, what is the front-to-side"+" ratio?","answer":"B","choices":{"a":"12 dB","b":"14 dB","c":"18 dB","d":"24 dB"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B04","question":"What may occur when a directional antenna is operated at different frequencies w"+"ithin the band for which it was designed?","answer":"D","choices":{"a":"Feed point impedance may become negative","b":"The E-field and H-field patterns may reverse","c":"Element spacing limits could be exceeded","d":"The gain may change depending on frequency"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B05","question":"What type of antenna pattern over real ground is shown in Figure E9-2?","answer":"A","choices":{"a":"Elevation","b":"Azimuth","c":"Radiation resistance","d":"Polarization"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B06","question":"What is the elevation angle of peak response in the antenna radiation pattern sh"+"own in Figure E9-2?","answer":"C","choices":{"a":"45 degrees","b":"75 degrees","c":"7.5 degrees","d":"25 degrees"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B07","question":"How does the total amount of radiation emitted by a directional gain antenna com"+"pare with the total amount of radiation emitted from an isotropic antenna, assum"+"ing each is driven by the same amount of power?","answer":"C","choices":{"a":"The total amount of radiation from the directional antenna is increased by the g"+"ain of the antenna","b":"The total amount of radiation from the directional antenna is stronger by its fr"+"ont-to-back ratio","c":"They are the same","d":"The radiation from the isotropic antenna is 2.15 dB stronger than that from the "+"directional antenna"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B08","question":"How can the approximate beam-width in a given plane of a directional antenna be "+"determined?","answer":"A","choices":{"a":"Note the two points where the signal strength of the antenna is 3 dB less than m"+"aximum and compute the angular difference","b":"Measure the ratio of the signal strengths of the radiated power lobes from the f"+"ront and rear of the antenna","c":"Draw two imaginary lines through the ends of the elements and measure the angle "+"between the lines","d":"Measure the ratio of the signal strengths of the radiated power lobes from the f"+"ront and side of the antenna"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B09","question":"What type of computer program technique is commonly used for modeling antennas?","answer":"B","choices":{"a":"Graphical analysis","b":"Method of Moments","c":"Mutual impedance analysis","d":"Calculus differentiation with respect to physical properties"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B10","question":"What is the principle of a Method of Moments analysis?","answer":"A","choices":{"a":"A wire is modeled as a series of segments, each having a uniform value of curren"+"t","b":"A wire is modeled as a single sine-wave current generator","c":"A wire is modeled as a series of points, each having a distinct location in spac"+"e","d":"A wire is modeled as a series of segments, each having a distinct value of volta"+"ge across it"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B11","question":"What is a disadvantage of decreasing the number of wire segments in an antenna m"+"odel below the guideline of 10 segments per half-wavelength?","answer":"C","choices":{"a":"Ground conductivity will not be accurately modeled","b":"The resulting design will favor radiation of harmonic energy","c":"The computed feed point impedance may be incorrect","d":"The antenna will become mechanically unstable"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B12","question":"What is the far field of an antenna?","answer":"D","choices":{"a":"The region of the ionosphere where radiated power is not refracted","b":"The region where radiated power dissipates over a specified time period","c":"The region where radiated field strengths are obstructed by objects of reflectio"+"n","d":"The region where the shape of the antenna pattern is independent of distance"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B13","question":"What does the abbreviation NEC stand for when applied to antenna modeling progra"+"ms?","answer":"B","choices":{"a":"Next Element Comparison","b":"Numerical Electromagnetic Code","c":"National Electrical Code","d":"Numeric Electrical Computation"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B14","question":"What type of information can be obtained by submitting the details of a proposed"+" new antenna to a modeling program?","answer":"D","choices":{"a":"SWR vs frequency charts","b":"Polar plots of the far field elevation and azimuth patterns","c":"Antenna gain","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B15","question":"What is the front-to-back ratio of the radiation pattern shown in Figure E9-2?","answer":"B","choices":{"a":"15 dB","b":"28 dB","c":"3 dB","d":"24 dB"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9B","questionID":"E9B16","question":"How many elevation lobes appear in the forward direction of the antenna radiatio"+"n pattern shown in Figure E9-2?","answer":"A","choices":{"a":"4","b":"3","c":"1","d":"7"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C01","question":"What is the radiation pattern of two 1/4-wavelength vertical antennas spaced 1/2"+"-wavelength apart and fed 180 degrees out of phase?","answer":"D","choices":{"a":"Cardioid","b":"Omni-directional","c":"A figure-8 broadside to the axis of the array","d":"A figure-8 oriented along the axis of the array"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C02","question":"What is the radiation pattern of two 1/4 wavelength vertical antennas spaced 1/4"+" wavelength apart and fed 90 degrees out of phase?","answer":"A","choices":{"a":"Cardioid","b":"A figure-8 end-fire along the axis of the array","c":"A figure-8 broadside to the axis of the array","d":"Omni-directional"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C03","question":"What is the radiation pattern of two 1/4 wavelength vertical antennas spaced a 1"+"/2 wavelength apart and fed in phase?","answer":"C","choices":{"a":"Omni-directional","b":"Cardioid","c":"A Figure-8 broadside to the axis of the array","d":"A Figure-8 end-fire along the axis of the array"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C04","question":"What happens to the radiation pattern of an unterminated long wire antenna as th"+"e wire length is increased?","answer":"B","choices":{"a":"The lobes become more perpendicular to the wire","b":"The lobes align more in the direction of the wire","c":"The vertical angle increases","d":"The front-to-back ratio decreases"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C05","question":"What is an OCFD antenna?","answer":"A","choices":{"a":"A dipole feed approximately 1/3 the way from one end with a 4:1 balun to provide"+" multiband operation","b":"A remotely tunable dipole antenna using orthogonally controlled frequency divers"+"ity","c":"An eight band dipole antenna using octophase filters","d":"A multiband dipole antenna using one-way circular polarization for frequency div"+"ersity"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C06","question":"What is the effect of a terminating resistor on a rhombic antenna?","answer":"B","choices":{"a":"It reflects the standing waves on the antenna elements back to the transmitter","b":"It changes the radiation pattern from bidirectional to unidirectional","c":"It changes the radiation pattern from horizontal to vertical polarization","d":"It decreases the ground loss"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C07","question":"What is the approximate feed point impedance at the center of a two-wire folded "+"dipole antenna?","answer":"A","choices":{"a":"300 ohms","b":"72 ohms","c":"50 ohms","d":"450 ohms"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C08","question":"What is a folded dipole antenna?","answer":"C","choices":{"a":"A dipole one-quarter wavelength long","b":"A type of ground-plane antenna","c":"A dipole consisting of one wavelength of wire forming a very thin loop","d":"A dipole configured to provide forward gain"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C09","question":"What is a G5RV antenna?","answer":"A","choices":{"a":"A multi-band dipole antenna fed with coax and a balun through a selected length "+"of open wire transmission line","b":"A multi-band trap antenna","c":"A phased array antenna consisting of multiple loops","d":"A wide band dipole using shorted coaxial cable for the radiating elements and fe"+"d with a 4:1 balun"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C10","question":"Which of the following describes a Zepp antenna?","answer":"B","choices":{"a":"A dipole constructed from zip cord","b":"An end fed dipole antenna","c":"An omni-directional antenna commonly used for satellite communications","d":"A vertical array capable of quickly changing the direction of maximum radiation "+"by changing phasing lines"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C11","question":"How is the far-field elevation pattern of a vertically polarized antenna affecte"+"d by being mounted over seawater versus rocky ground?","answer":"D","choices":{"a":"The low-angle radiation decreases","b":"The high-angle radiation increases","c":"Both the high-angle and low-angle radiation decrease","d":"The low-angle radiation increases"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C12","question":"Which of the following describes an extended double Zepp antenna?","answer":"C","choices":{"a":"A wideband vertical antenna constructed from precisely tapered aluminum tubing","b":"A portable antenna erected using two push support poles","c":"A center fed 1.25 wavelength antenna (two 5/8 wave elements in phase)","d":"An end fed folded dipole antenna"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C13","question":"What is the main effect of placing a vertical antenna over an imperfect ground?","answer":"C","choices":{"a":"It causes increased SWR","b":"It changes the impedance angle of the matching network","c":"It reduces low-angle radiation","d":"It reduces losses in the radiating portion of the antenna"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C14","question":"How does the performance of a horizontally polarized antenna mounted on the side"+" of a hill compare with the same antenna mounted on flat ground?","answer":"B","choices":{"a":"The main lobe takeoff angle increases in the downhill direction","b":"The main lobe takeoff angle decreases in the downhill direction","c":"The horizontal beam width decreases in the downhill direction","d":"The horizontal beam width increases in the uphill direction"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9C","questionID":"E9C15","question":"How does the radiation pattern of a horizontally polarized 3-element beam antenn"+"a vary with its height above ground?","answer":"B","choices":{"a":"The main lobe takeoff angle increases with increasing height","b":"The main lobe takeoff angle decreases with increasing height","c":"The horizontal beam width increases with height","d":"The horizontal beam width decreases with height"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D01","question":"How does the gain of an ideal parabolic dish antenna change when the operating f"+"requency is doubled?","answer":"C","choices":{"a":"Gain does not change","b":"Gain is multiplied by 0.707","c":"Gain increases by 6 dB","d":"Gain increases by 3 dB"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D02","question":"How can linearly polarized Yagi antennas be used to produce circular polarizatio"+"n?","answer":"C","choices":{"a":"Stack two Yagis fed 90 degrees out of phase to form an array with the respective"+" elements in parallel planes","b":"Stack two Yagis fed in phase to form an array with the respective elements in pa"+"rallel planes","c":"Arrange two Yagis perpendicular to each other with the driven elements at the sa"+"me point on the boom fed 90 degrees out of phase","d":"Arrange two Yagis collinear to each other with the driven elements fed 180 degre"+"es out of phase"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D03","question":"Where should a high Q loading coil be placed to minimize losses in a shortened v"+"ertical antenna?","answer":"A","choices":{"a":"Near the center of the vertical radiator","b":"As low as possible on the vertical radiator","c":"As close to the transmitter as possible","d":"At a voltage node"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D04","question":"Why should an HF mobile antenna loading coil have a high ratio of reactance to r"+"esistance?","answer":"C","choices":{"a":"To swamp out harmonics","b":"To maximize losses","c":"To minimize losses","d":"To minimize the Q"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D05","question":"What is a disadvantage of using a multiband trapped antenna?","answer":"A","choices":{"a":"It might radiate harmonics","b":"It radiates the harmonics and fundamental equally well","c":"It is too sharply directional at lower frequencies","d":"It must be neutralized"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D06","question":"What happens to the bandwidth of an antenna as it is shortened through the use o"+"f loading coils?","answer":"B","choices":{"a":"It is increased","b":"It is decreased","c":"No change occurs","d":"It becomes flat"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D07","question":"What is an advantage of using top loading in a shortened HF vertical antenna?","answer":"D","choices":{"a":"Lower Q","b":"Greater structural strength","c":"Higher losses","d":"Improved radiation efficiency"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D08","question":"What happens as the Q of an antenna increases?","answer":"B","choices":{"a":"SWR bandwidth increases","b":"SWR bandwidth decreases","c":"Gain is reduced","d":"More common-mode current is present on the feed line"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D09","question":"What is the function of a loading coil used as part of an HF mobile antenna?","answer":"D","choices":{"a":"To increase the SWR bandwidth","b":"To lower the losses","c":"To lower the Q","d":"To cancel capacitive reactance"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D10","question":"What happens to feed point impedance at the base of a fixed length HF mobile ant"+"enna as the frequency of operation is lowered?","answer":"B","choices":{"a":"The radiation resistance decreases and the capacitive reactance decreases","b":"The radiation resistance decreases and the capacitive reactance increases","c":"The radiation resistance increases and the capacitive reactance decreases","d":"The radiation resistance increases and the capacitive reactance increases"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D11","question":"Which of the following types of conductors would be best for minimizing losses i"+"n a station's RF ground system?","answer":"B","choices":{"a":"A resistive wire, such as spark plug wire","b":"A wide flat copper strap","c":"A cable with six or seven 18 gauge conductors in parallel","d":"A single 12 gauge or 10 gauge stainless steel wire"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D12","question":"Which of the following would provide the best RF ground for your station?","answer":"C","choices":{"a":"A 50 ohm resistor connected to ground","b":"An electrically short connection to a metal water pipe","c":"An electrically short connection to 3 or 4 interconnected ground rods driven int"+"o the Earth","d":"An electrically short connection to 3 or 4 interconnected ground rods via a seri"+"es RF choke"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9D","questionID":"E9D13","question":"What usually occurs if a Yagi antenna is designed solely for maximum forward gai"+"n?","answer":"B","choices":{"a":"The front-to-back ratio increases","b":"The front-to-back ratio decreases","c":"The frequency response is widened over the whole frequency band","d":"The SWR is reduced"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E01","question":"What system matches a higher impedance transmission line to a lower impedance an"+"tenna by connecting the line to the driven element in two places spaced a fracti"+"on of a wavelength each side of element center?","answer":"B","choices":{"a":"The gamma matching system","b":"The delta matching system","c":"The omega matching system","d":"The stub matching system"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E02","question":"What is the name of an antenna matching system that matches an unbalanced feed l"+"ine to an antenna by feeding the driven element both at the center of the elemen"+"t and at a fraction of a wavelength to one side of center?","answer":"A","choices":{"a":"The gamma match","b":"The delta match","c":"The epsilon match","d":"The stub match"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E03","question":"What is the name of the matching system that uses a section of transmission line"+" connected in parallel with the feed line at or near the feed point?","answer":"D","choices":{"a":"The gamma match","b":"The delta match","c":"The omega match","d":"The stub match"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E04","question":"What is the purpose of the series capacitor in a gamma-type antenna matching net"+"work?","answer":"B","choices":{"a":"To provide DC isolation between the feed line and the antenna","b":"To cancel the inductive reactance of the matching network","c":"To provide a rejection notch that prevents the radiation of harmonics","d":"To transform the antenna impedance to a higher value"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E05","question":"How must the driven element in a 3-element Yagi be tuned to use a hairpin matchi"+"ng system?","answer":"A","choices":{"a":"The driven element reactance must be capacitive","b":"The driven element reactance must be inductive","c":"The driven element resonance must be lower than the operating frequency","d":"The driven element radiation resistance must be higher than the characteristic i"+"mpedance of the transmission line"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E06","question":"What is the equivalent lumped-constant network for a hairpin matching system of "+"a","answer":"C","choices":{"a":"lement Yagi?","b":"Pi-network","c":"Pi-L-network","d":"A shunt inductor"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E07","question":"What term best describes the interactions at the load end of a mismatched transm"+"ission line?","answer":"B","choices":{"a":"Characteristic impedance","b":"Reflection coefficient","c":"Velocity factor","d":"Dielectric constant"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E08","question":"Which of the following measurements is characteristic of a mismatched transmissi"+"on line?","answer":"D","choices":{"a":"An SWR less than 1:1","b":"A reflection coefficient greater than 1","c":"A dielectric constant greater than 1","d":"An SWR greater than 1:1"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E09","question":"Which of these matching systems is an effective method of connecting a 50 ohm co"+"axial cable feed line to a grounded tower so it can be used as a vertical antenn"+"a?","answer":"C","choices":{"a":"Double-bazooka match","b":"Hairpin match","c":"Gamma match","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E10","question":"Which of these choices is an effective way to match an antenna with a 100 ohm fe"+"ed point impedance to a 50 ohm coaxial cable feed line?","answer":"C","choices":{"a":"Connect a 1/4-wavelength open stub of 300 ohm twin-lead in parallel with the coa"+"xial feed line where it connects to the antenna","b":"Insert a 1/2 wavelength piece of 300 ohm twin-lead in series between the antenna"+" terminals and the 50 ohm feed cable","c":"Insert a 1/4-wavelength piece of 75 ohm coaxial cable transmission line in serie"+"s between the antenna terminals and the 50 ohm feed cable","d":"Connect 1/2 wavelength shorted stub of 75 ohm cable in parallel with the 50 ohm "+"cable where it attaches to the antenna"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E11","question":"What is an effective way of matching a feed line to a VHF or UHF antenna when th"+"e impedances of both the antenna and feed line are unknown?","answer":"B","choices":{"a":"Use a 50 ohm 1:1 balun between the antenna and feed line","b":"Use the universal stub matching technique","c":"Connect a series-resonant LC network across the antenna feed terminals","d":"Connect a parallel-resonant LC network across the antenna feed terminals"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E12","question":"What is the primary purpose of a phasing line when used with an antenna having m"+"ultiple driven elements?","answer":"A","choices":{"a":"It ensures that each driven element operates in concert with the others to creat"+"e the desired antenna pattern","b":"It prevents reflected power from traveling back down the feed line and causing h"+"armonic radiation from the transmitter","c":"It allows single-band antennas to operate on other bands","d":"It makes sure the antenna has a low-angle radiation pattern"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9E","questionID":"E9E13","question":"What is a use for a Wilkinson divider?","answer":"C","choices":{"a":"It divides the operating frequency of a transmitter signal so it can be used on "+"a lower frequency band","b":"It is used to feed high-impedance antennas from a low-impedance source","c":"It is used to divide power equally between two 50 ohm loads while maintaining 50"+" ohm input impedance","d":"It is used to feed low-impedance loads from a high-impedance source"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F01","question":"What is the velocity factor of a transmission line?","answer":"D","choices":{"a":"The ratio of the characteristic impedance of the line to the terminating impedan"+"ce","b":"The index of shielding for coaxial cable","c":"The velocity of the wave in the transmission line multiplied by the velocity of "+"light in a vacuum","d":"The velocity of the wave in the transmission line divided by the velocity of lig"+"ht in a vacuum"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F02","question":"Which of the following determines the velocity factor of a transmission line?","answer":"C","choices":{"a":"The termination impedance","b":"The line length","c":"Dielectric materials used in the line","d":"The center conductor resistivity"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F03","question":"Why is the physical length of a coaxial cable transmission line shorter than its"+" electrical length?","answer":"D","choices":{"a":"Skin effect is less pronounced in the coaxial cable","b":"The characteristic impedance is higher in a parallel feed line","c":"The surge impedance is higher in a parallel feed line","d":"Electrical signals move more slowly in a coaxial cable than in air"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F04","question":"What is the typical velocity factor for a coaxial cable with solid polyethylene "+"dielectric?","answer":"B","choices":{"a":"2.70","b":"0.66","c":"0.30","d":"0.10"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F05","question":"What is the approximate physical length of a solid polyethylene dielectric coaxi"+"al transmission line that is electrically one-quarter wavelength long at 14.1 MH"+"z?","answer":"C","choices":{"a":"20 meters","b":"2.3 meters","c":"3.5 meters","d":"0.2 meters"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F06","question":"What is the approximate physical length of an air-insulated, parallel conductor "+"transmission line that is electrically one-half wavelength long at 14.10 MHz?","answer":"C","choices":{"a":"15 meters","b":"20 meters","c":"10 meters","d":"71 meters"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F07","question":"How does ladder line compare to small-diameter coaxial cable such as RG-58 at 50"+" MHz?","answer":"A","choices":{"a":"Lower loss","b":"Higher SWR","c":"Smaller reflection coefficient","d":"Lower velocity factor"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F08","question":"What is the term for the ratio of the actual speed at which a signal travels thr"+"ough a transmission line to the speed of light in a vacuum?","answer":"A","choices":{"a":"Velocity factor","b":"Characteristic impedance","c":"Surge impedance","d":"Standing wave ratio"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F09","question":"What is the approximate physical length of a solid polyethylene dielectric coaxi"+"al transmission line that is electrically one-quarter wavelength long at 7.2 MHz"+"?","answer":"B","choices":{"a":"10 meters","b":"6.9 meters","c":"24 meters","d":"50 meters"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F10","question":"What impedance does a 1/8 wavelength transmission line present to a generator wh"+"en the line is shorted at the far end?","answer":"C","choices":{"a":"A capacitive reactance","b":"The same as the characteristic impedance of the line","c":"An inductive reactance","d":"The same as the input impedance to the final generator stage"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F11","question":"What impedance does a 1/8 wavelength transmission line present to a generator wh"+"en the line is open at the far end?","answer":"C","choices":{"a":"The same as the characteristic impedance of the line","b":"An inductive reactance","c":"A capacitive reactance","d":"The same as the input impedance of the final generator stage"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F12","question":"What impedance does a 1/4 wavelength transmission line present to a generator wh"+"en the line is open at the far end?","answer":"D","choices":{"a":"The same as the characteristic impedance of the line","b":"The same as the input impedance to the generator","c":"Very high impedance","d":"Very low impedance"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F13","question":"What impedance does a 1/4 wavelength transmission line present to a generator wh"+"en the line is shorted at the far end?","answer":"A","choices":{"a":"Very high impedance","b":"Very low impedance","c":"The same as the characteristic impedance of the transmission line","d":"The same as the generator output impedance"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F14","question":"What impedance does a 1/2 wavelength transmission line present to a generator wh"+"en the line is shorted at the far end?","answer":"B","choices":{"a":"Very high impedance","b":"Very low impedance","c":"The same as the characteristic impedance of the line","d":"The same as the output impedance of the generator"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F15","question":"What impedance does a 1/2 wavelength transmission line present to a generator wh"+"en the line is open at the far end?","answer":"A","choices":{"a":"Very high impedance","b":"Very low impedance","c":"The same as the characteristic impedance of the line","d":"The same as the output impedance of the generator"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9F","questionID":"E9F16","question":"Which of the following is a significant difference between foam dielectric coaxi"+"al cable and solid dielectric cable, assuming all other parameters are the same?","answer":"D","choices":{"a":"Foam dielectric has lower safe operating voltage limits","b":"Foam dielectric has lower loss per unit of length","c":"Foam dielectric has higher velocity factor","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G01","question":"Which of the following can be calculated using a Smith chart?","answer":"A","choices":{"a":"Impedance along transmission lines","b":"Radiation resistance","c":"Antenna radiation pattern","d":"Radio propagation"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G02","question":"What type of coordinate system is used in a Smith chart?","answer":"B","choices":{"a":"Voltage circles and current arcs","b":"Resistance circles and reactance arcs","c":"Voltage lines and current chords","d":"Resistance lines and reactance chords"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G03","question":"Which of the following is often determined using a Smith chart?","answer":"C","choices":{"a":"Beam headings and radiation patterns","b":"Satellite azimuth and elevation bearings","c":"Impedance and SWR values in transmission lines","d":"Trigonometric functions"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G04","question":"What are the two families of circles and arcs that make up a Smith chart?","answer":"C","choices":{"a":"Resistance and voltage","b":"Reactance and voltage","c":"Resistance and reactance","d":"Voltage and impedance"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G05","question":"What type of chart is shown in Figure E9-3?","answer":"A","choices":{"a":"Smith chart","b":"Free space radiation directivity chart","c":"Elevation angle radiation pattern chart","d":"Azimuth angle radiation pattern chart"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G06","question":"On the Smith chart shown in Figure E9-3, what is the name for the large outer ci"+"rcle on which the reactance arcs terminate?","answer":"B","choices":{"a":"Prime axis","b":"Reactance axis","c":"Impedance axis","d":"Polar axis"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G07","question":"On the Smith chart shown in Figure E9-3, what is the only straight line shown?","answer":"D","choices":{"a":"The reactance axis","b":"The current axis","c":"The voltage axis","d":"The resistance axis"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G08","question":"What is the process of normalization with regard to a Smith chart?","answer":"C","choices":{"a":"Reassigning resistance values with regard to the reactance axis","b":"Reassigning reactance values with regard to the resistance axis","c":"Reassigning impedance values with regard to the prime center","d":"Reassigning prime center with regard to the reactance axis"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G09","question":"What third family of circles is often added to a Smith chart during the process "+"of solving problems?","answer":"A","choices":{"a":"Standing wave ratio circles","b":"Antenna-length circles","c":"Coaxial-length circles","d":"Radiation-pattern circles"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G10","question":"What do the arcs on a Smith chart represent?","answer":"D","choices":{"a":"Frequency","b":"SWR","c":"Points with constant resistance","d":"Points with constant reactance"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9G","questionID":"E9G11","question":"How are the wavelength scales on a Smith chart calibrated?","answer":"B","choices":{"a":"In fractions of transmission line electrical frequency","b":"In fractions of transmission line electrical wavelength","c":"In fractions of antenna electrical wavelength","d":"In fractions of antenna electrical frequency"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H01","question":"When constructing a Beverage antenna, which of the following factors should be i"+"ncluded in the design to achieve good performance at the desired frequency?","answer":"D","choices":{"a":"Its overall length must not exceed 1/4 wavelength","b":"It must be mounted more than 1 wavelength above ground","c":"It should be configured as a four-sided loop","d":"It should be one or more wavelengths long"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H02","question":"Which is generally true for low band (160 meter and 80 meter) receiving antennas"+"?","answer":"A","choices":{"a":"Atmospheric noise is so high that gain over a dipole is not important","b":"They must be erected at least 1/2 wavelength above the ground to attain good dir"+"ectivity","c":"Low loss coax transmission line is essential for good performance","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H03","question":"~~","answer":"E","choices":{"a":"04 (B)","b":"t is an advantage of using a shielded loop antenna for direction finding?","c":"It automatically cancels ignition noise in mobile installations","d":"It is electro statically balanced against ground, giving better nulls"},"metadata":"ebruary 1, 201"},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H04","question":"What is an advantage of using a shielded loop antenna for direction finding?","answer":"B","choices":{"a":"It automatically cancels ignition noise in mobile installations","b":"It is electro statically balanced against ground, giving better nulls","c":"It eliminates tracking errors caused by strong out-of-band signals","d":"It allows stations to communicate without giving away their position"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H05","question":"What is the main drawback of a wire-loop antenna for direction finding?","answer":"A","choices":{"a":"It has a bidirectional pattern","b":"It is non-rotatable","c":"It receives equally well in all directions","d":"It is practical for use only on VHF bands"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H06","question":"What is the triangulation method of direction finding?","answer":"C","choices":{"a":"The geometric angles of sky waves from the source are used to determine its posi"+"tion","b":"A fixed receiving station plots three headings to the signal source","c":"Antenna headings from several different receiving locations are used to locate t"+"he signal source","d":"A fixed receiving station uses three different antennas to plot the location of "+"the signal source"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H07","question":"Why is it advisable to use an RF attenuator on a receiver being used for directi"+"on finding?","answer":"D","choices":{"a":"It narrows the bandwidth of the received signal to improve signal to noise ratio","b":"It compensates for the effects of an isotropic antenna, thereby improving direct"+"ivity","c":"It reduces loss of received signals caused by antenna pattern nulls, thereby inc"+"reasing sensitivity","d":"It prevents receiver overload which could make it difficult to determine peaks o"+"r nulls"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H08","question":"What is the function of a sense antenna?","answer":"A","choices":{"a":"It modifies the pattern of a DF antenna array to provide a null in one direction","b":"It increases the sensitivity of a DF antenna array","c":"It allows DF antennas to receive signals at different vertical angles","d":"It provides diversity reception that cancels multipath signals"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H09","question":"Which of the following describes the construction of a receiving loop antenna?","answer":"C","choices":{"a":"A large circularly polarized antenna","b":"A small coil of wire tightly wound around a toroidal ferrite core","c":"One or more turns of wire wound in the shape of a large open coil","d":"A vertical antenna coupled to a feed line through an inductive loop of wire"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H10","question":"How can the output voltage of a multiple turn receiving loop antenna be increase"+"d?","answer":"D","choices":{"a":"By reducing the permeability of the loop shield","b":"By increasing the number of wire turns in the loop and reducing the area of the "+"loop structure","c":"By winding adjacent turns in opposing directions","d":"By increasing either the number of wire turns in the loop or the area of the loo"+"p structure or both"},"metadata":""},{"exam":"E","section":"E9","subSection":"E9H","questionID":"E9H11","question":"What characteristic of a cardioid pattern antenna is useful for direction findin"+"g?","answer":"B","choices":{"a":"A very sharp peak","b":"A very sharp single null","c":"Broad band response","d":"High-radiation angle"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A01","question":"What is the primary function of an external earth connection or ground rod?","answer":"B","choices":{"a":"Reduce received noise","b":"Lightning protection","c":"Reduce RF current flow between pieces of equipment","d":"Reduce RFI to telephones and home entertainment systems"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A02","question":"When evaluating RF exposure levels from your station at a neighbor�s home, what "+"must you do?","answer":"B","choices":{"a":"Make sure signals from your station are less than the controlled MPE limits","b":"Make sure signals from your station are less than the uncontrolled MPE limits","c":"You need only evaluate exposure levels on your own property","d":"Advise your neighbors of the results of your tests"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A03","question":"Which of the following would be a practical way to estimate whether the RF field"+"s produced by an amateur radio station are within permissible MPE limits?","answer":"C","choices":{"a":"Use a calibrated antenna analyzer","b":"Use a hand calculator plus Smith-chart equations to calculate the fields","c":"Use an antenna modeling program to calculate field strength at accessible locati"+"ons","d":"All of the choices are correct"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A04","question":"When evaluating a site with multiple transmitters operating at the same time, th"+"e operators and licensees of which transmitters are responsible for mitigating o"+"ver-exposure situations?","answer":"C","choices":{"a":"Only the most powerful transmitter","b":"Only commercial transmitters","c":"Each transmitter that produces 5 percent or more of its MPE limit at accessible "+"locations","d":"Each transmitter operating with a duty-cycle greater than 50 percent"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A05","question":"What is one of the potential hazards of using microwaves in the amateur radio ba"+"nds?","answer":"B","choices":{"a":"Microwaves are ionizing radiation","b":"The high gain antennas commonly used can result in high exposure levels","c":"Microwaves often travel long distances by ionospheric reflection","d":"The extremely high frequency energy can damage the joints of antenna structures"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A06","question":"Why are there separate electric (E) and magnetic (H) field MPE limits?","answer":"D","choices":{"a":"The body reacts to electromagnetic radiation from both the E and H fields","b":"Ground reflections and scattering make the field impedance vary with location","c":"E field and H field radiation intensity peaks can occur at different locations","d":"All of these choices are correct"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A07","question":"How may dangerous levels of carbon monoxide from an emergency generator be detec"+"ted?","answer":"B","choices":{"a":"By the odor","b":"Only with a carbon monoxide detector","c":"Any ordinary smoke detector can be used","d":"By the yellowish appearance of the gas"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A08","question":"What does SAR measure?","answer":"C","choices":{"a":"Synthetic Aperture Ratio of the human body","b":"Signal Amplification Rating","c":"The rate at which RF energy is absorbed by the body","d":"The rate of RF energy reflected from stationary terrain"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A09","question":"Which insulating material commonly used as a thermal conductor for some types of"+" electronic devices is extremely toxic if broken or crushed and the particles ar"+"e accidentally inhaled?","answer":"C","choices":{"a":"Mica","b":"Zinc oxide","c":"Beryllium Oxide","d":"Uranium Hexafluoride"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A10","question":"What toxic material may be present in some electronic components such as high vo"+"ltage capacitors and transformers?","answer":"A","choices":{"a":"Polychlorinated Biphenyls","b":"Polyethylene","c":"Polytetrafluroethylene","d":"Polymorphic silicon"},"metadata":""},{"exam":"E","section":"E0","subSection":"E0A","questionID":"E0A11","question":"Which of the following injuries can result from using high-power UHF or microwav"+"e transmitters?","answer":"C","choices":{"a":"Hearing loss caused by high voltage corona discharge","b":"Blood clotting from the intense magnetic field","c":"Localized heating of the body from RF exposure in excess of the MPE limits","d":"Ingestion of ozone gas from the cooling system"},"metadata":""}]});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({"sections":[{"subElement":"G1","subElementDescription":"COMMISSION'S RULES [5 Exam Questions - 5 Groups]","stats":["5 Exam Questions "," 5 Groups"],"numQuestions":"5","numGroups":"5"},{"subElement":"G2","subElementDescription":"OPERATING PROCEDURES [5 Exam Questions - 5 Groups]","stats":["5 Exam Questions "," 5 Groups"],"numQuestions":"5","numGroups":"5"},{"subElement":"G3","subElementDescription":"RADIO WAVE PROPAGATION [3 Exam Questions - 3 Groups] ","stats":["3 Exam Questions "," 3 Groups"],"numQuestions":"3","numGroups":"3"},{"subElement":"G4","subElementDescription":"AMATEUR RADIO PRACTICES [5 Exam Questions - 5 groups]","stats":["5 Exam Questions "," 5 groups"],"numQuestions":"5","numGroups":"5"},{"subElement":"G5","subElementDescription":"ELECTRICAL PRINCIPLES [3 Exam Questions – 3 Groups] ","stats":["3 Exam Questions – 3 Groups"],"numQuestions":"3","numGroups":""},{"subElement":"G6","subElementDescription":"CIRCUIT COMPONENTS [2 Exam Questions – 2 Groups]","stats":["2 Exam Questions – 2 Groups"],"numQuestions":"2","numGroups":""},{"subElement":"G8","subElementDescription":"SIGNALS AND EMISSIONS [3 Exam Questions – 3 Groups]","stats":["3 Exam Questions – 3 Groups"],"numQuestions":"3","numGroups":""},{"subElement":"G9","subElementDescription":"ANTENNAS AND FEED LINES [4 Exam Questions – 4 Groups]","stats":["4 Exam Questions – 4 Groups"],"numQuestions":"4","numGroups":""},{"subElement":"G0","subElementDescription":"ELECTRICAL AND RF SAFETY [2 Exam Questions – 2 Groups]","stats":["2 Exam Questions – 2 Groups"],"numQuestions":"2","numGroups":""}],"categories":[{"category":"G1A","categoryDescription":"General Class control operator frequency privileges; primary and secondary alloc"+"ations "},{"category":"G1B","categoryDescription":"Antenna structure limitations; good engineering and good amateur practice; beaco"+"n operation; prohibited transmissions; retransmitting radio signals "},{"category":"G1C","categoryDescription":"Transmitter power regulations; data emission standards"},{"category":"G1D","categoryDescription":"Volunteer Examiners and Volunteer Examiner Coordinators; temporary identificatio"+"n "},{"category":"G1E","categoryDescription":"Control categories; repeater regulations; harmful interference; third party rule"+"s; ITU regions; automatically controlled digital station"},{"category":"G2A","categoryDescription":"Phone operating procedures; USB/LSB conventions; procedural signals; breaking in"+"to a contact; VOX operation"},{"category":"G2B","categoryDescription":"Operating courtesy; band plans; emergencies, including drills and emergency comm"+"unications"},{"category":"G2C","categoryDescription":"CW operating procedures and procedural signals; Q signals and common abbreviatio"+"ns: full break in"},{"category":"G2D","categoryDescription":"Amateur Auxiliary; minimizing interference; HF operations"},{"category":"G2E","categoryDescription":"Digital operating: procedures, procedural signals and common abbreviations"},{"category":"G3A","categoryDescription":"Sunspots and solar radiation; ionospheric disturbances; propagation forecasting "+"and indices "},{"category":"G3B","categoryDescription":"Maximum Usable Frequency; Lowest Usable Frequency; propagation"},{"category":"G3C","categoryDescription":"Ionospheric layers; critical angle and frequency; HF scatter; Near Vertical Inci"+"dence Sky-wave"},{"category":"G4A","categoryDescription":"Station Operation and set up"},{"category":"G4B","categoryDescription":"Test and monitoring equipment; two-tone test"},{"category":"G4C","categoryDescription":"Interference with consumer electronics; grounding; DSP"},{"category":"G4D","categoryDescription":"Speech processors; S meters; sideband operation near band edges"},{"category":"G4E","categoryDescription":"HF mobile radio installations; emergency and battery powered operation "},{"category":"G5A","categoryDescription":"Reactance; inductance; capacitance; impedance; impedance matching"},{"category":"G5B","categoryDescription":"The Decibel; current and voltage dividers; electrical power calculations; sine w"+"ave root-mean-square (RMS) values; PEP calculations"},{"category":"G5C","categoryDescription":"Resistors, capacitors, and inductors in series and parallel; transformers"},{"category":"G6A","categoryDescription":"Resistors; Capacitors; Inductors; Rectifiers; solid state diodes and transistors"+"; vacuum tubes; batteries"},{"category":"G6B","categoryDescription":"Analog and digital integrated circuits (ICs); microprocessors; memory; I/O devic"+"es; microwave ICs (MMICs); display devices "},{"category":"G7A","categoryDescription":"wer supplies; and schematic symbols"},{"category":"G7B","categoryDescription":"Digital circuits; amplifiers and oscillators "},{"category":"G7C","categoryDescription":"Receivers and transmitters; filters, oscillators "},{"category":"G8A","categoryDescription":"Carriers and modulation: AM; FM; single sideband; modulation envelope; digital m"+"odulation; overmodulation "},{"category":"G8B","categoryDescription":"Frequency mixing; multiplication; bandwidths of various modes; deviation; duty c"+"ycle"},{"category":"G8C","categoryDescription":"Digital emission modes "},{"category":"G9A","categoryDescription":"Antenna feed lines: characteristic impedance, and attenuation; SWR calculation, "+"measurement and effects; matching networks "},{"category":"G9B","categoryDescription":"Basic antennas"},{"category":"G9C","categoryDescription":"Directional antennas"},{"category":"G9D","categoryDescription":"Specialized antennas"},{"category":"G0A","categoryDescription":"RF safety principles, rules and guidelines; routine station evaluation"},{"category":"G0B","categoryDescription":"Safety in the ham shack: electrical shock and treatment, safety grounding, fusin"+"g, interlocks, wiring, antenna and tower safety"}],"questions":[{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A01","question":"On which of the following bands is a General Class license holder granted all am"+"ateur frequency privileges?","answer":"C","choices":{"a":"60, 20, 17, and 12 meters","b":"160, 80, 40, and 10 meters","c":"160, 60, 30, 17, 12, and 10 meters","d":"160, 30, 17, 15, 12, and 10 meters"},"metadata":"97.301(d)"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A02","question":"On which of the following bands is phone operation prohibited?","answer":"B","choices":{"a":"160 meters","b":"30 meters","c":"17 meters","d":"12 meters"},"metadata":"97.305"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A03","question":"On which of the following bands is image transmission prohibited? ","answer":"B","choices":{"a":"160 meters","b":"30 meters","c":"20 meters","d":"12 meters"},"metadata":"97.305"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A04","question":"Which of the following amateur bands is restricted to communication on only spec"+"ific channels, rather than frequency ranges?","answer":"D","choices":{"a":"11 meters","b":"12 meters","c":"30 meters","d":"60 meters"},"metadata":"97.303 (h)"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A05","question":"Which of the following frequencies is in the General Class portion of the 40-met"+"er band?","answer":"A","choices":{"a":"7.250 MHz","b":"7.500 MHz","c":"40.200 MHz","d":"40.500 MHz"},"metadata":"97.301(d)"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A06","question":"Which of the following frequencies is within the General Class portion of the 75"+"-meter phone band?","answer":"C","choices":{"a":"1875 kHz","b":"3750 kHz","c":"3900 kHz","d":"4005 kHz"},"metadata":"97.301(d)] "},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A07","question":"Which of the following frequencies is within the General Class portion of the 20"+"-meter phone band?","answer":"C","choices":{"a":"14005 kHz","b":"14105 kHz","c":"14305 kHz","d":"14405 kHz"},"metadata":"97.301(d)"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A08","question":"Which of the following frequencies is within the General Class portion of the 80"+"-meter band?","answer":"C","choices":{"a":"1855 kHz","b":"2560 kHz","c":"3560 kHz","d":"3650 kHz"},"metadata":"97.301(d)] "},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A09","question":"Which of the following frequencies is within the General Class portion of the 15"+"-meter band?","answer":"C","choices":{"a":"14250 kHz","b":"18155 kHz","c":"21300 kHz","d":"24900 kHz"},"metadata":"97.301(d)] "},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A10","question":"Which of the following frequencies is available to a control operator holding a "+"General Class license?","answer":"D","choices":{"a":"28.020 MHz","b":"28.350 MHz","c":"28.550 MHz","d":"All of these choices are correct"},"metadata":"97.301(d)"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A11","question":"When General Class licensees are not permitted to use the entire voice portion o"+"f a particular band, which portion of the voice segment is generally available t"+"o them? ","answer":"B","choices":{"a":"The lower frequency end","b":"The upper frequency end","c":"The lower frequency end on frequencies below 7.3 MHz and the upper end on freque"+"ncies above 14.150 MHz","d":"The upper frequency end on frequencies below 7.3 MHz and the lower end on freque"+"ncies above 14.150 MHz"},"metadata":"97.301] "},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A12","question":"Which of the following applies when the FCC rules designate the Amateur Service "+"as a secondary user on a band?","answer":"C","choices":{"a":"Amateur stations must record the call sign of the primary service station before"+" operating on a frequency assigned to that station","b":"Amateur stations are allowed to use the band only during emergencies","c":"Amateur stations are allowed to use the band only if they do not cause harmful i"+"nterference to primary users","d":"Amateur stations may only operate during specific hours of the day, while primar"+"y users are permitted 24 hour use of the band"},"metadata":"97.303]"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A13","question":"What is the appropriate action if, when operating on either the 30-meter or 60-m"+"eter bands, a station in the primary service interferes with your contact? ","answer":"D","choices":{"a":"Notify the FCCs regional Engineer in Charge of the interference","b":"Increase your transmitter's power to overcome the interference","c":"Attempt to contact the station and request that it stop the interference","d":"Move to a clear frequency or stop transmitting"},"metadata":"97.303(h)(2)(j)"},{"exam":"G","section":"G1","subSection":"G1A","questionID":"G1A14","question":"In what ITU region is operation in the 7.175 to 7.300 MHz band permitted for a c"+"ontrol operator holding an FCC issued General Class license?","answer":"B","choices":{"a":"Region 1","b":"Region 2","c":"Region 3","d":"All three regions"},"metadata":"97.301(d)] "},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B01","question":"What is the maximum height above ground to which an antenna structure may be ere"+"cted without requiring notification to the FAA and registration with the FCC, pr"+"ovided it is not at or near a public use airport?","answer":"C","choices":{"a":"50 feet","b":"100 feet","c":"200 feet","d":"300 feet"},"metadata":"97.15(a)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B02","question":"With which of the following conditions must beacon stations comply?","answer":"D","choices":{"a":"A beacon station may not use automatic control","b":"The frequency must be coordinated with the National Beacon Organization","c":"The frequency must be posted on the Internet or published in a national periodic"+"al","d":"There must be no more than one beacon signal transmitting in the same band from "+"the same station location"},"metadata":"97.203(b)] "},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B03","question":"Which of the following is a purpose of a beacon station as identified in the FCC"+" rules?","answer":"A","choices":{"a":"Observation of propagation and reception","b":"Automatic identification of repeaters","c":"Transmission of bulletins of general interest to Amateur Radio licensees","d":"Identifying net frequencies"},"metadata":"97.3(a)(9)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B04","question":"Which of the following must be true before amateur stations may provide communic"+"ations to broadcasters for dissemination to the public?","answer":"A","choices":{"a":"The communications must directly relate to the immediate safety of human life or"+" protection of property and there must be no other means of communication reason"+"ably available before or at the time of the event","b":"The communications must be approved by a local emergency preparedness official a"+"nd conducted on officially designated frequencies","c":"The FCC must have declared a state of emergency","d":"All of these choices are correct"},"metadata":"97.113(b)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B05","question":"When may music be transmitted by an amateur station?","answer":"D","choices":{"a":"At any time, as long as it produces no spurious emissions","b":"When it is unintentionally transmitted from the background at the transmitter","c":"When it is transmitted on frequencies above 1215 MHz","d":"When it is an incidental part of a manned space craft retransmission"},"metadata":"97.113(c)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B06","question":"When is an amateur station permitted to transmit secret codes?","answer":"B","choices":{"a":"During a declared communications emergency","b":"To control a space station","c":"Only when the information is of a routine, personal nature","d":"Only with Special Temporary Authorization from the FCC"},"metadata":"97.113(a)(4) and 97.207(f)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B07","question":"What are the restrictions on the use of abbreviations or procedural signals in t"+"he Amateur Service?","answer":"B","choices":{"a":"Only \"Q\" signals are permitted","b":"They may be used if they do not obscure the meaning of a message","c":"They are not permitted","d":"Only \"10 codes\" are permitted"},"metadata":"97.113(a)(4)] "},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B08","question":"When choosing a transmitting frequency, what should you do to comply with good a"+"mateur practice?","answer":"D","choices":{"a":"Insure that the frequency and mode selected are within your license class privil"+"eges","b":"Follow generally accepted band plans agreed to by the Amateur Radio community","c":"Monitor the frequency before transmitting","d":"All of these choices are correct"},"metadata":"97.101(a)]"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B09","question":"When may an amateur station transmit communications in which the licensee or con"+"trol operator has a pecuniary (monetary) interest?","answer":"A","choices":{"a":"When other amateurs are being notified of the sale of apparatus normally used in"+" an amateur station and such activity is not done on a regular basis","b":"Only when there is no other means of communications readily available","c":"When other amateurs are being notified of the sale of any item with a monetary v"+"alue less than $200 and such activity is not done on a regular basis","d":"Never"},"metadata":"97.113(a)(3)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B10","question":"What is the power limit for beacon stations?","answer":"C","choices":{"a":"10 watts PEP output","b":"20 watts PEP output","c":"100 watts PEP output","d":"200 watts PEP output"},"metadata":"97.203(c)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B11","question":"How does the FCC require an amateur station to be operated in all respects not s"+"pecifically covered by the Part 97 rules?","answer":"C","choices":{"a":"In conformance with the rules of the IARU","b":"In conformance with Amateur Radio custom","c":"In conformance with good engineering and good amateur practice","d":"All of these choices are correct"},"metadata":"97.101(a)"},{"exam":"G","section":"G1","subSection":"G1B","questionID":"G1B12","question":"Who or what determines \"good engineering and good amateur practice\" as applied"+" to the operation of an amateur station in all respects not covered by the Part "+"97 rules?","answer":"A","choices":{"a":"The FCC","b":"The Control Operator","c":"The IEEE","d":"The ITU"},"metadata":"97.101(a)"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C01","question":"What is the maximum transmitting power an amateur station may use on 10.140 MHz?","answer":"A","choices":{"a":"200 watts PEP output","b":"1000 watts PEP output","c":"1500 watts PEP output","d":"2000 watts PEP output"},"metadata":"97.313(c)(1)"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C02","question":"What is the maximum transmitting power an amateur station may use on the 12-mete"+"r band?","answer":"C","choices":{"a":"50 watts PEP output","b":"200 watts PEP output","c":"1500 watts PEP output","d":"An effective radiated power equivalent to 100 watts from a half-wave dipole"},"metadata":"97.313(a),(b)]"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C03","question":"What is the maximum bandwidth permitted by FCC rules for Amateur Radio stations "+"transmitting on USB frequencies in the 60-meter band?","answer":"A","choices":{"a":"2.8 kHz","b":"5.6 kHz","c":"1.8 kHz","d":"3 kHz"},"metadata":"97.303(h)(1)]"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C04","question":"Which of the following limitations apply to transmitter power on every amateur b"+"and?","answer":"A","choices":{"a":"Only the minimum power necessary to carry out the desired communications should "+"be used","b":"Power must be limited to 200 watts when transmitting between 14.100 MHz and 14.1"+"50 MHz","c":"Power should be limited as necessary to avoid interference to another radio serv"+"ice on the frequency","d":"Effective radiated power cannot exceed 1500 watts"},"metadata":"97.313(a)]"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C05","question":"Which of the following is a limitation on transmitter power on the 28 MHz band f"+"or a General Class control operator?","answer":"C","choices":{"a":"100 watts PEP output","b":"1000 watts PEP output","c":"1500 watts PEP output","d":"2000 watts PEP output"},"metadata":"97.313(c)(2)] "},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C06","question":"Which of the following is a limitation on transmitter power on the 1.8 MHz band?","answer":"D","choices":{"a":"200 watts PEP output","b":"1000 watts PEP output","c":"1200 watts PEP output","d":"1500 watts PEP output"},"metadata":"97.313"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C07","question":"What is the maximum symbol rate permitted for RTTY or data emission transmission"+" on the 20-meter band?","answer":"D","choices":{"a":"56 kilobaud","b":"19.6 kilobaud","c":"1200 baud","d":"300 baud"},"metadata":"97.305(c), 97.307(f)(3)]"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C08","question":"What is the maximum symbol rate permitted for RTTY or data emission transmitted "+"at frequencies below 28 MHz? ","answer":"D","choices":{"a":"56 kilobaud","b":"19.6 kilobaud","c":"1200 baud","d":"300 baud"},"metadata":"97.307(f)(3)]"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C09","question":"What is the maximum symbol rate permitted for RTTY or data emission transmitted "+"on the 1.25-meter and 70-centimeter bands?","answer":"A","choices":{"a":"56 kilobaud","b":"19.6 kilobaud","c":"1200 baud","d":"300 baud"},"metadata":"97.305(c) and 97.307(f)(5)]"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C10","question":"What is the maximum symbol rate permitted for RTTY or data emission transmission"+"s on the 10-meter band?","answer":"C","choices":{"a":"56 kilobaud","b":"19.6 kilobaud","c":"1200 baud","d":"300 baud"},"metadata":"97.305(c) and 97.307(f)(4)"},{"exam":"G","section":"G1","subSection":"G1C","questionID":"G1C11","question":"What is the maximum symbol rate permitted for RTTY or data emission transmission"+"s on the 2-meter band?","answer":"B","choices":{"a":"56 kilobaud","b":"19.6 kilobaud","c":"1200 baud","d":"300 baud"},"metadata":"97.305(c) and 97.307(f)(5)"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D01","question":"Who may receive credit for the elements represented by an expired amateur radio "+"license?","answer":"A","choices":{"a":"Any person who can demonstrate that they once held an FCC issued General, Advanc"+"ed, or Amateur Extra class license that was not revoked by the FCC","b":"Anyone who held an FCC issued amateur radio license that has been expired for no"+"t less than 5 years and not more than 15 years","c":"Any person who previously held an amateur license issued by another country, but"+" only if that country has a current reciprocal licensing agreement with the FCC","d":"Only persons who once held an FCC issued Novice, Technician, or Technician Plus "+"license"},"metadata":"97.501, 97.505(a)] "},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D02","question":"What license examinations may you administer when you are an accredited VE holdi"+"ng a General Class operator license?","answer":"C","choices":{"a":"General and Technician","b":"General only","c":"Technician only","d":"Extra, General and Technician"},"metadata":"97.509(b)(3)(i)"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D03","question":"On which of the following band segments may you operate if you are a Technician "+"Class operator and have a CSCE for General Class privileges?","answer":"C","choices":{"a":"Only the Technician band segments until your upgrade is posted in the FCC databa"+"se","b":"Only on the Technician band segments until your license arrives in the mail","c":"On any General or Technician Class band segment","d":"On any General or Technician Class band segment except 30-meters and 60-meters"},"metadata":"97.9(b)]"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D04","question":"Which of the following is a requirement for administering a Technician Class lic"+"ense examination?","answer":"A","choices":{"a":"At least three General Class or higher VEs must observe the examination","b":"At least two General Class or higher VEs must be present","c":"At least two General Class or higher VEs must be present, but only one need be E"+"xtra Class","d":"At least three VEs of Technician Class or higher must observe the examination"},"metadata":"97.509(3)(i)(c)]"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D05","question":"Which of the following must a person have before they can be an administering VE"+" for a Technician Class license examination?","answer":"D","choices":{"a":"Notification to the FCC that you want to give an examination","b":"Receipt of a CSCE for General Class","c":"Possession of a properly obtained telegraphy license","d":"An FCC General Class or higher license and VEC accreditation"},"metadata":"97.509(b)(3)(i)]"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D06","question":"When must you add the special identifier \"AG\" after your call sign if you are "+"a Technician Class licensee and have a CSCE for General Class operator privilege"+"s, but the FCC has not yet posted your upgrade on its website ?","answer":"A","choices":{"a":"Whenever you operate using General Class frequency privileges","b":"Whenever you operate on any amateur frequency","c":"Whenever you operate using Technician frequency privileges","d":"A special identifier is not required as long as your General Class license appli"+"cation has been filed with the FCC"},"metadata":"97.119(f)(2)"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D07","question":"Volunteer Examiners are accredited by what organization?","answer":"C","choices":{"a":"The Federal Communications Commission","b":"The Universal Licensing System","c":"A Volunteer Examiner Coordinator","d":"The Wireless Telecommunications Bureau"},"metadata":"97.509(b)(1)]"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D08","question":"Which of the following criteria must be met for a non-U.S. citizen to be an accr"+"edited Volunteer Examiner?","answer":"B","choices":{"a":"The person must be a resident of the U.S. for a minimum of 5 years","b":"The person must hold an FCC granted Amateur Radio license of General Class or ab"+"ove","c":"The person’s home citizenship must be in ITU region 2","d":"None of these choices is correct; a non-U.S. citizen cannot be a Volunteer Exami"+"ner"},"metadata":"97.509(b)(3)]"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D09","question":"How long is a Certificate of Successful Completion of Examination (CSCE) valid f"+"or exam element credit?","answer":"C","choices":{"a":"30 days","b":"180 days","c":"365 days","d":"For as long as your current license is valid"},"metadata":"97.9(b)"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D10","question":"What is the minimum age that one must be to qualify as an accredited Volunteer E"+"xaminer?","answer":"B","choices":{"a":"12 years","b":"18 years","c":"21 years","d":"There is no age limit"},"metadata":"97.509(b)(2)"},{"exam":"G","section":"G1","subSection":"G1D","questionID":"G1D11","question":"If a person has an expired FCC issued amateur radio license of General Class or "+"higher, what is required before they can receive a new license? ","answer":"D","choices":{"a":"They must have a letter from the FCC showing they once held an amateur or commer"+"cial license","b":"There are no requirements other than being able to show a copy of the expired li"+"cense","c":"The applicant must be able to produce a copy of a page from a call book publishe"+"d in the USA showing his or her name and address","d":"The applicant must pass the current element 2 exam"},"metadata":""},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E01","question":"Which of the following would disqualify a third party from participating in stat"+"ing a message over an amateur station?","answer":"A","choices":{"a":"The third party’s amateur license has been revoked and not reinstated","b":"The third party is not a U.S. citizen","c":"The third party is a licensed amateur","d":"The third party is speaking in a language other than English"},"metadata":"97.115(b)(2)] "},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E02","question":"When may a 10-meter repeater retransmit the 2-meter signal from a station having"+" a Technician Class control operator?","answer":"D","choices":{"a":"Under no circumstances","b":"Only if the station on 10-meters is operating under a Special Temporary Authoriz"+"ation allowing such retransmission","c":"Only during an FCC declared general state of communications emergency","d":"Only if the 10-meter repeater control operator holds at least a General Class li"+"cense"},"metadata":"97.205(b)"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E03","question":"What is required to conduct communications with a digital station operating unde"+"r automatic control outside the automatic control band segments?","answer":"A","choices":{"a":"The station initiating the contact must be under local or remote control","b":"The interrogating transmission must be made by another automatically controlled "+"station","c":"No third party traffic maybe be transmitted","d":"The control operator of the interrogating station must hold an Extra"},"metadata":"97.221]"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E04","question":"Which of the following conditions require a licensed Amateur Radio operator to t"+"ake specific steps to avoid harmful interference to other users or facilities?","answer":"D","choices":{"a":"When operating within one mile of an FCC Monitoring Station","b":"When using a band where the Amateur Service is secondary","c":"When a station is transmitting spread spectrum emissions","d":"All of these choices are correct"},"metadata":"97.13(b), 97.303, 97.311(b)"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E05","question":"What types of messages for a third party in another country may be transmitted b"+"y an amateur station?","answer":"C","choices":{"a":"Any message, as long as the amateur operator is not paid","b":"Only messages for other licensed amateurs","c":"Only messages relating to Amateur Radio or remarks of a personal character, or m"+"essages relating to emergencies or disaster relief","d":"Any messages, as long as the text of the message is recorded in the station log"},"metadata":"97.115(a)(2),97.117]"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E06","question":"Which of the following applies in the event of interference between a coordinate"+"d repeater and an uncoordinated repeater?","answer":"A","choices":{"a":"The licensee of the uncoordinated repeater has primary responsibility to resolve"+" the interference","b":"The licensee of the coordinated repeater has primary responsibility to resolve t"+"he interference","c":"Both repeater licensees share equal responsibility to resolve the interference","d":"The frequency coordinator bears primary responsibility to resolve the interferen"+"ce"},"metadata":"97.205(c)"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E07","question":"With which foreign countries is third party traffic prohibited, except for messa"+"ges directly involving emergencies or disaster relief communications?","answer":"C","choices":{"a":"Countries in ITU Region 2","b":"Countries in ITU Region 1","c":"Every foreign country, unless there is a third party agreement in effect with th"+"at country","d":"Any country which is not a member of the International Amateur Radio Union (IARU"+")"},"metadata":"97.115(a)(2)]"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E08","question":"Which of the following is a requirement for a non-licensed person to communicate"+" with a foreign Amateur Radio station from a station with an FCC-granted license"+" at which an FCC licensed control operator is present?","answer":"B","choices":{"a":"Information must be exchanged in English","b":"The foreign amateur station must be in a country with which the United States ha"+"s a third party agreement","c":"The control operator must have at least a General Class license","d":"All of these choices are correct"},"metadata":"97.115(a)(b)"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E09","question":"What language must be used when identifying your station if you are using a lang"+"uage other than English in making a contact using phone emission?","answer":"C","choices":{"a":"The language being used for the contact","b":"Any language recognized by the United Nations","c":"English only","d":"English, Spanish, French, or German"},"metadata":"97.119(b)(2)]"},{"exam":"*","section":"**","subSection":"***","questionID":"***G1E10","question":"What portion of the 10-meter band is available for repeater use?","answer":"D","choices":{"a":"The entire band","b":"The portion between 28.1 MHz and 28.2 MHz","c":"The portion between 28.3 MHz and 28.5 MHz","d":"The portion above 29.6 MHz"},"metadata":"97.205(b)] *** QUESTION REMOVED BY QPC February 4, 2015***"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E11","question":"Which of the following is the FCC term for an unattended digital station that tr"+"ansfers messages to and from the Internet?","answer":"C","choices":{"a":"Locally controlled station","b":"Robotically controlled station","c":"Automatically controlled digital station","d":"Fail-safe digital station"},"metadata":"97.221]"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E12","question":"Under what circumstances are messages that are sent via digital modes exempt fro"+"m Part 97 third party rules that apply to other modes of communication?","answer":"A","choices":{"a":"Under no circumstances","b":"When messages are encrypted","c":"When messages are not encrypted","d":"When under automatic control"},"metadata":"97.115]"},{"exam":"G","section":"G1","subSection":"G1E","questionID":"G1E13","question":"On what bands may automatically controlled stations transmitting RTTY or data em"+"issions communicate with other automatically controlled digital stations?","answer":"D","choices":{"a":"On any band segment where digital operation is permitted","b":"Anywhere in the non-phone segments of the 10-meter or shorter wavelength bands","c":"Only in the non-phone Extra Class segments of the bands","d":"Anywhere in the 1.25-meter or shorter wavelength bands, and in specified segment"+"s of the 80-meter through 2-meter bands"},"metadata":"97.221, 97.305] "},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A01","question":"Which sideband is most commonly used for voice communications on frequencies of "+"14 MHz or higher?","answer":"A","choices":{"a":"Upper sideband","b":"Lower sideband","c":"Vestigial sideband","d":"Double sideband"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A02","question":"Which of the following modes is most commonly used for voice communications on t"+"he 160-meter, 75-meter, and 40-meter bands?","answer":"B","choices":{"a":"Upper sideband","b":"Lower sideband","c":"Vestigial sideband","d":"Double sideband"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A03","question":"Which of the following is most commonly used for SSB voice communications in the"+" VHF and UHF bands?","answer":"A","choices":{"a":"Upper sideband","b":"Lower sideband","c":"Vestigial sideband","d":"Double sideband"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A04","question":"Which mode is most commonly used for voice communications on the 17-meter and 12"+"-meter bands?","answer":"A","choices":{"a":"Upper sideband","b":"Lower sideband","c":"Vestigial sideband","d":"Double sideband"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A05","question":"Which mode of voice communication is most commonly used on the HF amateur bands?"+" ","answer":"C","choices":{"a":"Frequency modulation","b":"Double sideband","c":"Single sideband","d":"Phase modulation"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A06","question":"Which of the following is an advantage when using single sideband as compared to"+" other analog voice modes on the HF amateur bands?","answer":"B","choices":{"a":"Very high fidelity voice modulation","b":"Less bandwidth used and greater power efficiency","c":"Ease of tuning on receive and immunity to impulse noise","d":"Less subject to interference from atmospheric static crashes"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A07","question":"Which of the following statements is true of the single sideband voice mode? ","answer":"B","choices":{"a":"Only one sideband and the carrier are transmitted; the other sideband is suppres"+"sed","b":"Only one sideband is transmitted; the other sideband and carrier are suppressed","c":"SSB is the only voice mode that is authorized on the 20-meter, 15-meter, and 10-"+"meter amateur bands","d":"SSB is the only voice mode that is authorized on the 160-meter, 75-meter and 40-"+"meter amateur bands"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A08","question":"Which of the following is a recommended way to break into a contact when using p"+"hone?","answer":"B","choices":{"a":"Say \"QRZ\" several times followed by your call sign","b":"Say your call sign during a break between transmissions by the other stations","c":"Say \"Break Break Break\" and wait for a response","d":"Say \"CQ\" followed by the call sign of either station"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A09","question":"Why do most amateur stations use lower sideband on the 160-meter, 75-meter and 4"+"0-meter bands?","answer":"D","choices":{"a":"Lower sideband is more efficient than upper sideband at these frequencies","b":"Lower sideband is the only sideband legal on these frequency bands","c":"Because it is fully compatible with an AM detector","d":"Current amateur practice is to use lower sideband on these frequency bands"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A10","question":"Which of the following statements is true of voice VOX operation versus PTT oper"+"ation?","answer":"B","choices":{"a":"The received signal is more natural sounding","b":"It allows \"hands free\" operation","c":"It occupies less bandwidth","d":"It provides more power output"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2A","questionID":"G2A11","question":"What does the expression \"CQ DX\" usually indicate?","answer":"C","choices":{"a":"A general call for any station","b":"The caller is listening for a station in Germany","c":"The caller is looking for any station outside their own country","d":"A distress call"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B01","question":"Which of the following is true concerning access to frequencies in non-emergency"+" situations?","answer":"C","choices":{"a":"Nets always have priority","b":"QSOs in progress always have priority","c":"Except during FCC declared emergencies, no one has priority access to frequencie"+"s","d":"Contest operations must always yield to non-contest use of frequencies"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B02","question":"What is the first thing you should do if you are communicating with another amat"+"eur station and hear a station in distress break in?","answer":"B","choices":{"a":"Continue your communication because you were on the frequency first","b":"Acknowledge the station in distress and determine what assistance may be needed","c":"Change to a different frequency","d":"Immediately cease all transmissions"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B03","question":"If propagation changes during your contact and you notice increasing interferenc"+"e from other activity on the same frequency, what should you do?","answer":"C","choices":{"a":"Tell the interfering stations to change frequency","b":"Report the interference to your local Amateur Auxiliary Coordinator","c":"As a common courtesy, move your contact to another frequency","d":"Increase power to overcome interference"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B04","question":"When selecting a CW transmitting frequency, what minimum separation should be us"+"ed to minimize interference to stations on adjacent frequencies?","answer":"B","choices":{"a":"5 to 50 Hz","b":"150 to 500 Hz","c":"1 to 3 kHz","d":"3 to 6 kHz"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B05","question":"What is the customary minimum frequency separation between SSB signals under nor"+"mal conditions?","answer":"B","choices":{"a":"Between 150 and 500 Hz","b":"Approximately 3 kHz","c":"Approximately 6 kHz","d":"Approximately 10 kHz"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B06","question":"What is a practical way to avoid harmful interference on an apparently clear fre"+"quency before calling CQ on CW or phone?","answer":"A","choices":{"a":"Send \"QRL?\" on CW, followed by your call sign; or, if using phone, ask if the "+"frequency is in use, followed by your call sign","b":"Listen for 2 minutes before calling CQ","c":"Send the letter \"V\" in Morse code several times and listen for a response or s"+"ay \"test\" several times and listen for a response","d":"Send \"QSY\" on CW or if using phone, announce \"the frequency is in use\", then"+" give your call and listen for a response"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B07","question":"Which of the following complies with good amateur practice when choosing a frequ"+"ency on which to initiate a call?","answer":"C","choices":{"a":"Check to see if the channel is assigned to another station","b":"Identify your station by transmitting your call sign at least 3 times","c":"Follow the voluntary band plan for the operating mode you intend to use","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B08","question":"What is the \"DX window\" in a voluntary band plan?","answer":"A","choices":{"a":"A portion of the band that should not be used for contacts between stations with"+"in the 48 contiguous United States","b":"An FCC rule that prohibits contacts between stations within the United States an"+"d possessions in that portion of the band","c":"An FCC rule that allows only digital contacts in that portion of the band","d":"A portion of the band that has been voluntarily set aside for digital contacts o"+"nly"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B09","question":"Who may be the control operator of an amateur station transmitting in RACES to a"+"ssist relief operations during a disaster?","answer":"A","choices":{"a":"Only a person holding an FCC issued amateur operator license","b":"Only a RACES net control operator","c":"A person holding an FCC issued amateur operator license or an appropriate govern"+"ment official","d":"Any control operator when normal communication systems are operational"},"metadata":"97.407(a)]"},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B10","question":"When may the FCC restrict normal frequency operations of amateur stations partic"+"ipating in RACES?","answer":"D","choices":{"a":"When they declare a temporary state of communication emergency","b":"When they seize your equipment for use in disaster communications","c":"Only when all amateur stations are instructed to stop transmitting","d":"When the President’s War Emergency Powers have been invoked"},"metadata":"97.407(b)]"},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B11","question":"What frequency should be used to send a distress call?","answer":"A","choices":{"a":"Whichever frequency has the best chance of communicating the distress message","b":"Only frequencies authorized for RACES or ARES stations","c":"Only frequencies that are within your operating privileges","d":"Only frequencies used by police, fire or emergency medical services"},"metadata":"97.405]"},{"exam":"G","section":"G2","subSection":"G2B","questionID":"G2B12","question":"When is an amateur station allowed to use any means at its disposal to assist an"+"other station in distress?","answer":"C","choices":{"a":"Only when transmitting in RACES","b":"At any time when transmitting in an organized net","c":"At any time during an actual emergency","d":"Only on authorized HF frequencies"},"metadata":"97.405(b)]"},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C01","question":"Which of the following describes full break-in telegraphy (QSK)?","answer":"D","choices":{"a":"Breaking stations send the Morse code prosign BK","b":"Automatic keyers are used to send Morse code instead of hand keys","c":"An operator must activate a manual send/receive switch before and after every tr"+"ansmission","d":"Transmitting stations can receive between code characters and elements"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C02","question":"What should you do if a CW station sends \"QRS\"?","answer":"A","choices":{"a":"Send slower","b":"Change frequency","c":"Increase your power","d":"Repeat everything twice"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C03","question":"What does it mean when a CW operator sends \"KN\" at the end of a transmission?","answer":"C","choices":{"a":"Listening for novice stations","b":"Operating full break-in","c":"Listening only for a specific station or stations","d":"Closing station now"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C04","question":"What does the Q signal \"QRL?\" mean?","answer":"D","choices":{"a":"\"Will you keep the frequency clear?\"","b":"\"Are you operating full break-in\" or \"Can you operate full break-in?\"","c":"\"Are you listening only for a specific station?\"","d":"\"Are you busy?\", or \"Is this frequency in use?\""},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C05","question":"What is the best speed to use when answering a CQ in Morse code?","answer":"B","choices":{"a":"The fastest speed at which you are comfortable copying","b":"The speed at which the CQ was sent","c":"A slow speed until contact is established","d":"At the standard calling speed of 5 wpm"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C06","question":"What does the term \"zero beat\" mean in CW operation?","answer":"D","choices":{"a":"Matching the speed of the transmitting station","b":"Operating split to avoid interference on frequency","c":"Sending without error","d":"Matching your transmit frequency to the frequency of a received signal"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C07","question":"When sending CW, what does a \"C\" mean when added to the RST report?","answer":"A","choices":{"a":"Chirpy or unstable signal","b":"Report was read from an S meter rather than estimated","c":"100 percent copy","d":"Key clicks"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C08","question":"What prosign is sent to indicate the end of a formal message when using CW? ","answer":"C","choices":{"a":"SK","b":"BK","c":"AR","d":"KN"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C09","question":"What does the Q signal \"QSL\" mean?","answer":"C","choices":{"a":"Send slower","b":"We have already confirmed by card","c":"I acknowledge receipt","d":"We have worked before"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C10","question":"What does the Q signal \"QRN\" mean?","answer":"B","choices":{"a":"Send more slowly","b":"I am troubled by static","c":"Zero beat my signal","d":"Stop sending"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2C","questionID":"G2C11","question":"What does the Q signal \"QRV\" mean?","answer":"D","choices":{"a":"You are sending too fast","b":"There is interference on the frequency","c":"I am quitting for the day","d":"I am ready to receive messages"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D01","question":"What is the Amateur Auxiliary to the FCC?","answer":"A","choices":{"a":"Amateur volunteers who are formally enlisted to monitor the airwaves for rules v"+"iolations","b":"Amateur volunteers who conduct amateur licensing examinations","c":"Amateur volunteers who conduct frequency coordination for amateur VHF repeaters","d":"Amateur volunteers who use their station equipment to help civil defense organiz"+"ations in times of emergency"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D02","question":"Which of the following are objectives of the Amateur Auxiliary?","answer":"B","choices":{"a":"To conduct efficient and orderly amateur licensing examinations","b":"To encourage self-regulation and compliance with the rules by radio amateur oper"+"ators","c":"To coordinate repeaters for efficient and orderly spectrum usage","d":"To provide emergency and public safety communications"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D03","question":"What skills learned during hidden transmitter hunts are of help to the Amateur A"+"uxiliary? ","answer":"B","choices":{"a":"Identification of out of band operation","b":"Direction finding used to locate stations violating FCC Rules","c":"Identification of different call signs","d":"Hunters have an opportunity to transmit on non-amateur frequencies"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D04","question":"Which of the following describes an azimuthal projection map?","answer":"B","choices":{"a":"A map that shows accurate land masses","b":"A map that shows true bearings and distances from a particular location","c":"A map that shows the angle at which an amateur satellite crosses the equator","d":"A map that shows the number of degrees longitude that an amateur satellite appea"+"rs to move westward at the equator with each orbit"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D05","question":"When is it permissible to communicate with amateur stations in countries outside"+" the areas administered by the Federal Communications Commission?","answer":"B","choices":{"a":"Only when the foreign country has a formal third party agreement filed with the "+"FCC","b":"When the contact is with amateurs in any country except those whose administrati"+"ons have notified the ITU that they object to such communications","c":"When the contact is with amateurs in any country as long as the communication is"+" conducted in English","d":"Only when the foreign country is a member of the International Amateur Radio Uni"+"on"},"metadata":"97.111(a)(1)]"},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D06","question":"How is a directional antenna pointed when making a \"long-path\" contact with an"+"other station?","answer":"C","choices":{"a":"Toward the rising Sun","b":"Along the gray line","c":"180 degrees from its short-path heading","d":"Toward the north"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D07","question":"Which of the following is required by the FCC rules when operating in the 60-met"+"er band?","answer":"A","choices":{"a":"If you are using other than a dipole antenna, you must keep a record of the gain"+" of your antenna","b":"You must keep a record of the date, time, frequency, power level and stations wo"+"rked","c":"You must keep a record of all third party traffic","d":"You must keep a record of the manufacturer of your equipment and the antenna use"+"d"},"metadata":"97.303(i)]"},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D08","question":"What is a reason why many amateurs keep a station log?","answer":"D","choices":{"a":"The ITU requires a log of all international contacts","b":"The ITU requires a log of all international third party traffic","c":"The log provides evidence of operation needed to renew a license without retest","d":"To help with a reply if the FCC requests information"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D09","question":"What information is traditionally contained in a station log?","answer":"D","choices":{"a":"Date and time of contact","b":"Band and/or frequency of the contact","c":"Call sign of station contacted and the signal report given","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D10","question":"What is QRP operation?","answer":"B","choices":{"a":"Remote piloted model control","b":"Low power transmit operation","c":"Transmission using Quick Response Protocol","d":"Traffic relay procedure net operation"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2D","questionID":"G2D11","question":"Which HF antenna would be the best to use for minimizing interference?","answer":"C","choices":{"a":"A quarter-wave vertical antenna","b":"An isotropic antenna","c":"A directional antenna","d":"An omnidirectional antenna"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E01","question":"Which mode is normally used when sending an RTTY signal via AFSK with an SSB tra"+"nsmitter?","answer":"D","choices":{"a":"USB","b":"DSB","c":"CW","d":"LSB"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E02","question":"How can a PACTOR modem or controller be used to determine if the channel is in u"+"se by other PACTOR stations? ","answer":"B","choices":{"a":"Unplug the data connector temporarily and see if the channel-busy indication is "+"turned off","b":"Put the modem or controller in a mode which allows monitoring communications wit"+"hout a connection","c":"Transmit UI packets several times and wait to see if there is a response from an"+"other PACTOR station","d":"Send the message: \"Is this frequency in use?\""},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E03","question":"What symptoms may result from other signals interfering with a PACTOR or WINMOR "+"transmission?","answer":"D","choices":{"a":"Frequent retries or timeouts","b":"Long pauses in message transmission","c":"Failure to establish a connection between stations","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E04","question":"What segment of the 20-meter band is most often used for digital transmissions?","answer":"B","choices":{"a":"14.000 - 14.050 MHz","b":"14.070 - 14.100 MHz","c":"14.150 - 14.225 MHz","d":"14.275 - 14.350 MHz"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E05","question":"What is the standard sideband used to generate a JT65 or JT9 digital signal when"+" using AFSK in any amateur band?","answer":"B","choices":{"a":"LSB","b":"USB","c":"DSB","d":"SSB"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E06","question":"What is the most common frequency shift for RTTY emissions in the amateur HF ban"+"ds?","answer":"B","choices":{"a":"85 Hz","b":"170 Hz","c":"425 Hz","d":"850 Hz"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E07","question":"What segment of the 80-meter band is most commonly used for digital transmission"+"s?","answer":"A","choices":{"a":"3570 – 3600 kHz","b":"3500 – 3525 kHz","c":"3700 – 3750 kHz","d":"3775 – 3825 kHz"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E08","question":"In what segment of the 20-meter band are most PSK31 operations commonly found?","answer":"D","choices":{"a":"At the bottom of the slow-scan TV segment, near 14.230 MHz","b":"At the top of the SSB phone segment, near 14.325 MHz","c":"In the middle of the CW segment, near 14.100 MHz","d":"Below the RTTY segment, near 14.070 MHz"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E09 (C)","question":"How do you join a contact between two stations using the PACTOR protocol? ","answer":"","choices":{"a":"Send broadcast packets containing your call sign while in MONITOR mode","b":"Transmit a steady carrier until the PACTOR protocol times out and disconnects","c":"Joining an existing contact is not possible, PACTOR connections are limited to t"+"wo stations","d":"Send a NAK response continuously so that the sending station has to pause"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E10","question":"Which of the following is a way to establish contact with a digital messaging sy"+"stem gateway station?","answer":"D","choices":{"a":"Send an email to the system control operator","b":"Send QRL in Morse code","c":"Respond when the station broadcasts its SSID","d":"Transmit a connect message on the station’s published frequency"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E11","question":"What is indicated on a waterfall display by one or more vertical lines adjacent "+"to a PSK31 signal?","answer":"D","choices":{"a":"Long Path propagation","b":"Backscatter propagation","c":"Insufficient modulation","d":"Overmodulation"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E12","question":"Which of the following describes a waterfall display?","answer":"C","choices":{"a":"Frequency is horizontal, signal strength is vertical, time is intensity","b":"Frequency is vertical, signal strength is intensity, time is horizontal","c":"Frequency is horizontal, signal strength is intensity, time is vertical","d":"Frequency is vertical, signal strength is horizontal, time is intensity"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E13","question":"Which communication system sometimes uses the Internet to transfer messages?","answer":"A","choices":{"a":"Winlink","b":"RTTY","c":"ARES","d":"Skywarn"},"metadata":""},{"exam":"G","section":"G2","subSection":"G2E","questionID":"G2E14","question":"What could be wrong if you cannot decode an RTTY or other FSK signal even ","answer":"D","choices":{"a":"ugh it is apparently tuned in properly?","b":"The mark and space frequencies may be reversed","c":"You may have selected the wrong baud rate","d":"You may be listening on the wrong sideband"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A01","question":"What is the significance of the sunspot number with regard to HF propagation?","answer":"A","choices":{"a":"Higher sunspot numbers generally indicate a greater probability of good propagat"+"ion at higher frequencies","b":"Lower sunspot numbers generally indicate greater probability of sporadic E propa"+"gation","c":"A zero sunspot number indicate radio propagation is not possible on any band","d":"All of these choices are correct."},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A02","question":"What effect does a Sudden Ionospheric Disturbance have on the daytime ionospheri"+"c propagation of HF radio waves?","answer":"B","choices":{"a":"It enhances propagation on all HF frequencies","b":"It disrupts signals on lower frequencies more than those on higher frequencies","c":"It disrupts communications via satellite more than direct communications","d":"None, because only areas on the night side of the Earth are affected"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A03","question":"Approximately how long does it take the increased ultraviolet and X-ray radiatio"+"n from solar flares to affect radio propagation on the Earth?","answer":"C","choices":{"a":"28 days","b":"1 to 2 hours","c":"8 minutes","d":"20 to 40 hours"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A04","question":"Which of the following are least reliable for long distance communications durin"+"g periods of low solar activity?","answer":"D","choices":{"a":"80 meters and 160 meters","b":"60 meters and 40 meters","c":"30 meters and 20 meters","d":"15 meters, 12 meters and 10 meters"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A05","question":"What is the solar flux index?","answer":"D","choices":{"a":"A measure of the highest frequency that is useful for ionospheric propagation be"+"tween two points on the Earth","b":"A count of sunspots which is adjusted for solar emissions","c":"Another name for the American sunspot number","d":"A measure of solar radiation at 10.7 centimeters wavelength"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A06","question":"What is a geomagnetic storm?","answer":"D","choices":{"a":"A sudden drop in the solar flux index","b":"A thunderstorm which affects radio propagation","c":"Ripples in the ionosphere","d":"A temporary disturbance in the Earth's magnetosphere"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A07","question":"At what point in the solar cycle does the 20-meter band usually support worldwid"+"e propagation during daylight hours?","answer":"D","choices":{"a":"At the summer solstice","b":"Only at the maximum point of the solar cycle","c":"Only at the minimum point of the solar cycle","d":"At any point in the solar cycle"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A08","question":"Which of the following effects can a geomagnetic storm have on radio propagation"+"?","answer":"B","choices":{"a":"Improved high-latitude HF propagation","b":"Degraded high-latitude HF propagation","c":"Improved ground-wave propagation","d":"Improved chances of UHF ducting"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A09","question":"What effect does a high sunspot number have on radio communications?","answer":"C","choices":{"a":"High-frequency radio signals become weak and distorted","b":"Frequencies above 300 MHz become usable for long-distance communication","c":"Long-distance communication in the upper HF and lower VHF range is enhanced","d":"Microwave communications become unstable"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A10","question":"What causes HF propagation conditions to vary periodically in a 28 day cycle?","answer":"C","choices":{"a":"Long term oscillations in the upper atmosphere","b":"Cyclic variation in the Earth’s radiation belts","c":"The Sun’s rotation on its axis","d":"The position of the Moon in its orbit"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A11","question":"Approximately how long is the typical sunspot cycle?","answer":"D","choices":{"a":"8 minutes","b":"40 hours","c":"28 days","d":"11 years"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A12","question":"What does the K-index indicate?","answer":"B","choices":{"a":"The relative position of sunspots on the surface of the Sun","b":"The short term stability of the Earth’s magnetic field","c":"The stability of the Sun's magnetic field","d":"The solar radio flux at Boulder, Colorado"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A13","question":"What does the A-index indicate? ","answer":"C","choices":{"a":"The relative position of sunspots on the surface of the Sun","b":"The amount of polarization of the Sun's electric field","c":"The long term stability of the Earth’s geomagnetic field","d":"The solar radio flux at Boulder, Colorado"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A14","question":"How are radio communications usually affected by the charged particles that reac"+"h the Earth from solar coronal holes?","answer":"B","choices":{"a":"HF communications are improved","b":"HF communications are disturbed","c":"VHF/UHF ducting is improved","d":"VHF/UHF ducting is disturbed"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A15","question":"How long does it take charged particles from coronal mass ejections to affect ra"+"dio propagation on the Earth?","answer":"D","choices":{"a":"28 days","b":"14 days","c":"4 to 8 minutes","d":"20 to 40 hours"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3A","questionID":"G3A16","question":"What is a possible benefit to radio communications resulting from periods of hig"+"h geomagnetic activity?","answer":"A","choices":{"a":"Auroras that can reflect VHF signals","b":"Higher signal strength for HF signals passing through the polar regions","c":"Improved HF long path propagation","d":"Reduced long delayed echoes"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B01","question":"How might a sky-wave signal sound if it arrives at your receiver by both short p"+"ath and long path propagation?","answer":"D","choices":{"a":"Periodic fading approximately every 10 seconds","b":"Signal strength increased by 3 dB","c":"The signal might be cancelled causing severe attenuation","d":"A well-defined echo might be heard"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B02","question":"Which of the following is a good indicator of the possibility of sky-wave propag"+"ation on the 6-meter band?","answer":"A","choices":{"a":"Short skip sky-wave propagation on the 10-meter band","b":"Long skip sky-wave propagation on the 10-meter band","c":"Severe attenuation of signals on the 10-meter band","d":"Long delayed echoes on the 10-meter band"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B03","question":"Which of the following applies when selecting a frequency for lowest attenuation"+" when transmitting on HF?","answer":"A","choices":{"a":"Select a frequency just below the MUF","b":"Select a frequency just above the LUF","c":"Select a frequency just below the critical frequency","d":"Select a frequency just above the critical frequency"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B04","question":"What is a reliable way to determine if the MUF is high enough to support skip pr"+"opagation between your station and a distant location on frequencies between 14 "+"and 30 MHz?","answer":"A","choices":{"a":"Listen for signals from an international beacon in the frequency range you plan "+"to use","b":"Send a series of dots on the band and listen for echoes from your signal","c":"Check the strength of TV signals from Western Europe","d":"Check the strength of signals in the MF AM broadcast band"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B05","question":"What usually happens to radio waves with frequencies below the MUF and above the"+" LUF when they are sent into the ionosphere?","answer":"A","choices":{"a":"They are bent back to the Earth","b":"They pass through the ionosphere","c":"They are amplified by interaction with the ionosphere","d":"They are bent and trapped in the ionosphere to circle the Earth"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B06","question":"What usually happens to radio waves with frequencies below the LUF?","answer":"C","choices":{"a":"They are bent back to the Earth","b":"They pass through the ionosphere","c":"They are completely absorbed by the ionosphere","d":"They are bent and trapped in the ionosphere to circle the Earth"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B07","question":"What does LUF stand for?","answer":"A","choices":{"a":"The Lowest Usable Frequency for communications between two points","b":"The Longest Universal Function for communications between two points","c":"The Lowest Usable Frequency during a 24 hour period","d":"The Longest Universal Function during a 24 hour period"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B08","question":"What does MUF stand for?","answer":"B","choices":{"a":"The Minimum Usable Frequency for communications between two points","b":"The Maximum Usable Frequency for communications between two points","c":"The Minimum Usable Frequency during a 24 hour period","d":"The Maximum Usable Frequency during a 24 hour period"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B09","question":"What is the approximate maximum distance along the Earth's surface that is norma"+"lly covered in one hop using the F2 region?","answer":"C","choices":{"a":"180 miles","b":"1,200 miles","c":"2,500 miles","d":"12,000 miles"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B10","question":"What is the approximate maximum distance along the Earth's surface that is norma"+"lly covered in one hop using the E region?","answer":"B","choices":{"a":"180 miles","b":"1,200 miles","c":"2,500 miles","d":"12,000 miles"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B11","question":"What happens to HF propagation when the LUF exceeds the MUF?","answer":"A","choices":{"a":"No HF radio frequency will support ordinary sky-wave communications over the pat"+"h","b":"HF communications over the path are enhanced","c":"Double hop propagation along the path is more common","d":"Propagation over the path on all HF frequencies is enhanced"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3B","questionID":"G3B12","question":"What factor or factors affect the MUF?","answer":"D","choices":{"a":"Path distance and location","b":"Time of day and season","c":"Solar radiation and ionospheric disturbances","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C01","question":"Which ionospheric layer is closest to the surface of the Earth?","answer":"A","choices":{"a":"The D layer","b":"The E layer","c":"The F1 layer","d":"The F2 layer"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C02","question":"Where on the Earth do ionospheric layers reach their maximum height?","answer":"A","choices":{"a":"Where the Sun is overhead","b":"Where the Sun is on the opposite side of the Earth","c":"Where the Sun is rising","d":"Where the Sun has just set"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C03","question":"Why is the F2 region mainly responsible for the longest distance radio wave prop"+"agation?","answer":"C","choices":{"a":"Because it is the densest ionospheric layer","b":"Because it does not absorb radio waves as much as other ionospheric regions","c":"Because it is the highest ionospheric region","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C04","question":"What does the term \"critical angle\" mean as used in radio wave propagation?","answer":"D","choices":{"a":"The long path azimuth of a distant station","b":"The short path azimuth of a distant station","c":"The lowest takeoff angle that will return a radio wave to the Earth under specif"+"ic ionospheric conditions","d":"The highest takeoff angle that will return a radio wave to the Earth under speci"+"fic ionospheric conditions"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C05","question":"Why is long distance communication on the 40-meter, 60-meter, 80-meter and 160-m"+"eter bands more difficult during the day?","answer":"C","choices":{"a":"The F layer absorbs signals at these frequencies during daylight hours","b":"The F layer is unstable during daylight hours","c":"The D layer absorbs signals at these frequencies during daylight hours","d":"The E layer is unstable during daylight hours"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C06","question":"What is a characteristic of HF scatter signals?","answer":"B","choices":{"a":"They have high intelligibility","b":"They have a wavering sound","c":"They have very large swings in signal strength","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C07","question":"What makes HF scatter signals often sound distorted?","answer":"D","choices":{"a":"The ionospheric layer involved is unstable","b":"Ground waves are absorbing much of the signal","c":"The E-region is not present","d":"Energy is scattered into the skip zone through several different radio wave path"+"s"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C08","question":"Why are HF scatter signals in the skip zone usually weak?","answer":"A","choices":{"a":"Only a small part of the signal energy is scattered into the skip zone","b":"Signals are scattered from the magnetosphere which is not a good reflector","c":"Propagation is through ground waves which absorb most of the signal energy","d":"Propagations is through ducts in F region which absorb most of the energy"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C09","question":"What type of radio wave propagation allows a signal to be detected at a distance"+" too far for ground wave propagation but too near for normal sky-wave propagatio"+"n?","answer":"B","choices":{"a":"Faraday rotation","b":"Scatter","c":"Sporadic-E skip","d":"Short-path skip"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C10","question":"Which of the following might be an indication that signals heard on the HF bands"+" are being received via scatter propagation?","answer":"D","choices":{"a":"The communication is during a sunspot maximum","b":"The communication is during a sudden ionospheric disturbance","c":"The signal is heard on a frequency below the Maximum Usable Frequency","d":"The signal is heard on a frequency above the Maximum Usable Frequency"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C11","question":"Which of the following antenna types will be most effective for skip communicati"+"ons on 40-meters during the day?","answer":"B","choices":{"a":"A vertical antenna","b":"A horizontal dipole placed between 1/8 and 1/4 wavelength above the ground","c":"A left-hand circularly polarized antenna","d":"A right-hand circularly polarized antenna"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C12","question":"Which ionospheric layer is the most absorbent of long skip signals during daylig"+"ht hours on frequencies below 10 MHz?","answer":"D","choices":{"a":"The F2 layer","b":"The F1 layer","c":"The E layer","d":"The D layer"},"metadata":""},{"exam":"G","section":"G3","subSection":"G3C","questionID":"G3C13","question":"What is Near Vertical Incidence Sky-wave (NVIS) propagation?","answer":"B","choices":{"a":"Propagation near the MUF","b":"Short distance MF or HF propagation using high elevation angles","c":"Long path HF propagation at sunrise and sunset","d":"Double hop propagation near the LUF"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A01","question":"What is the purpose of the \"notch filter\" found on many HF transceivers?","answer":"B","choices":{"a":"To restrict the transmitter voice bandwidth","b":"To reduce interference from carriers in the receiver passband","c":"To eliminate receiver interference from impulse noise sources","d":"To enhance the reception of a specific frequency on a crowded band"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A02","question":"What is one advantage of selecting the opposite or \"reverse\" sideband when rec"+"eiving CW signals on a typical HF transceiver?","answer":"C","choices":{"a":"Interference from impulse noise will be eliminated","b":"More stations can be accommodated within a given signal passband","c":"It may be possible to reduce or eliminate interference from other signals","d":"Accidental out of band operation can be prevented"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A03","question":"What is normally meant by operating a transceiver in \"split\" mode?","answer":"C","choices":{"a":"The radio is operating at half power","b":"The transceiver is operating from an external power source","c":"The transceiver is set to different transmit and receive frequencies","d":"The transmitter is emitting an SSB signal, as opposed to DSB operation"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A04","question":"What reading on the plate current meter of a vacuum tube RF power amplifier indi"+"cates correct adjustment of the plate tuning control?","answer":"B","choices":{"a":"A pronounced peak","b":"A pronounced dip","c":"No change will be observed","d":"A slow, rhythmic oscillation"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A05","question":"What is a reason to use Automatic Level Control (ALC) with an RF power amplifier"+"?","answer":"C","choices":{"a":"To balance the transmitter audio frequency response","b":"To reduce harmonic radiation","c":"To reduce distortion due to excessive drive","d":"To increase overall efficiency"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A06","question":"What type of device is often used to match transmitter output impedance to an im"+"pedance not equal to 50 ohms?","answer":"C","choices":{"a":"Balanced modulator","b":"SWR Bridge","c":"Antenna coupler or antenna tuner","d":"Q Multiplier"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A07","question":"What condition can lead to permanent damage to a solid-state RF power amplifier?","answer":"D","choices":{"a":"Insufficient drive power","b":"Low input SWR","c":"Shorting the input signal to ground","d":"Excessive drive power"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A08","question":"What is the correct adjustment for the load or coupling control of a vacuum tube"+" RF power amplifier?","answer":"D","choices":{"a":"Minimum SWR on the antenna","b":"Minimum plate current without exceeding maximum allowable grid current","c":"Highest plate voltage while minimizing grid current","d":"Maximum power output without exceeding maximum allowable plate current"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A09","question":"Why is a time delay sometimes included in a transmitter keying circuit?","answer":"C","choices":{"a":"To prevent stations from interfering with one another","b":"To allow the transmitter power regulators to charge properly","c":"To allow time for transmit-receive changeover operations to complete properly be"+"fore RF output is allowed","d":"To allow time for a warning signal to be sent to other stations"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A10","question":"What is the purpose of an electronic keyer?","answer":"B","choices":{"a":"Automatic transmit/receive switching","b":"Automatic generation of strings of dots and dashes for CW operation","c":"VOX operation","d":"Computer interface for PSK and RTTY operation"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A11","question":"Which of the following is a use for the IF shift control on a receiver?","answer":"A","choices":{"a":"To avoid interference from stations very close to the receive frequency","b":"To change frequency rapidly","c":"To permit listening on a different frequency from that on which you are transmit"+"ting","d":"To tune in stations that are slightly off frequency without changing your transm"+"it frequency"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A12","question":"Which of the following is a common use for the dual VFO feature on a transceiver"+"? ","answer":"C","choices":{"a":"To allow transmitting on two frequencies at once","b":"To permit full duplex operation, that is transmitting and receiving at the same "+"time","c":"To permit monitoring of two different frequencies","d":"To facilitate computer interface"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A13","question":"What is one reason to use the attenuator function that is present on many HF tra"+"nsceivers?","answer":"A","choices":{"a":"To reduce signal overload due to strong incoming signals","b":"To reduce the transmitter power when driving a linear amplifier","c":"To reduce power consumption when operating from batteries","d":"To slow down received CW signals for better copy"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A14","question":"What is likely to happen if a transceiver’s ALC system is not set properly when "+"transmitting AFSK signals with the radio using single sideband mode?","answer":"B","choices":{"a":"ALC will invert the modulation of the AFSK mode","b":"Improper action of ALC distorts the signal and can cause spurious emissions","c":"When using digital modes, too much ALC activity can cause the transmitter to ove"+"rheat","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4A","questionID":"G4A15","question":"Which of the following can be a symptom of transmitted RF being picked up by an "+"audio cable carrying AFSK data signals between a computer and a transceiver?","answer":"D","choices":{"a":"The VOX circuit does not un-key the transmitter","b":"The transmitter signal is distorted","c":"Frequent connection timeouts","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B01","question":"What item of test equipment contains horizontal and vertical channel amplifiers?","answer":"D","choices":{"a":"An ohmmeter","b":"A signal generator","c":"An ammeter","d":"An oscilloscope"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B02","question":"Which of the following is an advantage of an oscilloscope versus a digital voltm"+"eter?","answer":"D","choices":{"a":"An oscilloscope uses less power","b":"Complex impedances can be easily measured","c":"Input impedance is much lower","d":"Complex waveforms can be measured"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B03","question":"Which of the following is the best instrument to use when checking the keying wa"+"veform of a CW transmitter?","answer":"A","choices":{"a":"An oscilloscope","b":"A field strength meter","c":"A sidetone monitor","d":"A wavemeter"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B04","question":"What signal source is connected to the vertical input of an oscilloscope when ch"+"ecking the RF envelope pattern of a transmitted signal?","answer":"D","choices":{"a":"The local oscillator of the transmitter","b":"An external RF oscillator","c":"The transmitter balanced mixer output","d":"The attenuated RF output of the transmitter"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B05","question":"Why is high input impedance desirable for a voltmeter?","answer":"D","choices":{"a":"It improves the frequency response","b":"It decreases battery consumption in the meter","c":"It improves the resolution of the readings","d":"It decreases the loading on circuits being measured"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B06","question":"What is an advantage of a digital voltmeter as compared to an analog voltmeter?","answer":"C","choices":{"a":"Better for measuring computer circuits","b":"Better for RF measurements","c":"Better precision for most uses","d":"Faster response"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B07","question":"What signals are used to conduct a two-tone test?","answer":"B","choices":{"a":"Two audio signals of the same frequency shifted 90 degrees","b":"Two non-harmonically related audio signals","c":"Two swept frequency tones","d":"Two audio frequency range square wave signals of equal amplitude"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B08","question":"Which of the following instruments may be used to monitor relative RF output whe"+"n making antenna and transmitter adjustments?","answer":"A","choices":{"a":"A field strength meter","b":"An antenna noise bridge","c":"A multimeter","d":"A Q meter"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B09","question":"Which of the following can be determined with a field strength meter?","answer":"B","choices":{"a":"The radiation resistance of an antenna","b":"The radiation pattern of an antenna","c":"The presence and amount of phase distortion of a transmitter","d":"The presence and amount of amplitude distortion of a transmitter"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B10","question":"Which of the following can be determined with a directional wattmeter?","answer":"A","choices":{"a":"Standing wave ratio","b":"Antenna front-to-back ratio","c":"RF interference","d":"Radio wave propagation"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B11","question":"Which of the following must be connected to an antenna analyzer when it is being"+" used for SWR measurements?","answer":"C","choices":{"a":"Receiver","b":"Transmitter","c":"Antenna and feed line","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B12","question":"What problem can occur when making measurements on an antenna system with an ant"+"enna analyzer? ","answer":"B","choices":{"a":"Permanent damage to the analyzer may occur if it is operated into a high SWR","b":"Strong signals from nearby transmitters can affect the accuracy of measurements","c":"The analyzer can be damaged if measurements outside the ham bands are attempted","d":"Connecting the analyzer to an antenna can cause it to absorb harmonics"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B13","question":"What is a use for an antenna analyzer other than measuring the SWR of an antenna"+" system? ","answer":"C","choices":{"a":"Measuring the front to back ratio of an antenna","b":"Measuring the turns ratio of a power transformer","c":"Determining the impedance of an unknown or unmarked coaxial cable","d":"Determining the gain of a directional antenna"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B14","question":"What is an instance in which the use of an instrument with analog readout may be"+" preferred over an instrument with a digital readout?","answer":"D","choices":{"a":"When testing logic circuits","b":"When high precision is desired","c":"When measuring the frequency of an oscillator","d":"When adjusting tuned circuits"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4B","questionID":"G4B15","question":"What type of transmitter performance does a two-tone test analyze?","answer":"A","choices":{"a":"Linearity","b":"Percentage of suppression of carrier and undesired sideband for SSB","c":"Percentage of frequency modulation","d":"Percentage of carrier phase shift"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C01","question":"Which of the following might be useful in reducing RF interference to audio freq"+"uency devices?","answer":"B","choices":{"a":"Bypass inductor","b":"Bypass capacitor","c":"Forward-biased diode","d":"Reverse-biased diode"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C02","question":"Which of the following could be a cause of interference covering a wide range of"+" frequencies? ","answer":"C","choices":{"a":"Not using a balun or line isolator to feed balanced antennas","b":"Lack of rectification of the transmitter's signal in power conductors","c":"Arcing at a poor electrical connection","d":"Using a balun to feed an unbalanced antenna"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C03","question":"What sound is heard from an audio device or telephone if there is interference f"+"rom a nearby single sideband phone transmitter?","answer":"C","choices":{"a":"A steady hum whenever the transmitter is on the air","b":"On-and-off humming or clicking","c":"Distorted speech","d":"Clearly audible speech"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C04","question":"What is the effect on an audio device or telephone system if there is interferen"+"ce from a nearby CW transmitter?","answer":"A","choices":{"a":"On-and-off humming or clicking","b":"A CW signal at a nearly pure audio frequency","c":"A chirpy CW signal","d":"Severely distorted audio"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C05","question":"What might be the problem if you receive an RF burn when touching your equipment"+" while transmitting on an HF band, assuming the equipment is connected to a grou"+"nd rod?","answer":"D","choices":{"a":"Flat braid rather than round wire has been used for the ground wire","b":"Insulated wire has been used for the ground wire","c":"The ground rod is resonant","d":"The ground wire has high impedance on that frequency"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C06","question":"What effect can be caused by a resonant ground connection?","answer":"C","choices":{"a":"Overheating of ground straps","b":"Corrosion of the ground rod","c":"High RF voltages on the enclosures of station equipment","d":"A ground loop"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C07","question":"What is one good way to avoid unwanted effects of stray RF energy in an amateur "+"station?","answer":"A","choices":{"a":"Connect all equipment grounds together","b":"Install an RF filter in series with the ground wire","c":"Use a ground loop for best conductivity","d":"Install a few ferrite beads on the ground wire where it connects to your station"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C08","question":"Which of the following would reduce RF interference caused by common-mode curren"+"t on an audio cable?","answer":"A","choices":{"a":"Placing a ferrite choke around the cable","b":"Adding series capacitors to the conductors","c":"Adding shunt inductors to the conductors","d":"Adding an additional insulating jacket to the cable"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C09","question":"How can a ground loop be avoided?","answer":"D","choices":{"a":"Connect all ground conductors in series","b":"Connect the AC neutral conductor to the ground wire","c":"Avoid using lock washers and star washers when making ground connections","d":"Connect all ground conductors to a single point"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C10","question":"What could be a symptom of a ground loop somewhere in your station?","answer":"A","choices":{"a":"You receive reports of \"hum\" on your station's transmitted signal","b":"The SWR reading for one or more antennas is suddenly very high","c":"An item of station equipment starts to draw excessive amounts of current","d":"You receive reports of harmonic interference from your station"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C11","question":"Which of the following is a function of a digital signal processor?","answer":"B","choices":{"a":"To provide adequate grounding","b":"To remove noise from received signals","c":"To increase antenna gain","d":"To increase antenna bandwidth"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C12","question":"Which of the following is an advantage of a receiver DSP IF filter as compared t"+"o an analog filter? ","answer":"A","choices":{"a":"A wide range of filter bandwidths and shapes can be created","b":"Fewer digital components are required","c":"Mixing products are greatly reduced","d":"The DSP filter is much more effective at VHF frequencies"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4C","questionID":"G4C13","question":"Which of the following can perform automatic notching of interfering carriers?","answer":"B","choices":{"a":"Bandpass tuning","b":"A Digital Signal Processor (DSP) filter","c":"Balanced mixing","d":"A noise limiter"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D01","question":"What is the purpose of a speech processor as used in a modern transceiver?","answer":"A","choices":{"a":"Increase the intelligibility of transmitted phone signals during poor conditions","b":"Increase transmitter bass response for more natural sounding SSB signals","c":"Prevent distortion of voice signals","d":"Decrease high-frequency voice output to prevent out of band operation"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D02","question":"Which of the following describes how a speech processor affects a transmitted si"+"ngle sideband phone signal?","answer":"B","choices":{"a":"It increases peak power","b":"It increases average power","c":"It reduces harmonic distortion","d":"It reduces intermodulation distortion"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D03","question":"Which of the following can be the result of an incorrectly adjusted speech proce"+"ssor?","answer":"D","choices":{"a":"Distorted speech","b":"Splatter","c":"Excessive background pickup","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D04","question":"What does an S meter measure?","answer":"C","choices":{"a":"Conductance","b":"Impedance","c":"Received signal strength","d":"Transmitter power output"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D05","question":"How does a signal that reads 20 dB over S9 compare to one that reads S9 on a rec"+"eiver, assuming a properly calibrated S meter?","answer":"D","choices":{"a":"It is 10 times less powerful","b":"It is 20 times less powerful","c":"It is 20 times more powerful","d":"It is 100 times more powerful"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D06","question":"Where is an S meter found?","answer":"A","choices":{"a":"In a receiver","b":"In an SWR bridge","c":"In a transmitter","d":"In a conductance bridge"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D07","question":"How much must the power output of a transmitter be raised to change the","answer":"C","choices":{"a":"eter reading on a distant receiver from S8 to S9?","b":"Approximately 1.5 times","c":"Approximately 2 times","d":"Approximately 4 times"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D08","question":"What frequency range is occupied by a 3 kHz LSB signal when the displayed carrie"+"r frequency is set to 7.178 MHz? ","answer":"C","choices":{"a":"7.178 to 7.181 MHz","b":"7.178 to 7.184 MHz","c":"7.175 to 7.178 MHz","d":"7.1765 to 7.1795 MHz"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D09","question":"What frequency range is occupied by a 3 kHz USB signal with the displayed carrie"+"r frequency set to 14.347 MHz?","answer":"B","choices":{"a":"14.347 to 14.647 MHz","b":"14.347 to 14.350 MHz","c":"14.344 to 14.347 MHz","d":"14.3455 to 14.3485 MHz"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D10","question":"How close to the lower edge of the 40-meter General Class phone segment should y"+"our displayed carrier frequency be when using 3 kHz wide LSB?","answer":"A","choices":{"a":"At least 3 kHz above the edge of the segment","b":"At least 3 kHz below the edge of the segment","c":"Your displayed carrier frequency may be set at the edge of the segment","d":"At least 1 kHz above the edge of the segment"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4D","questionID":"G4D11","question":"How close to the upper edge of the 20-meter General Class band should your displ"+"ayed carrier frequency be when using 3 kHz wide USB? ","answer":"B","choices":{"a":"At least 3 kHz above the edge of the band","b":"At least 3 kHz below the edge of the band","c":"Your displayed carrier frequency may be set at the edge of the band","d":"At least 1 kHz below the edge of the segment"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E01","question":"What is the purpose of a capacitance hat on a mobile antenna?","answer":"C","choices":{"a":"To increase the power handling capacity of a whip antenna","b":"To allow automatic band changing","c":"To electrically lengthen a physically short antenna","d":"To allow remote tuning"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E02","question":"What is the purpose of a corona ball on a HF mobile antenna?","answer":"D","choices":{"a":"To narrow the operating bandwidth of the antenna","b":"To increase the \"Q\" of the antenna","c":"To reduce the chance of damage if the antenna should strike an object","d":"To reduce high voltage discharge from the tip of the antenna"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E03","question":"Which of the following direct, fused power connections would be the best for a 1"+"00 watt HF mobile installation? ","answer":"A","choices":{"a":"To the battery using heavy gauge wire","b":"To the alternator or generator using heavy gauge wire","c":"To the battery using resistor wire","d":"To the alternator or generator using resistor wire"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E04","question":"Why is it best NOT to draw the DC power for a 100 watt HF transceiver from a veh"+"icle’s auxiliary power socket?","answer":"B","choices":{"a":"The socket is not wired with an RF-shielded power cable","b":"The socket's wiring may be inadequate for the current drawn by the transceiver","c":"The DC polarity of the socket is reversed from the polarity of modern HF transce"+"ivers","d":"Drawing more than 50 watts from this socket could cause the engine to overheat"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E05","question":"Which of the following most limits the effectiveness of an HF mobile transceiver"+" operating in the 75-meter band?","answer":"C","choices":{"a":"\"Picket Fencing\" signal variation","b":"The wire gauge of the DC power line to the transceiver","c":"The antenna system","d":"FCC rules limiting mobile output power on the 75-meter band"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E06","question":"What is one disadvantage of using a shortened mobile antenna as opposed to a ful"+"l size antenna?","answer":"C","choices":{"a":"Short antennas are more likely to cause distortion of transmitted signals","b":"Short antennas can only receive circularly polarized signals","c":"Operating bandwidth may be very limited","d":"Harmonic radiation may increase"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E07","question":"Which of the following may cause interference to be heard in the receiver of an "+"HF radio installed in a recent model vehicle?","answer":"D","choices":{"a":"The battery charging system","b":"The fuel delivery system","c":"The vehicle control computer","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E08","question":"What is the name of the process by which sunlight is changed directly into elect"+"ricity?","answer":"A","choices":{"a":"Photovoltaic conversion","b":"Photon emission","c":"Photosynthesis","d":"Photon decomposition"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E09","question":"What is the approximate open-circuit voltage from a fully illuminated silicon ph"+"otovoltaic cell?","answer":"B","choices":{"a":"0.02 VDC","b":"0.5 VDC","c":"0.2 VDC","d":"1.38 VDC"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E10","question":"What is the reason that a series diode is connected between a solar panel and a "+"storage battery that is being charged by the panel?","answer":"B","choices":{"a":"The diode serves to regulate the charging voltage to prevent overcharge","b":"The diode prevents self-discharge of the battery though the panel during times o"+"f low or no illumination","c":"The diode limits the current flowing from the panel to a safe value","d":"The diode greatly increases the efficiency during times of high illumination"},"metadata":""},{"exam":"G","section":"G4","subSection":"G4E","questionID":"G4E11","question":"Which of the following is a disadvantage of using wind as the primary source of "+"power for an emergency station?","answer":"C","choices":{"a":"The conversion efficiency from mechanical energy to electrical energy is less th"+"an 2 percent","b":"The voltage and current ratings of such systems are not compatible with amateur "+"equipment","c":"A large energy storage system is needed to supply power when the wind is not blo"+"wing","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A01","question":"What is impedance?","answer":"C","choices":{"a":"The electric charge stored by a capacitor","b":"The inverse of resistance","c":"The opposition to the flow of current in an AC circuit","d":"The force of repulsion between two similar electric fields"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A02","question":"What is reactance?","answer":"B","choices":{"a":"Opposition to the flow of direct current caused by resistance","b":"Opposition to the flow of alternating current caused by capacitance or inductanc"+"e","c":"A property of ideal resistors in AC circuits","d":"A large spark produced at switch contacts when an inductor is"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A03","question":"Which of the following causes opposition to the flow of alternating current in a"+"n inductor?","answer":"D","choices":{"a":"Conductance","b":"Reluctance","c":"Admittance","d":"Reactance"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A04","question":"Which of the following causes opposition to the flow of alternating current in a"+" capacitor?","answer":"C","choices":{"a":"Conductance","b":"Reluctance","c":"Reactance","d":"Admittance"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A05","question":"How does an inductor react to AC?","answer":"D","choices":{"a":"As the frequency of the applied AC increases, the reactance decreases","b":"As the amplitude of the applied AC increases, the reactance increases","c":"As the amplitude of the applied AC increases, the reactance decreases","d":"As the frequency of the applied AC increases, the reactance increases"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A06","question":"How does a capacitor react to AC?","answer":"A","choices":{"a":"As the frequency of the applied AC increases, the reactance decreases","b":"As the frequency of the applied AC increases, the reactance increases","c":"As the amplitude of the applied AC increases, the reactance increases","d":"As the amplitude of the applied AC increases, the reactance decreases"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A07","question":"What happens when the impedance of an electrical load is equal to the output imp"+"edance of a power source, assuming both impedances are resistive? ","answer":"D","choices":{"a":"The source delivers minimum power to the load","b":"The electrical load is shorted","c":"No current can flow through the circuit","d":"The source can deliver maximum power to the load"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A08","question":"Why is impedance matching important?","answer":"A","choices":{"a":"So the source can deliver maximum power to the load","b":"So the load will draw minimum power from the source","c":"To ensure that there is less resistance than reactance in the circuit","d":"To ensure that the resistance and reactance in the circuit are equal"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A09","question":"What unit is used to measure reactance?","answer":"B","choices":{"a":"Farad","b":"Ohm","c":"Ampere","d":"Siemens"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A10","question":"What unit is used to measure impedance?","answer":"B","choices":{"a":"Volt","b":"Ohm","c":"Ampere","d":"Watt"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A11","question":"Which of the following describes one method of impedance matching between two AC"+" circuits?","answer":"A","choices":{"a":"Insert an LC network between the two circuits","b":"Reduce the power output of the first circuit","c":"Increase the power output of the first circuit","d":"Insert a circulator between the two circuits"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A12","question":"What is one reason to use an impedance matching transformer?","answer":"B","choices":{"a":"To minimize transmitter power output","b":"To maximize the transfer of power","c":"To reduce power supply ripple","d":"To minimize radiation resistance"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5A","questionID":"G5A13","question":"Which of the following devices can be used for impedance matching at radio frequ"+"encies?","answer":"D","choices":{"a":"A transformer","b":"A Pi-network","c":"A length of transmission line","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B01","question":"What dB change represents a two-times increase or decrease in power?","answer":"B","choices":{"a":"Approximately 2 dB","b":"Approximately 3 dB","c":"Approximately 6 dB","d":"Approximately 12 dB"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B02","question":"How does the total current relate to the individual currents in each branch of a"+" purely resistive parallel circuit?","answer":"C","choices":{"a":"It equals the average of each branch current","b":"It decreases as more parallel branches are added to the circuit","c":"It equals the sum of the currents through each branch","d":"It is the sum of the reciprocal of each individual voltage drop"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B03","question":"How many watts of electrical power are used if 400 VDC is supplied to an 800 ohm"+" load?","answer":"B","choices":{"a":"0.5 watts","b":"200 watts","c":"400 watts","d":"3200 watts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B04","question":"How many watts of electrical power are used by a 12 VDC light bulb that draws 0."+"2 amperes?","answer":"A","choices":{"a":"2.4 watts","b":"24 watts","c":"6 watts","d":"60 watts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B05","question":"How many watts are dissipated when a current of 7.0 milliamperes flows through 1"+".25 kilohms resistance?","answer":"A","choices":{"a":"Approximately 61 milliwatts","b":"Approximately 61 watts","c":"Approximately 11 milliwatts","d":"Approximately 11 watts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B06","question":"What is the output PEP from a transmitter if an oscilloscope measures 200 volts "+"peak-to-peak across a 50 ohm dummy load connected to the transmitter output?","answer":"B","choices":{"a":"1.4 watts","b":"100 watts","c":"353.5 watts","d":"400 watts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B07","question":"What value of an AC signal produces the same power dissipation in a resistor as "+"a DC voltage of the same value? ","answer":"C","choices":{"a":"The peak-to-peak value","b":"The peak value","c":"The RMS value","d":"The reciprocal of the RMS value"},"metadata":""},{"exam":"*","section":"**","subSection":"***","questionID":"***G5B08","question":"What is the peak-to-peak voltage of a sine wave that has an RMS voltage of 120 v"+"olts? ","answer":"D","choices":{"a":"84.8 volts","b":"169.7 volts","c":"240.0 volts","d":"339.4 volts"},"metadata":"** QUESTION REMOVED BY QPC February 4, 2015***"},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B09","question":"What is the RMS voltage of a sine wave with a value of 17 volts peak? ","answer":"B","choices":{"a":"8.5 volts","b":"12 volts","c":"24 volts","d":"34 volts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B10","question":"What percentage of power loss would result from a transmission line loss of 1 dB"+"?","answer":"C","choices":{"a":"10.9 percent","b":"12.2 percent","c":"20.5 percent","d":"25.9 percent"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B11","question":"What is the ratio of peak envelope power to average power for an unmodulated car"+"rier?","answer":"B","choices":{"a":"0.707","b":"1.00","c":"1.414","d":"2.00"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B12","question":"What would be the RMS voltage across a 50 ohm dummy load dissipating 1200 watts?","answer":"B","choices":{"a":"173 volts","b":"245 volts","c":"346 volts","d":"692 volts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B13","question":"What is the output PEP of an unmodulated carrier if an average reading wattmeter"+" connected to the transmitter output indicates 1060 watts?","answer":"B","choices":{"a":"530 watts","b":"1060 watts","c":"1500 watts","d":"2120 watts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5B","questionID":"G5B14","question":"What is the output PEP from a transmitter if an oscilloscope measures 500 volts "+"peak-to-peak across a 50 ohm resistive load connected to the transmitter output?","answer":"B","choices":{"a":"8.75 watts","b":"625 watts","c":"2500 watts","d":"5000 watts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C01","question":"What causes a voltage to appear across the secondary winding of a transformer wh"+"en an AC voltage source is connected across its primary winding?","answer":"C","choices":{"a":"Capacitive coupling","b":"Displacement current coupling","c":"Mutual inductance","d":"Mutual capacitance"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C02","question":"What happens if you reverse the primary and secondary windings of a 4:1 voltage "+"step down transformer?","answer":"A","choices":{"a":"The secondary voltage becomes 4 times the primary voltage","b":"The transformer no longer functions as it is a unidirectional device","c":"Additional resistance must be added in series with the primary to prevent overlo"+"ad","d":"Additional resistance must be added in parallel with the secondary to prevent ov"+"erload"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C03","question":"Which of the following components should be added to an existing resistor to inc"+"rease the resistance?","answer":"B","choices":{"a":"A resistor in parallel","b":"A resistor in series","c":"A capacitor in series","d":"A capacitor in parallel"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C04","question":"What is the total resistance of three 100 ohm resistors in parallel?","answer":"C","choices":{"a":"0.30 ohms","b":"0.33 ohms","c":"33.3 ohms","d":"300 ohms"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C05","question":"If three equal value resistors in series produce 450 ohms, what is the value of "+"each resistor?","answer":"C","choices":{"a":"1500 ohms","b":"90 ohms","c":"150 ohms","d":"175 ohms"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C06","question":"What is the RMS voltage across a 500-turn secondary winding in a transformer if "+"the 2250-turn primary is connected to 120 VAC?","answer":"C","choices":{"a":"2370 volts","b":"540 volts","c":"26.7 volts","d":"5.9 volts"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C07","question":"What is the turns ratio of a transformer used to match an audio amplifier having"+" 600 ohm output impedance to a speaker having 4 ohm impedance?","answer":"A","choices":{"a":"12.2 to 1","b":"24.4 to 1","c":"150 to 1","d":"300 to 1"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C08","question":"What is the equivalent capacitance of two 5.0 nanofarad capacitors and one 750 p"+"icofarad capacitor connected in parallel?","answer":"D","choices":{"a":"576.9 nanofarads","b":"1733 picofarads","c":"3583 picofarads","d":"10.750 nanofarads"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C09","question":"What is the capacitance of three 100 microfarad capacitors connected in series?","answer":"C","choices":{"a":"0.30 microfarads","b":"0.33 microfarads","c":"33.3 microfarads","d":"300 microfarads"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C10","question":"What is the inductance of three 10 millihenry inductors connected in parallel?","answer":"C","choices":{"a":"0.30 henrys","b":"3.3 henrys","c":"3.3 millihenrys","d":"30 millihenrys"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C11","question":"What is the inductance of a 20 millihenry inductor connected in series with a 50"+" millihenry inductor?","answer":"C","choices":{"a":"0.07 millihenrys","b":"14.3 millihenrys","c":"70 millihenrys","d":"1000 millihenrys"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C12","question":"What is the capacitance of a 20 microfarad capacitor connected in series with a "+"50 microfarad capacitor?","answer":"B","choices":{"a":"0.07 microfarads","b":"14.3 microfarads","c":"70 microfarads","d":"1000 microfarads"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C13","question":"Which of the following components should be added to a capacitor to increase the"+" capacitance?","answer":"C","choices":{"a":"An inductor in series","b":"A resistor in series","c":"A capacitor in parallel","d":"A capacitor in series"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C14","question":"Which of the following components should be added to an inductor to increase the"+" inductance?","answer":"D","choices":{"a":"A capacitor in series","b":"A resistor in parallel","c":"An inductor in parallel","d":"An inductor in series"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C15","question":"What is the total resistance of a 10 ohm, a 20 ohm, and a 50 ohm resistor connec"+"ted in parallel?","answer":"A","choices":{"a":"5.9 ohms","b":"0.17 ohms","c":"10000 ohms","d":"80 ohms"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C16","question":"Why is the conductor of the primary winding of many voltage step up transformers"+" larger in diameter than the conductor of the secondary winding?","answer":"B","choices":{"a":"To improve the coupling between the primary and secondary","b":"To accommodate the higher current of the primary","c":"To prevent parasitic oscillations due to resistive losses in the primary","d":"To insure that the volume of the primary winding is equal to the volume of the s"+"econdary winding"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C17","question":"What is the value in nanofarads (nF) of a 22,000 pF capacitor?","answer":"C","choices":{"a":"0.22 nF","b":"2.2 nF","c":"22 nF","d":"220 nF"},"metadata":""},{"exam":"G","section":"G5","subSection":"G5C","questionID":"G5C18","question":"What is the value in microfarads of a 4700 nanofarad (nF) capacitor? ","answer":"D","choices":{"a":"47 µF","b":"0.47 µF","c":"47,000 µF","d":"4.7 µF"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A01","question":"What is the minimum allowable discharge voltage for maximum life of a standard 1"+"2 volt lead acid battery?","answer":"C","choices":{"a":"6 volts","b":"8.5 volts","c":"10.5 volts","d":"12 volts"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A02","question":"What is an advantage of the low internal resistance of nickel-cadmium batteries?","answer":"B","choices":{"a":"Long life","b":"High discharge current","c":"High voltage","d":"Rapid recharge"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A03","question":"What is the approximate junction threshold voltage of a germanium diode?","answer":"B","choices":{"a":"0.1 volt","b":"0.3 volts","c":"0.7 volts","d":"1.0 volts"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A04","question":"When is it acceptable to recharge a carbon-zinc primary cell?","answer":"D","choices":{"a":"As long as the voltage has not been allowed to drop below 1.0 volt","b":"When the cell is kept warm during the recharging period","c":"When a constant current charger is used","d":"Never"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A05","question":"What is the approximate junction threshold voltage of a conventional silicon dio"+"de?","answer":"C","choices":{"a":"0.1 volt","b":"0.3 volts","c":"0.7 volts","d":"1.0 volts"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A06","question":"Which of the following is an advantage of using a Schottky diode in an RF switch"+"ing circuit rather than a standard silicon diode?","answer":"A","choices":{"a":"Lower capacitance","b":"Lower inductance","c":"Longer switching times","d":"Higher breakdown voltage"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A07","question":"What are the stable operating points for a bipolar transistor used as a switch i"+"n a logic circuit?","answer":"A","choices":{"a":"Its saturation and cutoff regions","b":"Its active region (between the cutoff and saturation regions)","c":"Its peak and valley current points","d":"Its enhancement and depletion modes"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A08","question":"Why must the cases of some large power transistors be insulated from ground?","answer":"D","choices":{"a":"To increase the beta of the transistor","b":"To improve the power dissipation capability","c":"To reduce stray capacitance","d":"To avoid shorting the collector or drain voltage to ground"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A09","question":"Which of the following describes the construction of a MOSFET?","answer":"B","choices":{"a":"The gate is formed by a back-biased junction","b":"The gate is separated from the channel with a thin insulating layer","c":"The source is separated from the drain by a thin insulating layer","d":"The source is formed by depositing metal on silicon"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A10","question":"Which element of a triode vacuum tube is used to regulate the flow of electrons "+"between cathode and plate?","answer":"A","choices":{"a":"Control grid","b":"Heater","c":"Screen Grid","d":"Trigger electrode"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A11","question":"Which of the following solid state devices is most like a vacuum tube in its gen"+"eral operating characteristics?","answer":"B","choices":{"a":"A bipolar transistor","b":"A field effect transistor","c":"A tunnel diode","d":"A varistor"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A12","question":"What is the primary purpose of a screen grid in a vacuum tube?","answer":"A","choices":{"a":"To reduce grid-to-plate capacitance","b":"To increase efficiency","c":"To increase the control grid resistance","d":"To decrease plate resistance"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A13","question":"Why is the polarity of applied voltages important for polarized capacitors?","answer":"D","choices":{"a":"Incorrect polarity can cause the capacitor to short-circuit","b":"Reverse voltages can destroy the dielectric layer of an electrolytic capacitor","c":"The capacitor could overheat and explode","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A14","question":"Which of the following is an advantage of ceramic capacitors as compared to othe"+"r types of capacitors?","answer":"D","choices":{"a":"Tight tolerance","b":"High stability","c":"High capacitance for given volume","d":"Comparatively low cost"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A15(C)","question":"Which of the following is an advantage of an electrolytic capacitor?","answer":"","choices":{"a":"Tight tolerance","b":"Much less leakage than any other type","c":"High capacitance for a given volume","d":"Inexpensive RF capacitor"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A16","question":"What will happen to the resistance if the temperature of a resistor is increased"+"?","answer":"C","choices":{"a":"It will change depending on the resistor’s reactance coefficient","b":"It will stay the same","c":"It will change depending on the resistor's temperature coefficient","d":"It will become time dependent"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A17","question":"Which of the following is a reason not to use wire-wound resistors in an RF circ"+"uit?","answer":"B","choices":{"a":"The resistor's tolerance value would not be adequate for such a circuit","b":"The resistor's inductance could make circuit performance unpredictable","c":"The resistor could overheat","d":"The resistor's internal capacitance would detune the circuit"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A18","question":"What is an advantage of using a ferrite core toroidal inductor?","answer":"D","choices":{"a":"Large values of inductance may be obtained","b":"The magnetic properties of the core may be optimized for a specific range of fre"+"quencies","c":"Most of the magnetic field is contained in the core","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6A","questionID":"G6A19","question":"How should the winding axes of two solenoid inductors be oriented to minimize th"+"eir mutual inductance?","answer":"C","choices":{"a":"In line","b":"Parallel to each other","c":"At right angles to each other","d":"Interleaved"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B01","question":"Which of the following is an analog integrated circuit?","answer":"D","choices":{"a":"NAND Gate","b":"Microprocessor","c":"Frequency Counter","d":"Linear voltage regulator"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B02","question":"What is meant by the term MMIC?","answer":"B","choices":{"a":"Multi Megabyte Integrated Circuit","b":"Monolithic Microwave Integrated Circuit","c":"Military Manufactured Integrated Circuit","d":"Mode Modulated Integrated Circuit"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B03","question":"Which of the following is an advantage of CMOS integrated circuits compared to T"+"TL integrated circuits?","answer":"A","choices":{"a":"Low power consumption","b":"High power handling capability","c":"Better suited for RF amplification","d":"Better suited for power supply regulation"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B04","question":"What is meant by the term ROM?","answer":"B","choices":{"a":"Resistor Operated Memory","b":"Read Only Memory","c":"Random Operational Memory","d":"Resistant to Overload Memory"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B05","question":"What is meant when memory is characterized as non-volatile?","answer":"C","choices":{"a":"It is resistant to radiation damage","b":"It is resistant to high temperatures","c":"The stored information is maintained even if power is removed","d":"The stored information cannot be changed once written"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B06","question":"What kind of device is an integrated circuit operational amplifier?","answer":"D","choices":{"a":"Digital","b":"MMIC","c":"Programmable Logic","d":"Analog"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B07","question":"Which of the following is an advantage of an LED indicator compared to an incand"+"escent indicator?","answer":"D","choices":{"a":"Lower power consumption","b":"Faster response time","c":"Longer life","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B08","question":"How is an LED biased when emitting light?","answer":"D","choices":{"a":"Beyond cutoff","b":"At the Zener voltage","c":"Reverse Biased","d":"Forward Biased"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B09","question":"Which of the following is a characteristic of a liquid crystal display?","answer":"A","choices":{"a":"It requires ambient or back lighting","b":"It offers a wide dynamic range","c":"It has a wide viewing angle","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B10","question":"What two devices in an Amateur Radio station might be connected using a USB inte"+"rface?","answer":"A","choices":{"a":"Computer and transceiver","b":"Microphone and transceiver","c":"Amplifier and antenna","d":"Power supply and amplifier"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B11","question":"What is a microprocessor?","answer":"B","choices":{"a":"A low power analog signal processor used as a microwave detector","b":"A computer on a single integrated circuit","c":"A microwave detector, amplifier, and local oscillator on a single integrated cir"+"cuit","d":"A low voltage amplifier used in a microwave transmitter modulator stage"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B12","question":"Which of the following connectors would be a good choice for a serial data port?","answer":"D","choices":{"a":"PL-259","b":"Type N","c":"Type SMA","d":"DE-9"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B13","question":"Which of these connector types is commonly used for RF connections at frequencie"+"s up to 150 MHz? ","answer":"C","choices":{"a":"Octal","b":"RJ-11","c":"PL-259","d":"DB-25"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B14","question":"Which of these connector types is commonly used for audio signals in Amateur Rad"+"io stations? ","answer":"C","choices":{"a":"PL-259","b":"BNC","c":"RCA Phono","d":"Type N"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B15","question":"What is the main reason to use keyed connectors instead of non-keyed types?","answer":"B","choices":{"a":"Prevention of use by unauthorized persons","b":"Reduced chance of incorrect mating","c":"Higher current carrying capacity","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B16","question":"Which of the following describes a type N connector?","answer":"A","choices":{"a":"A moisture-resistant RF connector useful to 10 GHz","b":"A small bayonet connector used for data circuits","c":"A threaded connector used for hydraulic systems","d":"An audio connector used in surround-sound installations"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B17","question":"What is the general description of a DIN type connector?","answer":"C","choices":{"a":"A special connector for microwave interfacing","b":"A DC power connector rated for currents between 30 and 50 amperes","c":"A family of multiple circuit connectors suitable for audio and control signals","d":"A special watertight connector for use in marine applications"},"metadata":""},{"exam":"G","section":"G6","subSection":"G6B","questionID":"G6B18","question":"What is a type SMA connector?","answer":"B","choices":{"a":"A large bayonet connector usable at power levels in excess of 1 KW","b":"A small threaded connector suitable for signals up to several GHz","c":"A connector designed for serial multiple access signals","d":"A type of push-on connector intended for high voltage applications"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A01","question":"What useful feature does a power supply bleeder resistor provide?","answer":"B","choices":{"a":"It acts as a fuse for excess voltage","b":"It ensures that the filter capacitors are discharged when power is removed","c":"It removes shock hazards from the induction coils","d":"It eliminates ground loop current"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A02","question":"Which of the following components are used in a power supply filter network?","answer":"D","choices":{"a":"Diodes","b":"Transformers and transducers","c":"Quartz crystals","d":"Capacitors and inductors"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A03","question":"What is the peak-inverse-voltage across the rectifiers in a full-wave bridge pow"+"er supply?","answer":"D","choices":{"a":"One-quarter the normal output voltage of the power supply","b":"Half the normal output voltage of the power supply","c":"Double the normal peak output voltage of the power supply","d":"Equal to the normal peak output voltage of the power supply"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A04","question":"What is the peak-inverse-voltage across the rectifier in a half-wave power suppl"+"y?","answer":"D","choices":{"a":"One-half the normal peak output voltage of the power supply","b":"One-half the normal output voltage of the power supply","c":"Equal to the normal output voltage of the power supply","d":"Two times the normal peak output voltage of the power supply"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A05","question":"What portion of the AC cycle is converted to DC by a half-wave rectifier?","answer":"B","choices":{"a":"90 degrees","b":"180 degrees","c":"270 degrees","d":"360 degrees"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A06","question":"What portion of the AC cycle is converted to DC by a full-wave rectifier?","answer":"D","choices":{"a":"90 degrees","b":"180 degrees","c":"270 degrees","d":"360 degrees"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A07","question":"What is the output waveform of an unfiltered full-wave rectifier connected to a "+"resistive load?","answer":"A","choices":{"a":"A series of DC pulses at twice the frequency of the AC input","b":"A series of DC pulses at the same frequency as the AC input","c":"A sine wave at half the frequency of the AC input","d":"A steady DC voltage"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A08(C)","question":"Which of the following is an advantage of a switchmode power supply as compared "+"to a linear power supply?","answer":"","choices":{"a":"Faster switching time makes higher output voltage possible","b":"Fewer circuit components are required","c":"High frequency operation allows the use of smaller components","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A09","question":"Which symbol in figure G7-1 represents a field effect transistor?","answer":"C","choices":{"a":"Symbol 2","b":"Symbol 5","c":"Symbol 1","d":"Symbol 4"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A10","question":"Which symbol in figure G7-1 represents a Zener diode?","answer":"D","choices":{"a":"Symbol 4","b":"Symbol 1","c":"Symbol 11","d":"Symbol 5"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A11","question":"Which symbol in figure G7-1 represents an NPN junction transistor?","answer":"B","choices":{"a":"Symbol 1","b":"Symbol 2","c":"Symbol 7","d":"Symbol 11"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A12","question":"Which symbol in Figure G7-1 represents a multiple-winding transformer?","answer":"C","choices":{"a":"Symbol 4","b":"Symbol 7","c":"Symbol 6","d":"Symbol 1"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7A","questionID":"G7A13","question":"Which symbol in Figure G7-1 represents a tapped inductor?","answer":"A","choices":{"a":"Symbol 7","b":"Symbol 11","c":"Symbol 6","d":"Symbol 1"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B01","question":"Complex digital circuitry can often be replaced by what type of integrated circu"+"it?","answer":"A","choices":{"a":"Microcontroller","b":"Charge-coupled device","c":"Phase detector","d":"Window comparator"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B02","question":"Which of the following is an advantage of using the binary system when processin"+"g digital signals?","answer":"A","choices":{"a":"Binary \"ones\" and \"zeros\" are easy to represent by an \"on\" or \"off\" stat"+"e","b":"The binary number system is most accurate","c":"Binary numbers are more compatible with analog circuitry","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B03","question":"Which of the following describes the function of a two input AND gate?","answer":"B","choices":{"a":"Output is high when either or both inputs are low","b":"Output is high only when both inputs are high","c":"Output is low when either or both inputs are high","d":"Output is low only when both inputs are high"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B04","question":"Which of the following describes the function of a two input NOR gate?","answer":"C","choices":{"a":"Output is high when either or both inputs are low","b":"Output is high only when both inputs are high","c":"Output is low when either or both inputs are high","d":"Output is low only when both inputs are high"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B05","question":"How many states does a 3-bit binary counter have?","answer":"C","choices":{"a":"3","b":"6","c":"8","d":"16"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B06","question":"What is a shift register?","answer":"A","choices":{"a":"A clocked array of circuits that passes data in steps along the array","b":"An array of operational amplifiers used for tri-state arithmetic operations","c":"A digital mixer","d":"An analog mixer"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B07","question":"What are the basic components of virtually all sine wave oscillators?","answer":"D","choices":{"a":"An amplifier and a divider","b":"A frequency multiplier and a mixer","c":"A circulator and a filter operating in a feed-forward loop","d":"A filter and an amplifier operating in a feedback loop"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B08","question":"How is the efficiency of an RF power amplifier determined?","answer":"B","choices":{"a":"Divide the DC input power by the DC output power","b":"Divide the RF output power by the DC input power","c":"Multiply the RF input power by the reciprocal of the RF output power","d":"Add the RF input power to the DC output power"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B09","question":"What determines the frequency of an LC oscillator?","answer":"C","choices":{"a":"The number of stages in the counter","b":"The number of stages in the divider","c":"The inductance and capacitance in the tank circuit","d":"The time delay of the lag circuit"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B10","question":"Which of the following is a characteristic of a Class A amplifier?","answer":"D","choices":{"a":"Low standby power","b":"High Efficiency","c":"No need for bias","d":"Low distortion"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B11","question":"For which of the following modes is a Class C power stage appropriate for amplif"+"ying a modulated signal?","answer":"B","choices":{"a":"SSB","b":"CW","c":"AM","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B12","question":"Which of these classes of amplifiers has the highest efficiency?","answer":"D","choices":{"a":"Class A","b":"Class B","c":"Class AB","d":"Class C"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B13","question":"What is the reason for neutralizing the final amplifier stage of a transmitter?","answer":"B","choices":{"a":"To limit the modulation index","b":"To eliminate self-oscillations","c":"To cut off the final amplifier during standby periods","d":"To keep the carrier on frequency"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7B","questionID":"G7B14","question":"Which of the following describes a linear amplifier?","answer":"B","choices":{"a":"Any RF power amplifier used in conjunction with an amateur transceiver","b":"An amplifier in which the output preserves the input waveform","c":"A Class C high efficiency amplifier","d":"An amplifier used as a frequency multiplier"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C01","question":"Which of the following is used to process signals from the balanced modulator th"+"en send them to the mixer in some single sideband phone transmitters?","answer":"B","choices":{"a":"Carrier oscillator","b":"Filter","c":"IF amplifier","d":"RF amplifier"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C02","question":"Which circuit is used to combine signals from the carrier oscillator and speech "+"amplifier then send the result to the filter in some single sideband phone trans"+"mitters?","answer":"D","choices":{"a":"Discriminator","b":"Detector","c":"IF amplifier","d":"Balanced modulator"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C03","question":"What circuit is used to process signals from the RF amplifier and local oscillat"+"or then send the result to the IF filter in a superheterodyne receiver?","answer":"C","choices":{"a":"Balanced modulator","b":"IF amplifier","c":"Mixer","d":"Detector"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C04","question":"What circuit is used to combine signals from the IF amplifier and BFO and send t"+"he result to the AF amplifier in some single sideband receivers?","answer":"D","choices":{"a":"RF oscillator","b":"IF filter","c":"Balanced modulator","d":"Product detector"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C05","question":"Which of the following is an advantage of a transceiver controlled by a direct d"+"igital synthesizer (DDS)?","answer":"D","choices":{"a":"Wide tuning range and no need for band switching","b":"Relatively high power output","c":"Relatively low power consumption","d":"Variable frequency with the stability of a crystal oscillator"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C06","question":"What should be the impedance of a low-pass filter as compared to the impedance o"+"f the transmission line into which it is inserted? ","answer":"B","choices":{"a":"Substantially higher","b":"About the same","c":"Substantially lower","d":"Twice the transmission line impedance"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C07","question":"What is the simplest combination of stages that implement a superheterodyne rece"+"iver?","answer":"C","choices":{"a":"RF amplifier, detector, audio amplifier","b":"RF amplifier, mixer, IF discriminator","c":"HF oscillator, mixer, detector","d":"HF oscillator, prescaler, audio amplifier"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C08","question":"What type of circuit is used in many FM receivers to convert signals coming from"+" the IF amplifier to audio?","answer":"D","choices":{"a":"Product detector","b":"Phase inverter","c":"Mixer","d":"Discriminator"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C09","question":"Which of the following is needed for a Digital Signal Processor IF filter?","answer":"D","choices":{"a":"An analog to digital converter","b":"A digital to analog converter","c":"A digital processor chip","d":"All of the these choices are correct"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C10","question":"How is Digital Signal Processor filtering accomplished?","answer":"B","choices":{"a":"By using direct signal phasing","b":"By converting the signal from analog to digital and using digital processing","c":"By differential spurious phasing","d":"By converting the signal from digital to analog and taking the difference of mix"+"ing products"},"metadata":""},{"exam":"G","section":"G7","subSection":"G7C","questionID":"G7C11","question":"What is meant by the term \"software defined radio\" (SDR)?","answer":"A","choices":{"a":"A radio in which most major signal processing functions are performed by softwar"+"e","b":"A radio that provides computer interface for automatic logging of band and frequ"+"ency","c":"A radio that uses crystal filters designed using software","d":"A computer model that can simulate performance of a radio to aid in the design p"+"rocess"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A01","question":"How is an FSK signal generated?","answer":"B","choices":{"a":"By keying an FM transmitter with a sub-audible tone","b":"By changing an oscillator’s frequency directly with a digital control signal","c":"By using a transceiver’s computer data interface protocol to change frequencies","d":"By reconfiguring the CW keying input to act as a tone generator"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A02","question":"What is the name of the process that changes the phase angle of an RF wave to co"+"nvey information?","answer":"B","choices":{"a":"Phase convolution","b":"Phase modulation","c":"Angle convolution","d":"Radian inversion"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A03","question":"What is the name of the process that changes the instantaneous frequency of an R"+"F wave to convey information?","answer":"D","choices":{"a":"Frequency convolution","b":"Frequency transformation","c":"Frequency conversion","d":"Frequency modulation"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A04","question":"What emission is produced by a reactance modulator connected to a transmitter RF"+" amplifier stage?","answer":"B","choices":{"a":"Multiplex modulation","b":"Phase modulation","c":"Amplitude modulation","d":"Pulse modulation"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A05","question":"What type of modulation varies the instantaneous power level of the RF signal?","answer":"D","choices":{"a":"Frequency shift keying","b":"Phase modulation","c":"Frequency modulation","d":"Amplitude modulation"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A06","question":"What is one advantage of carrier suppression in a single sideband phone transmis"+"sion versus full carrier amplitude modulation?","answer":"C","choices":{"a":"Audio fidelity is improved","b":"Greater modulation percentage is obtainable with lower distortion","c":"Available transmitter power can be used more effectively","d":"Simpler receiving equipment can be used"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A07","question":"Which of the following phone emissions uses the narrowest bandwidth?","answer":"A","choices":{"a":"Single sideband","b":"Double sideband","c":"Phase modulation","d":"Frequency modulation"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A08","question":"Which of the following is an effect of overmodulation?","answer":"D","choices":{"a":"Insufficient audio","b":"Insufficient bandwidth","c":"Frequency drift","d":"Excessive bandwidth"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A09","question":"What control is typically adjusted for proper ALC setting on an amateur single s"+"ideband transceiver?","answer":"B","choices":{"a":"The RF clipping level","b":"Transmit audio or microphone gain","c":"Antenna inductance or capacitance","d":"Attenuator level"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A10","question":"What is meant by the term flat-topping when referring to a single sideband phone"+" transmission?","answer":"C","choices":{"a":"Signal distortion caused by insufficient collector current","b":"The transmitter's automatic level control (ALC) is properly adjusted","c":"Signal distortion caused by excessive drive","d":"The transmitter's carrier is properly suppressed"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8A","questionID":"G8A11","question":"What is the modulation envelope of an AM signal? ","answer":"A","choices":{"a":"The waveform created by connecting the peak values of the modulated signal","b":"The carrier frequency that contains the signal","c":"Spurious signals that envelop nearby frequencies","d":"The bandwidth of the modulated signal"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B01","question":"What receiver stage combines a 14.250 MHz input signal with a 13.795 MHz oscilla"+"tor signal to produce a 455 kHz intermediate frequency (IF) signal?","answer":"A","choices":{"a":"Mixer","b":"BFO","c":"VFO","d":"Discriminator"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B02","question":"If a receiver mixes a 13.800 MHz VFO with a 14.255 MHz received signal to produc"+"e a 455 kHz intermediate frequency (IF) signal, what type of interference will a"+" 13.345 MHz signal produce in the receiver?","answer":"B","choices":{"a":"Quadrature noise","b":"Image response","c":"Mixer interference","d":"Intermediate interference"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B03","question":"What is another term for the mixing of two RF signals?","answer":"A","choices":{"a":"Heterodyning","b":"Synthesizing","c":"Cancellation","d":"Phase inverting"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B04","question":"What is the stage in a VHF FM transmitter that generates a harmonic of a lower f"+"requency signal to reach the desired operating frequency?","answer":"D","choices":{"a":"Mixer","b":"Reactance modulator","c":"Pre-emphasis network","d":"Multiplier"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B05","question":"What is the approximate bandwidth of a PACTOR3 signal at maximum data rate?","answer":"D","choices":{"a":"31.5 Hz","b":"500 Hz","c":"1800 Hz","d":"2300 Hz"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B06","question":"What is the total bandwidth of an FM phone transmission having 5 kHz deviation a"+"nd 3 kHz modulating frequency?","answer":"D","choices":{"a":"3 kHz","b":"5 kHz","c":"8 kHz","d":"16 kHz"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B07","question":"What is the frequency deviation for a 12.21 MHz reactance modulated oscillator i"+"n a 5 kHz deviation, 146.52 MHz FM phone transmitter?","answer":"B","choices":{"a":"101.75 Hz","b":"416.7 Hz","c":"5 kHz","d":"60 kHz"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B08","question":"Why is it important to know the duty cycle of the mode you are using when transm"+"itting?","answer":"B","choices":{"a":"To aid in tuning your transmitter","b":"Some modes have high duty cycles which could exceed the transmitter's average po"+"wer rating.","c":"To allow time for the other station to break in during a transmission","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B09","question":"Why is it good to match receiver bandwidth to the bandwidth of the operating mod"+"e?","answer":"D","choices":{"a":"It is required by FCC rules","b":"It minimizes power consumption in the receiver","c":"It improves impedance matching of the antenna","d":"It results in the best signal to noise ratio"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8B","questionID":"G8B10","question":"What is the relationship between transmitted symbol rate and bandwidth?","answer":"B","choices":{"a":"Symbol rate and bandwidth are not related","b":"Higher symbol rates require wider bandwidth","c":"Lower symbol rates require wider bandwidth","d":"Bandwidth is always half the symbol rate"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C01","question":"Which of the following digital modes is designed to operate at extremely low sig"+"nal strength on the HF bands? ","answer":"B","choices":{"a":"FSK441 and Hellschreiber","b":"JT9 and JT65","c":"Clover","d":"RTTY"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C02(A)","question":"How many data bits are sent in a single PSK31 character?","answer":"","choices":{"a":"The number varies","b":"5","c":"7","d":"8"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C03","question":"What part of a data packet contains the routing and handling information?","answer":"C","choices":{"a":"Directory","b":"Preamble","c":"Header","d":"Footer"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C04","question":"Which of the following describes Baudot code?","answer":"C","choices":{"a":"A 7-bit code with start, stop and parity bits","b":"A code using error detection and correction","c":"A 5-bit code with additional start and stop bits","d":"A code using SELCAL and LISTEN"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C05","question":"In the PACTOR protocol, what is meant by an NAK response to a transmitted packet"+"?","answer":"A","choices":{"a":"The receiver is requesting the packet be retransmitted","b":"The receiver is reporting the packet was received without error","c":"The receiver is busy decoding the packet","d":"The entire file has been received correctly"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C06","question":"What action results from a failure to exchange information due to excessive tran"+"smission attempts when using PACTOR or WINMOR? ","answer":"B","choices":{"a":"The checksum overflows","b":"The connection is dropped","c":"Packets will be routed incorrectly","d":"Encoding reverts to the default character set"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C07","question":"How does the receiving station respond to an ARQ data mode packet containing err"+"ors?","answer":"B","choices":{"a":"It terminates the contact","b":"It requests the packet be retransmitted","c":"It sends the packet back to the transmitting station","d":"It requests a change in transmitting protocol"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C08","question":"Which of the following statements is true about PSK31?","answer":"B","choices":{"a":"Upper case letters make the signal stronger","b":"Upper case letters use longer Varicode signals and thus slow down transmission","c":"Varicode Error Correction is used to ensure accurate message reception","d":"Higher power is needed as compared to RTTY for similar error rates"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C09","question":"What does the number 31 represent in \"PSK31\"?","answer":"A","choices":{"a":"The approximate transmitted symbol rate","b":"The version of the PSK protocol","c":"The year in which PSK31 was invented","d":"The number of characters that can be represented by PSK31"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C10","question":"How does forward error correction (FEC) allow the receiver to correct errors in "+"received data packets?","answer":"C","choices":{"a":"By controlling transmitter output power for optimum signal strength","b":"By using the varicode character set","c":"By transmitting redundant information with the data","d":"By using a parity bit with each character"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C11","question":"How are the two separate frequencies of a Frequency Shift Keyed (FSK) signal ide"+"ntified?","answer":"D","choices":{"a":"Dot and Dash","b":"On and Off","c":"High and Low","d":"Mark and Space"},"metadata":""},{"exam":"G","section":"G8","subSection":"G8C","questionID":"G8C12","question":"Which type of code is used for sending characters in a PSK31 signal?","answer":"A","choices":{"a":"Varicode","b":"Viterbi","c":"Volumetric","d":"Binary"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A01","question":"Which of the following factors determine the characteristic impedance of a paral"+"lel conductor antenna feed line?","answer":"A","choices":{"a":"The distance between the centers of the conductors and the radius of the conduct"+"ors","b":"The distance between the centers of the conductors and the length of the line","c":"The radius of the conductors and the frequency of the signal","d":"The frequency of the signal and the length of the line"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A02","question":"What are the typical characteristic impedances of coaxial cables used for antenn"+"a feed lines at amateur stations?","answer":"B","choices":{"a":"25 and 30 ohms","b":"50 and 75 ohms","c":"80 and 100 ohms","d":"500 and 750 ohms"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A03","question":"What is the characteristic impedance of flat ribbon TV type twinlead?","answer":"D","choices":{"a":"50 ohms","b":"75 ohms","c":"100 ohms","d":"300 ohms"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A04","question":"What might cause reflected power at the point where a feed line connects to an a"+"ntenna?","answer":"C","choices":{"a":"Operating an antenna at its resonant frequency","b":"Using more transmitter power than the antenna can handle","c":"A difference between feed line impedance and antenna feed point impedance","d":"Feeding the antenna with unbalanced feed line"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A05","question":"How does the attenuation of coaxial cable change as the frequency of the signal "+"it is carrying increases?","answer":"B","choices":{"a":"Attenuation is independent of frequency","b":"Attenuation increases","c":"Attenuation decreases","d":"Attenuation reaches a maximum at approximately 18 MHz"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A06","question":"In what units is RF feed line loss usually expressed?","answer":"D","choices":{"a":"Ohms per 1000 feet","b":"Decibels per 1000 feet","c":"Ohms per 100 feet","d":"Decibels per 100 feet"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A07","question":"What must be done to prevent standing waves on an antenna feed line?","answer":"D","choices":{"a":"The antenna feed point must be at DC ground potential","b":"The feed line must be cut to a length equal to an odd number of electrical quart"+"er wavelengths","c":"The feed line must be cut to a length equal to an even number of physical half w"+"avelengths","d":"The antenna feed point impedance must be matched to the characteristic impedance"+" of the feed line"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A08","question":"If the SWR on an antenna feed line is 5 to 1, and a matching network at the tran"+"smitter end of the feed line is adjusted to 1 to 1 SWR, what is the resulting SW"+"R on the feed line?","answer":"B","choices":{"a":"1 to 1","b":"5 to 1","c":"Between 1 to 1 and 5 to 1 depending on the characteristic impedance of the line","d":"Between 1 to 1 and 5 to 1 depending on the reflected power at the transmitter"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A09","question":"What standing wave ratio will result when connecting a 50 ohm feed line to a non"+"-reactive load having 200 ohm impedance?","answer":"A","choices":{"a":"4:1","b":"1:4","c":"2:1","d":"1:2"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A10","question":"What standing wave ratio will result when connecting a 50 ohm feed line to a non"+"-reactive load having 10 ohm impedance?","answer":"D","choices":{"a":"2:1","b":"50:1","c":"1:5","d":"5:1"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A11","question":"What standing wave ratio will result when connecting a 50 ohm feed line to a non"+"-reactive load having 50 ohm impedance?","answer":"B","choices":{"a":"2:1","b":"1:1","c":"50:50","d":"0:0"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A12","question":"What standing wave ratio will result when connecting a 50 ohm feed line to a non"+"-reactive load having 25 ohm impedance?","answer":"A","choices":{"a":"2:1","b":"2.5:1","c":"1.25:1","d":"You cannot determine SWR from impedance values"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A13","question":"What standing wave ratio will result when connecting a 50 ohm feed line to an an"+"tenna that has a purely resistive 300 ohm feed point impedance?","answer":"C","choices":{"a":"1.5:1","b":"3:1","c":"6:1","d":"You cannot determine SWR from impedance values"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A14","question":"What is the interaction between high standing wave ratio (SWR) and transmission "+"line loss?","answer":"B","choices":{"a":"There is no interaction between transmission line loss and SWR","b":"If a transmission line is lossy, high SWR will increase the loss","c":"High SWR makes it difficult to measure transmission line loss","d":"High SWR reduces the relative effect of transmission line loss"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9A","questionID":"G9A15","question":"What is the effect of transmission line loss on SWR measured at the input to the"+" line?","answer":"A","choices":{"a":"The higher the transmission line loss, the more the SWR will read artificially l"+"ow","b":"The higher the transmission line loss, the more the SWR will read artificially h"+"igh","c":"The higher the transmission line loss, the more accurate the SWR measurement wil"+"l be","d":"Transmission line loss does not affect the SWR measurement"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B01","question":"What is one disadvantage of a directly fed random-wire HF antenna?","answer":"B","choices":{"a":"It must be longer than 1 wavelength","b":"You may experience RF burns when touching metal objects in your station","c":"It produces only vertically polarized radiation","d":"It is more effective on the lower HF bands than on the higher bands"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B02","question":"Which of the following is a common way to adjust the feed point impedance of a q"+"uarter wave ground plane vertical antenna to be approximately 50 ohms?","answer":"B","choices":{"a":"Slope the radials upward","b":"Slope the radials downward","c":"Lengthen the radials","d":"Shorten the radials"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B03","question":"What happens to the feed point impedance of a ground plane antenna when its radi"+"als are changed from horizontal to sloping downward?","answer":"B","choices":{"a":"It decreases","b":"It increases","c":"It stays the same","d":"It reaches a maximum at an angle of 45 degrees"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B04","question":"What is the radiation pattern of a dipole antenna in free space in the plane of "+"the conductor?","answer":"A","choices":{"a":"It is a figure-eight at right angles to the antenna","b":"It is a figure-eight off both ends of the antenna","c":"It is a circle (equal radiation in all directions)","d":"It has a pair of lobes on one side of the antenna and a single lobe on the other"+" side"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B05","question":"How does antenna height affect the horizontal (azimuthal) radiation pattern of a"+" horizontal dipole HF antenna?","answer":"C","choices":{"a":"If the antenna is too high, the pattern becomes unpredictable","b":"Antenna height has no effect on the pattern","c":"If the antenna is less than 1/2 wavelength high, the azimuthal pattern is almost"+" omnidirectional","d":"If the antenna is less than 1/2 wavelength high, radiation off the ends of the w"+"ire is eliminated"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B06","question":"Where should the radial wires of a ground-mounted vertical antenna system be pla"+"ced?","answer":"C","choices":{"a":"As high as possible above the ground","b":"Parallel to the antenna element","c":"On the surface of the Earth or buried a few inches below the ground","d":"At the center of the antenna"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B07","question":"How does the feed point impedance of a 1/2 wave dipole antenna change as the ant"+"enna is lowered below 1/4 wave above ground?","answer":"B","choices":{"a":"It steadily increases","b":"It steadily decreases","c":"It peaks at about 1/8 wavelength above ground","d":"It is unaffected by the height above ground"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B08","question":"How does the feed point impedance of a 1/2 wave dipole change as the feed point "+"is moved from the center toward the ends?","answer":"A","choices":{"a":"It steadily increases","b":"It steadily decreases","c":"It peaks at about 1/8 wavelength from the end","d":"It is unaffected by the location of the feed point"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B09","question":"Which of the following is an advantage of a horizontally polarized as compared t"+"o a vertically polarized HF antenna?","answer":"A","choices":{"a":"Lower ground reflection losses","b":"Lower feed point impedance","c":"Shorter Radials","d":"Lower radiation resistance"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B10","question":"What is the approximate length for a 1/2 wave dipole antenna cut for 14.250 MHz?","answer":"D","choices":{"a":"8 feet","b":"16 feet","c":"24 feet","d":"32 feet"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B11","question":"What is the approximate length for a 1/2 wave dipole antenna cut for 3.550 MHz?","answer":"C","choices":{"a":"42 feet","b":"84 feet","c":"131 feet","d":"263 feet"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9B","questionID":"G9B12","question":"What is the approximate length for a 1/4 wave vertical antenna cut for 28.5 MHz?","answer":"A","choices":{"a":"8 feet","b":"11 feet","c":"16 feet","d":"21 feet"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C01","question":"Which of the following would increase the bandwidth of a Yagi antenna?","answer":"A","choices":{"a":"Larger diameter elements","b":"Closer element spacing","c":"Loading coils in series with the element","d":"Tapered-diameter elements"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C02","question":"What is the approximate length of the driven element of a Yagi antenna?","answer":"B","choices":{"a":"1/4 wavelength","b":"1/2 wavelength","c":"3/4 wavelength","d":"1 wavelength"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C03","question":"Which statement about a three-element, single-band Yagi antenna is true?","answer":"B","choices":{"a":"The reflector is normally the shortest element","b":"The director is normally the shortest element","c":"The driven element is the longest element","d":"Low feed point impedance increases bandwidth"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C04","question":"Which statement about a three-element, single-band Yagi antenna is true?","answer":"A","choices":{"a":"The reflector is normally the longest element","b":"The director is normally the longest element","c":"The reflector is normally the shortest element","d":"All of the elements must be the same length"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C05","question":"How does increasing boom length and adding directors affect a Yagi antenna?","answer":"A","choices":{"a":"Gain increases","b":"Beamwidth increases","c":"Front to back ratio decreases","d":"Front to side ratio decreases"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C06","question":"What configuration of the loops of a two-element quad antenna must be used for t"+"he antenna to operate as a beam antenna, assuming one of the elements is used as"+" a reflector? ","answer":"D","choices":{"a":"The driven element must be fed with a balun transformer","b":"There must be an open circuit in the driven element at the point opposite the fe"+"ed point","c":"The reflector element must be approximately 5 percent shorter than the driven el"+"ement","d":"The reflector element must be approximately 5 percent longer than the driven ele"+"ment"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C07","question":"What does \"front-to-back ratio\" mean in reference to a Yagi antenna?","answer":"C","choices":{"a":"The number of directors versus the number of reflectors","b":"The relative position of the driven element with respect to the reflectors and d"+"irectors","c":"The power radiated in the major radiation lobe compared to the power radiated in"+" exactly the opposite direction","d":"The ratio of forward gain to dipole gain"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C08","question":"What is meant by the \"main lobe\" of a directive antenna?","answer":"D","choices":{"a":"The magnitude of the maximum vertical angle of radiation","b":"The point of maximum current in a radiating antenna element","c":"The maximum voltage standing wave point on a radiating element","d":"The direction of maximum radiated field strength from the antenna"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C09","question":"How does the gain of two 3-element horizontally polarized Yagi antennas spaced v"+"ertically 1/2 wavelength apart typically compare to the gain of a single 3-eleme"+"nt Yagi?","answer":"B","choices":{"a":"Approximately 1.5 dB higher","b":"Approximately 3 dB higher","c":"Approximately 6 dB higher","d":"Approximately 9 dB higher"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C10","question":"Which of the following is a Yagi antenna design variable that could be adjusted "+"to optimize forward gain, front-to-back ratio, or SWR bandwidth? ","answer":"D","choices":{"a":"The physical length of the boom","b":"The number of elements on the boom","c":"The spacing of each element along the boom","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C11","question":"What is the purpose of a gamma match used with Yagi antennas?","answer":"A","choices":{"a":"To match the relatively low feed point impedance to 50 ohms","b":"To match the relatively high feed point impedance to 50 ohms","c":"To increase the front-to-back ratio","d":"To increase the main lobe gain"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C12","question":"Which of the following is an advantage of using a gamma match for impedance matc"+"hing of a Yagi antenna to 50 ohm coax feed line?","answer":"A","choices":{"a":"It does not require that the elements be insulated from the boom","b":"It does not require any inductors or capacitors","c":"It is useful for matching multiband antennas","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C13","question":"Approximately how long is each side of the driven element of a quad antenna?","answer":"A","choices":{"a":"1/4 wavelength","b":"1/2 wavelength","c":"3/4 wavelength","d":"1 wavelength"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C14","question":"How does the forward gain of a two-element quad antenna compare to the forward g"+"ain of a three-element Yagi antenna?","answer":"B","choices":{"a":"About 2/3 as much","b":"About the same","c":"About 1.5 times as much","d":"About twice as much"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C15","question":"Approximately how long is each side of the reflector element of a quad antenna?","answer":"B","choices":{"a":"Slightly less than 1/4 wavelength","b":"Slightly more than 1/4 wavelength","c":"Slightly less than 1/2 wavelength","d":"Slightly more than 1/2 wavelength"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C16","question":"How does the gain of a two-element delta-loop beam compare to the gain of a two-"+"element quad antenna?","answer":"D","choices":{"a":"3 dB higher","b":"3 dB lower","c":"2.54 dB higher","d":"About the same"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C17","question":"Approximately how long is each leg of a symmetrical delta-loop antenna?","answer":"B","choices":{"a":"1/4 wavelength","b":"1/3 wavelength","c":"1/2 wavelength","d":"2/3 wavelength"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C18","question":"What happens when the feed point of a quad antenna of any shape is moved from th"+"e midpoint of the top or bottom to the midpoint of either side?","answer":"A","choices":{"a":"The polarization of the radiated signal changes from horizontal to vertical","b":"The polarization of the radiated signal changes from vertical to horizontal","c":"There is no change in polarization","d":"The radiated signal becomes circularly polarized"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C19","question":"How does antenna gain stated in dBi compare to gain stated in dBd for the same a"+"ntenna?","answer":"B","choices":{"a":"dBi gain figures are 2.15 dB lower then dBd gain figures","b":"dBi gain figures are 2.15 dB higher than dBd gain figures","c":"dBi gain figures are the same as the square root of dBd gain figures multiplied "+"by 2.15","d":"dBi gain figures are the reciprocal of dBd gain figures + 2.15 dB"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9C","questionID":"G9C20","question":"What is meant by the terms dBi and dBd when referring to antenna gain?","answer":"A","choices":{"a":"dBi refers to an isotropic antenna, dBd refers to a dipole antenna","b":"dBi refers to an ionospheric reflecting antenna, dBd refers to a dissipative ant"+"enna","c":"dBi refers to an inverted-vee antenna, dBd refers to a downward reflecting anten"+"na","d":"dBi refers to an isometric antenna, dBd refers to a discone antenna"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D01","question":"What does the term NVIS mean as related to antennas?","answer":"D","choices":{"a":"Nearly Vertical Inductance System","b":"Non-Varying Indicated SWR","c":"Non-Varying Impedance Smoothing","d":"Near Vertical Incidence sky-wave"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D02","question":"Which of the following is an advantage of an NVIS antenna?","answer":"B","choices":{"a":"Low vertical angle radiation for working stations out to ranges of several thous"+"and kilometers","b":"High vertical angle radiation for working stations within a radius of a few hund"+"red kilometers","c":"High forward gain","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D03","question":"At what height above ground is an NVIS antenna typically installed?","answer":"D","choices":{"a":"As close to 1/2 wavelength as possible","b":"As close to one wavelength as possible","c":"Height is not critical as long as it is significantly more than 1/2 wavelength","d":"Between 1/10 and 1/4 wavelength"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D04","question":"What is the primary purpose of antenna traps?","answer":"A","choices":{"a":"To permit multiband operation","b":"To notch spurious frequencies","c":"To provide balanced feed point impedance","d":"To prevent out of band operation"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D05","question":"What is an advantage of vertical stacking of horizontally polarized Yagi antenna"+"s?","answer":"D","choices":{"a":"It allows quick selection of vertical or horizontal polarization","b":"It allows simultaneous vertical and horizontal polarization","c":"It narrows the main lobe in azimuth","d":"It narrows the main lobe in elevation"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D06","question":"Which of the following is an advantage of a log periodic antenna?","answer":"A","choices":{"a":"Wide bandwidth","b":"Higher gain per element than a Yagi antenna","c":"Harmonic suppression","d":"Polarization diversity"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D07","question":"Which of the following describes a log periodic antenna?","answer":"A","choices":{"a":"Length and spacing of the elements increase logarithmically from one end of the "+"boom to the other","b":"Impedance varies periodically as a function of frequency","c":"Gain varies logarithmically as a function of frequency","d":"SWR varies periodically as a function of boom length"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D08","question":"Why is a Beverage antenna not used for transmitting?","answer":"B","choices":{"a":"Its impedance is too low for effective matching","b":"It has high losses compared to other types of antennas","c":"It has poor directivity","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D09","question":"Which of the following is an application for a Beverage antenna?","answer":"B","choices":{"a":"Directional transmitting for low HF bands","b":"Directional receiving for low HF bands","c":"Portable direction finding at higher HF frequencies","d":"Portable direction finding at lower HF frequencies"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D10","question":"Which of the following describes a Beverage antenna?","answer":"D","choices":{"a":"A vertical antenna","b":"A broad-band mobile antenna","c":"A helical antenna for space reception","d":"A very long and low directional receiving antenna"},"metadata":""},{"exam":"G","section":"G9","subSection":"G9D","questionID":"G9D11","question":"Which of the following is a disadvantage of multiband antennas?","answer":"D","choices":{"a":"They present low impedance on all design frequencies","b":"They must be used with an antenna tuner","c":"They must be fed with open wire line","d":"They have poor harmonic rejection"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A01","question":"What is one way that RF energy can affect human body tissue?","answer":"A","choices":{"a":"It heats body tissue","b":"It causes radiation poisoning","c":"It causes the blood count to reach a dangerously low level","d":"It cools body tissue"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A02","question":"Which of the following properties is important in estimating whether an RF signa"+"l exceeds the maximum permissible exposure (MPE)?","answer":"D","choices":{"a":"Its duty cycle","b":"Its frequency","c":"Its power density","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A03","question":"How can you determine that your station complies with FCC RF exposure regulation"+"s?","answer":"D","choices":{"a":"By calculation based on FCC OET Bulletin 65","b":"By calculation based on computer modeling","c":"By measurement of field strength using calibrated equipment","d":"All of these choices are correct"},"metadata":"97.13(c)(1)"},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A04","question":"What does \"time averaging\" mean in reference to RF radiation exposure?","answer":"D","choices":{"a":"The average amount of power developed by the transmitter over a specific 24 hour"+" period","b":"The average time it takes RF radiation to have any long-term effect on the body","c":"The total time of the exposure","d":"The total RF exposure averaged over a certain time"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A05","question":"What must you do if an evaluation of your station shows RF energy radiated from "+"your station exceeds permissible limits?","answer":"A","choices":{"a":"Take action to prevent human exposure to the excessive RF fields","b":"File an Environmental Impact Statement (EIS-97) with the FCC","c":"Secure written permission from your neighbors to operate above the controlled MP"+"E limits","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A06","question":"What precaution should be taken when installing a ground-mounted antenna?","answer":"D","choices":{"a":"It should not be installed higher than you can reach","b":"It should not be installed in a wet area","c":"It should limited to 10 feet in height","d":"It should be installed such that it is protected against unauthorized access"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A07","question":"What effect does transmitter duty cycle have when evaluating RF exposure? ","answer":"A","choices":{"a":"A lower transmitter duty cycle permits greater short-term exposure levels","b":"A higher transmitter duty cycle permits greater short-term exposure levels","c":"Low duty cycle transmitters are exempt from RF exposure evaluation requirements","d":"High duty cycle transmitters are exempt from RF exposure requirements"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A08","question":"Which of the following steps must an amateur operator take to ensure compliance "+"with RF safety regulations when transmitter power exceeds levels specified in FC"+"C Part 97.13?","answer":"C","choices":{"a":"Post a copy of FCC Part 97.13 in the station","b":"Post a copy of OET Bulletin 65 in the station","c":"Perform a routine RF exposure evaluation","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A09","question":"What type of instrument can be used to accurately measure an RF field?","answer":"B","choices":{"a":"A receiver with an S meter","b":"A calibrated field strength meter with a calibrated antenna","c":"An SWR meter with a peak-reading function","d":"An oscilloscope with a high-stability crystal marker generator"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A10","question":"What is one thing that can be done if evaluation shows that a neighbor might rec"+"eive more than the allowable limit of RF exposure from the main lobe of a direct"+"ional antenna?","answer":"D","choices":{"a":"Change to a non-polarized antenna with higher gain","b":"Post a warning sign that is clearly visible to the neighbor","c":"Use an antenna with a higher front-to-back ratio","d":"Take precautions to ensure that the antenna cannot be pointed in their direction"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A11","question":"What precaution should you take if you install an indoor transmitting antenna?","answer":"C","choices":{"a":"Locate the antenna close to your operating position to minimize feed line radiat"+"ion","b":"Position the antenna along the edge of a wall to reduce parasitic radiation","c":"Make sure that MPE limits are not exceeded in occupied areas","d":"Make sure the antenna is properly shielded"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0A","questionID":"G0A12","question":"What precaution should you take whenever you make adjustments or repairs to an a"+"ntenna?","answer":"B","choices":{"a":"Ensure that you and the antenna structure are grounded","b":"Turn off the transmitter and disconnect the feed line","c":"Wear a radiation badge","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B01","question":"Which wire or wires in a four-conductor connection should be attached to fuses o"+"r circuit breakers in a device operated from a 240 VAC single phase source?","answer":"A","choices":{"a":"Only the two wires carrying voltage","b":"Only the neutral wire","c":"Only the ground wire","d":"All wires"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B02","question":"What is the minimum wire size that may be safely used for a circuit that draws u"+"p to 20 amperes of continuous current?","answer":"C","choices":{"a":"AWG number 20","b":"AWG number 16","c":"AWG number 12","d":"AWG number 8"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B03","question":"Which size of fuse or circuit breaker would be appropriate to use with a circuit"+" that uses AWG number 14 wiring? ","answer":"D","choices":{"a":"100 amperes","b":"60 amperes","c":"30 amperes","d":"15 amperes"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B04","question":"Which of the following is a primary reason for not placing a gasoline-fueled gen"+"erator inside an occupied area?","answer":"A","choices":{"a":"Danger of carbon monoxide poisoning","b":"Danger of engine over torque","c":"Lack of oxygen for adequate combustion","d":"Lack of nitrogen for adequate combustion"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B05","question":"Which of the following conditions will cause a Ground Fault Circuit Interrupter "+"(GFCI) to disconnect the 120 or 240 Volt AC line power to a device?","answer":"B","choices":{"a":"Current flowing from one or more of the voltage-carrying wires to the neutral wi"+"re","b":"Current flowing from one or more of the voltage-carrying wires directly to groun"+"d","c":"Overvoltage on the voltage-carrying wires","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B06","question":"Why must the metal enclosure of every item of station equipment be grounded?","answer":"D","choices":{"a":"It prevents a blown fuse in the event of an internal short circuit","b":"It prevents signal overload","c":"It ensures that the neutral wire is grounded","d":"It ensures that hazardous voltages cannot appear on the chassis"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B07","question":"Which of these choices should be observed when climbing a tower using a safety b"+"elt or harness?","answer":"B","choices":{"a":"Never lean back and rely on the belt alone to support your weight","b":"Confirm that the belt is rated for the weight of the climber and that it is with"+"in its allowable service life","c":"Ensure that all heavy tools are securely fastened to the belt D-ring","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B08","question":"What should be done by any person preparing to climb a tower that supports elect"+"rically powered devices?","answer":"B","choices":{"a":"Notify the electric company that a person will be working on the tower","b":"Make sure all circuits that supply power to the tower are locked out and tagged","c":"Unground the base of the tower","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B09","question":"Why should soldered joints not be used with the wires that connect the base of a"+" tower to a system of ground rods?","answer":"D","choices":{"a":"The resistance of solder is too high","b":"Solder flux will prevent a low conductivity connection","c":"Solder has too high a dielectric constant to provide adequate lightning protecti"+"on","d":"A soldered joint will likely be destroyed by the heat of a lightning strike"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B10","question":"Which of the following is a danger from lead-tin solder?","answer":"A","choices":{"a":"Lead can contaminate food if hands are not washed carefully after handling the s"+"older","b":"High voltages can cause lead-tin solder to disintegrate suddenly","c":"Tin in the solder can \"cold flow\" causing shorts in the circuit","d":"RF energy can convert the lead into a poisonous gas"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B11","question":"Which of the following is good practice for lightning protection grounds?","answer":"D","choices":{"a":"They must be bonded to all buried water and gas lines","b":"Bends in ground wires must be made as close as possible to a right angle","c":"Lightning grounds must be connected to all ungrounded wiring","d":"They must be bonded together with all other grounds"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B12","question":"What is the purpose of a power supply interlock?","answer":"C","choices":{"a":"To prevent unauthorized changes to the circuit that would void the manufacturer’"+"s warranty","b":"To shut down the unit if it becomes too hot","c":"To ensure that dangerous voltages are removed if the cabinet is opened","d":"To shut off the power supply if too much voltage is produced"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B13","question":"What must you do when powering your house from an emergency generator?","answer":"A","choices":{"a":"Disconnect the incoming utility power feed","b":"Insure that the generator is not grounded","c":"Insure that all lightning grounds are disconnected","d":"All of these choices are correct"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B14","question":"Which of the following is covered by the National Electrical Code?","answer":"C","choices":{"a":"Acceptable bandwidth limits","b":"Acceptable modulation limits","c":"Electrical safety inside the ham shack","d":"RF exposure limits of the human body"},"metadata":""},{"exam":"G","section":"G0","subSection":"G0B","questionID":"G0B15","question":"Which of the following is true of an emergency generator installation?","answer":"A","choices":{"a":"The generator should be located in a well-ventilated area","b":"The generator must be insulated from ground","c":"Fuel should be stored near the generator for rapid refueling in case of an emerg"+"ency","d":"All of these choices are correct"},"metadata":""}]});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({"sections":[{"subElement":"T1","subElementDescription":"FCC Rules, descriptions and definitions for the Amateur Radio Service, operator "+"and station license responsibilities - [6 Exam Questions - 6 Groups]","stats":["6 Exam Questions "," 6 Groups"],"numQuestions":"6","numGroups":"6"},{"subElement":"T2","subElementDescription":"Operating Procedures [3 Exam Questions - 3 Groups]","stats":["3 Exam Questions "," 3 Groups"],"numQuestions":"3","numGroups":"3"},{"subElement":"T3","subElementDescription":"Radio wave characteristics: properties of radio waves; propagation modes � [3 Ex"+"am Questions - 3 Groups]","stats":["3 Exam Questions "," 3 Groups"],"numQuestions":"3","numGroups":"3"},{"subElement":"T4","subElementDescription":"Amateur radio practices and station set up � [2 Exam Questions - 2 Groups]","stats":["2 Exam Questions "," 2 Groups"],"numQuestions":"2","numGroups":"2"},{"subElement":"T5","subElementDescription":"Electrical principles: math for electronics; electronic principles; Ohm�s Law � "+"[4 Exam Questions - 4 Groups]","stats":["4 Exam Questions "," 4 Groups"],"numQuestions":"4","numGroups":"4"},{"subElement":"T6","subElementDescription":"Electrical components: semiconductors; circuit diagrams; component functions � ["+"4 Exam Questions - 4 Groups]","stats":["4 Exam Questions "," 4 Groups"],"numQuestions":"4","numGroups":"4"},{"subElement":"T7","subElementDescription":"Station equipment: common transmitter and receiver problems; antenna measurement"+"s; troubleshooting; basic repair and testing � [4 Exam Questions - 4 Groups]","stats":["4 Exam Questions "," 4 Groups"],"numQuestions":"4","numGroups":"4"},{"subElement":"T8","subElementDescription":"Modulation modes: amateur satellite operation; operating activities; non-voice c"+"ommunications � [4 Exam Questions - 4 Groups]","stats":["4 Exam Questions "," 4 Groups"],"numQuestions":"4","numGroups":"4"},{"subElement":"T9","subElementDescription":"Antennas and feed lines - [2 Exam Questions - 2 Groups]","stats":["2 Exam Questions "," 2 Groups"],"numQuestions":"2","numGroups":"2"},{"subElement":"T0","subElementDescription":"Electrical safety: AC and DC power circuits; antenna installation; RF hazards � "+"[3 Exam Questions - 3 Groups]","stats":["3 Exam Questions "," 3 Groups"],"numQuestions":"3","numGroups":"3"}],"categories":[{"category":"T1A","categoryDescription":"Amateur Radio Service: purpose and permissible use of the Amateur Radio Service;"+" operator/primary station license grant; where FCC rules are codified; basis and"+" purpose of FCC rules; meanings of basic terms used in FCC rules; interference; "+"spectrum management"},{"category":"T1B","categoryDescription":"Authorized frequencies: frequency allocations; ITU regions; emission modes; rest"+"ricted sub-bands; spectrum sharing; transmissions near band edges "},{"category":"T1C","categoryDescription":"Operator licensing: operator classes; sequential, special event, and vanity call"+" sign systems; international communications; reciprocal operation; station licen"+"se and licensee; places where the amateur service is regulated by the FCC; name "+"and address on FCC license database; license term; renewal; grace period"},{"category":"T1D","categoryDescription":"Authorized and prohibited transmission: communications with other countries; mus"+"ic; exchange of information with other services; indecent language; compensation"+" for use of station; retransmission of other amateur signals; codes and ciphers;"+" sale of equipment; unidentified transmissions; broadcasting "},{"category":"T1E","categoryDescription":"Control operator and control types: control operator required; eligibility; desi"+"gnation of control operator; privileges and duties; control point; local, automa"+"tic and remote control; location of control operator "},{"category":"T1F","categoryDescription":"Station identification; repeaters; third party communications; club stations; FC"+"C inspection "},{"category":"T2A","categoryDescription":"Station operation: choosing an operating frequency; calling another station; tes"+"t transmissions; procedural signs; use of minimum power; choosing an operating f"+"requency; band plans; calling frequencies; repeater offsets "},{"category":"T2B","categoryDescription":"VHF/UHF operating practices: SSB phone; FM repeater; simplex; splits and shifts;"+" CTCSS; DTMF; tone squelch; carrier squelch; phonetics; operational problem reso"+"lution; Q signals "},{"category":"T2C","categoryDescription":"Public service: emergency and non-emergency operations; applicability of FCC rul"+"es; RACES and ARES; net and traffic procedures; emergency restrictions"},{"category":"T3A","categoryDescription":"Radio wave characteristics: how a radio signal travels; fading; multipath; wavel"+"ength vs. penetration; antenna orientation"},{"category":"T3B","categoryDescription":"Radio and electromagnetic wave properties: the electromagnetic spectrum; wavelen"+"gth vs. frequency; velocity of electromagnetic waves; calculating wavelength"},{"category":"T3C","categoryDescription":"Propagation modes: line of sight; sporadic E; meteor and auroral scatter and ref"+"lections; tropospheric ducting; F layer skip; radio horizon "},{"category":"T4A","categoryDescription":"Station setup: connecting microphones; reducing unwanted emissions; power source"+"; connecting a computer; RF grounding; connecting digital equipment; connecting "+"an SWR meter"},{"category":"T4B","categoryDescription":"Operating controls: tuning; use of filters; squelch function; AGC; repeater offs"+"et; memory channels "},{"category":"T5A","categoryDescription":"Electrical principles, units, and terms: current and voltage; conductors and ins"+"ulators; alternating and direct current"},{"category":"T5B","categoryDescription":"Math for electronics: conversion of electrical units; decibels; the metric syste"+"m "},{"category":"T5C","categoryDescription":"Electronic principles: capacitance; inductance; current flow in circuits; altern"+"ating current; definition of RF; DC power calculations; impedance"},{"category":"T5D","categoryDescription":"Ohm�s Law: formulas and usage "},{"category":"T6A","categoryDescription":"Electrical components: fixed and variable resistors; capacitors and inductors; f"+"uses; switches; batteries"},{"category":"T6B","categoryDescription":"Semiconductors: basic principles and applications of solid state devices; diodes"+" and transistors "},{"category":"T6C","categoryDescription":"Circuit diagrams; schematic symbols "},{"category":"T6D","categoryDescription":"Component functions: rectification; switches; indicators; power supply component"+"s; resonant circuit; shielding; power transformers; integrated circuits"},{"category":"T7A","categoryDescription":"Station equipment: receivers; transmitters; transceivers; modulation; transverte"+"rs; low power and weak signal operation; transmit and receive amplifiers"},{"category":"T7B","categoryDescription":"Common transmitter and receiver problems: symptoms of overload and overdrive; di"+"stortion; causes of interference; interference and consumer electronics; part 15"+" devices; over and under modulation; RF feedback; off frequency signals; fading "+"and noise; problems with digital communications interfaces "},{"category":"T7C","categoryDescription":"Antenna measurements and troubleshooting: measuring SWR; dummy loads; coaxial ca"+"bles; feed line failure modes "},{"category":"T7D","categoryDescription":"Basic repair and testing: soldering; using basic test instruments; connecting a "+"voltmeter, ammeter, or ohmmeter "},{"category":"T8A","categoryDescription":"Modulation modes: bandwidth of various signals; choice of emission type"},{"category":"T8B","categoryDescription":"Amateur satellite operation; Doppler shift, basic orbits, operating protocols; c"+"ontrol operator, transmitter power considerations; satellite tracking; digital m"+"odes "},{"category":"T8C","categoryDescription":"Operating activities: radio direction finding; radio control; contests; linking "+"over the Internet; grid locators "},{"category":"T8D","categoryDescription":"Non-voice communications: image signals; digital modes; CW; packet; PSK31; APRS;"+" error detection and correction; NTSC"},{"category":"T9A","categoryDescription":"Antennas: vertical and horizontal polarization; concept of gain; common portable"+" and mobile antennas; relationships between antenna length and frequency"},{"category":"T9B","categoryDescription":"Feed lines: types of feed lines; attenuation vs. frequency; SWR concepts; matchi"+"ng; weather protection; choosing RF connectors and feed lines "},{"category":"T0A","categoryDescription":"Power circuits and hazards: hazardous voltages; fuses and circuit breakers; grou"+"nding; lightning protection; battery safety; electrical code compliance"},{"category":"T0B","categoryDescription":"Antenna safety: tower safety; erecting an antenna support; overhead power lines;"+" installing an antenna"},{"category":"T0C","categoryDescription":"RF hazards: radiation exposure; proximity to antennas; recognized safe power lev"+"els; exposure to others; radiation types; duty cycle "}],"questions":[{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A01","question":"Which of the following is a purpose of the Amateur Radio Service as stated in th"+"e FCC rules and regulations?","answer":"C","choices":{"a":"Providing personal radio communications for as many citizens as possible","b":"Providing communications for international non-profit organizations","c":"Advancing skills in the technical and communication phases of the radio art","d":"All of these choices are correct"},"metadata":"97.1"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A02","question":"Which agency regulates and enforces the rules for the Amateur Radio Service in t"+"he United States?","answer":"C","choices":{"a":"FEMA","b":"The ITU","c":"The FCC","d":"Homeland Security"},"metadata":"97.1"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A03","question":"Which part of the FCC regulations contains the rules governing the Amateur Radio"+" Service?","answer":"D","choices":{"a":"Part 73","b":"Part 95","c":"Part 90","d":"Part 97"},"metadata":""},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A04","question":"Which of the following meets the FCC definition of harmful interference?","answer":"C","choices":{"a":"Radio transmissions that annoy users of a repeater","b":"Unwanted radio transmissions that cause costly harm to radio station apparatus","c":"That which seriously degrades, obstructs, or repeatedly interrupts a radio commu"+"nication service operating in accordance with the Radio Regulations","d":"Static from lightning storms"},"metadata":"97.3(a)(23)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A05","question":"Which of the following is a purpose of the Amateur Radio Service rules and regul"+"ations as defined by the FCC?","answer":"A","choices":{"a":"Enhancing international goodwill","b":"Providing inexpensive communication for local emergency organizations","c":"Training of operators in military radio operating procedures","d":"All of these choices are correct"},"metadata":"97.1 (e)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A06","question":"Which of the following services are protected from interference by amateur signa"+"ls under all circumstances?","answer":"D","choices":{"a":"Citizens Radio Service","b":"Broadcast Service","c":"Land Mobile Radio Service","d":"Radionavigation Service"},"metadata":"97.101 (d), 97.303 (o)(2)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A07","question":"What is the FCC Part 97 definition of telemetry?","answer":"C","choices":{"a":"An information bulletin issued by the FCC","b":"A one-way transmission to initiate, modify or terminate functions of a device at"+" a distance","c":"A one-way transmission of measurements at a distance from the measuring instrume"+"nt","d":"An information bulletin from a VEC"},"metadata":"97.3(a)(46)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A08","question":"Which of the following entities recommends transmit/receive channels and other p"+"arameters for auxiliary and repeater stations?","answer":"B","choices":{"a":"Frequency Spectrum Manager","b":"Frequency Coordinator","c":"FCC Regional Field Office","d":"International Telecommunications Union"},"metadata":"97.3(a)(22)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A09","question":"Who selects a Frequency Coordinator?","answer":"C","choices":{"a":"The FCC Office of Spectrum Management and Coordination Policy","b":"The local chapter of the Office of National Council of Independent Frequency Coo"+"rdinators","c":"Amateur operators in a local or regional area whose stations are eligible to be "+"auxiliary or repeater stations","d":"FCC Regional Field Office"},"metadata":"97.3(a)(22)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A10","question":"What is the FCC Part 97 definition of an amateur station?","answer":"A","choices":{"a":"A station in the Amateur Radio Service consisting of the apparatus necessary for"+" carrying on radio communications","b":"A building where Amateur Radio receivers, transmitters, and RF power amplifiers "+"are installed","c":"Any radio station operated by a non-professional","d":"Any radio station for hobby use"},"metadata":"97.3(a)(5)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A11","question":"When is willful interference to other amateur radio stations permitted?","answer":"B","choices":{"a":"Only if the station being interfered with is expressing extreme religious or pol"+"itical views","b":"At no time","c":"Only during a contest","d":"At any time, amateurs are not protected from willful interference"},"metadata":"97.101 (d)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A12","question":"Which of the following is a permissible use of the Amateur Radio Service? ","answer":"D","choices":{"a":"Broadcasting music and videos to friends","b":"Providing a way for amateur radio operators to earn additional income by using t"+"heir stations to pass messages","c":"Providing low-cost communications for start-up businesses","d":"Allowing a person to conduct radio experiments and to communicate with other lic"+"ensed hams around the world"},"metadata":""},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A13","question":"What is the FCC Part 97 definition of telecommand?","answer":"C","choices":{"a":"An instruction bulletin issued by the FCC","b":"A one-way radio transmission of measurements at a distance from the measuring in"+"strument","c":"A one-way transmission to initiate, modify or terminate functions of a device at"+" a distance","d":"An instruction from a VEC"},"metadata":"97.3(a)(45)"},{"exam":"T","section":"T1","subSection":"T1A","questionID":"T1A14","question":"What must you do if you are operating on the 23 cm band and learn that you are i"+"nterfering with a radiolocation station outside the United States?","answer":"A","choices":{"a":"Stop operating or take steps to eliminate the harmful interference","b":"Nothing, because this band is allocated exclusively to the amateur service","c":"Establish contact with the radiolocation station and ask them to change frequenc"+"y","d":"Change to CW mode, because this would not likely cause interference"},"metadata":"97.303(d)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B01","question":"What is the ITU?","answer":"B","choices":{"a":"An agency of the United States Department of Telecommunications Management","b":"A United Nations agency for information and communication technology issues","c":"An independent frequency coordination agency","d":"A department of the FCC"},"metadata":""},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B02","question":"Why are the frequency assignments for some U.S. Territories different from those"+" in the 50 U.S. States?","answer":"A","choices":{"a":"Some U. S. Territories are located in ITU regions other than region 2","b":"Territorial governments are allowed to select their own frequency allocations","c":"Territorial frequency allocations must also include those of adjacent countries","d":"Any territory that was in existence before the ratification of the Communication"+"s Act of 1934 is exempt from FCC frequency regulations"},"metadata":"97.301"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B03","question":"Which frequency is within the 6 meter band?","answer":"B","choices":{"a":"49.00 MHz","b":"52.525 MHz","c":"28.50 MHz","d":"222.15 MHz"},"metadata":"97.301(a)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B04","question":"Which amateur band are you using when your station is transmitting on 146.52 MHz"+"?","answer":"A","choices":{"a":"2 meter band","b":"20 meter band","c":"14 meter band","d":"6 meter band"},"metadata":"97.301(a)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B05","question":"Which 70 cm frequency is authorized to a Technician Class license holder operati"+"ng in ITU Region 2?","answer":"C","choices":{"a":"53.350 MHz","b":"146.520 MHz","c":"443.350 MHz","d":"222.520 MHz"},"metadata":"97.301(a)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B06","question":"Which 23 cm frequency is authorized to a Technician Class licensee?","answer":"B","choices":{"a":"2315 MHz","b":"1296 MHz","c":"3390 MHz","d":"146.52 MHz"},"metadata":"97.301(a)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B07","question":"What amateur band are you using if you are transmitting on 223.50 MHz?","answer":"D","choices":{"a":"15 meter band","b":"10 meter band","c":"2 meter band","d":"1.25 meter band"},"metadata":"97.301(a)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B08","question":"Which of the following is a result of the fact that the amateur service is secon"+"dary in some portions of the 70 cm band?","answer":"A","choices":{"a":"U.S. amateurs may find non-amateur stations in the bands, and must avoid interfe"+"ring with them","b":"U.S. amateurs must give foreign amateur stations priority in those portions","c":"International communications are not permitted on 70 cm","d":"Digital transmissions are not permitted on 70 cm"},"metadata":"97.303"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B09","question":"Why should you not set your transmit frequency to be exactly at the edge of an a"+"mateur band or sub-band?","answer":"D","choices":{"a":"To allow for calibration error in the transmitter frequency display","b":"So that modulation sidebands do not extend beyond the band edge","c":"To allow for transmitter frequency drift","d":"All of these choices are correct"},"metadata":"97.101(a), 97.301(a-e)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B10","question":"Which of the bands above 30 MHz that are available to Technician Class operators"+" have mode-restricted sub-bands?","answer":"C","choices":{"a":"The 6 meter, 2 meter, and 70 cm bands","b":"The 2 meter and 13 cm bands","c":"The 6 meter, 2 meter, and 1.25 meter bands","d":"The 2 meter and 70 cm bands"},"metadata":"97.301(e), 97.305(c)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B11","question":"What emission modes are permitted in the mode-restricted sub-bands at 50.0 to 50"+".1 MHz and 144.0 to 144.1 MHz?","answer":"A","choices":{"a":"CW only","b":"CW and RTTY","c":"SSB only","d":"CW and SSB"},"metadata":"97.301(a), 97.305 (a)(c)"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B12","question":"Why are frequency assignments for U.S. stations operating maritime mobile not th"+"e same everywhere in the world?","answer":"B","choices":{"a":"Amateur maritime mobile stations in international waters must conform to the fre"+"quency assignments of the country nearest to their vessel","b":"Amateur frequency assignments can vary among the three ITU regions","c":"Frequency assignments are determined by the captain of the vessel","d":"Amateur frequency assignments are different in each of the 90 ITU zones"},"metadata":"97.301"},{"exam":"T","section":"T1","subSection":"T1B","questionID":"T1B13","question":"Which emission may be used between 219 and 220 MHz?","answer":"B","choices":{"a":"Spread spectrum","b":"Data","c":"SSB voice","d":"Fast-scan television"},"metadata":"97.305(c)"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C01","question":"Which type of call sign has a single letter in both its prefix and suffix?","answer":"C","choices":{"a":"Vanity","b":"Sequential","c":"Special event","d":"In-memoriam"},"metadata":"97.3(a)(11)(iii)"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C02","question":"Which of the following is a valid US amateur radio station call sign?","answer":"B","choices":{"a":"KMA3505","b":"W3ABC","c":"KDKA","d":"11Q1176"},"metadata":""},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C03","question":"What types of international communications are permitted by an FCC-licensed amat"+"eur station?","answer":"A","choices":{"a":"Communications incidental to the purposes of the amateur service and remarks of "+"a personal character","b":"Communications incidental to conducting business or remarks of a personal nature","c":"Only communications incidental to contest exchanges, all other communications ar"+"e prohibited","d":"Any communications that would be permitted by an international broadcast station"},"metadata":"97.117"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C04","question":"When are you allowed to operate your amateur station in a foreign country?","answer":"A","choices":{"a":"When the foreign country authorizes it","b":"When there is a mutual agreement allowing third party communications","c":"When authorization permits amateur communications in a foreign language","d":"When you are communicating with non-licensed individuals in another country"},"metadata":"97.107"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C05","question":"Which of the following is a vanity call sign which a technician class amateur op"+"erator might select if available?","answer":"A","choices":{"a":"K1XXX","b":"KA1X","c":"W1XX","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C06","question":"From which of the following locations may an FCC-licensed amateur station transm"+"it, in addition to places where the FCC regulates communications?","answer":"D","choices":{"a":"From within any country that belongs to the International Telecommunications Uni"+"on","b":"From within any country that is a member of the United Nations","c":"From anywhere within in ITU Regions 2 and 3","d":"From any vessel or craft located in international waters and documented or regis"+"tered in the United States"},"metadata":"97.5(a)(2)"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C07","question":"What may result when correspondence from the FCC is returned as undeliverable be"+"cause the grantee failed to provide the correct mailing address?","answer":"B","choices":{"a":"Fine or imprisonment","b":"Revocation of the station license or suspension of the operator license","c":"Require the licensee to be re-examined","d":"A reduction of one rank in operator class"},"metadata":"97.23"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C08","question":"What is the normal term for an FCC-issued primary station/operator amateur radio"+" license grant?","answer":"C","choices":{"a":"Five years","b":"Life","c":"Ten years","d":"Twenty years"},"metadata":"97.25"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C09","question":"What is the grace period following the expiration of an amateur license within w"+"hich the license may be renewed?","answer":"A","choices":{"a":"Two years","b":"Three years","c":"Five years","d":"Ten years"},"metadata":"97.21(a)(b)"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C10","question":"How soon after passing the examination for your first amateur radio license may "+"you operate a transmitter on an amateur service frequency? ","answer":"C","choices":{"a":"Immediately","b":"30 days after the test date","c":"As soon as your operator/station license grant appears in the FCC�s license data"+"base","d":"You must wait until you receive your license in the mail from the FCC"},"metadata":"97.5a"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C11","question":"If your license has expired and is still within the allowable grace period, may "+"you continue to operate a transmitter on amateur service frequencies?","answer":"A","choices":{"a":"No, transmitting is not allowed until the FCC license database shows that the li"+"cense has been renewed","b":"Yes, but only if you identify using the suffix GP","c":"Yes, but only during authorized nets","d":"Yes, for up to two years"},"metadata":"97.21(b)"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C12","question":"Who may select a desired call sign under the vanity call sign rules?","answer":"D","choices":{"a":"Only licensed amateurs with general or extra class licenses","b":"Only licensed amateurs with an extra class license","c":"Only an amateur licensee who has been licensed continuously for more than 10 yea"+"rs","d":"Any licensed amateur"},"metadata":"97.19"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C13","question":"For which licenses classes are new licenses currently available from the FCC?","answer":"D","choices":{"a":"Novice, Technician, General, Advanced","b":"Technician, Technician Plus, General, Advanced","c":"Novice, Technician Plus, General, Advanced","d":"Technician, General, Amateur Extra"},"metadata":"97.9(a), 97.17(a)"},{"exam":"T","section":"T1","subSection":"T1C","questionID":"T1C14","question":"Who may select a vanity call sign for a club station?","answer":"D","choices":{"a":"Any Extra Class member of the club","b":"Any member of the club","c":"Any officer of the club","d":"Only the person named as trustee on the club station license grant"},"metadata":"97.21(a) (1)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D01","question":"With which countries are FCC-licensed amateur stations prohibited from exchangin"+"g communications?","answer":"A","choices":{"a":"Any country whose administration has notified the ITU that it objects to such co"+"mmunications","b":"Any country whose administration has notified the ARRL that it objects to such c"+"ommunications","c":"Any country engaged in hostilities with another country","d":"Any country in violation of the War Powers Act of 1934"},"metadata":"97.111(a)(1)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D02","question":"On which of the following occasions may an FCC-licensed amateur station exchange"+" messages with a U.S. military station?","answer":"A","choices":{"a":"During an Armed Forces Day Communications Test","b":"During a Memorial Day Celebration","c":"During an Independence Day celebration","d":"During a propagation test"},"metadata":"97.111(a)(5)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D03","question":"When is the transmission of codes or ciphers that hide the meaning of a message "+"allowed by an amateur station?","answer":"C","choices":{"a":"Only during contests","b":"Only when operating mobile","c":"Only when transmitting control commands to space stations or radio control craft","d":"Only when frequencies above 1280 MHz are used"},"metadata":"97.211(b), 97.215(b)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D04","question":"What is the only time an amateur station is authorized to transmit music?","answer":"A","choices":{"a":"When incidental to an authorized retransmission of manned spacecraft communicati"+"ons","b":"When the music produces no spurious emissions","c":"When the purpose is to interfere with an illegal transmission","d":"When the music is transmitted above 1280 MHz"},"metadata":"97.113(a)(4), 97.113(c)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D05","question":"When may amateur radio operators use their stations to notify other amateurs of "+"the availability of equipment for sale or trade?","answer":"A","choices":{"a":"When the equipment is normally used in an amateur station and such activity is n"+"ot conducted on a regular basis","b":"When the asking price is $100.00 or less","c":"When the asking price is less than its appraised value","d":"When the equipment is not the personal property of either the station licensee o"+"r the control operator or their close relatives"},"metadata":"97.113(a)(3)(ii)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D06","question":"What, if any, are the restrictions concerning transmission of language that may "+"be considered indecent or obscene?","answer":"B","choices":{"a":"The FCC maintains a list of words that are not permitted to be used on amateur f"+"requencies","b":"Any such language is prohibited","c":"The ITU maintains a list of words that are not permitted to be used on amateur f"+"requencies","d":"There is no such prohibition"},"metadata":"97.113(a)(4)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D07","question":"What types of amateur stations can automatically retransmit the signals of other"+" amateur stations?","answer":"B","choices":{"a":"Auxiliary, beacon, or Earth stations","b":"Auxiliary, repeater, or space stations","c":"Beacon, repeater, or space stations","d":"Earth, repeater, or space stations"},"metadata":"97.113(d)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D08","question":"In which of the following circumstances may the control operator of an amateur s"+"tation receive compensation for operating the station? ","answer":"B","choices":{"a":"When engaging in communications on behalf of their employer","b":"When the communication is incidental to classroom instruction at an educational "+"institution","c":"When re-broadcasting weather alerts during a RACES net","d":"When notifying other amateur operators of the availability for sale or trade of "+"apparatus"},"metadata":"97.113(a)(3)(iii)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D09","question":"Under which of the following circumstances are amateur stations authorized to tr"+"ansmit signals related to broadcasting, program production, or news gathering, a"+"ssuming no other means is available?","answer":"A","choices":{"a":"Only where such communications directly relate to the immediate safety of human "+"life or protection of property","b":"Only when broadcasting communications to or from the space shuttle","c":"Only where noncommercial programming is gathered and supplied exclusively to the"+" National Public Radio network","d":"Only when using amateur repeaters linked to the Internet"},"metadata":"97.113(5)(b)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D10","question":"What is the meaning of the term �broadcasting� in the FCC rules for the amateur "+"services?","answer":"D","choices":{"a":"Two-way transmissions by amateur stations","b":"Transmission of music","c":"Transmission of messages directed only to amateur operators","d":"Transmissions intended for reception by the general public"},"metadata":"97.3(a)(10)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D11","question":"When may an amateur station transmit without identifying?","answer":"D","choices":{"a":"When the transmissions are of a brief nature to make station adjustments","b":"When the transmissions are unmodulated","c":"When the transmitted power level is below 1 watt","d":"When transmitting signals to control a model craft"},"metadata":"97.119(a)"},{"exam":"T","section":"T1","subSection":"T1D","questionID":"T1D12","question":"Under which of the following circumstances may an amateur radio station engage i"+"n broadcasting?","answer":"B","choices":{"a":"Under no circumstances","b":"When transmitting code practice, information bulletins, or transmissions necessa"+"ry to provide emergency communications","c":"At any time as long as no music is transmitted","d":"At any time as long as the material being transmitted did not originate from a c"+"ommercial broadcast station"},"metadata":"97.111(b)(4,5,6"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E01","question":"When is an amateur station permitted to transmit without a control operator?","answer":"D","choices":{"a":"When using automatic control, such as in the case of a repeater","b":"When the station licensee is away and another licensed amateur is using the stat"+"ion","c":"When the transmitting station is an auxiliary station","d":"Never"},"metadata":"97.7(a)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E02","question":"Who may a station licensee designate to be the control operator of an amateur st"+"ation?","answer":"D","choices":{"a":"Any U.S. citizen or registered alien","b":"Any family member of the station licensee","c":"Any person over the age of 18","d":"Only a person for whom an amateur operator/primary station license grant appears"+" in the FCC database or who is authorized for alien reciprocal operation"},"metadata":"97.7(a)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E03","question":"Who must designate the station control operator?","answer":"A","choices":{"a":"The station licensee","b":"The FCC","c":"The frequency coordinator","d":"The ITU"},"metadata":"97.103(b)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E04","question":"What determines the transmitting privileges of an amateur station?","answer":"D","choices":{"a":"The frequency authorized by the frequency coordinator","b":"The class of operator license held by the station licensee","c":"The highest class of operator license held by anyone on the premises","d":"The class of operator license held by the control operator"},"metadata":"97.103(b)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E05","question":"What is an amateur station control point?","answer":"C","choices":{"a":"The location of the station�s transmitting antenna","b":"The location of the station transmitting apparatus","c":"The location at which the control operator function is performed","d":"The mailing address of the station licensee"},"metadata":"97.3(a)(14)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E06","question":"Under what type of control do APRS network digipeaters operate?","answer":"A","choices":{"a":"Automatic","b":"Remote","c":"Local","d":"Manual"},"metadata":"97.109(d)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E07","question":"When the control operator is not the station licensee, who is responsible for th"+"e proper operation of the station?","answer":"D","choices":{"a":"All licensed amateurs who are present at the operation","b":"Only the station licensee","c":"Only the control operator","d":"The control operator and the station licensee are equally responsible"},"metadata":"97.103(a)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E08","question":"Which of the following is an example of automatic control?","answer":"A","choices":{"a":"Repeater operation","b":"Controlling the station over the Internet","c":"Using a computer or other device to automatically send CW","d":"Using a computer or other device to automatically identify"},"metadata":"97.3(a)(6), 97.205(d)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E09","question":"What type of control is being used when the control operator is at the control p"+"oint?","answer":"D","choices":{"a":"Radio control","b":"Unattended control","c":"Automatic control","d":"Local control"},"metadata":"97.109(b)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E10","question":"Which of the following is an example of remote control as defined in Part 97?","answer":"B","choices":{"a":"Repeater operation","b":"Operating the station over the Internet","c":"Controlling a model aircraft, boat or car by amateur radio","d":"All of these choices are correct"},"metadata":"97.3(a)(39)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E11","question":"Who does the FCC presume to be the control operator of an amateur station, unles"+"s documentation to the contrary is in the station records?","answer":"D","choices":{"a":"The station custodian","b":"The third party participant","c":"The person operating the station equipment","d":"The station licensee"},"metadata":"97.103(a)"},{"exam":"T","section":"T1","subSection":"T1E","questionID":"T1E12","question":"When, under normal circumstances, may a Technician Class licensee be the control"+" operator of a station operating in an exclusive Extra Class operator segment of"+" the amateur bands?","answer":"A","choices":{"a":"At no time","b":"When operating a special event station","c":"As part of a multi-operator contest team","d":"When using a club station whose trustee is an Extra Class operator licensee"},"metadata":"97.119(e)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F01","question":"What type of identification is being used when identifying a station on the air "+"as Race Headquarters?","answer":"A","choices":{"a":"Tactical call sign","b":"An official call sign reserved for RACES drills","c":"SSID","d":"Broadcast station"},"metadata":""},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F02","question":"When using tactical identifiers such as �Race Headquarters� during a community s"+"ervice net operation, how often must your station transmit the station�s FCC-ass"+"igned call sign? ","answer":"C","choices":{"a":"Never, the tactical call is sufficient","b":"Once during every hour","c":"At the end of each communication and every ten minutes during a communication","d":"At the end of every transmission"},"metadata":"97.119 (a)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F03","question":"When is an amateur station required to transmit its assigned call sign?","answer":"D","choices":{"a":"At the beginning of each contact, and every 10 minutes thereafter","b":"At least once during each transmission","c":"At least every 15 minutes during and at the end of a communication","d":"At least every 10 minutes during and at the end of a communication"},"metadata":"97.119(a)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F04","question":"Which of the following is an acceptable language to use for station identificati"+"on when operating in a phone sub-band?","answer":"C","choices":{"a":"Any language recognized by the United Nations","b":"Any language recognized by the ITU","c":"The English language","d":"English, French, or Spanish"},"metadata":"97.119(b)(2)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F05","question":"What method of call sign identification is required for a station transmitting p"+"hone signals?","answer":"B","choices":{"a":"Send the call sign followed by the indicator RPT","b":"Send the call sign using CW or phone emission","c":"Send the call sign followed by the indicator R","d":"Send the call sign using only phone emission"},"metadata":"97.119(b)(2)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F06","question":"Which of the following formats of a self-assigned indicator is acceptable when i"+"dentifying using a phone transmission?","answer":"D","choices":{"a":"KL7CC stroke W3","b":"KL7CC slant W3","c":"KL7CC slash W3","d":"All of these choices are correct"},"metadata":"97.119(c)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F07","question":"Which of the following restrictions apply when a non-licensed person is allowed "+"to speak to a foreign station using a station under the control of a Technician "+"Class control operator?","answer":"B","choices":{"a":"The person must be a U.S. citizen","b":"The foreign station must be one with which the U.S. has a third party agreement","c":"The licensed control operator must do the station identification","d":"All of these choices are correct"},"metadata":"97.115(a)(2)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F08","question":"Which indicator is required by the FCC to be transmitted after a station call si"+"gn?","answer":"D","choices":{"a":"/M when operating mobile","b":"/R when operating a repeater","c":"/ followed the FCC Region number when operating out of the region in which the l"+"icense was issued","d":"/KT, /AE or /AG when using new license privileges earned by CSCE while waiting f"+"or an upgrade to a previously issued license to appear in the FCC license databa"+"se"},"metadata":"97.119(f)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F09","question":"What type of amateur station simultaneously retransmits the signal of another am"+"ateur station on a different channel or channels?","answer":"C","choices":{"a":"Beacon station","b":"Earth station","c":"Repeater station","d":"Message forwarding station"},"metadata":"97.3(a)(40)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F10","question":"Who is accountable should a repeater inadvertently retransmit communications tha"+"t violate the FCC rules?","answer":"A","choices":{"a":"The control operator of the originating station","b":"The control operator of the repeater","c":"The owner of the repeater","d":"Both the originating station and the repeater owner"},"metadata":"97.205(g)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F11","question":"To which foreign stations do the FCC rules authorize the transmission of non-eme"+"rgency third party communications?","answer":"A","choices":{"a":"Any station whose government permits such communications","b":"Those in ITU Region 2 only","c":"Those in ITU Regions 2 and 3 only","d":"Those in ITU Region 3 only"},"metadata":"97.115(a)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F12","question":"How many persons are required to be members of a club for a club station license"+" to be issued by the FCC?","answer":"B","choices":{"a":"At least 5","b":"At least 4","c":"A trustee and 2 officers","d":"At least 2"},"metadata":"97.5(b)(2)"},{"exam":"T","section":"T1","subSection":"T1F","questionID":"T1F13","question":"When must the station licensee make the station and its records available for FC"+"C inspection?","answer":"B","choices":{"a":"At any time ten days after notification by the FCC of such an inspection","b":"At any time upon request by an FCC representative","c":"Only after failing to comply with an FCC notice of violation","d":"Only when presented with a valid warrant by an FCC official or government agent"},"metadata":"97.103(c)"},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A01","question":"What is the most common repeater frequency offset in the 2 meter band?","answer":"B","choices":{"a":"Plus 500 kHz","b":"Plus or minus 600 kHz","c":"Minus 500 kHz","d":"Only plus 600 kHz"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A02","question":"What is the national calling frequency for FM simplex operations in the 70 cm ba"+"nd?","answer":"D","choices":{"a":"146.520 MHz","b":"145.000 MHz","c":"432.100 MHz","d":"446.000 MHz"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A03","question":"What is a common repeater frequency offset in the 70 cm band?","answer":"A","choices":{"a":"Plus or minus 5 MHz","b":"Plus or minus 600 kHz","c":"Minus 600 kHz","d":"Plus 600 kHz"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A04","question":"What is an appropriate way to call another station on a repeater if you know the"+" other station's call sign?","answer":"B","choices":{"a":"Say break, break then say the station's call sign","b":"Say the station's call sign then identify with your call sign","c":"Say CQ three times then the other station's call sign","d":"Wait for the station to call CQ then answer it"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A05","question":"How should you respond to a station calling CQ?","answer":"C","choices":{"a":"Transmit CQ followed by the other station�s call sign","b":"Transmit your call sign followed by the other station�s call sign","c":"Transmit the other station�s call sign followed by your call sign","d":"Transmit a signal report followed by your call sign"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A06","question":"What must an amateur operator do when making on-air transmissions to test equipm"+"ent or antennas?","answer":"A","choices":{"a":"Properly identify the transmitting station","b":"Make test transmissions only after 10:00 p.m. local time","c":"Notify the FCC of the test transmission","d":"State the purpose of the test during the test procedure"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A07","question":"Which of the following is true when making a test transmission?","answer":"D","choices":{"a":"Station identification is not required if the transmission is less than 15 secon"+"ds","b":"Station identification is not required if the transmission is less than 1 watt","c":"Station identification is only required once an hour when the transmissions are "+"for test purposes only","d":"Station identification is required at least every ten minutes during the test an"+"d at the end of the test"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A08","question":"What is the meaning of the procedural signal �CQ�?","answer":"D","choices":{"a":"Call on the quarter hour","b":"A new antenna is being tested (no station should answer)","c":"Only the called station should transmit","d":"Calling any station"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A09","question":"What brief statement is often transmitted in place of �CQ� to indicate that you "+"are listening on a repeater?","answer":"B","choices":{"a":"The words �Hello test� followed by your call sign","b":"Your call sign","c":"The repeater call sign followed by your call sign","d":"The letters �QSY� followed by your call sign"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A10","question":"What is a band plan, beyond the privileges established by the FCC?","answer":"A","choices":{"a":"A voluntary guideline for using different modes or activities within an amateur "+"band","b":"A mandated list of operating schedules","c":"A list of scheduled net frequencies","d":"A plan devised by a club to indicate frequency band usage"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A11","question":"Which of the following is an FCC rule regarding power levels used in the amateur"+" bands, under normal, non-distress circumstances?","answer":"D","choices":{"a":"There is no limit to power as long as there is no interference with other servic"+"es","b":"No more than 200 watts PEP may be used","c":"Up to 1500 watts PEP may be used on any amateur frequency without restriction","d":"While not exceeding the maximum power permitted on a given band, use the minimum"+" power necessary to carry out the desired communication"},"metadata":"97.313(a)"},{"exam":"T","section":"T2","subSection":"T2A","questionID":"T2A12","question":"Which of the following is a guideline to use when choosing an operating frequenc"+"y for calling CQ?","answer":"D","choices":{"a":"Listen first to be sure that no one else is using the frequency","b":"Ask if the frequency is in use","c":"Make sure you are in your assigned band","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B01","question":"What is the term used to describe an amateur station that is transmitting and re"+"ceiving on the same frequency?","answer":"C","choices":{"a":"Full duplex communication","b":"Diplex communication","c":"Simplex communication","d":"Multiplex communication"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B02","question":"What is the term used to describe the use of a sub-audible tone transmitted with"+" normal voice audio to open the squelch of a receiver?","answer":"D","choices":{"a":"Carrier squelch","b":"Tone burst","c":"DTMF","d":"CTCSS"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B03","question":"Which of the following describes the muting of receiver audio controlled solely "+"by the presence or absence of an RF signal?","answer":"B","choices":{"a":"Tone squelch","b":"Carrier squelch","c":"CTCSS","d":"Modulated carrier"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B04","question":"Which of the following common problems might cause you to be able to hear but no"+"t access a repeater even when transmitting with the proper offset?","answer":"D","choices":{"a":"The repeater receiver may require an audio tone burst for access","b":"The repeater receiver may require a CTCSS tone for access","c":"The repeater receiver may require a DCS tone sequence for access","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B05","question":"What determines the amount of deviation of an FM (as opposed to PM) signal?","answer":"C","choices":{"a":"Both the frequency and amplitude of the modulating signal","b":"The frequency of the modulating signal","c":"The amplitude of the modulating signal","d":"The relative phase of the modulating signal and the carrier"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B06","question":"What happens when the deviation of an FM transmitter is increased?","answer":"A","choices":{"a":"Its signal occupies more bandwidth","b":"Its output power increases","c":"Its output power and bandwidth increases","d":"Asymmetric modulation occurs"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B07","question":"What could cause your FM signal to interfere with stations on nearby frequencies"+"?","answer":"A","choices":{"a":"Microphone gain too high, causing over-deviation","b":"SWR too high","c":"Incorrect CTCSS Tone","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B08","question":"Which of the following applies when two stations transmitting on the same freque"+"ncy interfere with each other?","answer":"A","choices":{"a":"Common courtesy should prevail, but no one has absolute right to an amateur freq"+"uency","b":"Whoever has the strongest signal has priority on the frequency","c":"Whoever has been on the frequency the longest has priority on the frequency","d":"The station which has the weakest signal has priority on the frequency"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B09","question":"Which of the following methods is encouraged by the FCC when identifying your st"+"ation when using phone?","answer":"A","choices":{"a":"Use of a phonetic alphabet","b":"Send your call sign in CW as well as voice","c":"Repeat your call sign three times","d":"Increase your signal to full power when identifying"},"metadata":"97.119(b)(2)"},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B10","question":"Which Q signal indicates that you are receiving interference from other stations"+"?","answer":"A","choices":{"a":"QRM","b":"QRN","c":"QTH","d":"QSB"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B11","question":"Which Q signal indicates that you are changing frequency?","answer":"B","choices":{"a":"QRU","b":"QSY","c":"QSL","d":"QRZ"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B12","question":"Under what circumstances should you consider communicating via simplex rather th"+"an a repeater?","answer":"A","choices":{"a":"When the stations can communicate directly without using a repeater","b":"Only when you have an endorsement for simplex operation on your license","c":"Only when third party traffic is not being passed","d":"Only if you have simplex modulation capability"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2B","questionID":"T2B13","question":"Which of the following is true of the use of SSB phone in amateur bands above 50"+" MHz?","answer":"C","choices":{"a":"It is permitted only by holders of a General Class or higher license","b":"It is permitted only on repeaters","c":"It is permitted in at least some portion of all the amateur bands above 50 MHz","d":"It is permitted only on when power is limited to no more than 100 watts"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C01","question":"When do the FCC rules NOT apply to the operation of an amateur station?","answer":"D","choices":{"a":"When operating a RACES station","b":"When operating under special FEMA rules","c":"When operating under special ARES rules","d":"Never, FCC rules always apply"},"metadata":"97.103(a)"},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C02","question":"What is one way to recharge a 12-volt lead-acid station battery if the commercia"+"l power is out?","answer":"C","choices":{"a":"Cool the battery in ice for several hours","b":"Add acid to the battery","c":"Connect the battery in parallel with a vehicle�s battery and run the engine","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C03","question":"What should be done to insure that voice message traffic containing proper names"+" and unusual words are copied correctly by the receiving station?","answer":"C","choices":{"a":"The entire message should be repeated at least four times","b":"Such messages must be limited to no more than 10 words","c":"Such words and terms should be spelled out using a standard phonetic alphabet","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C04","question":"What do RACES and ARES have in common?","answer":"D","choices":{"a":"They represent the two largest ham clubs in the United States","b":"Both organizations broadcast road and weather information","c":"Neither may handle emergency traffic supporting public service agencies","d":"Both organizations may provide communications during emergencies"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C05","question":"Which of the following describes the Radio Amateur Civil Emergency Service (RACE"+"S)? ","answer":"D","choices":{"a":"A radio service using amateur frequencies for emergency management or civil defe"+"nse communications","b":"A radio service using amateur stations for emergency management or civil defense"+" communications","c":"An emergency service using amateur operators certified by a civil defense organi"+"zation as being enrolled in that organization","d":"All of these choices are correct"},"metadata":"97.3(a)(38), 97.407"},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C06","question":"Which of the following is an accepted practice to get the immediate attention of"+" a net control station when reporting an emergency?","answer":"C","choices":{"a":"Repeat the words SOS three times followed by the call sign of the reporting stat"+"ion","b":"Press the push-to-talk button three times","c":"Begin your transmission by saying \"Priority\" or \"Emergency\" followed by your"+" call sign","d":"Play a pre-recorded emergency alert tone followed by your call sign"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C07","question":"Which of the following is an accepted practice for an amateur operator who has c"+"hecked into an emergency traffic net?","answer":"C","choices":{"a":"Provided that the frequency is quiet, announce the station call sign and locatio"+"n every 5 minutes","b":"Move 5 kHz away from the net's frequency and use high power to ask other hams to"+" keep clear of the net frequency","c":"Remain on frequency without transmitting until asked to do so by the net control"+" station","d":"All of the choices are correct"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C08","question":"Which of the following is a characteristic of good emergency traffic handling? ","answer":"A","choices":{"a":"Passing messages exactly as received","b":"Making decisions as to whether or not messages should be relayed or delivered","c":"Communicating messages to the news media for broadcast outside the disaster area","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C09","question":"Are amateur station control operators ever permitted to operate outside the freq"+"uency privileges of their license class?","answer":"D","choices":{"a":"No","b":"Yes, but only when part of a FEMA emergency plan","c":"Yes, but only when part of a RACES emergency plan","d":"Yes, but only if necessary in situations involving the immediate safety of human"+" life or protection of property"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C10","question":"What is the preamble in a formal traffic message?","answer":"D","choices":{"a":"The first paragraph of the message text","b":"The message number","c":"The priority handling indicator for the message","d":"The information needed to track the message as it passes through the amateur rad"+"io traffic handling system"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C11","question":"What is meant by the term �check� in reference to a formal traffic message?","answer":"A","choices":{"a":"The check is a count of the number of words or word equivalents in the text port"+"ion of the message","b":"The check is the value of a money order attached to the message","c":"The check is a list of stations that have relayed the message","d":"The check is a box on the message form that tells you the message was received"},"metadata":""},{"exam":"T","section":"T2","subSection":"T2C","questionID":"T2C12","question":"What is the Amateur Radio Emergency Service (ARES)?","answer":"A","choices":{"a":"Licensed amateurs who have voluntarily registered their qualifications and equip"+"ment for communications duty in the public service","b":"Licensed amateurs who are members of the military and who voluntarily agreed to "+"provide message handling services in the case of an emergency","c":"A training program that provides licensing courses for those interested in obtai"+"ning an amateur license to use during emergencies","d":"A training program that certifies amateur operators for membership in the Radio "+"Amateur Civil Emergency Service"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A01","question":"What should you do if another operator reports that your station�s 2 meter signa"+"ls were strong just a moment ago, but now they are weak or distorted?","answer":"D","choices":{"a":"Change the batteries in your radio to a different type","b":"Turn on the CTCSS tone","c":"Ask the other operator to adjust his squelch control","d":"Try moving a few feet or changing the direction of your antenna if possible, as "+"reflections may be causing multi-path distortion"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A02","question":"Why are UHF signals often more effective from inside buildings than VHF signals?","answer":"B","choices":{"a":"VHF signals lose power faster over distance","b":"The shorter wavelength allows them to more easily penetrate the structure of bui"+"ldings","c":"This is incorrect; VHF works better than UHF inside buildings","d":"UHF antennas are more efficient than VHF antennas"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A03","question":"What antenna polarization is normally used for long-distance weak-signal CW and "+"SSB contacts using the VHF and UHF bands?","answer":"C","choices":{"a":"Right-hand circular","b":"Left-hand circular","c":"Horizontal","d":"Vertical"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A04","question":"What can happen if the antennas at opposite ends of a VHF or UHF line of sight r"+"adio link are not using the same polarization?","answer":"B","choices":{"a":"The modulation sidebands might become inverted","b":"Signals could be significantly weaker","c":"Signals have an echo effect on voices","d":"Nothing significant will happen"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A05","question":"When using a directional antenna, how might your station be able to access a dis"+"tant repeater if buildings or obstructions are blocking the direct line of sight"+" path?","answer":"B","choices":{"a":"Change from vertical to horizontal polarization","b":"Try to find a path that reflects signals to the repeater","c":"Try the long path","d":"Increase the antenna SWR"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A06","question":"What term is commonly used to describe the rapid fluttering sound sometimes hear"+"d from mobile stations that are moving while transmitting?","answer":"B","choices":{"a":"Flip-flopping","b":"Picket fencing","c":"Frequency shifting","d":"Pulsing"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A07","question":"What type of wave carries radio signals between transmitting and receiving stati"+"ons?","answer":"A","choices":{"a":"Electromagnetic","b":"Electrostatic","c":"Surface acoustic","d":"Magnetostrictive"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A08","question":"Which of the following is a likely cause of irregular fading of signals received"+" by ionospheric reflection?","answer":"C","choices":{"a":"Frequency shift due to Faraday rotation","b":"Interference from thunderstorms","c":"Random combining of signals arriving via different paths","d":"Intermodulation distortion"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A09","question":"Which of the following results from the fact that skip signals refracted from th"+"e ionosphere are elliptically polarized?","answer":"B","choices":{"a":"Digital modes are unusable","b":"Either vertically or horizontally polarized antennas may be used for transmissio"+"n or reception","c":"FM voice is unusable","d":"Both the transmitting and receiving antennas must be of the same polarization"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A10","question":"What may occur if data signals propagate over multiple paths?","answer":"D","choices":{"a":"Transmission rates can be increased by a factor equal to the number of separate "+"paths observed","b":"Transmission rates must be decreased by a factor equal to the number of separate"+" paths observed","c":"No significant changes will occur if the signals are transmitting using FM","d":"Error rates are likely to increase"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3A","questionID":"T3A11","question":"Which part of the atmosphere enables the propagation of radio signals around the"+" world?","answer":"C","choices":{"a":"The stratosphere","b":"The troposphere","c":"The ionosphere","d":"The magnetosphere"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B01","question":"What is the name for the distance a radio wave travels during one complete cycle"+"?","answer":"C","choices":{"a":"Wave speed","b":"Waveform","c":"Wavelength","d":"Wave spread"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B02","question":"What property of a radio wave is used to describe its polarization?","answer":"A","choices":{"a":"The orientation of the electric field","b":"The orientation of the magnetic field","c":"The ratio of the energy in the magnetic field to the energy in the electric fiel"+"d","d":"The ratio of the velocity to the wavelength"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B03","question":"What are the two components of a radio wave?","answer":"C","choices":{"a":"AC and DC","b":"Voltage and current","c":"Electric and magnetic fields","d":"Ionizing and non-ionizing radiation"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B04","question":"How fast does a radio wave travel through free space?","answer":"A","choices":{"a":"At the speed of light","b":"At the speed of sound","c":"Its speed is inversely proportional to its wavelength","d":"Its speed increases as the frequency increases"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B05","question":"How does the wavelength of a radio wave relate to its frequency?","answer":"B","choices":{"a":"The wavelength gets longer as the frequency increases","b":"The wavelength gets shorter as the frequency increases","c":"There is no relationship between wavelength and frequency","d":"The wavelength depends on the bandwidth of the signal"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B06","question":"What is the formula for converting frequency to approximate wavelength in meters"+"?","answer":"D","choices":{"a":"Wavelength in meters equals frequency in hertz multiplied by 300","b":"Wavelength in meters equals frequency in hertz divided by 300","c":"Wavelength in meters equals frequency in megahertz divided by 300","d":"Wavelength in meters equals 300 divided by frequency in megahertz"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B07","question":"What property of radio waves is often used to identify the different frequency b"+"ands?","answer":"A","choices":{"a":"The approximate wavelength","b":"The magnetic intensity of waves","c":"The time it takes for waves to travel one mile","d":"The voltage standing wave ratio of waves"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B08","question":"What are the frequency limits of the VHF spectrum?","answer":"B","choices":{"a":"30 to 300 kHz","b":"30 to 300 MHz","c":"300 to 3000 kHz","d":"300 to 3000 MHz"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B09","question":"What are the frequency limits of the UHF spectrum?","answer":"D","choices":{"a":"30 to 300 kHz","b":"30 to 300 MHz","c":"300 to 3000 kHz","d":"300 to 3000 MHz"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B10","question":"What frequency range is referred to as HF?","answer":"C","choices":{"a":"300 to 3000 MHz","b":"30 to 300 MHz","c":"3 to 30 MHz","d":"300 to 3000 kHz"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3B","questionID":"T3B11","question":"What is the approximate velocity of a radio wave as it travels through free spac"+"e?","answer":"B","choices":{"a":"3000 kilometers per second","b":"300,000,000 meters per second","c":"300,000 miles per hour","d":"186,000 miles per hour"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C01","question":"Why are direct (not via a repeater) UHF signals rarely heard from stations outsi"+"de your local coverage area?","answer":"C","choices":{"a":"They are too weak to go very far","b":"FCC regulations prohibit them from going more than 50 miles","c":"UHF signals are usually not reflected by the ionosphere","d":"They collide with trees and shrubbery and fade out"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C02","question":"Which of the following might be happening when VHF signals are being received fr"+"om long distances?","answer":"D","choices":{"a":"Signals are being reflected from outer space","b":"Signals are arriving by sub-surface ducting","c":"Signals are being reflected by lightning storms in your area","d":"Signals are being refracted from a sporadic E layer"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C03","question":"What is a characteristic of VHF signals received via auroral reflection?","answer":"B","choices":{"a":"Signals from distances of 10,000 or more miles are common","b":"The signals exhibit rapid fluctuations of strength and often sound distorted","c":"These types of signals occur only during winter nighttime hours","d":"These types of signals are generally strongest when your antenna is aimed west"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C04","question":"Which of the following propagation types is most commonly associated with occasi"+"onal strong over-the-horizon signals on the 10, 6, and 2 meter bands?","answer":"B","choices":{"a":"Backscatter","b":"Sporadic E","c":"D layer absorption","d":"Gray-line propagation"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C05","question":"Which of the following effects might cause radio signals to be heard despite obs"+"tructions between the transmitting and receiving stations?","answer":"A","choices":{"a":"Knife-edge diffraction","b":"Faraday rotation","c":"Quantum tunneling","d":"Doppler shift"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C06","question":"What mode is responsible for allowing over-the-horizon VHF and UHF communication"+"s to ranges of approximately 300 miles on a regular basis?","answer":"A","choices":{"a":"Tropospheric scatter","b":"D layer refraction","c":"F2 layer refraction","d":"Faraday rotation"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C07","question":"What band is best suited for communicating via meteor scatter?","answer":"B","choices":{"a":"10 meters","b":"6 meters","c":"2 meters","d":"70 cm"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C08","question":"What causes tropospheric ducting?","answer":"D","choices":{"a":"Discharges of lightning during electrical storms","b":"Sunspots and solar flares","c":"Updrafts from hurricanes and tornadoes","d":"Temperature inversions in the atmosphere"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C09","question":"What is generally the best time for long-distance 10 meter band propagation via "+"the F layer?","answer":"A","choices":{"a":"From dawn to shortly after sunset during periods of high sunspot activity","b":"From shortly after sunset to dawn during periods of high sunspot activity","c":"From dawn to shortly after sunset during periods of low sunspot activity","d":"From shortly after sunset to dawn during periods of low sunspot activity"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C10","question":"What is the radio horizon?","answer":"A","choices":{"a":"The distance over which two stations can communicate by direct path","b":"The distance from the ground to a horizontally mounted antenna","c":"The farthest point you can see when standing at the base of your antenna tower","d":"The shortest distance between two points on the Earth's surface"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C11","question":"Why do VHF and UHF radio signals usually travel somewhat farther than the visual"+" line of sight distance between two stations?","answer":"C","choices":{"a":"Radio signals move somewhat faster than the speed of light","b":"Radio waves are not blocked by dust particles","c":"The Earth seems less curved to radio waves than to light","d":"Radio waves are blocked by dust particles"},"metadata":""},{"exam":"T","section":"T3","subSection":"T3C","questionID":"T3C12","question":"Which of the following bands may provide long distance communications during the"+" peak of the sunspot cycle?","answer":"A","choices":{"a":"Six or ten meters","b":"23 centimeters","c":"70 centimeters or 1.25 meters","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A01","question":"Which of the following is true concerning the microphone connectors on amateur t"+"ransceivers?","answer":"B","choices":{"a":"All transceivers use the same microphone connector type","b":"Some connectors include push-to-talk and voltages for powering the microphone","c":"All transceivers using the same connector type are wired identically","d":"Un-keyed connectors allow any microphone to be connected"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A02","question":"How might a computer be used as part of an amateur radio station?","answer":"D","choices":{"a":"For logging contacts and contact information","b":"For sending and/or receiving CW","c":"For generating and decoding digital signals","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A03","question":"Which is a good reason to use a regulated power supply for communications equipm"+"ent?","answer":"A","choices":{"a":"It prevents voltage fluctuations from reaching sensitive circuits","b":"A regulated power supply has FCC approval","c":"A fuse or circuit breaker regulates the power","d":"Power consumption is independent of load"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A04","question":"Where must a filter be installed to reduce harmonic emissions from your station?","answer":"A","choices":{"a":"Between the transmitter and the antenna","b":"Between the receiver and the transmitter","c":"At the station power supply","d":"At the microphone"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A05","question":"Where should an in-line SWR meter be connected to monitor the standing wave rati"+"o of the station antenna system?","answer":"A","choices":{"a":"In series with the feed line, between the transmitter and antenna","b":"In series with the station's ground","c":"In parallel with the push-to-talk line and the antenna","d":"In series with the power supply cable, as close as possible to the radio"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A06","question":"Which of the following would be connected between a transceiver and computer in "+"a packet radio station?","answer":"C","choices":{"a":"Transmatch","b":"Mixer","c":"Terminal node controller","d":"Antenna"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A07","question":"How is a computer�s sound card used when conducting digital communications using"+" a computer?","answer":"C","choices":{"a":"The sound card communicates between the computer CPU and the video display","b":"The sound card records the audio frequency for video display","c":"The sound card provides audio to the microphone input and converts received audi"+"o to digital form","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A08","question":"Which type of conductor is best to use for RF grounding?","answer":"D","choices":{"a":"Round stranded wire","b":"Round copper-clad steel wire","c":"Twisted-pair cable","d":"Flat strap"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A09","question":"Which of the following could you use to cure distorted audio caused by RF curren"+"t flowing on the shield of a microphone cable?","answer":"D","choices":{"a":"Band-pass filter","b":"Low-pass filter","c":"Preamplifier","d":"Ferrite choke"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A10","question":"What is the source of a high-pitched whine that varies with engine speed in a mo"+"bile transceiver�s receive audio?","answer":"B","choices":{"a":"The ignition system","b":"The alternator","c":"The electric fuel pump","d":"Anti-lock braking system controllers"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A11","question":"Where should the negative return connection of a mobile transceiver's power cabl"+"e be connected?","answer":"A","choices":{"a":"At the battery or engine block ground strap","b":"At the antenna mount","c":"To any metal part of the vehicle","d":"Through the transceiver�s mounting bracket"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4A","questionID":"T4A12","question":"What could be happening if another operator reports a variable high-pitched whin"+"e on the audio from your mobile transmitter?","answer":"D","choices":{"a":"Your microphone is picking up noise from an open window","b":"You have the volume on your receiver set too high","c":"You need to adjust your squelch control","d":"Noise on the vehicle�s electrical system is being transmitted along with your sp"+"eech audio"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B01","question":"What may happen if a transmitter is operated with the microphone gain set too hi"+"gh?","answer":"B","choices":{"a":"The output power might be too high","b":"The output signal might become distorted","c":"The frequency might vary","d":"The SWR might increase"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B02","question":"Which of the following can be used to enter the operating frequency on a modern "+"transceiver?","answer":"A","choices":{"a":"The keypad or VFO knob","b":"The CTCSS or DTMF encoder","c":"The Automatic Frequency Control","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B03","question":"What is the purpose of the squelch control on a transceiver?","answer":"D","choices":{"a":"To set the highest level of volume desired","b":"To set the transmitter power level","c":"To adjust the automatic gain control","d":"To mute receiver output noise when no signal is being received"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B04","question":"What is a way to enable quick access to a favorite frequency on your transceiver"+"?","answer":"B","choices":{"a":"Enable the CTCSS tones","b":"Store the frequency in a memory channel","c":"Disable the CTCSS tones","d":"Use the scan mode to select the desired frequency"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B05","question":"Which of the following would reduce ignition interference to a receiver?","answer":"C","choices":{"a":"Change frequency slightly","b":"Decrease the squelch setting","c":"Turn on the noise blanker","d":"Use the RIT control"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B06","question":"Which of the following controls could be used if the voice pitch of a single-sid"+"eband signal seems too high or low?","answer":"D","choices":{"a":"The AGC or limiter","b":"The bandwidth selection","c":"The tone squelch","d":"The receiver RIT or clarifier"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B07","question":"What does the term �RIT� mean?","answer":"B","choices":{"a":"Receiver Input Tone","b":"Receiver Incremental Tuning","c":"Rectifier Inverter Test","d":"Remote Input Transmitter"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B08","question":"What is the advantage of having multiple receive bandwidth choices on a multimod"+"e transceiver?","answer":"B","choices":{"a":"Permits monitoring several modes at once","b":"Permits noise or interference reduction by selecting a bandwidth matching the mo"+"de","c":"Increases the number of frequencies that can be stored in memory","d":"Increases the amount of offset between receive and transmit frequencies"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B09","question":"Which of the following is an appropriate receive filter bandwidth to select in o"+"rder to minimize noise and interference for SSB reception?","answer":"C","choices":{"a":"500 Hz","b":"1000 Hz","c":"2400 Hz","d":"5000 Hz"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B10","question":"Which of the following is an appropriate receive filter bandwidth to select in o"+"rder to minimize noise and interference for CW reception?","answer":"A","choices":{"a":"500 Hz","b":"1000 Hz","c":"2400 Hz","d":"5000 Hz"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B11","question":"Which of the following describes the common meaning of the term \"repeater offse"+"t\"?","answer":"C","choices":{"a":"The distance between the repeater�s transmit and receive antennas","b":"The time delay before the repeater timer resets","c":"The difference between the repeater�s transmit and receive frequencies","d":"Matching the antenna impedance to the feed line impedance"},"metadata":""},{"exam":"T","section":"T4","subSection":"T4B","questionID":"T4B12","question":"What is the function of automatic gain control or AGC?","answer":"A","choices":{"a":"To keep received audio relatively constant","b":"To protect an antenna from lightning","c":"To eliminate RF on the station cabling","d":"An asymmetric goniometer control used for antenna matching"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A01","question":"Electrical current is measured in which of the following units?","answer":"D","choices":{"a":"Volts","b":"Watts","c":"Ohms","d":"Amperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A02","question":"Electrical power is measured in which of the following units?","answer":"B","choices":{"a":"Volts","b":"Watts","c":"Ohms","d":"Amperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A03","question":"What is the name for the flow of electrons in an electric circuit?","answer":"D","choices":{"a":"Voltage","b":"Resistance","c":"Capacitance","d":"Current"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A04","question":"What is the name for a current that flows only in one direction?","answer":"B","choices":{"a":"Alternating current","b":"Direct current","c":"Normal current","d":"Smooth current"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A05","question":"What is the electrical term for the electromotive force (EMF) that causes electr"+"on flow?","answer":"A","choices":{"a":"Voltage","b":"Ampere-hours","c":"Capacitance","d":"Inductance"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A06","question":"How much voltage does a mobile transceiver usually require?","answer":"A","choices":{"a":"About 12 volts","b":"About 30 volts","c":"About 120 volts","d":"About 240 volts"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A07","question":"Which of the following is a good electrical conductor?","answer":"C","choices":{"a":"Glass","b":"Wood","c":"Copper","d":"Rubber"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A08","question":"Which of the following is a good electrical insulator?","answer":"B","choices":{"a":"Copper","b":"Glass","c":"Aluminum","d":"Mercury"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A09","question":"What is the name for a current that reverses direction on a regular basis?","answer":"A","choices":{"a":"Alternating current","b":"Direct current","c":"Circular current","d":"Vertical current"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A10","question":"Which term describes the rate at which electrical energy is used?","answer":"C","choices":{"a":"Resistance","b":"Current","c":"Power","d":"Voltage"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A11","question":"What is the basic unit of electromotive force?","answer":"A","choices":{"a":"The volt","b":"The watt","c":"The ampere","d":"The ohm"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5A","questionID":"T5A12","question":"What term describes the number of times per second that an alternating current r"+"everses direction?","answer":"D","choices":{"a":"Pulse rate","b":"Speed","c":"Wavelength","d":"Frequency"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B01","question":"How many milliamperes is 1.5 amperes?","answer":"C","choices":{"a":"15 milliamperes","b":"150 milliamperes","c":"1,500 milliamperes","d":"15,000 milliamperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B02","question":"What is another way to specify a radio signal frequency of 1,500,000 hertz?","answer":"A","choices":{"a":"1500 kHz","b":"1500 MHz","c":"15 GHz","d":"150 kHz"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B03","question":"How many volts are equal to one kilovolt?","answer":"C","choices":{"a":"One one-thousandth of a volt","b":"One hundred volts","c":"One thousand volts","d":"One million volts"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B04","question":"How many volts are equal to one microvolt?","answer":"A","choices":{"a":"One one-millionth of a volt","b":"One million volts","c":"One thousand kilovolts","d":"One one-thousandth of a volt"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B05","question":"Which of the following is equivalent to 500 milliwatts?","answer":"B","choices":{"a":"0.02 watts","b":"0.5 watts","c":"5 watts","d":"50 watts"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B06","question":"If an ammeter calibrated in amperes is used to measure a 3000-milliampere curren"+"t, what reading would it show?","answer":"C","choices":{"a":"0.003 amperes","b":"0.3 amperes","c":"3 amperes","d":"3,000,000 amperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B07","question":"If a frequency readout calibrated in megahertz shows a reading of 3.525 MHz, wha"+"t would it show if it were calibrated in kilohertz? ","answer":"C","choices":{"a":"0.003525 kHz","b":"35.25 kHz","c":"3525 kHz","d":"3,525,000 kHz"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B08","question":"How many microfarads are 1,000,000 picofarads?","answer":"B","choices":{"a":"0.001 microfarads","b":"1 microfarad","c":"1000 microfarads","d":"1,000,000,000 microfarads"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B09","question":"What is the approximate amount of change, measured in decibels (dB), of a power "+"increase from 5 watts to 10 watts?","answer":"B","choices":{"a":"2 dB","b":"3 dB","c":"5 dB","d":"10 dB"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B10","question":"What is the approximate amount of change, measured in decibels (dB), of a power "+"decrease from 12 watts to 3 watts?","answer":"C","choices":{"a":"-1 dB","b":"-3 dB","c":"-6 dB","d":"-9 dB"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B11","question":"What is the approximate amount of change, measured in decibels (dB), of a power "+"increase from 20 watts to 200 watts?","answer":"A","choices":{"a":"10 dB","b":"12 dB","c":"18 dB","d":"28 dB"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B12","question":"Which of the following frequencies is equal to 28,400 kHz?","answer":"A","choices":{"a":"28.400 MHz","b":"2.800 MHz","c":"284.00 MHz","d":"28.400 kHz"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5B","questionID":"T5B13","question":"If a frequency readout shows a reading of 2425 MHz, what frequency is that in GH"+"z?","answer":"C","choices":{"a":"0.002425 GHZ","b":"24.25 GHz","c":"2.425 GHz","d":"2425 GHz"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C01","question":"What is the ability to store energy in an electric field called?","answer":"D","choices":{"a":"Inductance","b":"Resistance","c":"Tolerance","d":"Capacitance"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C02","question":"What is the basic unit of capacitance?","answer":"A","choices":{"a":"The farad","b":"The ohm","c":"The volt","d":"The henry"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C03","question":"What is the ability to store energy in a magnetic field called?","answer":"D","choices":{"a":"Admittance","b":"Capacitance","c":"Resistance","d":"Inductance"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C04","question":"What is the basic unit of inductance?","answer":"C","choices":{"a":"The coulomb","b":"The farad","c":"The henry","d":"The ohm"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C05","question":"What is the unit of frequency?","answer":"A","choices":{"a":"Hertz","b":"Henry","c":"Farad","d":"Tesla"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C06","question":"What does the abbreviation �RF� refer to? ","answer":"A","choices":{"a":"Radio frequency signals of all types","b":"The resonant frequency of a tuned circuit","c":"The real frequency transmitted as opposed to the apparent frequency","d":"Reflective force in antenna transmission lines"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C07","question":"What is a usual name for electromagnetic waves that travel through space?","answer":"C","choices":{"a":"Gravity waves","b":"Sound waves","c":"Radio waves","d":"Pressure waves"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C08","question":"What is the formula used to calculate electrical power in a DC circuit?","answer":"A","choices":{"a":"Power (P) equals voltage (E) multiplied by current (I)","b":"Power (P) equals voltage (E) divided by current (I)","c":"Power (P) equals voltage (E) minus current (I)","d":"Power (P) equals voltage (E) plus current (I)"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C09","question":"How much power is being used in a circuit when the applied voltage is 13.8 volts"+" DC and the current is 10 amperes?","answer":"A","choices":{"a":"138 watts","b":"0.7 watts","c":"23.8 watts","d":"3.8 watts"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C10","question":"How much power is being used in a circuit when the applied voltage is 12 volts D"+"C and the current is 2.5 amperes?","answer":"B","choices":{"a":"4.8 watts","b":"30 watts","c":"14.5 watts","d":"0.208 watts"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C11","question":"How many amperes are flowing in a circuit when the applied voltage is 12 volts D"+"C and the load is 120 watts?","answer":"B","choices":{"a":"0.1 amperes","b":"10 amperes","c":"12 amperes","d":"132 amperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C12","question":"What is meant by the term impedance? ","answer":"A","choices":{"a":"It is a measure of the opposition to AC current flow in a circuit","b":"It is the inverse of resistance","c":"It is a measure of the Q or Quality Factor of a component","d":"It is a measure of the power handling capability of a component"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5C","questionID":"T5C13","question":"What are the units of impedance? ","answer":"D","choices":{"a":"Volts","b":"Amperes","c":"Coulombs","d":"Ohms"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D01","question":"What formula is used to calculate current in a circuit?","answer":"B","choices":{"a":"Current (I) equals voltage (E) multiplied by resistance (R)","b":"Current (I) equals voltage (E) divided by resistance (R)","c":"Current (I) equals voltage (E) added to resistance (R)","d":"Current (I) equals voltage (E) minus resistance (R)"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D02","question":"What formula is used to calculate voltage in a circuit?","answer":"A","choices":{"a":"Voltage (E) equals current (I) multiplied by resistance (R)","b":"Voltage (E) equals current (I) divided by resistance (R)","c":"Voltage (E) equals current (I) added to resistance (R)","d":"Voltage (E) equals current (I) minus resistance (R)"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D03","question":"What formula is used to calculate resistance in a circuit?","answer":"B","choices":{"a":"Resistance (R) equals voltage (E) multiplied by current (I)","b":"Resistance (R) equals voltage (E) divided by current (I)","c":"Resistance (R) equals voltage (E) added to current (I)","d":"Resistance (R) equals voltage (E) minus current (I)"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D04","question":"What is the resistance of a circuit in which a current of 3 amperes flows throug"+"h a resistor connected to 90 volts?","answer":"B","choices":{"a":"3 ohms","b":"30 ohms","c":"93 ohms","d":"270 ohms"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D05","question":"What is the resistance in a circuit for which the applied voltage is 12 volts an"+"d the current flow is 1.5 amperes?","answer":"C","choices":{"a":"18 ohms","b":"0.125 ohms","c":"8 ohms","d":"13.5 ohms"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D06","question":"What is the resistance of a circuit that draws 4 amperes from a 12-volt source?","answer":"A","choices":{"a":"3 ohms","b":"16 ohms","c":"48 ohms","d":"8 Ohms"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D07","question":"What is the current flow in a circuit with an applied voltage of 120 volts and a"+" resistance of 80 ohms?","answer":"D","choices":{"a":"9600 amperes","b":"200 amperes","c":"0.667 amperes","d":"1.5 amperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D08","question":"What is the current flowing through a 100-ohm resistor connected across 200 volt"+"s?","answer":"C","choices":{"a":"20,000 amperes","b":"0.5 amperes","c":"2 amperes","d":"100 amperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D09","question":"What is the current flowing through a 24-ohm resistor connected across 240 volts"+"?","answer":"C","choices":{"a":"24,000 amperes","b":"0.1 amperes","c":"10 amperes","d":"216 amperes"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D10","question":"What is the voltage across a 2-ohm resistor if a current of 0.5 amperes flows th"+"rough it?","answer":"A","choices":{"a":"1 volt","b":"0.25 volts","c":"2.5 volts","d":"1.5 volts"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D11","question":"What is the voltage across a 10-ohm resistor if a current of 1 ampere flows thro"+"ugh it?","answer":"B","choices":{"a":"1 volt","b":"10 volts","c":"11 volts","d":"9 volts"},"metadata":""},{"exam":"T","section":"T5","subSection":"T5D","questionID":"T5D12","question":"What is the voltage across a 10-ohm resistor if a current of 2 amperes flows thr"+"ough it?","answer":"D","choices":{"a":"8 volts","b":"0.2 volts","c":"12 volts","d":"20 volts"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A01","question":"What electrical component is used to oppose the flow of current in a DC circuit?","answer":"B","choices":{"a":"Inductor","b":"Resistor","c":"Voltmeter","d":"Transformer"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A02","question":"What type of component is often used as an adjustable volume control?","answer":"C","choices":{"a":"Fixed resistor","b":"Power resistor","c":"Potentiometer","d":"Transformer"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A03","question":"What electrical parameter is controlled by a potentiometer?","answer":"B","choices":{"a":"Inductance","b":"Resistance","c":"Capacitance","d":"Field strength"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A04","question":"What electrical component stores energy in an electric field?","answer":"B","choices":{"a":"Resistor","b":"Capacitor","c":"Inductor","d":"Diode"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A05","question":"What type of electrical component consists of two or more conductive surfaces se"+"parated by an insulator?","answer":"D","choices":{"a":"Resistor","b":"Potentiometer","c":"Oscillator","d":"Capacitor"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A06","question":"What type of electrical component stores energy in a magnetic field?","answer":"C","choices":{"a":"Resistor","b":"Capacitor","c":"Inductor","d":"Diode"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A07","question":"What electrical component is usually composed of a coil of wire?","answer":"D","choices":{"a":"Switch","b":"Capacitor","c":"Diode","d":"Inductor"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A08","question":"What electrical component is used to connect or disconnect electrical circuits?","answer":"B","choices":{"a":"Magnetron","b":"Switch","c":"Thermistor","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A09","question":"What electrical component is used to protect other circuit components from curre"+"nt overloads?","answer":"A","choices":{"a":"Fuse","b":"Capacitor","c":"Inductor","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A10","question":"Which of the following battery types is rechargeable?","answer":"D","choices":{"a":"Nickel-metal hydride","b":"Lithium-ion","c":"Lead-acid gel-cell","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6A","questionID":"T6A11","question":"Which of the following battery types is not rechargeable?","answer":"B","choices":{"a":"Nickel-cadmium","b":"Carbon-zinc","c":"Lead-acid","d":"Lithium-ion"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B01","question":"What class of electronic components is capable of using a voltage or current sig"+"nal to control current flow?","answer":"D","choices":{"a":"Capacitors","b":"Inductors","c":"Resistors","d":"Transistors"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B02","question":"What electronic component allows current to flow in only one direction?","answer":"C","choices":{"a":"Resistor","b":"Fuse","c":"Diode","d":"Driven Element"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B03","question":"Which of these components can be used as an electronic switch or amplifier?","answer":"C","choices":{"a":"Oscillator","b":"Potentiometer","c":"Transistor","d":"Voltmeter"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B04","question":"Which of the following components can be made of three layers of semiconductor m"+"aterial?","answer":"B","choices":{"a":"Alternator","b":"Transistor","c":"Triode","d":"Pentagrid converter"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B05","question":"Which of the following electronic components can amplify signals?","answer":"A","choices":{"a":"Transistor","b":"Variable resistor","c":"Electrolytic capacitor","d":"Multi-cell battery"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B06","question":"How is the cathode lead of a semiconductor diode usually identified?","answer":"B","choices":{"a":"With the word cathode","b":"With a stripe","c":"With the letter C","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B07","question":"What does the abbreviation LED stand for?","answer":"B","choices":{"a":"Low Emission Diode","b":"Light Emitting Diode","c":"Liquid Emission Detector","d":"Long Echo Delay"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B08","question":"What does the abbreviation FET stand for?","answer":"A","choices":{"a":"Field Effect Transistor","b":"Fast Electron Transistor","c":"Free Electron Transition","d":"Field Emission Thickness"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B09","question":"What are the names of the two electrodes of a diode?","answer":"C","choices":{"a":"Plus and minus","b":"Source and drain","c":"Anode and cathode","d":"Gate and base"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B10","question":"What are the three electrodes of a PNP or NPN transistor?","answer":"A","choices":{"a":"Emitter, base, and collector","b":"Source, gate, and drain","c":"Cathode, grid, and plate","d":"Cathode, drift cavity, and collector"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B11","question":"What at are the three electrodes of a field effect transistor?","answer":"B","choices":{"a":"Emitter, base, and collector","b":"Source, gate, and drain","c":"Cathode, grid, and plate","d":"Cathode, gate, and anode"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6B","questionID":"T6B12","question":"What is the term that describes a transistor's ability to amplify a signal?","answer":"A","choices":{"a":"Gain","b":"Forward resistance","c":"Forward voltage drop","d":"On resistance"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C01","question":"What is the name for standardized representations of components in an electrical"+" wiring diagram?","answer":"C","choices":{"a":"Electrical depictions","b":"Grey sketch","c":"Schematic symbols","d":"Component callouts"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C02","question":"What is component 1 in figure T1?","answer":"A","choices":{"a":"Resistor","b":"Transistor","c":"Battery","d":"Connector"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C03","question":"What is component 2 in figure T1?","answer":"B","choices":{"a":"Resistor","b":"Transistor","c":"Indicator lamp","d":"Connector"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C04","question":"What is component 3 in figure T1?","answer":"C","choices":{"a":"Resistor","b":"Transistor","c":"Lamp","d":"Ground symbol"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C05","question":"What is component 4 in figure T1?","answer":"C","choices":{"a":"Resistor","b":"Transistor","c":"Battery","d":"Ground symbol"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C06","question":"What is component 6 in figure T2?","answer":"B","choices":{"a":"Resistor","b":"Capacitor","c":"Regulator IC","d":"Transistor"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C07","question":"What is component 8 in figure T2?","answer":"D","choices":{"a":"Resistor","b":"Inductor","c":"Regulator IC","d":"Light emitting diode"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C08","question":"What is component 9 in figure T2?","answer":"C","choices":{"a":"Variable capacitor","b":"Variable inductor","c":"Variable resistor","d":"Variable transformer"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C09","question":"What is component 4 in figure T2?","answer":"D","choices":{"a":"Variable inductor","b":"Double-pole switch","c":"Potentiometer","d":"Transformer"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C10","question":"What is component 3 in figure T3?","answer":"D","choices":{"a":"Connector","b":"Meter","c":"Variable capacitor","d":"Variable inductor"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C11","question":"What is component 4 in figure T3?","answer":"A","choices":{"a":"Antenna","b":"Transmitter","c":"Dummy load","d":"Ground"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C12","question":"What do the symbols on an electrical circuit schematic diagram represent?","answer":"A","choices":{"a":"Electrical components","b":"Logic states","c":"Digital codes","d":"Traffic nodes"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6C","questionID":"T6C13","question":"Which of the following is accurately represented in electrical circuit schematic"+" diagrams?","answer":"C","choices":{"a":"Wire lengths","b":"Physical appearance of components","c":"The way components are interconnected","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D01","question":"Which of the following devices or circuits changes an alternating current into a"+" varying direct current signal?","answer":"B","choices":{"a":"Transformer","b":"Rectifier","c":"Amplifier","d":"Reflector"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D02","question":"What best describes a relay?","answer":"A","choices":{"a":"A switch controlled by an electromagnet","b":"A current controlled amplifier","c":"An optical sensor","d":"A pass transistor"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D03","question":"What type of switch is represented by component 3 in figure T2?","answer":"A","choices":{"a":"Single-pole single-throw","b":"Single-pole double-throw","c":"Double-pole single-throw","d":"Double-pole double-throw"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D04","question":"Which of the following can be used to display signal strength on a numeric scale"+"?","answer":"C","choices":{"a":"Potentiometer","b":"Transistor","c":"Meter","d":"Relay"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D05","question":"What type of circuit controls the amount of voltage from a power supply?","answer":"A","choices":{"a":"Regulator","b":"Oscillator","c":"Filter","d":"Phase inverter"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D06","question":"What component is commonly used to change 120V AC house current to a lower AC vo"+"ltage for other uses?","answer":"B","choices":{"a":"Variable capacitor","b":"Transformer","c":"Transistor","d":"Diode"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D07","question":"Which of the following is commonly used as a visual indicator?","answer":"A","choices":{"a":"LED","b":"FET","c":"Zener diode","d":"Bipolar transistor"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D08","question":"Which of the following is used together with an inductor to make a tuned circuit"+"?","answer":"D","choices":{"a":"Resistor","b":"Zener diode","c":"Potentiometer","d":"Capacitor"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D09","question":"What is the name of a device that combines several semiconductors and other comp"+"onents into one package?","answer":"C","choices":{"a":"Transducer","b":"Multi-pole relay","c":"Integrated circuit","d":"Transformer"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D10","question":"What is the function of component 2 in Figure T1?","answer":"C","choices":{"a":"Give off light when current flows through it","b":"Supply electrical energy","c":"Control the flow of current","d":"Convert electrical energy into radio waves"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D11","question":"What is a simple resonant or tuned circuit?","answer":"A","choices":{"a":"An inductor and a capacitor connected in series or parallel to form a filter","b":"A type of voltage regulator","c":"A resistor circuit used for reducing standing wave ratio","d":"A circuit designed to provide high fidelity audio"},"metadata":""},{"exam":"T","section":"T6","subSection":"T6D","questionID":"T6D12","question":"Which of the following is a common reason to use shielded wire?","answer":"C","choices":{"a":"To decrease the resistance of DC power connections","b":"To increase the current carrying capability of the wire","c":"To prevent coupling of unwanted signals to or from the wire","d":"To couple the wire to other signals"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A01","question":"Which term describes the ability of a receiver to detect the presence of a signa"+"l?","answer":"B","choices":{"a":"Linearity","b":"Sensitivity","c":"Selectivity","d":"Total Harmonic Distortion"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A02","question":"What is a transceiver?","answer":"B","choices":{"a":"A type of antenna switch","b":"A unit combining the functions of a transmitter and a receiver","c":"A component in a repeater which filters out unwanted interference","d":"A type of antenna matching network"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A03","question":"Which of the following is used to convert a radio signal from one frequency to a"+"nother?","answer":"B","choices":{"a":"Phase splitter","b":"Mixer","c":"Inverter","d":"Amplifier"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A04","question":"Which term describes the ability of a receiver to discriminate between multiple "+"signals?","answer":"C","choices":{"a":"Discrimination ratio","b":"Sensitivity","c":"Selectivity","d":"Harmonic Distortion"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A05","question":"What is the name of a circuit that generates a signal of a desired frequency?","answer":"D","choices":{"a":"Reactance modulator","b":"Product detector","c":"Low-pass filter","d":"Oscillator"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A06","question":"What device takes the output of a low-powered 28 MHz SSB exciter and produces a "+"222 MHz output signal?","answer":"C","choices":{"a":"High-pass filter","b":"Low-pass filter","c":"Transverter","d":"Phase converter"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A07","question":"What is meant by term �PTT�?","answer":"D","choices":{"a":"Pre-transmission tuning to reduce transmitter harmonic emission","b":"Precise tone transmissions used to limit repeater access to only certain signals","c":"A primary transformer tuner use to match antennas","d":"The push to talk function which switches between receive and transmit"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A08","question":"Which of the following describes combining speech with an RF carrier signal?-","answer":"C","choices":{"a":"Impedance matching","b":"Oscillation","c":"Modulation","d":"Low-pass filtering"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A09","question":"Which of the following devices is most useful for VHF weak-signal communication?","answer":"B","choices":{"a":"A quarter-wave vertical antenna","b":"A multi-mode VHF transceiver","c":"An omni-directional antenna","d":"A mobile VHF FM transceiver"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A10","question":"What device increases the low-power output from a handheld transceiver?","answer":"B","choices":{"a":"A voltage divider","b":"An RF power amplifier","c":"An impedance network","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7A","questionID":"T7A11","question":"Where is an RF preamplifier installed?","answer":"A","choices":{"a":"Between the antenna and receiver","b":"At the output of the transmitter's power amplifier","c":"Between a transmitter and antenna tuner","d":"At the receiver's audio output"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B01","question":"What can you do if you are told your FM handheld or mobile transceiver is over-d"+"eviating?","answer":"D","choices":{"a":"Talk louder into the microphone","b":"Let the transceiver cool off","c":"Change to a higher power level","d":"Talk farther away from the microphone"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B02","question":"What would cause a broadcast AM or FM radio to receive an amateur radio transmis"+"sion unintentionally?","answer":"A","choices":{"a":"The receiver is unable to reject strong signals outside the AM or FM band","b":"The microphone gain of the transmitter is turned up too high","c":"The audio amplifier of the transmitter is overloaded","d":"The deviation of an FM transmitter is set too low"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B03","question":"Which of the following may be a cause of radio frequency interference?","answer":"D","choices":{"a":"Fundamental overload","b":"Harmonics","c":"Spurious emissions","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B04","question":"Which of the following is a way to reduce or eliminate interference by an amateu"+"r transmitter to a nearby telephone?","answer":"D","choices":{"a":"Put a filter on the amateur transmitter","b":"Reduce the microphone gain","c":"Reduce the SWR on the transmitter transmission line","d":"Put a RF filter on the telephone"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B05","question":"How can overload of a non-amateur radio or TV receiver by an amateur signal be r"+"educed or eliminated?","answer":"A","choices":{"a":"Block the amateur signal with a filter at the antenna input of the affected rece"+"iver","b":"Block the interfering signal with a filter on the amateur transmitter","c":"Switch the transmitter from FM to SSB","d":"Switch the transmitter to a narrow-band mode"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B06","question":"Which of the following actions should you take if a neighbor tells you that your"+" station�s transmissions are interfering with their radio or TV reception?","answer":"A","choices":{"a":"Make sure that your station is functioning properly and that it does not cause i"+"nterference to your own radio or television when it is tuned to the same channel","b":"Immediately turn off your transmitter and contact the nearest FCC office for ass"+"istance","c":"Tell them that your license gives you the right to transmit and nothing can be d"+"one to reduce the interference","d":"Install a harmonic doubler on the output of your transmitter and tune it until t"+"he interference is eliminated"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B07","question":"Which of the following may be useful in correcting a radio frequency interferenc"+"e problem?","answer":"D","choices":{"a":"Snap-on ferrite chokes","b":"Low-pass and high-pass filters","c":"Band-reject and band-pass filters","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B08","question":"What should you do if something in a neighbor�s home is causing harmful interfer"+"ence to your amateur station?","answer":"D","choices":{"a":"Work with your neighbor to identify the offending device","b":"Politely inform your neighbor about the rules that prohibit the use of devices w"+"hich cause interference","c":"Check your station and make sure it meets the standards of good amateur practice","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B09","question":"What is a Part 15 device?","answer":"A","choices":{"a":"An unlicensed device that may emit low powered radio signals on frequencies used"+" by a licensed service","b":"A type of amateur radio that can legally be used in the citizen�s band","c":"A device for long distance communications using special codes sanctioned by the "+"International Amateur Radio Union","d":"A type of test set used to determine whether a transmitter is in compliance with"+" FCC regulation 91.15"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B10","question":"What might be the problem if you receive a report that your audio signal through"+" the repeater is distorted or unintelligible?","answer":"D","choices":{"a":"Your transmitter may be slightly off frequency","b":"Your batteries may be running low","c":"You could be in a bad location","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B11","question":"What is a symptom of RF feedback in a transmitter or transceiver?","answer":"C","choices":{"a":"Excessive SWR at the antenna connection","b":"The transmitter will not stay on the desired frequency","c":"Reports of garbled, distorted, or unintelligible transmissions","d":"Frequent blowing of power supply fuses"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7B","questionID":"T7B12","question":"What might be the first step to resolve cable TV interference from your ham radi"+"o transmission?","answer":"D","choices":{"a":"Add a low pass filter to the TV antenna input","b":"Add a high pass filter to the TV antenna input","c":"Add a preamplifier to the TV antenna input","d":"Be sure all TV coaxial connectors are installed properly"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C01","question":"What is the primary purpose of a dummy load?","answer":"A","choices":{"a":"To prevent the radiation of signals when making tests","b":"To prevent over-modulation of your transmitter","c":"To improve the radiation from your antenna","d":"To improve the signal to noise ratio of your receiver"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C02","question":"Which of the following instruments can be used to determine if an antenna is res"+"onant at the desired operating frequency?","answer":"B","choices":{"a":"A VTVM","b":"An antenna analyzer","c":"A Q meter","d":"A frequency counter"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C03","question":"What, in general terms, is standing wave ratio (SWR)?","answer":"A","choices":{"a":"A measure of how well a load is matched to a transmission line","b":"The ratio of high to low impedance in a feed line","c":"The transmitter efficiency ratio","d":"An indication of the quality of your station�s ground connection"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C04","question":"What reading on an SWR meter indicates a perfect impedance match between the ant"+"enna and the feed line?","answer":"C","choices":{"a":"2 to 1","b":"1 to 3","c":"1 to 1","d":"10 to 1"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C05","question":"What is the approximate SWR value above which the protection circuits in most so"+"lid-state transmitters begin to reduce transmitter power?","answer":"A","choices":{"a":"2 to 1","b":"1 to 2","c":"6 to 1","d":"10 to 1"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C06","question":"What does an SWR reading of 4:1 indicate?","answer":"D","choices":{"a":"Loss of -4dB","b":"Good impedance match","c":"Gain of +4dB","d":"Impedance mismatch"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C07","question":"What happens to power lost in a feed line?","answer":"C","choices":{"a":"It increases the SWR","b":"It comes back into your transmitter and could cause damage","c":"It is converted into heat","d":"It can cause distortion of your signal"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C08","question":"What instrument other than an SWR meter could you use to determine if a feed lin"+"e and antenna are properly matched?","answer":"D","choices":{"a":"Voltmeter","b":"Ohmmeter","c":"Iambic pentameter","d":"Directional wattmeter"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C09","question":"Which of the following is the most common cause for failure of coaxial cables?","answer":"A","choices":{"a":"Moisture contamination","b":"Gamma rays","c":"The velocity factor exceeds 1.0","d":"Overloading"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C10","question":"Why should the outer jacket of coaxial cable be resistant to ultraviolet light?","answer":"D","choices":{"a":"Ultraviolet resistant jackets prevent harmonic radiation","b":"Ultraviolet light can increase losses in the cable�s jacket","c":"Ultraviolet and RF signals can mix together, causing interference","d":"Ultraviolet light can damage the jacket and allow water to enter the cable"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C11","question":"What is a disadvantage of air core coaxial cable when compared to foam or solid "+"dielectric types?","answer":"C","choices":{"a":"It has more loss per foot","b":"It cannot be used for VHF or UHF antennas","c":"It requires special techniques to prevent water absorption","d":"It cannot be used at below freezing temperatures"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C12","question":"Which of the following is a common use of coaxial cable?","answer":"B","choices":{"a":"Carrying dc power from a vehicle battery to a mobile radio","b":"Carrying RF signals between a radio and antenna","c":"Securing masts, tubing, and other cylindrical objects on towers","d":"Connecting data signals from a TNC to a computer"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7C","questionID":"T7C13","question":"What does a dummy load consist of?","answer":"B","choices":{"a":"A high-gain amplifier and a TR switch","b":"A non-inductive resistor and a heat sink","c":"A low voltage power supply and a DC relay","d":"A 50 ohm reactance used to terminate a transmission line"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D01","question":"Which instrument would you use to measure electric potential or electromotive fo"+"rce?","answer":"B","choices":{"a":"An ammeter","b":"A voltmeter","c":"A wavemeter","d":"An ohmmeter"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D02","question":"What is the correct way to connect a voltmeter to a circuit?","answer":"B","choices":{"a":"In series with the circuit","b":"In parallel with the circuit","c":"In quadrature with the circuit","d":"In phase with the circuit"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D03","question":"How is an ammeter usually connected to a circuit?","answer":"A","choices":{"a":"In series with the circuit","b":"In parallel with the circuit","c":"In quadrature with the circuit","d":"In phase with the circuit"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D04","question":"Which instrument is used to measure electric current?","answer":"D","choices":{"a":"An ohmmeter","b":"A wavemeter","c":"A voltmeter","d":"An ammeter"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D05","question":"What instrument is used to measure resistance?","answer":"D","choices":{"a":"An oscilloscope","b":"A spectrum analyzer","c":"A noise bridge","d":"An ohmmeter"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D06","question":"Which of the following might damage a multimeter?","answer":"C","choices":{"a":"Measuring a voltage too small for the chosen scale","b":"Leaving the meter in the milliamps position overnight","c":"Attempting to measure voltage when using the resistance setting","d":"Not allowing it to warm up properly"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D07","question":"Which of the following measurements are commonly made using a multimeter?","answer":"D","choices":{"a":"SWR and RF power","b":"Signal strength and noise","c":"Impedance and reactance","d":"Voltage and resistance"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D08","question":"Which of the following types of solder is best for radio and electronic use?","answer":"C","choices":{"a":"Acid-core solder","b":"Silver solder","c":"Rosin-core solder","d":"Aluminum solder"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D09","question":"What is the characteristic appearance of a cold solder joint?","answer":"C","choices":{"a":"Dark black spots","b":"A bright or shiny surface","c":"A grainy or dull surface","d":"A greenish tint"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D10","question":"What is probably happening when an ohmmeter, connected across an unpowered circu"+"it, initially indicates a low resistance and then shows increasing resistance wi"+"th time?","answer":"B","choices":{"a":"The ohmmeter is defective","b":"The circuit contains a large capacitor","c":"The circuit contains a large inductor","d":"The circuit is a relaxation oscillator"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D11","question":"Which of the following precautions should be taken when measuring circuit resist"+"ance with an ohmmeter?","answer":"B","choices":{"a":"Ensure that the applied voltages are correct","b":"Ensure that the circuit is not powered","c":"Ensure that the circuit is grounded","d":"Ensure that the circuit is operating at the correct frequency"},"metadata":""},{"exam":"T","section":"T7","subSection":"T7D","questionID":"T7D12","question":"Which of the following precautions should be taken when measuring high voltages "+"with a voltmeter?","answer":"B","choices":{"a":"Ensure that the voltmeter has very low impedance","b":"Ensure that the voltmeter and leads are rated for use at the voltages to be meas"+"ured","c":"Ensure that the circuit is grounded through the voltmeter","d":"Ensure that the voltmeter is set to the correct frequency"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A01","question":"Which of the following is a form of amplitude modulation?","answer":"C","choices":{"a":"Spread-spectrum","b":"Packet radio","c":"Single sideband","d":"Phase shift keying"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A02","question":"What type of modulation is most commonly used for VHF packet radio transmissions"+"?","answer":"A","choices":{"a":"FM","b":"SSB","c":"AM","d":"Spread Spectrum"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A03","question":"Which type of voice mode is most often used for long-distance (weak signal) cont"+"acts on the VHF and UHF bands?","answer":"C","choices":{"a":"FM","b":"DRM","c":"SSB","d":"PM"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A04","question":"Which type of modulation is most commonly used for VHF and UHF voice repeaters?","answer":"D","choices":{"a":"AM","b":"SSB","c":"PSK","d":"FM"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A05","question":"Which of the following types of emission has the narrowest bandwidth?","answer":"C","choices":{"a":"FM voice","b":"SSB voice","c":"CW","d":"Slow-scan TV"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A06","question":"Which sideband is normally used for 10 meter HF, VHF and UHF single-sideband com"+"munications?","answer":"A","choices":{"a":"Upper sideband","b":"Lower sideband","c":"Suppressed sideband","d":"Inverted sideband"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A07","question":"What is the primary advantage of single sideband over FM for voice transmissions"+"?","answer":"C","choices":{"a":"SSB signals are easier to tune","b":"SSB signals are less susceptible to interference","c":"SSB signals have narrower bandwidth","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A08","question":"What is the approximate bandwidth of a single sideband voice signal?","answer":"B","choices":{"a":"1 kHz","b":"3 kHz","c":"6 kHz","d":"15 kHz"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A09","question":"What is the approximate bandwidth of a VHF repeater FM phone signal?","answer":"C","choices":{"a":"Less than 500 Hz","b":"About 150 kHz","c":"Between 10 and 15 kHz","d":"Between 50 and 125 kHz"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A10","question":"What is the typical bandwidth of analog fast-scan TV transmissions on the 70 cm "+"band?","answer":"B","choices":{"a":"More than 10 MHz","b":"About 6 MHz","c":"About 3 MHz","d":"About 1 MHz"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8A","questionID":"T8A11","question":"What is the approximate maximum bandwidth required to transmit a CW signal?","answer":"B","choices":{"a":"2.4 kHz","b":"150 Hz","c":"1000 Hz","d":"15 kHz"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B01","question":"Who may be the control operator of a station communicating through an amateur sa"+"tellite or space station?","answer":"D","choices":{"a":"Only an Amateur Extra Class operator","b":"A General Class licensee or higher licensee who has a satellite operator certifi"+"cation","c":"Only an Amateur Extra Class operator who is also an AMSAT member","d":"Any amateur whose license privileges allow them to transmit on the satellite upl"+"ink frequency"},"metadata":"97.301, 97.207(c)"},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B02","question":"How much transmitter power should be used on the uplink frequency of an amateur "+"satellite or space station?","answer":"B","choices":{"a":"The maximum power of your transmitter","b":"The minimum amount of power needed to complete the contact","c":"No more than half the rating of your linear amplifier","d":"Never more than 1 watt"},"metadata":"97.313"},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B03","question":"Which of the following are provided by satellite tracking programs?","answer":"D","choices":{"a":"Maps showing the real-time position of the satellite track over the earth","b":"The time, azimuth, and elevation of the start, maximum altitude, and end of a pa"+"ss","c":"The apparent frequency of the satellite transmission, including effects of Doppl"+"er shift","d":"All of these answers are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B04","question":"Which amateur stations may make contact with an amateur station on the Internati"+"onal Space Station using 2 meter and 70 cm band amateur radio frequencies?","answer":"B","choices":{"a":"Only members of amateur radio clubs at NASA facilities","b":"Any amateur holding a Technician or higher class license","c":"Only the astronaut's family members who are hams","d":"You cannot talk to the ISS on amateur radio frequencies"},"metadata":"97.301, 97.207(c)"},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B05","question":"What is a satellite beacon?","answer":"D","choices":{"a":"The primary transmit antenna on the satellite","b":"An indicator light that that shows where to point your antenna","c":"A reflective surface on the satellite","d":"A transmission from a space station that contains information about a satellite"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B06","question":"Which of the following are inputs to a satellite tracking program?","answer":"B","choices":{"a":"The weight of the satellite","b":"The Keplerian elements","c":"The last observed time of zero Doppler shift","d":"All of these answers are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B07","question":"With regard to satellite communications, what is Doppler shift?","answer":"C","choices":{"a":"A change in the satellite orbit","b":"A mode where the satellite receives signals on one band and transmits on another","c":"An observed change in signal frequency caused by relative motion between the sat"+"ellite and the earth station","d":"A special digital communications mode for some satellites"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B08","question":"What is meant by the statement that a satellite is operating in mode U/V?","answer":"B","choices":{"a":"The satellite uplink is in the 15 meter band and the downlink is in the 10 meter"+" band","b":"The satellite uplink is in the 70 cm band and the downlink is in the 2 meter ban"+"d","c":"The satellite operates using ultraviolet frequencies","d":"The satellite frequencies are usually variable"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B09","question":"What causes spin fading when referring to satellite signals?","answer":"B","choices":{"a":"Circular polarized noise interference radiated from the sun","b":"Rotation of the satellite and its antennas","c":"Doppler shift of the received signal","d":"Interfering signals within the satellite uplink band"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B10","question":"What do the initials LEO tell you about an amateur satellite?","answer":"C","choices":{"a":"The satellite battery is in Low Energy Operation mode","b":"The satellite is performing a Lunar Ejection Orbit maneuver","c":"The satellite is in a Low Earth Orbit","d":"The satellite uses Light Emitting Optics"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8B","questionID":"T8B11","question":"What is a commonly used method of sending signals to and from a digital satellit"+"e?","answer":"C","choices":{"a":"USB AFSK","b":"PSK31","c":"FM Packet","d":"WSJT"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C01","question":"Which of the following methods is used to locate sources of noise interference o"+"r jamming?","answer":"C","choices":{"a":"Echolocation","b":"Doppler radar","c":"Radio direction finding","d":"Phase locking"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C02","question":"Which of these items would be useful for a hidden transmitter hunt?","answer":"B","choices":{"a":"Calibrated SWR meter","b":"A directional antenna","c":"A calibrated noise bridge","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C03","question":"What popular operating activity involves contacting as many stations as possible"+" during a specified period of time?","answer":"A","choices":{"a":"Contesting","b":"Net operations","c":"Public service events","d":"Simulated emergency exercises"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C04","question":"Which of the following is good procedure when contacting another station in a ra"+"dio contest?","answer":"C","choices":{"a":"Be sure to sign only the last two letters of your call if there is a pileup call"+"ing the station","b":"Work the station twice to be sure that you are in his log","c":"Send only the minimum information needed for proper identification and the conte"+"st exchange","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C05","question":"What is a grid locator?","answer":"A","choices":{"a":"A letter-number designator assigned to a geographic location","b":"A letter-number designator assigned to an azimuth and elevation","c":"An instrument for neutralizing a final amplifier","d":"An instrument for radio direction finding"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C06","question":"How is access to an IRLP node accomplished?","answer":"B","choices":{"a":"By obtaining a password which is sent via voice to the node","b":"By using DTMF signals","c":"By entering the proper Internet password","d":"By using CTCSS tone codes"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C07","question":"What is the maximum power allowed when transmitting telecommand signals to radio"+" controlled models?","answer":"B","choices":{"a":"500 milliwatts","b":"1 watt","c":"25 watts","d":"1500 watts"},"metadata":"97.215(c)"},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C08","question":"What is required in place of on-air station identification when sending signals "+"to a radio control model using amateur frequencies?","answer":"C","choices":{"a":"Voice identification must be transmitted every 10 minutes","b":"Morse code ID must be sent once per hour","c":"A label indicating the licensee�s name, call sign and address must be affixed to"+" the transmitter","d":"A flag must be affixed to the transmitter antenna with the station call sign in "+"1 inch high letters or larger"},"metadata":"97.215(a)"},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C09","question":"How might you obtain a list of active nodes that use VoIP?","answer":"C","choices":{"a":"From the FCC Rulebook","b":"From your local emergency coordinator","c":"From a repeater directory","d":"From the local repeater frequency coordinator"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C10","question":"How do you select a specific IRLP node when using a portable transceiver?","answer":"D","choices":{"a":"Choose a specific CTCSS tone","b":"Choose the correct DSC tone","c":"Access the repeater autopatch","d":"Use the keypad to transmit the IRLP node ID"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C11","question":"What name is given to an amateur radio station that is used to connect other ama"+"teur stations to the Internet?","answer":"A","choices":{"a":"A gateway","b":"A repeater","c":"A digipeater","d":"A beacon"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C12","question":"What is meant by Voice Over Internet Protocol (VoIP) as used in amateur radio?","answer":"D","choices":{"a":"A set of rules specifying how to identify your station when linked over the Inte"+"rnet to another station","b":"A set of guidelines for working DX during contests using Internet access","c":"A technique for measuring the modulation quality of a transmitter using remote s"+"ites monitored via the Internet","d":"A method of delivering voice communications over the Internet using digital tech"+"niques"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8C","questionID":"T8C13","question":"What is the Internet Radio Linking Project (IRLP)?","answer":"A","choices":{"a":"A technique to connect amateur radio systems, such as repeaters, via the Interne"+"t using Voice Over Internet Protocol","b":"A system for providing access to websites via amateur radio","c":"A system for informing amateurs in real time of the frequency of active DX stati"+"ons","d":"A technique for measuring signal strength of an amateur transmitter via the Inte"+"rnet"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D01","question":"Which of the following is an example of a digital communications method?","answer":"D","choices":{"a":"Packet","b":"PSK31","c":"MFSK","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D02","question":"What does the term �APRS� mean?","answer":"A","choices":{"a":"Automatic Packet Reporting System","b":"Associated Public Radio Station","c":"Auto Planning Radio Set-up","d":"Advanced Polar Radio System"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D03","question":"Which of the following devices provides data to the transmitter when sending aut"+"omatic position reports from a mobile amateur radio station?","answer":"D","choices":{"a":"The vehicle speedometer","b":"A WWV receiver","c":"A connection to a broadcast FM sub-carrier receiver","d":"A Global Positioning System receiver"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D04","question":"What type of transmission is indicated by the term NTSC?","answer":"C","choices":{"a":"A Normal Transmission mode in Static Circuit","b":"A special mode for earth satellite uplink","c":"An analog fast scan color TV signal","d":"A frame compression scheme for TV signals"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D05","question":"Which of the following is an application of APRS (Automatic Packet Reporting Sys"+"tem)?","answer":"A","choices":{"a":"Providing real time tactical digital communications in conjunction with a map sh"+"owing the locations of stations","b":"Showing automatically the number of packets transmitted via PACTOR during a spec"+"ific time interval","c":"Providing voice over Internet connection between repeaters","d":"Providing information on the number of stations signed into a repeater"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D06","question":"What does the abbreviation PSK mean?","answer":"B","choices":{"a":"Pulse Shift Keying","b":"Phase Shift Keying","c":"Packet Short Keying","d":"Phased Slide Keying"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D07","question":"What is PSK31?","answer":"D","choices":{"a":"A high-rate data transmission mode","b":"A method of reducing noise interference to FM signals","c":"A method of compressing digital television signals","d":"A low-rate data transmission mode"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D08","question":"Which of the following may be included in packet transmissions?","answer":"D","choices":{"a":"A check sum which permits error detection","b":"A header which contains the call sign of the station to which the information is"+" being sent","c":"Automatic repeat request in case of error","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D09","question":"What code is used when sending CW in the amateur bands?","answer":"C","choices":{"a":"Baudot","b":"Hamming","c":"International Morse","d":"Gray"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D10","question":"Which of the following can be used to transmit CW in the amateur bands?","answer":"D","choices":{"a":"Straight Key","b":"Electronic Keyer","c":"Computer Keyboard","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T8","subSection":"T8D","questionID":"T8D11","question":"What is an ARQ transmission system?","answer":"C","choices":{"a":"A special transmission format limited to video signals","b":"A system used to encrypt command signals to an amateur radio satellite","c":"A digital scheme whereby the receiving station detects errors and sends a reques"+"t to the sending station to retransmit the information","d":"A method of compressing the data in a message so more information can be sent in"+" a shorter time"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A01","question":"What is a beam antenna?","answer":"C","choices":{"a":"An antenna built from aluminum I-beams","b":"An omnidirectional antenna invented by Clarence Beam","c":"An antenna that concentrates signals in one direction","d":"An antenna that reverses the phase of received signals"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A02","question":"Which of the following is true regarding vertical antennas?","answer":"B","choices":{"a":"The magnetic field is perpendicular to the Earth","b":"The electric field is perpendicular to the Earth","c":"The phase is inverted","d":"The phase is reversed"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A03","question":"Which of the following describes a simple dipole mounted so the conductor is par"+"allel to the Earth's surface?","answer":"B","choices":{"a":"A ground wave antenna","b":"A horizontally polarized antenna","c":"A rhombic antenna","d":"A vertically polarized antenna"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A04","question":"What is a disadvantage of the �rubber duck� antenna supplied with most handheld "+"radio transceivers?","answer":"A","choices":{"a":"It does not transmit or receive as effectively as a full-sized antenna","b":"It transmits a circularly polarized signal","c":"If the rubber end cap is lost it will unravel very quickly","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A05","question":"How would you change a dipole antenna to make it resonant on a higher frequency?","answer":"C","choices":{"a":"Lengthen it","b":"Insert coils in series with radiating wires","c":"Shorten it","d":"Add capacitive loading to the ends of the radiating wires"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A06","question":"What type of antennas are the quad, Yagi, and dish?","answer":"C","choices":{"a":"Non-resonant antennas","b":"Loop antennas","c":"Directional antennas","d":"Isotropic antennas"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A07","question":"What is a good reason not to use a �rubber duck� antenna inside your car?","answer":"A","choices":{"a":"Signals can be significantly weaker than when it is outside of the vehicle","b":"It might cause your radio to overheat","c":"The SWR might decrease, decreasing the signal strength","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A08","question":"What is the approximate length, in inches, of a quarter-wavelength vertical ante"+"nna for 146 MHz?","answer":"C","choices":{"a":"112","b":"50","c":"19","d":"12"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A09","question":"What is the approximate length, in inches, of a 6 meter 1/2-wavelength wire dipo"+"le antenna?","answer":"C","choices":{"a":"6","b":"50","c":"112","d":"236"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A10","question":"In which direction is the radiation strongest from a half-wave dipole antenna in"+" free space?","answer":"C","choices":{"a":"Equally in all directions","b":"Off the ends of the antenna","c":"Broadside to the antenna","d":"In the direction of the feed line"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A11","question":"What is meant by the gain of an antenna?","answer":"C","choices":{"a":"The additional power that is added to the transmitter power","b":"The additional power that is lost in the antenna when transmitting on a higher f"+"requency","c":"The increase in signal strength in a specified direction when compared to a refe"+"rence antenna","d":"The increase in impedance on receive or transmit compared to a reference antenna"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A12","question":"What is a reason to use a properly mounted 5/8 wavelength antenna for VHF or UHF"+" mobile service?","answer":"A","choices":{"a":"It offers a lower angle of radiation and more gain than a 1/4 wavelength antenna"+" and usually provides improved coverage","b":"It features a very high angle of radiation and is better for communicating via a"+" repeater","c":"The 5/8 wavelength antenna completely eliminates distortion caused by reflected "+"signals","d":"The 5/8 wavelength antenna offers a 10-times power gain over a 1/4 wavelength de"+"sign"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A13","question":"Why are VHF or UHF mobile antennas often mounted in the center of the vehicle ro"+"of?","answer":"C","choices":{"a":"Roof mounts have the lowest possible SWR of any mounting configuration","b":"Only roof mounting can guarantee a vertically polarized signal","c":"A roof mounted antenna normally provides the most uniform radiation pattern","d":"Roof mounted antennas are always the easiest to install"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9A","questionID":"T9A14","question":"Which of the following terms describes a type of loading when referring to an an"+"tenna?","answer":"A","choices":{"a":"Inserting an inductor in the radiating portion of the antenna to make it electri"+"cally longer","b":"Inserting a resistor in the radiating portion of the antenna to make it resonant","c":"Installing a spring at the base of the antenna to absorb the effects of collisio"+"ns with other objects","d":"Making the antenna heavier so it will resist wind effects when in motion"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B01","question":"Why is it important to have a low SWR in an antenna system that uses coaxial cab"+"le feed line?","answer":"B","choices":{"a":"To reduce television interference","b":"To allow the efficient transfer of power and reduce losses","c":"To prolong antenna life","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B02","question":"What is the impedance of the most commonly used coaxial cable in typical amateur"+" radio installations?","answer":"B","choices":{"a":"8 ohms","b":"50 ohms","c":"600 ohms","d":"12 ohms"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B03","question":"Why is coaxial cable used more often than any other feed line for amateur radio "+"antenna systems?","answer":"A","choices":{"a":"It is easy to use and requires few special installation considerations","b":"It has less loss than any other type of feed line","c":"It can handle more power than any other type of feed line","d":"It is less expensive than any other types of feed line"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B04","question":"What does an antenna tuner do?","answer":"A","choices":{"a":"It matches the antenna system impedance to the transceiver's output impedance","b":"It helps a receiver automatically tune in weak stations","c":"It allows an antenna to be used on both transmit and receive","d":"It automatically selects the proper antenna for the frequency band being used"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B05","question":"What generally happens as the frequency of a signal passing through coaxial cabl"+"e is increased?","answer":"D","choices":{"a":"The apparent SWR increases","b":"The reflected power increases","c":"The characteristic impedance increases","d":"The loss increases"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B06","question":"Which of the following connectors is most suitable for frequencies above 400 MHz"+"?","answer":"B","choices":{"a":"A UHF (PL-259/SO-239) connector","b":"A Type N connector","c":"An RS-213 connector","d":"A DB-25 connector"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B07","question":"Which of the following is true of PL-259 type coax connectors?","answer":"C","choices":{"a":"They are preferred for microwave operation","b":"They are water tight","c":"They are commonly used at HF frequencies","d":"They are a bayonet type connector"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B08","question":"Why should coax connectors exposed to the weather be sealed against water intrus"+"ion?","answer":"A","choices":{"a":"To prevent an increase in feed line loss","b":"To prevent interference to telephones","c":"To keep the jacket from becoming loose","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B09","question":"What might cause erratic changes in SWR readings?","answer":"B","choices":{"a":"The transmitter is being modulated","b":"A loose connection in an antenna or a feed line","c":"The transmitter is being over-modulated","d":"Interference from other stations is distorting your signal"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B10","question":"What electrical difference exists between the smaller RG-58 and larger RG-8 coax"+"ial cables?","answer":"C","choices":{"a":"There is no significant difference between the two types","b":"RG-58 cable has less loss at a given frequency","c":"RG-8 cable has less loss at a given frequency","d":"RG-58 cable can handle higher power levels"},"metadata":""},{"exam":"T","section":"T9","subSection":"T9B","questionID":"T9B11","question":"Which of the following types of feed line has the lowest loss at VHF and UHF?","answer":"C","choices":{"a":"50-ohm flexible coax","b":"Multi-conductor unbalanced cable","c":"Air-insulated hard line","d":"75-ohm flexible coax"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A01","question":"Which of the following is a safety hazard of a 12-volt storage battery?","answer":"B","choices":{"a":"Touching both terminals with the hands can cause electrical shock","b":"Shorting the terminals can cause burns, fire, or an explosion","c":"RF emissions from the battery","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A02","question":"How does current flowing through the body cause a health hazard?","answer":"D","choices":{"a":"By heating tissue","b":"It disrupts the electrical functions of cells","c":"It causes involuntary muscle contractions","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A03","question":"What is connected to the green wire in a three-wire electrical AC plug?","answer":"C","choices":{"a":"Neutral","b":"Hot","c":"Safety ground","d":"The white wire"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A04","question":"What is the purpose of a fuse in an electrical circuit?","answer":"B","choices":{"a":"To prevent power supply ripple from damaging a circuit","b":"To interrupt power in case of overload","c":"To limit current to prevent shocks","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A05","question":"Why is it unwise to install a 20-ampere fuse in the place of a 5-ampere fuse?","answer":"C","choices":{"a":"The larger fuse would be likely to blow because it is rated for higher current","b":"The power supply ripple would greatly increase","c":"Excessive current could cause a fire","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A06","question":"What is a good way to guard against electrical shock at your station?","answer":"D","choices":{"a":"Use three-wire cords and plugs for all AC powered equipment","b":"Connect all AC powered station equipment to a common safety ground","c":"Use a circuit protected by a ground-fault interrupter","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A07","question":"Which of these precautions should be taken when installing devices for lightning"+" protection in a coaxial cable feed line?","answer":"D","choices":{"a":"Include a parallel bypass switch for each protector so that it can be switched o"+"ut of the circuit when running high power","b":"Include a series switch in the ground line of each protector to prevent RF overl"+"oad from inadvertently damaging the protector","c":"Keep the ground wires from each protector separate and connected to station grou"+"nd","d":"Ground all of the protectors to a common plate which is in turn connected to an "+"external ground"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A08","question":"What safety equipment should always be included in home-built equipment that is "+"powered from 120V AC power circuits?","answer":"A","choices":{"a":"A fuse or circuit breaker in series with the AC hot conductor","b":"An AC voltmeter across the incoming power source","c":"An inductor in series with the AC power source","d":"A capacitor across the AC power source"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A09","question":"What kind of hazard is presented by a conventional 12-volt storage battery?","answer":"C","choices":{"a":"It emits ozone which can be harmful to the atmosphere","b":"Shock hazard due to high voltage","c":"Explosive gas can collect if not properly vented","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A10","question":"What can happen if a lead-acid storage battery is charged or discharged too quic"+"kly?","answer":"A","choices":{"a":"The battery could overheat and give off flammable gas or explode","b":"The voltage can become reversed","c":"The memory effect will reduce the capacity of the battery","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0A","questionID":"T0A11","question":"What kind of hazard might exist in a power supply when it is turned off and disc"+"onnected?","answer":"D","choices":{"a":"Static electricity could damage the grounding system","b":"Circulating currents inside the transformer might cause damage","c":"The fuse might blow if you remove the cover","d":"You might receive an electric shock from the charged stored in large capacitors"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B01","question":"When should members of a tower work team wear a hard hat and safety glasses?","answer":"C","choices":{"a":"At all times except when climbing the tower","b":"At all times except when belted firmly to the tower","c":"At all times when any work is being done on the tower","d":"Only when the tower exceeds 30 feet in height"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B02","question":"What is a good precaution to observe before climbing an antenna tower?","answer":"C","choices":{"a":"Make sure that you wear a grounded wrist strap","b":"Remove all tower grounding connections","c":"Put on a climbing harness and safety glasses","d":"All of the these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B03","question":"Under what circumstances is it safe to climb a tower without a helper or observe"+"r?","answer":"D","choices":{"a":"When no electrical work is being performed","b":"When no mechanical work is being performed","c":"When the work being done is not more than 20 feet above the ground","d":"Never"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B04","question":"Which of the following is an important safety precaution to observe when putting"+" up an antenna tower?","answer":"C","choices":{"a":"Wear a ground strap connected to your wrist at all times","b":"Insulate the base of the tower to avoid lightning strikes","c":"Look for and stay clear of any overhead electrical wires","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B05","question":"What is the purpose of a gin pole?","answer":"C","choices":{"a":"To temporarily replace guy wires","b":"To be used in place of a safety harness","c":"To lift tower sections or antennas","d":"To provide a temporary ground"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B06","question":"What is the minimum safe distance from a power line to allow when installing an "+"antenna?","answer":"D","choices":{"a":"Half the width of your property","b":"The height of the power line above ground","c":"1/2 wavelength at the operating frequency","d":"So that if the antenna falls unexpectedly, no part of it can come closer than 10"+" feet to the power wires"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B07","question":"Which of the following is an important safety rule to remember when using a cran"+"k-up tower?","answer":"C","choices":{"a":"This type of tower must never be painted","b":"This type of tower must never be grounded","c":"This type of tower must never be climbed unless it is in the fully retracted pos"+"ition","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B08","question":"What is considered to be a proper grounding method for a tower?","answer":"C","choices":{"a":"A single four-foot ground rod, driven into the ground no more than 12 inches fro"+"m the base","b":"A ferrite-core RF choke connected between the tower and ground","c":"Separate eight-foot long ground rods for each tower leg, bonded to the tower and"+" each other","d":"A connection between the tower base and a cold water pipe"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B09","question":"Why should you avoid attaching an antenna to a utility pole?","answer":"C","choices":{"a":"The antenna will not work properly because of induced voltages","b":"The utility company will charge you an extra monthly fee","c":"The antenna could contact high-voltage power wires","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B10","question":"Which of the following is true concerning grounding conductors used for lightnin"+"g protection?","answer":"C","choices":{"a":"Only non-insulated wire must be used","b":"Wires must be carefully routed with precise right-angle bends","c":"Sharp bends must be avoided","d":"Common grounds must be avoided"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B11","question":"Which of the following establishes grounding requirements for an amateur radio t"+"ower or antenna?","answer":"B","choices":{"a":"FCC Part 97 Rules","b":"Local electrical codes","c":"FAA tower lighting regulations","d":"Underwriters Laboratories' recommended practices"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0B","questionID":"T0B12","question":"Which of the following is good practice when installing ground wires on a tower "+"for lightning protection?","answer":"C","choices":{"a":"Put a loop in the ground connection to prevent water damage to the ground system","b":"Make sure that all bends in the ground wires are clean, right angle bends","c":"Ensure that connections are short and direct","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C01","question":"What type of radiation are VHF and UHF radio signals?","answer":"D","choices":{"a":"Gamma radiation","b":"Ionizing radiation","c":"Alpha radiation","d":"Non-ionizing radiation"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C02","question":"Which of the following frequencies has the lowest value for Maximum Permissible "+"Exposure limit?","answer":"B","choices":{"a":"3.5 MHz","b":"50 MHz","c":"440 MHz","d":"1296 MHz"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C03","question":"What is the maximum power level that an amateur radio station may use at VHF fre"+"quencies before an RF exposure evaluation is required?","answer":"C","choices":{"a":"1500 watts PEP transmitter output","b":"1 watt forward power","c":"50 watts PEP at the antenna","d":"50 watts PEP reflected power"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C04","question":"What factors affect the RF exposure of people near an amateur station antenna?","answer":"D","choices":{"a":"Frequency and power level of the RF field","b":"Distance from the antenna to a person","c":"Radiation pattern of the antenna","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C05","question":"Why do exposure limits vary with frequency?","answer":"D","choices":{"a":"Lower frequency RF fields have more energy than higher frequency fields","b":"Lower frequency RF fields do not penetrate the human body","c":"Higher frequency RF fields are transient in nature","d":"The human body absorbs more RF energy at some frequencies than at others"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C06","question":"Which of the following is an acceptable method to determine that your station co"+"mplies with FCC RF exposure regulations?","answer":"D","choices":{"a":"By calculation based on FCC OET Bulletin 65","b":"By calculation based on computer modeling","c":"By measurement of field strength using calibrated equipment","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C07","question":"What could happen if a person accidentally touched your antenna while you were t"+"ransmitting?","answer":"B","choices":{"a":"Touching the antenna could cause television interference","b":"They might receive a painful RF burn","c":"They might develop radiation poisoning","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C08","question":"Which of the following actions might amateur operators take to prevent exposure "+"to RF radiation in excess of FCC-supplied limits?","answer":"A","choices":{"a":"Relocate antennas","b":"Relocate the transmitter","c":"Increase the duty cycle","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C09","question":"How can you make sure your station stays in compliance with RF safety regulation"+"s?","answer":"B","choices":{"a":"By informing the FCC of any changes made in your station","b":"By re-evaluating the station whenever an item of equipment is changed","c":"By making sure your antennas have low SWR","d":"All of these choices are correct"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C10","question":"Why is duty cycle one of the factors used to determine safe RF radiation exposur"+"e levels?","answer":"A","choices":{"a":"It affects the average exposure of people to radiation","b":"It affects the peak exposure of people to radiation","c":"It takes into account the antenna feed line loss","d":"It takes into account the thermal effects of the final amplifier"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C11","question":"What is the definition of duty cycle during the averaging time for RF exposure? ","answer":"C","choices":{"a":"The difference between the lowest power output and the highest power output of a"+" transmitter","b":"The difference between the PEP and average power output of a transmitter","c":"The percentage of time that a transmitter is transmitting","d":"The percentage of time that a transmitter is not transmitting"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C12","question":"How does RF radiation differ from ionizing radiation (radioactivity)?","answer":"A","choices":{"a":"RF radiation does not have sufficient energy to cause genetic damage","b":"RF radiation can only be detected with an RF dosimeter","c":"RF radiation is limited in range to a few feet","d":"RF radiation is perfectly safe"},"metadata":""},{"exam":"T","section":"T0","subSection":"T0C","questionID":"T0C13","question":"If the averaging time for exposure is 6 minutes, how much power density is permi"+"tted if the signal is present for 3 minutes and absent for 3 minutes rather than"+" being present for the entire 6 minutes? ","answer":"C","choices":{"a":"3 times as much","b":"1/2 as much","c":"2 times as much","d":"There is no adjustment allowed for shorter exposure times"},"metadata":""}]});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var About=function About(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"about-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"about-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"About")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"about-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This app will help you practice for the various Ham radio exams. There are three of these:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Technician (beginner)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"General (intermediate)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Extra (advanced)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The questions are pulled from the current ARRL\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"http://www.arrl.org/question-pools",className:"normal-link"},"official question pools"),"\xA0 as of Summer 2017."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"I regexed them all into a more Javascript-friendly format and rigged this up with React. Niche hardware hobbies and modern web development don't seem to have as much overlap as I expected. A lot of the sites I found were not very mobile friendly, so I made my own."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"I hope it is of some use to you. :)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For taking the actual test:\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"normal-link ",href:"http://www.arrl.org/find-an-amateur-radio-license-exam-session"},"Find an Amateur Radio License Exam Location in Your Area"),".")));};/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OffCanvasMenu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_json_qs_technician__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_json_qs_general__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_json_qs_extra__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_main_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutability_helper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_transition_group__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Container=function(_Component){_inherits(Container,_Component);function Container(props){_classCallCheck(this,Container);var _this=_possibleConstructorReturn(this,(Container.__proto__||Object.getPrototypeOf(Container)).call(this,props));var i=0;// let completed = 0;
var dataset=__WEBPACK_IMPORTED_MODULE_4__assets_json_qs_technician__["a" /* default */];_this.state={mode:"orderly",uniqueRandoms:[],correctAnswer:dataset.questions[i].answer,completed:0,total:dataset.questions.length,percent:0,index:i,data:dataset,exam:"technician",question:dataset.questions[i].question,questions:dataset.questions,a:{text:dataset.questions[i].choices.a,attempted:false},b:{text:dataset.questions[i].choices.b,attempted:false},c:{text:dataset.questions[i].choices.c,attempted:false},d:{text:dataset.questions[i].choices.d,attempted:false},answer:dataset.questions[i].answer,message:"",lastGuess:"",menuOpen:false};_this.handleGuess=_this.handleGuess.bind(_this);_this.toggleMode=_this.toggleMode.bind(_this);_this.toggleExam=_this.toggleExam.bind(_this);_this.toggleMenu=_this.toggleMenu.bind(_this);_this.changeQuestionPool=_this.changeQuestionPool.bind(_this);return _this;}_createClass(Container,[{key:'handleGuess',value:function handleGuess(e){e.preventDefault();this.setState({guess:e.target.dataset.letter},this.isGuessCorrect);}},{key:'isGuessCorrect',value:function isGuessCorrect(){this.setState({guessedCorrectly:this.state.answer===this.state.guess?true:false},this.notifyOfResult);}},{key:'notifyOfResult',value:function notifyOfResult(){var lowered=this.state.guess.toLowerCase();var letter=this.state[lowered];var merged=__WEBPACK_IMPORTED_MODULE_8_immutability_helper___default()(letter,{$merge:{attempted:true}});if(this.state.guessedCorrectly){this.setState({message:"Good job!"},this.increment);}else{this.setState(_defineProperty({},lowered,merged));}}},{key:'increment',value:function increment(){var inc=void 0;if(this.state.mode==="orderly"){inc=this.state.index+1;}else{inc=this.fetchRandomIndex();}this.setState({completed:this.state.completed+1,index:inc},this.update);if(this.state.completed+1>this.state.total){this.setState({completed:1},this.calculateCompletion);}this.getNewQuestion();}},{key:'update',value:function update(){this.calculateCompletion();this.getNewQuestion();}},{key:'calculateCompletion',value:function calculateCompletion(){this.setState({percent:this.state.completed/this.state.total*100});}},{key:'getNewQuestion',value:function getNewQuestion(){var i=this.state.index;this.setState({question:this.state.questions[i].question,a:{text:this.state.questions[i].choices.a,attempted:false},b:{text:this.state.questions[i].choices.b,attempted:false},c:{text:this.state.questions[i].choices.c,attempted:false},d:{text:this.state.questions[i].choices.d,attempted:false},answer:this.state.questions[i].answer,guess:"",guessedCorrectly:false},this.calculateCompletion);}},{key:'toggleMenu',value:function toggleMenu(){this.setState({menuOpen:!this.state.menuOpen});}},{key:'toggleExam',value:function toggleExam(e){var newExam=e.target.dataset.exam;this.setState({exam:newExam},this.changeQuestionPool);}},{key:'changeQuestionPool',value:function changeQuestionPool(){var newExam=void 0;switch(this.state.exam){case"extra":newExam=__WEBPACK_IMPORTED_MODULE_6__assets_json_qs_extra__["a" /* default */];break;case"general":newExam=__WEBPACK_IMPORTED_MODULE_5__assets_json_qs_general__["a" /* default */];break;default:newExam=__WEBPACK_IMPORTED_MODULE_4__assets_json_qs_technician__["a" /* default */];}this.setState({lastGuess:"",questions:newExam.questions,index:0,data:newExam,total:newExam.questions.length,completed:0,uniqueRandoms:[]},this.getNewQuestion);}},{key:'toggleMode',value:function toggleMode(){this.setState({mode:this.state.mode==="orderly"?"random":"orderly",completed:0});}},{key:'fetchRandomIndex',value:function fetchRandomIndex(){var numRandoms=this.state.total;var uniqueRandoms=this.state.uniqueRandoms;// refill the array if needed
if(!uniqueRandoms.length){for(var i=0;i<numRandoms;i++){uniqueRandoms.push(i);}}var index=Math.floor(Math.random()*uniqueRandoms.length);var uniqueIndex=uniqueRandoms[index];// now remove used up value from the array
uniqueRandoms.splice(index,1);return uniqueIndex;}},{key:'render',value:function render(){var className=this.state.menuOpen?"show-nav":"hide-nav";var overlay=this.state.menuOpen?"overlay-active":"overlay-dormant";var action=void 0;if(this.state.menuOpen){action=this.toggleMenu;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'site-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OffCanvasMenu__["a" /* default */],Object.assign({},this.state,{toggleMenu:this.toggleMenu,'class':className}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'site-canvas',className:overlay},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container',onClick:action},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */],Object.assign({},this.state,{toggleMenu:this.toggleMenu})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Main__["a" /* default */],Object.assign({},this.state,{handleGuess:this.handleGuess,toggleMode:this.toggleMode,toggleExam:this.toggleExam}))))));}}]);return Container;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fontawesome__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_fa_css_font_awesome_min_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_fa_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_fa_css_font_awesome_min_css__);
var Hamburger=function Hamburger(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:props.toggleMenu,className:'hamburger-menu-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hamburger-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_fontawesome___default.a,{name:'bars'})));};/* harmony default export */ __webpack_exports__["a"] = (Hamburger);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Hamburger__ = __webpack_require__(108);
var Header=function Header(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Hamburger__["a" /* default */],{toggleMenu:props.toggleMenu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ProgressBar__["a" /* default */],{percent:props.percent,completed:props.completed,total:props.total}));};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__About__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Settings__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Quiz__ = __webpack_require__(113);
var Main=function Main(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"main-island"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:'/',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Quiz__["a" /* default */],Object.assign({},props,{handleGuess:props.handleGuess}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/about',component:__WEBPACK_IMPORTED_MODULE_2__About__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/settings',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Settings__["a" /* default */],Object.assign({toggleMode:props.toggleMode,toggleExam:props.toggleExam},props));}})));};/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_fa_css_font_awesome_min_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_fa_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_fa_css_font_awesome_min_css__);
var OffCanvasMenu=function OffCanvasMenu(props){var activeClass="menu-container "+props.class;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-wrapper'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'site-menu',className:activeClass},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'site-menu-option'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],{to:'/',onClick:props.toggleMenu,className:'navLink'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'home'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' return '),' '),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'site-menu-option site-menu-status'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'site-menu-status-exam'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'pencil-square-o'}),' ',props.exam,' '),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'site-menu-option'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],{to:'/settings',onClick:props.toggleMenu},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'gears'}),' Settings '),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'site-menu-option'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],{to:'/about',onClick:props.toggleMenu},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'question'}),' About '),' '),' '),' ');};/* harmony default export */ __webpack_exports__["a"] = (OffCanvasMenu);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ProgressBar=function ProgressBar(props){var style={width:props.percent+"%"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"progressbar-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"progressbar-progress",style:style}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"progressbar-text"},props.completed+"/"+props.total));};/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
var Quiz=function Quiz(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question'},props.question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'choices'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"a",'data-letter':'A',onClick:props.handleGuess,className:"choice-a "+(props.a.attempted?" strike-through":"")},props.a.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"b",'data-letter':'B',onClick:props.handleGuess,className:"choice-b "+(props.b.attempted?" strike-through":"")},props.b.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"c",'data-letter':'C',onClick:props.handleGuess,className:"choice-c "+(props.c.attempted?" strike-through":"")},props.c.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"d",'data-letter':'D',onClick:props.handleGuess,className:"choice-d "+(props.d.attempted?" strike-through":"")},props.d.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status'}));};/* harmony default export */ __webpack_exports__["a"] = (Quiz);//    <div className="message">{props.message}</div>

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Settings=function Settings(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"settings-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"settings-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Settings")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"setting"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"setting-description"},"Exam")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"setting"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"data-exam":"technician",onClick:props.toggleExam,className:props.exam==="technician"?"activeSetting setting-option":"setting-option"},"Technician"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"data-exam":"general",onClick:props.toggleExam,className:props.exam==="general"?"activeSetting setting-option":"setting-option"},"General"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"data-exam":"extra",onClick:props.toggleExam,className:props.exam==="extra"?"activeSetting setting-option":"setting-option"},"Extra")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"setting"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"setting-description"},"Question Progression")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"setting"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:props.toggleMode,className:props.mode==="orderly"?"activeSetting setting-option":"setting-option"},"In Order"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:props.toggleMode,className:props.mode==="random"?"activeSetting setting-option":"setting-option"},"Random")));};/* harmony default export */ __webpack_exports__["a"] = (Settings);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/hammertime",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/hammertime"+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 116 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var emptyObject = __webpack_require__(28);
var _invariant = __webpack_require__(0);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(119);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(56);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(56);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(126);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(136);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(0);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(7);

var createArrayFromMixed = __webpack_require__(129);
var getMarkupWrap = __webpack_require__(131);
var invariant = __webpack_require__(0);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(7);

var invariant = __webpack_require__(0);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(133);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(135);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(22);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(35);

var _PathUtils = __webpack_require__(21);

var _createTransitionManager = __webpack_require__(36);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(22);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(35);

var _PathUtils = __webpack_require__(21);

var _createTransitionManager = __webpack_require__(36);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(21);

var _LocationUtils = __webpack_require__(35);

var _createTransitionManager = __webpack_require__(36);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(22);

var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;

var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
  getAllKeys(source).forEach(function(key) {
    if (hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  });
  return target;
};

var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };

/* istanbul ignore next */
function copy(object) {
  if (object instanceof Array) {
    return assign(object.constructor(object.length), object)
  } else if (object && typeof object === 'object') {
    var prototype = object.constructor && object.constructor.prototype
    return assign(Object.create(prototype || null), object);
  } else {
    return object;
  }
}

function newContext() {
  var commands = assign({}, defaultCommands);
  update.extend = function(directive, fn) {
    commands[directive] = fn;
  };
  update.isEquals = function(a, b) { return a === b; };

  return update;

  function update(object, spec) {
    if (!(Array.isArray(object) && Array.isArray(spec))) {
      invariant(
        !Array.isArray(spec),
        'update(): You provided an invalid spec to update(). The spec may ' +
        'not contain an array except as the value of $set, $push, $unshift, ' +
        '$splice or any custom command allowing an array value.'
      );
    }

    invariant(
      typeof spec === 'object' && spec !== null,
      'update(): You provided an invalid spec to update(). The spec and ' +
      'every included key path must be plain objects containing one of the ' +
      'following commands: %s.',
      Object.keys(commands).join(', ')
    );

    var nextObject = object;
    var index, key;
    getAllKeys(spec).forEach(function(key) {
      if (hasOwnProperty.call(commands, key)) {
        var objectWasNextObject = object === nextObject;
        nextObject = commands[key](spec[key], nextObject, spec, object);
        if (objectWasNextObject && update.isEquals(nextObject, object)) {
          nextObject = object;
        }
      } else {
        var nextValueForKey = update(object[key], spec[key]);
        if (!update.isEquals(nextValueForKey, nextObject[key]) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
          if (nextObject === object) {
            nextObject = copy(object);
          }
          nextObject[key] = nextValueForKey;
        }
      }
    })
    return nextObject;
  }

}

var defaultCommands = {
  $push: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$push');
    return value.length ? nextObject.concat(value) : nextObject;
  },
  $unshift: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$unshift');
    return value.length ? value.concat(nextObject) : nextObject;
  },
  $splice: function(value, nextObject, spec, originalObject) {
    invariantSplices(nextObject, spec);
    value.forEach(function(args) {
      invariantSplice(args);
      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
      splice.apply(nextObject, args);
    });
    return nextObject;
  },
  $set: function(value, nextObject, spec) {
    invariantSet(spec);
    return value;
  },
  $toggle: function(targets, nextObject) {
    invariantToggle(targets, nextObject);
    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;

    targets.forEach(function(target) {
      nextObjectCopy[target] = !nextObject[target];
    });

    return nextObjectCopy;
  },
  $unset: function(value, nextObject, spec, originalObject) {
    invariant(
      Array.isArray(value),
      'update(): expected spec of $unset to be an array; got %s. ' +
      'Did you forget to wrap the key(s) in an array?',
      value
    );
    value.forEach(function(key) {
      if (Object.hasOwnProperty.call(nextObject, key)) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  $merge: function(value, nextObject, spec, originalObject) {
    invariantMerge(nextObject, value);
    getAllKeys(value).forEach(function(key) {
      if (value[key] !== nextObject[key]) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        nextObject[key] = value[key];
      }
    });
    return nextObject;
  },
  $apply: function(value, original) {
    invariantApply(value);
    return value(original);
  }
};

module.exports = newContext();
module.exports.newContext = newContext;

// invariants

function invariantPushAndUnshift(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  var specValue = spec[command];
  invariant(
    Array.isArray(specValue),
    'update(): expected spec of %s to be an array; got %s. ' +
    'Did you forget to wrap your parameter in an array?',
    command,
    specValue
  );
}

function invariantToggle(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $toggle to be an array; got %s. ' +
    'Did you forget to wrap the key(s) in an array?',
    value
  );
}

function invariantSplices(value, spec) {
  invariant(
    Array.isArray(value),
    'Expected $splice target to be an array; got %s',
    value
  );
  invariantSplice(spec['$splice']);
}

function invariantSplice(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
    'Did you forget to wrap your parameters in an array?',
    value
  );
}

function invariantApply(fn) {
  invariant(
    typeof fn === 'function',
    'update(): expected spec of $apply to be a function; got %s.',
    fn
  );
}

function invariantSet(spec) {
  invariant(
    Object.keys(spec).length === 1,
    'Cannot have more than one key in an object with $set'
  );
}

function invariantMerge(target, specValue) {
  invariant(
    specValue && typeof specValue === 'object',
    'update(): $merge expects a spec of type \'object\'; got %s',
    specValue
  );
  invariant(
    target && typeof target === 'object',
    'update(): $merge expects a target of type \'object\'; got %s',
    target
  );
}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(144)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(8);
var invariant = __webpack_require__(0);
var ReactPropTypesSecret = __webpack_require__(64);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(8);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var ReactPropTypesSecret = __webpack_require__(64);
var checkPropTypes = __webpack_require__(145);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(5);

var focusNode = __webpack_require__(59);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(24);
var ExecutionEnvironment = __webpack_require__(7);
var FallbackCompositionState = __webpack_require__(156);
var SyntheticCompositionEvent = __webpack_require__(193);
var SyntheticInputEvent = __webpack_require__(196);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(66);
var ExecutionEnvironment = __webpack_require__(7);
var ReactInstrumentation = __webpack_require__(10);

var camelizeStyleName = __webpack_require__(127);
var dangerousStyleValue = __webpack_require__(202);
var hyphenateStyleName = __webpack_require__(134);
var memoizeStringOnly = __webpack_require__(137);
var warning = __webpack_require__(1);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(23);
var EventPropagators = __webpack_require__(24);
var ExecutionEnvironment = __webpack_require__(7);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);
var SyntheticEvent = __webpack_require__(12);

var inputValueTracking = __webpack_require__(82);
var getEventTarget = __webpack_require__(49);
var isEventSupported = __webpack_require__(50);
var isTextInputElement = __webpack_require__(84);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(16);
var ExecutionEnvironment = __webpack_require__(7);

var createNodesFromMarkup = __webpack_require__(130);
var emptyFunction = __webpack_require__(8);
var invariant = __webpack_require__(0);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(24);
var ReactDOMComponentTree = __webpack_require__(5);
var SyntheticMouseEvent = __webpack_require__(30);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var PooledClass = __webpack_require__(15);

var getTextContentAccessor = __webpack_require__(81);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(17);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(18);

var instantiateReactComponent = __webpack_require__(83);
var KeyEscapeUtils = __webpack_require__(41);
var shouldUpdateReactComponent = __webpack_require__(51);
var traverseAllChildren = __webpack_require__(86);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/hammertime"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(95);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(37);
var ReactDOMIDOperations = __webpack_require__(166);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(4);

var React = __webpack_require__(19);
var ReactComponentEnvironment = __webpack_require__(43);
var ReactCurrentOwner = __webpack_require__(13);
var ReactErrorUtils = __webpack_require__(44);
var ReactInstanceMap = __webpack_require__(25);
var ReactInstrumentation = __webpack_require__(10);
var ReactNodeTypes = __webpack_require__(76);
var ReactReconciler = __webpack_require__(18);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(28);
var invariant = __webpack_require__(0);
var shallowEqual = __webpack_require__(34);
var shouldUpdateReactComponent = __webpack_require__(51);
var warning = __webpack_require__(1);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(5);
var ReactDefaultInjection = __webpack_require__(174);
var ReactMount = __webpack_require__(75);
var ReactReconciler = __webpack_require__(18);
var ReactUpdates = __webpack_require__(11);
var ReactVersion = __webpack_require__(187);

var findDOMNode = __webpack_require__(203);
var getHostComponentFromComposite = __webpack_require__(80);
var renderSubtreeIntoContainer = __webpack_require__(210);
var warning = __webpack_require__(1);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(4);

var AutoFocusUtils = __webpack_require__(149);
var CSSPropertyOperations = __webpack_require__(151);
var DOMLazyTree = __webpack_require__(16);
var DOMNamespaces = __webpack_require__(38);
var DOMProperty = __webpack_require__(17);
var DOMPropertyOperations = __webpack_require__(68);
var EventPluginHub = __webpack_require__(23);
var EventPluginRegistry = __webpack_require__(39);
var ReactBrowserEventEmitter = __webpack_require__(29);
var ReactDOMComponentFlags = __webpack_require__(69);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMInput = __webpack_require__(167);
var ReactDOMOption = __webpack_require__(168);
var ReactDOMSelect = __webpack_require__(70);
var ReactDOMTextarea = __webpack_require__(171);
var ReactInstrumentation = __webpack_require__(10);
var ReactMultiChild = __webpack_require__(180);
var ReactServerRenderingTransaction = __webpack_require__(185);

var emptyFunction = __webpack_require__(8);
var escapeTextContentForBrowser = __webpack_require__(32);
var invariant = __webpack_require__(0);
var isEventSupported = __webpack_require__(50);
var shallowEqual = __webpack_require__(34);
var inputValueTracking = __webpack_require__(82);
var validateDOMNesting = __webpack_require__(52);
var warning = __webpack_require__(1);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(52);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var DOMLazyTree = __webpack_require__(16);
var ReactDOMComponentTree = __webpack_require__(5);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(37);
var ReactDOMComponentTree = __webpack_require__(5);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(4);

var DOMPropertyOperations = __webpack_require__(68);
var LinkedValueUtils = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var React = __webpack_require__(19);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMSelect = __webpack_require__(70);

var warning = __webpack_require__(1);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(7);

var getNodeForCharacterOffset = __webpack_require__(207);
var getTextContentAccessor = __webpack_require__(81);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(4);

var DOMChildrenOperations = __webpack_require__(37);
var DOMLazyTree = __webpack_require__(16);
var ReactDOMComponentTree = __webpack_require__(5);

var escapeTextContentForBrowser = __webpack_require__(32);
var invariant = __webpack_require__(0);
var validateDOMNesting = __webpack_require__(52);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(4);

var LinkedValueUtils = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var ReactUpdates = __webpack_require__(11);
var Transaction = __webpack_require__(31);

var emptyFunction = __webpack_require__(8);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(148);
var BeforeInputEventPlugin = __webpack_require__(150);
var ChangeEventPlugin = __webpack_require__(152);
var DefaultEventPluginOrder = __webpack_require__(154);
var EnterLeaveEventPlugin = __webpack_require__(155);
var HTMLDOMPropertyConfig = __webpack_require__(157);
var ReactComponentBrowserEnvironment = __webpack_require__(159);
var ReactDOMComponent = __webpack_require__(162);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMEmptyComponent = __webpack_require__(164);
var ReactDOMTreeTraversal = __webpack_require__(172);
var ReactDOMTextComponent = __webpack_require__(170);
var ReactDefaultBatchingStrategy = __webpack_require__(173);
var ReactEventListener = __webpack_require__(177);
var ReactInjection = __webpack_require__(178);
var ReactReconcileTransaction = __webpack_require__(183);
var SVGDOMPropertyConfig = __webpack_require__(188);
var SelectEventPlugin = __webpack_require__(189);
var SimpleEventPlugin = __webpack_require__(190);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(23);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var EventListener = __webpack_require__(58);
var ExecutionEnvironment = __webpack_require__(7);
var PooledClass = __webpack_require__(15);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var getEventTarget = __webpack_require__(49);
var getUnboundedScrollPosition = __webpack_require__(132);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(17);
var EventPluginHub = __webpack_require__(23);
var EventPluginUtils = __webpack_require__(40);
var ReactComponentEnvironment = __webpack_require__(43);
var ReactEmptyComponent = __webpack_require__(71);
var ReactBrowserEventEmitter = __webpack_require__(29);
var ReactHostComponent = __webpack_require__(73);
var ReactUpdates = __webpack_require__(11);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(201);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactComponentEnvironment = __webpack_require__(43);
var ReactInstanceMap = __webpack_require__(25);
var ReactInstrumentation = __webpack_require__(10);

var ReactCurrentOwner = __webpack_require__(13);
var ReactReconciler = __webpack_require__(18);
var ReactChildReconciler = __webpack_require__(158);

var emptyFunction = __webpack_require__(8);
var flattenChildren = __webpack_require__(204);
var invariant = __webpack_require__(0);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var CallbackQueue = __webpack_require__(67);
var PooledClass = __webpack_require__(15);
var ReactBrowserEventEmitter = __webpack_require__(29);
var ReactInputSelection = __webpack_require__(74);
var ReactInstrumentation = __webpack_require__(10);
var Transaction = __webpack_require__(31);
var ReactUpdateQueue = __webpack_require__(45);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(181);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(4);

var PooledClass = __webpack_require__(15);
var Transaction = __webpack_require__(31);
var ReactInstrumentation = __webpack_require__(10);
var ReactServerUpdateQueue = __webpack_require__(186);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(45);

var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(24);
var ExecutionEnvironment = __webpack_require__(7);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInputSelection = __webpack_require__(74);
var SyntheticEvent = __webpack_require__(12);

var getActiveElement = __webpack_require__(60);
var isTextInputElement = __webpack_require__(84);
var shallowEqual = __webpack_require__(34);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var EventListener = __webpack_require__(58);
var EventPropagators = __webpack_require__(24);
var ReactDOMComponentTree = __webpack_require__(5);
var SyntheticAnimationEvent = __webpack_require__(191);
var SyntheticClipboardEvent = __webpack_require__(192);
var SyntheticEvent = __webpack_require__(12);
var SyntheticFocusEvent = __webpack_require__(195);
var SyntheticKeyboardEvent = __webpack_require__(197);
var SyntheticMouseEvent = __webpack_require__(30);
var SyntheticDragEvent = __webpack_require__(194);
var SyntheticTouchEvent = __webpack_require__(198);
var SyntheticTransitionEvent = __webpack_require__(199);
var SyntheticUIEvent = __webpack_require__(26);
var SyntheticWheelEvent = __webpack_require__(200);

var emptyFunction = __webpack_require__(8);
var getEventCharCode = __webpack_require__(47);
var invariant = __webpack_require__(0);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(12);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(12);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(12);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(30);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(26);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(12);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(26);

var getEventCharCode = __webpack_require__(47);
var getEventKey = __webpack_require__(205);
var getEventModifierState = __webpack_require__(48);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(26);

var getEventModifierState = __webpack_require__(48);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(12);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(30);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(66);
var warning = __webpack_require__(1);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(13);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInstanceMap = __webpack_require__(25);

var getHostComponentFromComposite = __webpack_require__(80);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(41);
var traverseAllChildren = __webpack_require__(86);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/hammertime"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(95);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(47);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(7);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(32);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(75);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0px',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0px, 0px, 0px, 0px)',
  border: '0px'
};
module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Router */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Router */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* unused harmony reexport default */


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(88);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [activeClassName, className].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

NavLink.defaultProps = {
  activeClassName: 'active'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* unused harmony reexport default */


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* unused harmony reexport default */


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* unused harmony reexport default */


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* unused harmony reexport default */


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* unused harmony reexport default */


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* unused harmony reexport default */


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Router__ = __webpack_require__(54);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (MemoryRouter);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (Prompt);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for updating the location programatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (Redirect);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(54);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (StaticRouter);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(55);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(89);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* unused harmony default export */ var _unused_webpack_default_export = (withRouter);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(90);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(90);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(91);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(233);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(118);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(120);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(122);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(121);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(65);

var _PropTypes = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(3);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(236);
var ReactElement = __webpack_require__(20);

var emptyFunction = __webpack_require__(8);
var traverseAllChildren = __webpack_require__(246);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(20);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(20),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(63);

module.exports = factory(isValidElement);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(94),
    Component = _require.Component;

var _require2 = __webpack_require__(20),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(97);
var factory = __webpack_require__(117);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(27);

var ReactElement = __webpack_require__(20);

var invariant = __webpack_require__(0);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(27);

var ReactCurrentOwner = __webpack_require__(13);
var REACT_ELEMENT_TYPE = __webpack_require__(96);

var getIteratorFn = __webpack_require__(242);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(235);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsolute = function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
};

// About 1.5x faster than the two-arg version of Array#splice()
var spliceOne = function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }list.pop();
};

// This implementation is based heavily on node's url.parse
var resolvePathname = function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
};

module.exports = resolvePathname;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
    return valueEqual(item, b[index]);
  });

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
module.exports = __webpack_require__(99);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.a759fb9b.js